/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 184);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(185);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(186);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
        _classCallCheck(this, Loader);

        return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
    }

    _createClass(Loader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { id: 'loader' },
                _react2.default.createElement('div', { className: 'spinner-border text-danger', role: 'status' })
            );
        }
    }]);

    return Loader;
}(_react2.default.Component);

exports.default = Loader;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(190)();
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppHeader2 = function (_React$Component) {
    _inherits(AppHeader2, _React$Component);

    function AppHeader2(props) {
        _classCallCheck(this, AppHeader2);

        var _this = _possibleConstructorReturn(this, (AppHeader2.__proto__ || Object.getPrototypeOf(AppHeader2)).call(this, props));

        _this.handleSearchClick = function (e) {

            e.preventDefault();
            var a = $("#search").hasClass("show");
            if (a) {
                $("#search").removeClass("show");
            } else {
                $("#search").addClass("show");
                $("#search .form-control").focus();
            }
        };

        _this.state = {
            AppHeaderClass: props.AppHeaderClass,
            AppHeaderLeft: props.AppHeaderLeft,
            AppHeaderLeftLink: props.AppHeaderLeftLink,
            AppHeaderTitle: props.AppHeaderTitle,
            AppHeaderRight: props.AppHeaderRight,
            AppHeaderRightLink: props.AppHeaderRightLink,
            AppHeaderSearch: props.AppHeaderSearch || '',
            redirect: false,
            search_text: ''
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(AppHeader2, [{
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
            this.setState({ redirect: true });
            this.setState({ search_text: event.target.elements.search.value });

            event.target.elements.search.value = '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.redirect) {
                this.setState({ redirect: false });
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/search/' + this.state.search_text });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { id: 'search', className: 'appHeader' },
                    _react2.default.createElement(
                        'form',
                        { className: 'search-form', onSubmit: this.handleSubmit },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group searchbox' },
                            _react2.default.createElement('input', { type: 'search', className: 'form-control', id: 'search_text', name: 'search', placeholder: 'Search...', onKeyDown: this.onKeyDown, minLength: '3' }),
                            _react2.default.createElement(
                                'i',
                                { className: 'input-icon' },
                                _react2.default.createElement('ion-icon', { name: 'search-outline' })
                            ),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '#', className: 'ml-1 close toggle-searchbox', onClick: this.handleSearchClick },
                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: this.state.AppHeaderClass },
                    _react2.default.createElement(
                        'div',
                        { className: 'left' },
                        this.state.AppHeaderLeft == 'showLINK' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: this.state.AppHeaderLeftLink, className: 'headerButton goBack pl-0' },
                            _react2.default.createElement('ion-icon', { name: 'chevron-back-outline' })
                        ),
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '/home', className: 'headerButton p-0' },
                            _react2.default.createElement('img', { src: '/assets/img/done-logo.png', alt: 'image', className: 'form-image' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'pageTitle title-cut' },
                        this.state.AppHeaderSearch != '' && _react2.default.createElement(
                            'div',
                            { className: 'chip chip-outline search-chip' },
                            _react2.default.createElement(
                                'span',
                                { className: 'chip-label' },
                                ' ',
                                this.state.AppHeaderSearch,
                                ' '
                            ),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '/categories', className: 'chip-delete' },
                                _react2.default.createElement('ion-icon', { name: 'close-circle', role: 'img', className: 'md hydrated', 'aria-label': 'close circle' })
                            )
                        ),
                        this.state.AppHeaderSearch == '' && _react2.default.createElement(
                            'div',
                            { className: 'title-cut-sub' },
                            this.state.AppHeaderTitle
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'right' },
                        this.state.AppHeaderRightLink == 'SEARCH' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '#', onClick: function onClick(e) {
                                    _this2.handleSearchClick(e);
                                }, className: 'headerButton toggle-searchbox' },
                            ' ',
                            _react2.default.createElement('ion-icon', { name: 'search-outline' }),
                            ' '
                        ),
                        this.state.AppHeaderRightLink != 'SEARCH' && this.state.AppHeaderRightLink != '' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: this.state.AppHeaderRightLink, className: 'headerButton text-secondary' },
                            ' ',
                            this.state.AppHeaderRight,
                            ' '
                        ),
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '#', className: 'headerButton text-light', 'data-toggle': 'modal', 'data-target': '#sidebarPanel' },
                            _react2.default.createElement('ion-icon', { name: 'menu-outline' })
                        )
                    )
                )
            );
        }
    }]);

    return AppHeader2;
}(_react2.default.Component);

exports.default = AppHeader2;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarPanel = function (_React$Component) {
    _inherits(SidebarPanel, _React$Component);

    function SidebarPanel(props) {
        _classCallCheck(this, SidebarPanel);

        var _this = _possibleConstructorReturn(this, (SidebarPanel.__proto__ || Object.getPrototypeOf(SidebarPanel)).call(this, props));

        _this.state = {
            CUSTOMER_DET: props.CUSTOMER_DET
        };
        return _this;
    }

    _createClass(SidebarPanel, [{
        key: 'render',
        value: function render() {

            var NAME = '';
            var EMAIL = '';
            var MOBILE = '';

            if (this.state.CUSTOMER_DET != '') {
                var customer = this.state.CUSTOMER_DET.split('~~**~~');
                NAME = customer[0];
                if (customer[1] != '' && customer[1] != undefined) EMAIL = customer[1];
                if (customer[2] != '' && customer[2] != undefined) MOBILE = customer[2];
            }

            return _react2.default.createElement(
                'div',
                { className: 'modal fade panelbox panelbox-right', id: 'sidebarPanel', tabIndex: '-1', role: 'dialog' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-dialog', role: 'document' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-body p-0' },
                            _react2.default.createElement(
                                'div',
                                { className: 'profileBox' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'in pr-0' },
                                    NAME != '' && _react2.default.createElement(
                                        'strong',
                                        null,
                                        NAME
                                    ),
                                    EMAIL != '' && _react2.default.createElement(
                                        'div',
                                        { className: 'text-muted' },
                                        EMAIL
                                    ),
                                    MOBILE != '' && _react2.default.createElement(
                                        'div',
                                        { className: 'text-muted' },
                                        MOBILE
                                    )
                                ),
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: 'javascript:;', className: 'close-sidebar-button', 'data-dismiss': 'modal' },
                                    _react2.default.createElement('ion-icon', { name: 'close' })
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'listview flush transparent no-line image-listview mt-2' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/categories', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' Categories '
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/special-offers', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                null,
                                                'Special Offers'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/about-us', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' About Us '
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/cancellation-and-refunds', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' Cancellations & Refunds '
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/privacy-policy', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' Privacy Policy '
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/terms-and-conditions', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' Terms & Conditions '
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/disclaimer', className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            ' Disclaimer '
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SidebarPanel;
}(_react2.default.Component);

exports.default = SidebarPanel;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BottomMenu = function (_React$Component) {
  _inherits(BottomMenu, _React$Component);

  function BottomMenu(props) {
    _classCallCheck(this, BottomMenu);

    var _this = _possibleConstructorReturn(this, (BottomMenu.__proto__ || Object.getPrototypeOf(BottomMenu)).call(this, props));

    _this.state = {
      currentLocation: props.LOCATION
    };
    return _this;
  }

  _createClass(BottomMenu, [{
    key: 'render',
    value: function render() {
      var profile = localStorage.getItem('userData') == null ? '/login' : '/profile';
      var reorder = localStorage.getItem('userData') == null ? '/login' : '/reorder';

      var cartItemCount = 0;
      var cart = localStorage.getItem('cartData');
      var cartData = JSON.parse(cart);
      if (cart !== null && cart !== '{}') {
        Object.keys(cartData).forEach(function (key) {
          var itemCOUNT = cartData[key];
          cartItemCount = parseFloat(cartItemCount) + parseFloat(itemCOUNT);
        });
      }

      var homeCSS = this.state.currentLocation == '/home' ? ' active' : '';
      var listingCSS = this.state.currentLocation == '/categories' ? ' active' : '';
      if (this.state.currentLocation.search('category') == '1') listingCSS = ' active';
      var cartCSS = this.state.currentLocation == '/cart' ? ' active' : '';
      var reorderCSS = this.state.currentLocation == '/reorder' ? ' active' : '';
      var profileCSS = this.state.currentLocation == '/profile' ? ' active' : '';

      return _react2.default.createElement(
        'div',
        { className: 'appBottomMenu' },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/home', className: 'item' + homeCSS },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement('ion-icon', { name: 'home-outline', role: 'img', className: 'md hydrated', 'aria-label': 'file tray full outline' }),
            _react2.default.createElement(
              'strong',
              null,
              'Home'
            )
          )
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/categories', className: 'item' + listingCSS },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement('ion-icon', { name: 'list', role: 'img', className: 'md hydrated', 'aria-label': 'calendar outline' }),
            _react2.default.createElement(
              'strong',
              null,
              'Categories'
            )
          )
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/cart', className: 'item' + cartCSS },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement(
              'div',
              { className: 'action-button large' },
              cartItemCount != 0 && _react2.default.createElement(
                'span',
                { className: 'badge badge-danger' },
                cartItemCount
              ),
              _react2.default.createElement('ion-icon', { name: 'cart-outline', role: 'img', className: 'md hydrated', 'aria-label': 'add outline' })
            )
          )
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: reorder, className: 'item' + reorderCSS },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement('ion-icon', { name: 'heart-circle-outline', role: 'img', className: 'md hydrated', 'aria-label': 'document text outline' }),
            _react2.default.createElement(
              'strong',
              null,
              'Reorder'
            )
          )
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: profile, className: 'item' + profileCSS },
          _react2.default.createElement(
            'div',
            { className: 'col' },
            _react2.default.createElement('ion-icon', { name: 'person-circle-outline', role: 'img', className: 'md hydrated', 'aria-label': 'people outline' }),
            _react2.default.createElement(
              'strong',
              null,
              'Profile'
            )
          )
        )
      );
    }
  }]);

  return BottomMenu;
}(_react2.default.Component);

exports.default = BottomMenu;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(282), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(135);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(136);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(310);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(314);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(136);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(135);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = (exports.MARKER =
  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var RECTANGLE = (exports.RECTANGLE =
  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYLINE = (exports.POLYLINE =
  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var POLYGON = (exports.POLYGON =
  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var CIRCLE = (exports.CIRCLE =
  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var KML_LAYER = (exports.KML_LAYER =
  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var ANCHOR = (exports.ANCHOR =
  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_WINDOW = (exports.INFO_WINDOW =
  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var GROUND_LAYER = (exports.GROUND_LAYER =
  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var SEARCH_BOX = (exports.SEARCH_BOX =
  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var INFO_BOX = (exports.INFO_BOX =
  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")

var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _bind2 = __webpack_require__(53)

var _bind3 = _interopRequireDefault(_bind2)

var _isFunction2 = __webpack_require__(54)

var _isFunction3 = _interopRequireDefault(_isFunction2)

var _reduce3 = __webpack_require__(367)

var _reduce4 = _interopRequireDefault(_reduce3)

var _forEach2 = __webpack_require__(443)

var _forEach3 = _interopRequireDefault(_forEach2)

var _lowerFirst2 = __webpack_require__(445)

var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)

var _has2 = __webpack_require__(452)

var _has3 = _interopRequireDefault(_has2)

exports.construct = construct
exports.componentDidMount = componentDidMount
exports.componentDidUpdate = componentDidUpdate
exports.componentWillUnmount = componentWillUnmount

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
/* eslint-disable no-param-reassign */
function rdcUncontrolledAndControlledProps(acc, value, key) {
  if ((0, _has3.default)(acc.prevProps, key)) {
    var match = key.match(/^default(\S+)/)
    if (match) {
      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
        acc.nextProps[unprefixedKey] = acc.prevProps[key]
      }
    } else {
      acc.nextProps[key] = acc.prevProps[key]
    }
  }
  return acc
}

function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
    var nextValue = nextProps[key]
    if (nextValue !== prevProps[key]) {
      fn(instance, nextValue)
    }
  })
}

function construct(propTypes, updaterMap, prevProps, instance) {
  var _reduce2 = (0, _reduce4.default)(
      propTypes,
      rdcUncontrolledAndControlledProps,
      {
        nextProps: {},
        prevProps: prevProps,
      }
    ),
    nextProps = _reduce2.nextProps

  applyUpdaterToNextProps(
    updaterMap,
    {
      /* empty prevProps for construct */
    },
    nextProps,
    instance
  )
}

function componentDidMount(component, instance, eventMap) {
  registerEvents(component, instance, eventMap)
}

function componentDidUpdate(
  component,
  instance,
  eventMap,
  updaterMap,
  prevProps
) {
  component.unregisterAllEvents()
  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
  registerEvents(component, instance, eventMap)
}

function componentWillUnmount(component) {
  component.unregisterAllEvents()
}

function registerEvents(component, instance, eventMap) {
  var registeredList = (0, _reduce4.default)(
    eventMap,
    function(acc, googleEventName, onEventName) {
      if ((0, _isFunction3.default)(component.props[onEventName])) {
        acc.push(
          google.maps.event.addListener(
            instance,
            googleEventName,
            component.props[onEventName]
          )
        )
      }
      return acc
    },
    []
  )

  component.unregisterAllEvents = (0, _bind3.default)(
    _forEach3.default,
    null,
    registeredList,
    unregisterEvent
  )
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered)
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(147);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(81)('wks');
var uid = __webpack_require__(50);
var Symbol = __webpack_require__(22).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(18);
var ctx = __webpack_require__(82);
var hide = __webpack_require__(32);
var has = __webpack_require__(27);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(33);
var IE8_DOM_DEFINE = __webpack_require__(133);
var toPrimitive = __webpack_require__(83);
var dP = Object.defineProperty;

exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(35)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.String = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var camelize = exports.camelize = function camelize(str) {
    return str.split('_').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join('');
  };
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(320),
    getValue = __webpack_require__(325);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

var ReactCurrentOwner = __webpack_require__(120);

var warning = __webpack_require__(73);
var canDefineProperty = __webpack_require__(118);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(121);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(42);
module.exports = __webpack_require__(25) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(141);
var defined = __webpack_require__(79);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(234), __webpack_require__(238), __webpack_require__(239), __webpack_require__(242), __webpack_require__(243), __webpack_require__(244), __webpack_require__(245), __webpack_require__(246), __webpack_require__(0), __webpack_require__(4), __webpack_require__(1), __webpack_require__(26), __webpack_require__(248)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./GoogleApiComponent'), require('./components/Marker'), require('./components/InfoWindow'), require('./components/HeatMap'), require('./components/Polygon'), require('./components/Polyline'), require('./components/Circle'), require('./components/Rectangle'), require('react'), require('prop-types'), require('react-dom'), require('./lib/String'), require('./lib/cancelablePromise'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.GoogleApiComponent, global.Marker, global.InfoWindow, global.HeatMap, global.Polygon, global.Polyline, global.Circle, global.Rectangle, global.react, global.propTypes, global.reactDom, global.String, global.cancelablePromise);
    global.index = mod.exports;
  }
})(this, function (exports, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _Circle, _Rectangle, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Map = exports.Rectangle = exports.Circle = exports.Polyline = exports.Polygon = exports.HeatMap = exports.InfoWindow = exports.Marker = exports.GoogleApiWrapper = undefined;
  Object.defineProperty(exports, 'GoogleApiWrapper', {
    enumerable: true,
    get: function () {
      return _GoogleApiComponent.wrapper;
    }
  });
  Object.defineProperty(exports, 'Marker', {
    enumerable: true,
    get: function () {
      return _Marker.Marker;
    }
  });
  Object.defineProperty(exports, 'InfoWindow', {
    enumerable: true,
    get: function () {
      return _InfoWindow.InfoWindow;
    }
  });
  Object.defineProperty(exports, 'HeatMap', {
    enumerable: true,
    get: function () {
      return _HeatMap.HeatMap;
    }
  });
  Object.defineProperty(exports, 'Polygon', {
    enumerable: true,
    get: function () {
      return _Polygon.Polygon;
    }
  });
  Object.defineProperty(exports, 'Polyline', {
    enumerable: true,
    get: function () {
      return _Polyline.Polyline;
    }
  });
  Object.defineProperty(exports, 'Circle', {
    enumerable: true,
    get: function () {
      return _Circle.Circle;
    }
  });
  Object.defineProperty(exports, 'Rectangle', {
    enumerable: true,
    get: function () {
      return _Rectangle.Rectangle;
    }
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var mapStyles = {
    container: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    map: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    }
  };

  var evtNames = ['ready', 'click', 'dragend', 'recenter', 'bounds_changed', 'center_changed', 'dblclick', 'dragstart', 'heading_change', 'idle', 'maptypeid_changed', 'mousemove', 'mouseout', 'mouseover', 'projection_changed', 'resize', 'rightclick', 'tilesloaded', 'tilt_changed', 'zoom_changed'];

  var Map = exports.Map = function (_React$Component) {
    _inherits(Map, _React$Component);

    function Map(props) {
      _classCallCheck(this, Map);

      var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

      if (!props.hasOwnProperty('google')) {
        throw new Error('You must include a `google` prop');
      }

      _this.listeners = {};
      _this.state = {
        currentLocation: {
          lat: _this.props.initialCenter.lat,
          lng: _this.props.initialCenter.lng
        }
      };

      _this.mapRef = _react2.default.createRef();
      return _this;
    }

    _createClass(Map, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        if (this.props.centerAroundCurrentLocation) {
          if (navigator && navigator.geolocation) {
            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(resolve, reject);
            }));

            this.geoPromise.promise.then(function (pos) {
              var coords = pos.coords;
              _this2.setState({
                currentLocation: {
                  lat: coords.latitude,
                  lng: coords.longitude
                }
              });
            }).catch(function (e) {
              return e;
            });
          }
        }
        this.loadMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          this.loadMap();
        }
        if (this.props.visible !== prevProps.visible) {
          this.restyleMap();
        }
        if (this.props.zoom !== prevProps.zoom) {
          this.map.setZoom(this.props.zoom);
        }
        if (this.props.center !== prevProps.center) {
          this.setState({
            currentLocation: this.props.center
          });
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          this.recenterMap();
        }
        if (this.props.bounds && this.props.bounds !== prevProps.bounds) {
          this.map.fitBounds(this.props.bounds);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        var google = this.props.google;

        if (this.geoPromise) {
          this.geoPromise.cancel();
        }
        Object.keys(this.listeners).forEach(function (e) {
          google.maps.event.removeListener(_this3.listeners[e]);
        });
      }
    }, {
      key: 'loadMap',
      value: function loadMap() {
        var _this4 = this;

        if (this.props && this.props.google) {
          var google = this.props.google;

          var maps = google.maps;

          var mapRef = this.mapRef.current;
          var node = _reactDom2.default.findDOMNode(mapRef);
          var curr = this.state.currentLocation;
          var center = new maps.LatLng(curr.lat, curr.lng);

          var mapTypeIds = this.props.google.maps.MapTypeId || {};
          var mapTypeFromProps = String(this.props.mapType).toUpperCase();

          var mapConfig = Object.assign({}, {
            mapTypeId: mapTypeIds[mapTypeFromProps],
            center: center,
            zoom: this.props.zoom,
            maxZoom: this.props.maxZoom,
            minZoom: this.props.minZoom,
            clickableIcons: !!this.props.clickableIcons,
            disableDefaultUI: this.props.disableDefaultUI,
            zoomControl: this.props.zoomControl,
            zoomControlOptions: this.props.zoomControlOptions,
            mapTypeControl: this.props.mapTypeControl,
            mapTypeControlOptions: this.props.mapTypeControlOptions,
            scaleControl: this.props.scaleControl,
            streetViewControl: this.props.streetViewControl,
            streetViewControlOptions: this.props.streetViewControlOptions,
            panControl: this.props.panControl,
            rotateControl: this.props.rotateControl,
            fullscreenControl: this.props.fullscreenControl,
            scrollwheel: this.props.scrollwheel,
            draggable: this.props.draggable,
            draggableCursor: this.props.draggableCursor,
            keyboardShortcuts: this.props.keyboardShortcuts,
            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
            noClear: this.props.noClear,
            styles: this.props.styles,
            gestureHandling: this.props.gestureHandling
          });

          Object.keys(mapConfig).forEach(function (key) {
            // Allow to configure mapConfig with 'false'
            if (mapConfig[key] === null) {
              delete mapConfig[key];
            }
          });

          this.map = new maps.Map(node, mapConfig);

          evtNames.forEach(function (e) {
            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
          });
          maps.event.trigger(this.map, 'ready');
          this.forceUpdate();
        }
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evtName) {
        var _this5 = this;

        var timeout = void 0;
        var handlerName = 'on' + (0, _String.camelize)(evtName);

        return function (e) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(function () {
            if (_this5.props[handlerName]) {
              _this5.props[handlerName](_this5.props, _this5.map, e);
            }
          }, 0);
        };
      }
    }, {
      key: 'recenterMap',
      value: function recenterMap() {
        var map = this.map;

        var google = this.props.google;


        if (!google) return;
        var maps = google.maps;

        if (map) {
          var center = this.state.currentLocation;
          if (!(center instanceof google.maps.LatLng)) {
            center = new google.maps.LatLng(center.lat, center.lng);
          }
          // map.panTo(center)
          map.setCenter(center);
          maps.event.trigger(map, 'recenter');
        }
      }
    }, {
      key: 'restyleMap',
      value: function restyleMap() {
        if (this.map) {
          var google = this.props.google;

          google.maps.event.trigger(this.map, 'resize');
        }
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var _this6 = this;

        var children = this.props.children;


        if (!children) return;

        return _react2.default.Children.map(children, function (c) {
          if (!c) return;
          return _react2.default.cloneElement(c, {
            map: _this6.map,
            google: _this6.props.google,
            mapCenter: _this6.state.currentLocation
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var style = Object.assign({}, mapStyles.map, this.props.style, {
          display: this.props.visible ? 'inherit' : 'none'
        });

        var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);

        return _react2.default.createElement(
          'div',
          { style: containerStyles, className: this.props.className },
          _react2.default.createElement(
            'div',
            { style: style, ref: this.mapRef },
            'Loading map...'
          ),
          this.renderChildren()
        );
      }
    }]);

    return Map;
  }(_react2.default.Component);

  Map.propTypes = {
    google: _propTypes2.default.object,
    zoom: _propTypes2.default.number,
    centerAroundCurrentLocation: _propTypes2.default.bool,
    center: _propTypes2.default.object,
    initialCenter: _propTypes2.default.object,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    containerStyle: _propTypes2.default.object,
    visible: _propTypes2.default.bool,
    mapType: _propTypes2.default.string,
    maxZoom: _propTypes2.default.number,
    minZoom: _propTypes2.default.number,
    clickableIcons: _propTypes2.default.bool,
    disableDefaultUI: _propTypes2.default.bool,
    zoomControl: _propTypes2.default.bool,
    zoomControlOptions: _propTypes2.default.object,
    mapTypeControl: _propTypes2.default.bool,
    mapTypeControlOptions: _propTypes2.default.bool,
    scaleControl: _propTypes2.default.bool,
    streetViewControl: _propTypes2.default.bool,
    streetViewControlOptions: _propTypes2.default.object,
    panControl: _propTypes2.default.bool,
    rotateControl: _propTypes2.default.bool,
    fullscreenControl: _propTypes2.default.bool,
    scrollwheel: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    draggableCursor: _propTypes2.default.string,
    keyboardShortcuts: _propTypes2.default.bool,
    disableDoubleClickZoom: _propTypes2.default.bool,
    noClear: _propTypes2.default.bool,
    styles: _propTypes2.default.array,
    gestureHandling: _propTypes2.default.string,
    bounds: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
  });

  Map.defaultProps = {
    zoom: 14,
    initialCenter: {
      lat: 37.774929,
      lng: -122.419416
    },
    center: {},
    centerAroundCurrentLocation: false,
    style: {},
    containerStyle: {},
    visible: true
  };

  exports.default = Map;
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppHeader = function (_React$Component) {
    _inherits(AppHeader, _React$Component);

    function AppHeader(props) {
        _classCallCheck(this, AppHeader);

        var _this = _possibleConstructorReturn(this, (AppHeader.__proto__ || Object.getPrototypeOf(AppHeader)).call(this, props));

        _this.handleSearchClick = function (e) {

            e.preventDefault();
            var a = $("#search").hasClass("show");
            if (a) {
                $("#search").removeClass("show");
            } else {
                $("#search").addClass("show");
                $("#search .form-control").focus();
            }
        };

        _this.state = {
            AppHeaderClass: props.AppHeaderClass,
            AppHeaderLeft: props.AppHeaderLeft,
            AppHeaderLeftLink: props.AppHeaderLeftLink,
            AppHeaderTitle: props.AppHeaderTitle,
            AppHeaderRight: props.AppHeaderRight,
            AppHeaderRightLink: props.AppHeaderRightLink,
            AppHeaderSearch: props.AppHeaderSearch || '',
            redirect: false,
            search_text: ''
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(AppHeader, [{
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
            this.setState({ redirect: true });
            this.setState({ search_text: event.target.elements.search.value });

            event.target.elements.search.value = '';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //console.log(this.state);

            if (this.state.redirect) {
                this.setState({ redirect: false });
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/search/' + this.state.search_text });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: this.state.AppHeaderClass },
                    _react2.default.createElement(
                        'div',
                        { className: 'left' },
                        this.state.AppHeaderLeft == 'showLINK' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: this.state.AppHeaderLeftLink, className: 'headerButton goBack pl-0' },
                            _react2.default.createElement('ion-icon', { name: 'chevron-back-outline' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'pageTitle' },
                        this.state.AppHeaderSearch != '' && _react2.default.createElement(
                            'div',
                            { 'class': 'chip chip-outline search-chip' },
                            _react2.default.createElement(
                                'span',
                                { 'class': 'chip-label' },
                                ' ',
                                this.state.AppHeaderSearch,
                                ' '
                            ),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '/categories', 'class': 'chip-delete' },
                                _react2.default.createElement('ion-icon', { name: 'close-circle', role: 'img', 'class': 'md hydrated', 'aria-label': 'close circle' })
                            )
                        ),
                        this.state.AppHeaderSearch == '' && this.state.AppHeaderTitle
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'right' },
                        this.state.AppHeaderRightLink == 'SEARCH' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '#', onClick: function onClick(e) {
                                    _this2.handleSearchClick(e);
                                }, className: 'headerButton toggle-searchbox' },
                            ' ',
                            _react2.default.createElement('ion-icon', { name: 'search-outline' }),
                            ' '
                        ),
                        this.state.AppHeaderRightLink != 'SEARCH' && this.state.AppHeaderRightLink != '' && _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: this.state.AppHeaderRightLink, className: 'headerButton text-secondary' },
                            ' ',
                            this.state.AppHeaderRight,
                            ' '
                        ),
                        this.state.AppHeaderRightLink == '' && this.state.AppHeaderRight
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'search', className: 'appHeader' },
                    _react2.default.createElement(
                        'form',
                        { className: 'search-form', ref: function ref(el) {
                                return _this2.form = el;
                            }, onSubmit: this.handleSubmit },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group searchbox' },
                            _react2.default.createElement('input', { type: 'search', className: 'form-control', name: 'search', placeholder: 'Search...', minLength: '3' }),
                            _react2.default.createElement(
                                'i',
                                { className: 'input-icon' },
                                _react2.default.createElement('ion-icon', { name: 'search-outline' })
                            ),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '#', className: 'ml-1 close toggle-searchbox', onClick: function onClick(e) {
                                        _this2.handleSearchClick(e);
                                    } },
                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AppHeader;
}(_react2.default.Component);

exports.default = AppHeader;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(79);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(55),
    getRawTag = __webpack_require__(321),
    objectToString = __webpack_require__(322);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(140);
var enumBugKeys = __webpack_require__(87);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(92),
    createWrap = __webpack_require__(326),
    getHolder = __webpack_require__(97),
    replaceHolders = __webpack_require__(58);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(45),
    isObject = __webpack_require__(29);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(94),
    isObject = __webpack_require__(29);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(372),
    baseKeys = __webpack_require__(379),
    isArrayLike = __webpack_require__(61);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(54),
    isLength = __webpack_require__(98);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(386),
    listCacheDelete = __webpack_require__(387),
    listCacheGet = __webpack_require__(388),
    listCacheHas = __webpack_require__(389),
    listCacheSet = __webpack_require__(390);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(64);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(404);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(59);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(69);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBrowserHistory */
/* unused harmony export createHashHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(109);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"](location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __WEBPACK_IMPORTED_MODULE_2_value_equal__["default"](a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"](false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"](false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? module.exports = factory(__webpack_require__(214)) :
    typeof define === 'function' && define.amd ? define(['react'], factory) :
    (global.ReactOwlCarousel = factory(global.React));
}(this, (function (React) { 'use strict';

    var React__default = 'default' in React ? React['default'] : React;

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    }

    /**
     * Owl Carousel v2.3.4
     * Copyright 2013-2018 David Deutsch
     * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
     */
    (function($, window, document, undefined) {

    	/**
    	 * Creates a carousel.
    	 * @class The Owl Carousel.
    	 * @public
    	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
    	 * @param {Object} [options] - The options
    	 */
    	function Owl(element, options) {

    		/**
    		 * Current settings for the carousel.
    		 * @public
    		 */
    		this.settings = null;

    		/**
    		 * Current options set by the caller including defaults.
    		 * @public
    		 */
    		this.options = $.extend({}, Owl.Defaults, options);

    		/**
    		 * Plugin element.
    		 * @public
    		 */
    		this.$element = $(element);

    		/**
    		 * Proxied event handlers.
    		 * @protected
    		 */
    		this._handlers = {};

    		/**
    		 * References to the running plugins of this carousel.
    		 * @protected
    		 */
    		this._plugins = {};

    		/**
    		 * Currently suppressed events to prevent them from being retriggered.
    		 * @protected
    		 */
    		this._supress = {};

    		/**
    		 * Absolute current position.
    		 * @protected
    		 */
    		this._current = null;

    		/**
    		 * Animation speed in milliseconds.
    		 * @protected
    		 */
    		this._speed = null;

    		/**
    		 * Coordinates of all items in pixel.
    		 * @todo The name of this member is missleading.
    		 * @protected
    		 */
    		this._coordinates = [];

    		/**
    		 * Current breakpoint.
    		 * @todo Real media queries would be nice.
    		 * @protected
    		 */
    		this._breakpoint = null;

    		/**
    		 * Current width of the plugin element.
    		 */
    		this._width = null;

    		/**
    		 * All real items.
    		 * @protected
    		 */
    		this._items = [];

    		/**
    		 * All cloned items.
    		 * @protected
    		 */
    		this._clones = [];

    		/**
    		 * Merge values of all items.
    		 * @todo Maybe this could be part of a plugin.
    		 * @protected
    		 */
    		this._mergers = [];

    		/**
    		 * Widths of all items.
    		 */
    		this._widths = [];

    		/**
    		 * Invalidated parts within the update process.
    		 * @protected
    		 */
    		this._invalidated = {};

    		/**
    		 * Ordered list of workers for the update process.
    		 * @protected
    		 */
    		this._pipe = [];

    		/**
    		 * Current state information for the drag operation.
    		 * @todo #261
    		 * @protected
    		 */
    		this._drag = {
    			time: null,
    			target: null,
    			pointer: null,
    			stage: {
    				start: null,
    				current: null
    			},
    			direction: null
    		};

    		/**
    		 * Current state information and their tags.
    		 * @type {Object}
    		 * @protected
    		 */
    		this._states = {
    			current: {},
    			tags: {
    				'initializing': [ 'busy' ],
    				'animating': [ 'busy' ],
    				'dragging': [ 'interacting' ]
    			}
    		};

    		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
    			this._handlers[handler] = $.proxy(this[handler], this);
    		}, this));

    		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
    			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
    				= new plugin(this);
    		}, this));

    		$.each(Owl.Workers, $.proxy(function(priority, worker) {
    			this._pipe.push({
    				'filter': worker.filter,
    				'run': $.proxy(worker.run, this)
    			});
    		}, this));

    		this.setup();
    		this.initialize();
    	}

    	/**
    	 * Default options for the carousel.
    	 * @public
    	 */
    	Owl.Defaults = {
    		items: 3,
    		loop: false,
    		center: false,
    		rewind: false,
    		checkVisibility: true,

    		mouseDrag: true,
    		touchDrag: true,
    		pullDrag: true,
    		freeDrag: false,

    		margin: 0,
    		stagePadding: 0,

    		merge: false,
    		mergeFit: true,
    		autoWidth: false,

    		startPosition: 0,
    		rtl: false,

    		smartSpeed: 250,
    		fluidSpeed: false,
    		dragEndSpeed: false,

    		responsive: {},
    		responsiveRefreshRate: 200,
    		responsiveBaseElement: window,

    		fallbackEasing: 'swing',
    		slideTransition: '',

    		info: false,

    		nestedItemSelector: false,
    		itemElement: 'div',
    		stageElement: 'div',

    		refreshClass: 'owl-refresh',
    		loadedClass: 'owl-loaded',
    		loadingClass: 'owl-loading',
    		rtlClass: 'owl-rtl',
    		responsiveClass: 'owl-responsive',
    		dragClass: 'owl-drag',
    		itemClass: 'owl-item',
    		stageClass: 'owl-stage',
    		stageOuterClass: 'owl-stage-outer',
    		grabClass: 'owl-grab'
    	};

    	/**
    	 * Enumeration for width.
    	 * @public
    	 * @readonly
    	 * @enum {String}
    	 */
    	Owl.Width = {
    		Default: 'default',
    		Inner: 'inner',
    		Outer: 'outer'
    	};

    	/**
    	 * Enumeration for types.
    	 * @public
    	 * @readonly
    	 * @enum {String}
    	 */
    	Owl.Type = {
    		Event: 'event',
    		State: 'state'
    	};

    	/**
    	 * Contains all registered plugins.
    	 * @public
    	 */
    	Owl.Plugins = {};

    	/**
    	 * List of workers involved in the update process.
    	 */
    	Owl.Workers = [ {
    		filter: [ 'width', 'settings' ],
    		run: function() {
    			this._width = this.$element.width();
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function(cache) {
    			cache.current = this._items && this._items[this.relative(this._current)];
    		}
    	}, {
    		filter: [ 'items', 'settings' ],
    		run: function() {
    			this.$stage.children('.cloned').remove();
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function(cache) {
    			var margin = this.settings.margin || '',
    				grid = !this.settings.autoWidth,
    				rtl = this.settings.rtl,
    				css = {
    					'width': 'auto',
    					'margin-left': rtl ? margin : '',
    					'margin-right': rtl ? '' : margin
    				};

    			!grid && this.$stage.children().css(css);

    			cache.css = css;
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function(cache) {
    			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
    				merge = null,
    				iterator = this._items.length,
    				grid = !this.settings.autoWidth,
    				widths = [];

    			cache.items = {
    				merge: false,
    				width: width
    			};

    			while (iterator--) {
    				merge = this._mergers[iterator];
    				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

    				cache.items.merge = merge > 1 || cache.items.merge;

    				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
    			}

    			this._widths = widths;
    		}
    	}, {
    		filter: [ 'items', 'settings' ],
    		run: function() {
    			var clones = [],
    				items = this._items,
    				settings = this.settings,
    				// TODO: Should be computed from number of min width items in stage
    				view = Math.max(settings.items * 2, 4),
    				size = Math.ceil(items.length / 2) * 2,
    				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
    				append = '',
    				prepend = '';

    			repeat /= 2;

    			while (repeat > 0) {
    				// Switch to only using appended clones
    				clones.push(this.normalize(clones.length / 2, true));
    				append = append + items[clones[clones.length - 1]][0].outerHTML;
    				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
    				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
    				repeat -= 1;
    			}

    			this._clones = clones;

    			$(append).addClass('cloned').appendTo(this.$stage);
    			$(prepend).addClass('cloned').prependTo(this.$stage);
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function() {
    			var rtl = this.settings.rtl ? 1 : -1,
    				size = this._clones.length + this._items.length,
    				iterator = -1,
    				previous = 0,
    				current = 0,
    				coordinates = [];

    			while (++iterator < size) {
    				previous = coordinates[iterator - 1] || 0;
    				current = this._widths[this.relative(iterator)] + this.settings.margin;
    				coordinates.push(previous + current * rtl);
    			}

    			this._coordinates = coordinates;
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function() {
    			var padding = this.settings.stagePadding,
    				coordinates = this._coordinates,
    				css = {
    					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
    					'padding-left': padding || '',
    					'padding-right': padding || ''
    				};

    			this.$stage.css(css);
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function(cache) {
    			var iterator = this._coordinates.length,
    				grid = !this.settings.autoWidth,
    				items = this.$stage.children();

    			if (grid && cache.items.merge) {
    				while (iterator--) {
    					cache.css.width = this._widths[this.relative(iterator)];
    					items.eq(iterator).css(cache.css);
    				}
    			} else if (grid) {
    				cache.css.width = cache.items.width;
    				items.css(cache.css);
    			}
    		}
    	}, {
    		filter: [ 'items' ],
    		run: function() {
    			this._coordinates.length < 1 && this.$stage.removeAttr('style');
    		}
    	}, {
    		filter: [ 'width', 'items', 'settings' ],
    		run: function(cache) {
    			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
    			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
    			this.reset(cache.current);
    		}
    	}, {
    		filter: [ 'position' ],
    		run: function() {
    			this.animate(this.coordinates(this._current));
    		}
    	}, {
    		filter: [ 'width', 'position', 'items', 'settings' ],
    		run: function() {
    			var rtl = this.settings.rtl ? 1 : -1,
    				padding = this.settings.stagePadding * 2,
    				begin = this.coordinates(this.current()) + padding,
    				end = begin + this.width() * rtl,
    				inner, outer, matches = [], i, n;

    			for (i = 0, n = this._coordinates.length; i < n; i++) {
    				inner = this._coordinates[i - 1] || 0;
    				outer = Math.abs(this._coordinates[i]) + padding * rtl;

    				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
    					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
    					matches.push(i);
    				}
    			}

    			this.$stage.children('.active').removeClass('active');
    			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

    			this.$stage.children('.center').removeClass('center');
    			if (this.settings.center) {
    				this.$stage.children().eq(this.current()).addClass('center');
    			}
    		}
    	} ];

    	/**
    	 * Create the stage DOM element
    	 */
    	Owl.prototype.initializeStage = function() {
    		this.$stage = this.$element.find('.' + this.settings.stageClass);

    		// if the stage is already in the DOM, grab it and skip stage initialization
    		if (this.$stage.length) {
    			return;
    		}

    		this.$element.addClass(this.options.loadingClass);

    		// create stage
    		this.$stage = $('<' + this.settings.stageElement + '>', {
    			"class": this.settings.stageClass
    		}).wrap( $( '<div/>', {
    			"class": this.settings.stageOuterClass
    		}));

    		// append stage
    		this.$element.append(this.$stage.parent());
    	};

    	/**
    	 * Create item DOM elements
    	 */
    	Owl.prototype.initializeItems = function() {
    		var $items = this.$element.find('.owl-item');

    		// if the items are already in the DOM, grab them and skip item initialization
    		if ($items.length) {
    			this._items = $items.get().map(function(item) {
    				return $(item);
    			});

    			this._mergers = this._items.map(function() {
    				return 1;
    			});

    			this.refresh();

    			return;
    		}

    		// append content
    		this.replace(this.$element.children().not(this.$stage.parent()));

    		// check visibility
    		if (this.isVisible()) {
    			// update view
    			this.refresh();
    		} else {
    			// invalidate width
    			this.invalidate('width');
    		}

    		this.$element
    			.removeClass(this.options.loadingClass)
    			.addClass(this.options.loadedClass);
    	};

    	/**
    	 * Initializes the carousel.
    	 * @protected
    	 */
    	Owl.prototype.initialize = function() {
    		this.enter('initializing');
    		this.trigger('initialize');

    		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

    		if (this.settings.autoWidth && !this.is('pre-loading')) {
    			var imgs, nestedSelector, width;
    			imgs = this.$element.find('img');
    			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
    			width = this.$element.children(nestedSelector).width();

    			if (imgs.length && width <= 0) {
    				this.preloadAutoWidthImages(imgs);
    			}
    		}

    		this.initializeStage();
    		this.initializeItems();

    		// register event handlers
    		this.registerEventHandlers();

    		this.leave('initializing');
    		this.trigger('initialized');
    	};

    	/**
    	 * @returns {Boolean} visibility of $element
    	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
    	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
    	 */
    	Owl.prototype.isVisible = function() {
    		return this.settings.checkVisibility
    			? this.$element.is(':visible')
    			: true;
    	};

    	/**
    	 * Setups the current settings.
    	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
    	 * @todo Support for media queries by using `matchMedia` would be nice.
    	 * @public
    	 */
    	Owl.prototype.setup = function() {
    		var viewport = this.viewport(),
    			overwrites = this.options.responsive,
    			match = -1,
    			settings = null;

    		if (!overwrites) {
    			settings = $.extend({}, this.options);
    		} else {
    			$.each(overwrites, function(breakpoint) {
    				if (breakpoint <= viewport && breakpoint > match) {
    					match = Number(breakpoint);
    				}
    			});

    			settings = $.extend({}, this.options, overwrites[match]);
    			if (typeof settings.stagePadding === 'function') {
    				settings.stagePadding = settings.stagePadding();
    			}
    			delete settings.responsive;

    			// responsive class
    			if (settings.responsiveClass) {
    				this.$element.attr('class',
    					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
    				);
    			}
    		}

    		this.trigger('change', { property: { name: 'settings', value: settings } });
    		this._breakpoint = match;
    		this.settings = settings;
    		this.invalidate('settings');
    		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
    	};

    	/**
    	 * Updates option logic if necessery.
    	 * @protected
    	 */
    	Owl.prototype.optionsLogic = function() {
    		if (this.settings.autoWidth) {
    			this.settings.stagePadding = false;
    			this.settings.merge = false;
    		}
    	};

    	/**
    	 * Prepares an item before add.
    	 * @todo Rename event parameter `content` to `item`.
    	 * @protected
    	 * @returns {jQuery|HTMLElement} - The item container.
    	 */
    	Owl.prototype.prepare = function(item) {
    		var event = this.trigger('prepare', { content: item });

    		if (!event.data) {
    			event.data = $('<' + this.settings.itemElement + '/>')
    				.addClass(this.options.itemClass).append(item);
    		}

    		this.trigger('prepared', { content: event.data });

    		return event.data;
    	};

    	/**
    	 * Updates the view.
    	 * @public
    	 */
    	Owl.prototype.update = function() {
    		var i = 0,
    			n = this._pipe.length,
    			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
    			cache = {};

    		while (i < n) {
    			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
    				this._pipe[i].run(cache);
    			}
    			i++;
    		}

    		this._invalidated = {};

    		!this.is('valid') && this.enter('valid');
    	};

    	/**
    	 * Gets the width of the view.
    	 * @public
    	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
    	 * @returns {Number} - The width of the view in pixel.
    	 */
    	Owl.prototype.width = function(dimension) {
    		dimension = dimension || Owl.Width.Default;
    		switch (dimension) {
    			case Owl.Width.Inner:
    			case Owl.Width.Outer:
    				return this._width;
    			default:
    				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
    		}
    	};

    	/**
    	 * Refreshes the carousel primarily for adaptive purposes.
    	 * @public
    	 */
    	Owl.prototype.refresh = function() {
    		this.enter('refreshing');
    		this.trigger('refresh');

    		this.setup();

    		this.optionsLogic();

    		this.$element.addClass(this.options.refreshClass);

    		this.update();

    		this.$element.removeClass(this.options.refreshClass);

    		this.leave('refreshing');
    		this.trigger('refreshed');
    	};

    	/**
    	 * Checks window `resize` event.
    	 * @protected
    	 */
    	Owl.prototype.onThrottledResize = function() {
    		window.clearTimeout(this.resizeTimer);
    		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
    	};

    	/**
    	 * Checks window `resize` event.
    	 * @protected
    	 */
    	Owl.prototype.onResize = function() {
    		if (!this._items.length) {
    			return false;
    		}

    		if (this._width === this.$element.width()) {
    			return false;
    		}

    		if (!this.isVisible()) {
    			return false;
    		}

    		this.enter('resizing');

    		if (this.trigger('resize').isDefaultPrevented()) {
    			this.leave('resizing');
    			return false;
    		}

    		this.invalidate('width');

    		this.refresh();

    		this.leave('resizing');
    		this.trigger('resized');
    	};

    	/**
    	 * Registers event handlers.
    	 * @todo Check `msPointerEnabled`
    	 * @todo #261
    	 * @protected
    	 */
    	Owl.prototype.registerEventHandlers = function() {
    		if ($.support.transition) {
    			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
    		}

    		if (this.settings.responsive !== false) {
    			this.on(window, 'resize', this._handlers.onThrottledResize);
    		}

    		if (this.settings.mouseDrag) {
    			this.$element.addClass(this.options.dragClass);
    			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
    			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
    		}

    		if (this.settings.touchDrag){
    			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
    			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
    		}
    	};

    	/**
    	 * Handles `touchstart` and `mousedown` events.
    	 * @todo Horizontal swipe threshold as option
    	 * @todo #261
    	 * @protected
    	 * @param {Event} event - The event arguments.
    	 */
    	Owl.prototype.onDragStart = function(event) {
    		var stage = null;

    		if (event.which === 3) {
    			return;
    		}

    		if ($.support.transform) {
    			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
    			stage = {
    				x: stage[stage.length === 16 ? 12 : 4],
    				y: stage[stage.length === 16 ? 13 : 5]
    			};
    		} else {
    			stage = this.$stage.position();
    			stage = {
    				x: this.settings.rtl ?
    					stage.left + this.$stage.width() - this.width() + this.settings.margin :
    					stage.left,
    				y: stage.top
    			};
    		}

    		if (this.is('animating')) {
    			$.support.transform ? this.animate(stage.x) : this.$stage.stop();
    			this.invalidate('position');
    		}

    		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

    		this.speed(0);

    		this._drag.time = new Date().getTime();
    		this._drag.target = $(event.target);
    		this._drag.stage.start = stage;
    		this._drag.stage.current = stage;
    		this._drag.pointer = this.pointer(event);

    		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

    		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
    			var delta = this.difference(this._drag.pointer, this.pointer(event));

    			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

    			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
    				return;
    			}

    			event.preventDefault();

    			this.enter('dragging');
    			this.trigger('drag');
    		}, this));
    	};

    	/**
    	 * Handles the `touchmove` and `mousemove` events.
    	 * @todo #261
    	 * @protected
    	 * @param {Event} event - The event arguments.
    	 */
    	Owl.prototype.onDragMove = function(event) {
    		var minimum = null,
    			maximum = null,
    			pull = null,
    			delta = this.difference(this._drag.pointer, this.pointer(event)),
    			stage = this.difference(this._drag.stage.start, delta);

    		if (!this.is('dragging')) {
    			return;
    		}

    		event.preventDefault();

    		if (this.settings.loop) {
    			minimum = this.coordinates(this.minimum());
    			maximum = this.coordinates(this.maximum() + 1) - minimum;
    			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
    		} else {
    			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
    			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
    			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
    			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
    		}

    		this._drag.stage.current = stage;

    		this.animate(stage.x);
    	};

    	/**
    	 * Handles the `touchend` and `mouseup` events.
    	 * @todo #261
    	 * @todo Threshold for click event
    	 * @protected
    	 * @param {Event} event - The event arguments.
    	 */
    	Owl.prototype.onDragEnd = function(event) {
    		var delta = this.difference(this._drag.pointer, this.pointer(event)),
    			stage = this._drag.stage.current,
    			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

    		$(document).off('.owl.core');

    		this.$element.removeClass(this.options.grabClass);

    		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
    			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
    			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
    			this.invalidate('position');
    			this.update();

    			this._drag.direction = direction;

    			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
    				this._drag.target.one('click.owl.core', function() { return false; });
    			}
    		}

    		if (!this.is('dragging')) {
    			return;
    		}

    		this.leave('dragging');
    		this.trigger('dragged');
    	};

    	/**
    	 * Gets absolute position of the closest item for a coordinate.
    	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
    	 * @protected
    	 * @param {Number} coordinate - The coordinate in pixel.
    	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
    	 * @return {Number} - The absolute position of the closest item.
    	 */
    	Owl.prototype.closest = function(coordinate, direction) {
    		var position = -1,
    			pull = 30,
    			width = this.width(),
    			coordinates = this.coordinates();

    		if (!this.settings.freeDrag) {
    			// check closest item
    			$.each(coordinates, $.proxy(function(index, value) {
    				// on a left pull, check on current index
    				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
    					position = index;
    				// on a right pull, check on previous index
    				// to do so, subtract width from value and set position = index + 1
    				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
    					position = index + 1;
    				} else if (this.op(coordinate, '<', value)
    					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
    					position = direction === 'left' ? index + 1 : index;
    				}
    				return position === -1;
    			}, this));
    		}

    		if (!this.settings.loop) {
    			// non loop boundries
    			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
    				position = coordinate = this.minimum();
    			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
    				position = coordinate = this.maximum();
    			}
    		}

    		return position;
    	};

    	/**
    	 * Animates the stage.
    	 * @todo #270
    	 * @public
    	 * @param {Number} coordinate - The coordinate in pixels.
    	 */
    	Owl.prototype.animate = function(coordinate) {
    		var animate = this.speed() > 0;

    		this.is('animating') && this.onTransitionEnd();

    		if (animate) {
    			this.enter('animating');
    			this.trigger('translate');
    		}

    		if ($.support.transform3d && $.support.transition) {
    			this.$stage.css({
    				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
    				transition: (this.speed() / 1000) + 's' + (
    					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
    				)
    			});
    		} else if (animate) {
    			this.$stage.animate({
    				left: coordinate + 'px'
    			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
    		} else {
    			this.$stage.css({
    				left: coordinate + 'px'
    			});
    		}
    	};

    	/**
    	 * Checks whether the carousel is in a specific state or not.
    	 * @param {String} state - The state to check.
    	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
    	 */
    	Owl.prototype.is = function(state) {
    		return this._states.current[state] && this._states.current[state] > 0;
    	};

    	/**
    	 * Sets the absolute position of the current item.
    	 * @public
    	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
    	 * @returns {Number} - The absolute position of the current item.
    	 */
    	Owl.prototype.current = function(position) {
    		if (position === undefined) {
    			return this._current;
    		}

    		if (this._items.length === 0) {
    			return undefined;
    		}

    		position = this.normalize(position);

    		if (this._current !== position) {
    			var event = this.trigger('change', { property: { name: 'position', value: position } });

    			if (event.data !== undefined) {
    				position = this.normalize(event.data);
    			}

    			this._current = position;

    			this.invalidate('position');

    			this.trigger('changed', { property: { name: 'position', value: this._current } });
    		}

    		return this._current;
    	};

    	/**
    	 * Invalidates the given part of the update routine.
    	 * @param {String} [part] - The part to invalidate.
    	 * @returns {Array.<String>} - The invalidated parts.
    	 */
    	Owl.prototype.invalidate = function(part) {
    		if ($.type(part) === 'string') {
    			this._invalidated[part] = true;
    			this.is('valid') && this.leave('valid');
    		}
    		return $.map(this._invalidated, function(v, i) { return i });
    	};

    	/**
    	 * Resets the absolute position of the current item.
    	 * @public
    	 * @param {Number} position - The absolute position of the new item.
    	 */
    	Owl.prototype.reset = function(position) {
    		position = this.normalize(position);

    		if (position === undefined) {
    			return;
    		}

    		this._speed = 0;
    		this._current = position;

    		this.suppress([ 'translate', 'translated' ]);

    		this.animate(this.coordinates(position));

    		this.release([ 'translate', 'translated' ]);
    	};

    	/**
    	 * Normalizes an absolute or a relative position of an item.
    	 * @public
    	 * @param {Number} position - The absolute or relative position to normalize.
    	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
    	 * @returns {Number} - The normalized position.
    	 */
    	Owl.prototype.normalize = function(position, relative) {
    		var n = this._items.length,
    			m = relative ? 0 : this._clones.length;

    		if (!this.isNumeric(position) || n < 1) {
    			position = undefined;
    		} else if (position < 0 || position >= n + m) {
    			position = ((position - m / 2) % n + n) % n + m / 2;
    		}

    		return position;
    	};

    	/**
    	 * Converts an absolute position of an item into a relative one.
    	 * @public
    	 * @param {Number} position - The absolute position to convert.
    	 * @returns {Number} - The converted position.
    	 */
    	Owl.prototype.relative = function(position) {
    		position -= this._clones.length / 2;
    		return this.normalize(position, true);
    	};

    	/**
    	 * Gets the maximum position for the current item.
    	 * @public
    	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
    	 * @returns {Number}
    	 */
    	Owl.prototype.maximum = function(relative) {
    		var settings = this.settings,
    			maximum = this._coordinates.length,
    			iterator,
    			reciprocalItemsWidth,
    			elementWidth;

    		if (settings.loop) {
    			maximum = this._clones.length / 2 + this._items.length - 1;
    		} else if (settings.autoWidth || settings.merge) {
    			iterator = this._items.length;
    			if (iterator) {
    				reciprocalItemsWidth = this._items[--iterator].width();
    				elementWidth = this.$element.width();
    				while (iterator--) {
    					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
    					if (reciprocalItemsWidth > elementWidth) {
    						break;
    					}
    				}
    			}
    			maximum = iterator + 1;
    		} else if (settings.center) {
    			maximum = this._items.length - 1;
    		} else {
    			maximum = this._items.length - settings.items;
    		}

    		if (relative) {
    			maximum -= this._clones.length / 2;
    		}

    		return Math.max(maximum, 0);
    	};

    	/**
    	 * Gets the minimum position for the current item.
    	 * @public
    	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
    	 * @returns {Number}
    	 */
    	Owl.prototype.minimum = function(relative) {
    		return relative ? 0 : this._clones.length / 2;
    	};

    	/**
    	 * Gets an item at the specified relative position.
    	 * @public
    	 * @param {Number} [position] - The relative position of the item.
    	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
    	 */
    	Owl.prototype.items = function(position) {
    		if (position === undefined) {
    			return this._items.slice();
    		}

    		position = this.normalize(position, true);
    		return this._items[position];
    	};

    	/**
    	 * Gets an item at the specified relative position.
    	 * @public
    	 * @param {Number} [position] - The relative position of the item.
    	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
    	 */
    	Owl.prototype.mergers = function(position) {
    		if (position === undefined) {
    			return this._mergers.slice();
    		}

    		position = this.normalize(position, true);
    		return this._mergers[position];
    	};

    	/**
    	 * Gets the absolute positions of clones for an item.
    	 * @public
    	 * @param {Number} [position] - The relative position of the item.
    	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
    	 */
    	Owl.prototype.clones = function(position) {
    		var odd = this._clones.length / 2,
    			even = odd + this._items.length,
    			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

    		if (position === undefined) {
    			return $.map(this._clones, function(v, i) { return map(i) });
    		}

    		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
    	};

    	/**
    	 * Sets the current animation speed.
    	 * @public
    	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
    	 * @returns {Number} - The current animation speed in milliseconds.
    	 */
    	Owl.prototype.speed = function(speed) {
    		if (speed !== undefined) {
    			this._speed = speed;
    		}

    		return this._speed;
    	};

    	/**
    	 * Gets the coordinate of an item.
    	 * @todo The name of this method is missleanding.
    	 * @public
    	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
    	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
    	 */
    	Owl.prototype.coordinates = function(position) {
    		var multiplier = 1,
    			newPosition = position - 1,
    			coordinate;

    		if (position === undefined) {
    			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
    				return this.coordinates(index);
    			}, this));
    		}

    		if (this.settings.center) {
    			if (this.settings.rtl) {
    				multiplier = -1;
    				newPosition = position + 1;
    			}

    			coordinate = this._coordinates[position];
    			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
    		} else {
    			coordinate = this._coordinates[newPosition] || 0;
    		}

    		coordinate = Math.ceil(coordinate);

    		return coordinate;
    	};

    	/**
    	 * Calculates the speed for a translation.
    	 * @protected
    	 * @param {Number} from - The absolute position of the start item.
    	 * @param {Number} to - The absolute position of the target item.
    	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
    	 * @returns {Number} - The time in milliseconds for the translation.
    	 */
    	Owl.prototype.duration = function(from, to, factor) {
    		if (factor === 0) {
    			return 0;
    		}

    		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
    	};

    	/**
    	 * Slides to the specified item.
    	 * @public
    	 * @param {Number} position - The position of the item.
    	 * @param {Number} [speed] - The time in milliseconds for the transition.
    	 */
    	Owl.prototype.to = function(position, speed) {
    		var current = this.current(),
    			revert = null,
    			distance = position - this.relative(current),
    			direction = (distance > 0) - (distance < 0),
    			items = this._items.length,
    			minimum = this.minimum(),
    			maximum = this.maximum();

    		if (this.settings.loop) {
    			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
    				distance += direction * -1 * items;
    			}

    			position = current + distance;
    			revert = ((position - minimum) % items + items) % items + minimum;

    			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
    				current = revert - distance;
    				position = revert;
    				this.reset(current);
    			}
    		} else if (this.settings.rewind) {
    			maximum += 1;
    			position = (position % maximum + maximum) % maximum;
    		} else {
    			position = Math.max(minimum, Math.min(maximum, position));
    		}

    		this.speed(this.duration(current, position, speed));
    		this.current(position);

    		if (this.isVisible()) {
    			this.update();
    		}
    	};

    	/**
    	 * Slides to the next item.
    	 * @public
    	 * @param {Number} [speed] - The time in milliseconds for the transition.
    	 */
    	Owl.prototype.next = function(speed) {
    		speed = speed || false;
    		this.to(this.relative(this.current()) + 1, speed);
    	};

    	/**
    	 * Slides to the previous item.
    	 * @public
    	 * @param {Number} [speed] - The time in milliseconds for the transition.
    	 */
    	Owl.prototype.prev = function(speed) {
    		speed = speed || false;
    		this.to(this.relative(this.current()) - 1, speed);
    	};

    	/**
    	 * Handles the end of an animation.
    	 * @protected
    	 * @param {Event} event - The event arguments.
    	 */
    	Owl.prototype.onTransitionEnd = function(event) {

    		// if css2 animation then event object is undefined
    		if (event !== undefined) {
    			event.stopPropagation();

    			// Catch only owl-stage transitionEnd event
    			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
    				return false;
    			}
    		}

    		this.leave('animating');
    		this.trigger('translated');
    	};

    	/**
    	 * Gets viewport width.
    	 * @protected
    	 * @return {Number} - The width in pixel.
    	 */
    	Owl.prototype.viewport = function() {
    		var width;
    		if (this.options.responsiveBaseElement !== window) {
    			width = $(this.options.responsiveBaseElement).width();
    		} else if (window.innerWidth) {
    			width = window.innerWidth;
    		} else if (document.documentElement && document.documentElement.clientWidth) {
    			width = document.documentElement.clientWidth;
    		} else {
    			console.warn('Can not detect viewport width.');
    		}
    		return width;
    	};

    	/**
    	 * Replaces the current content.
    	 * @public
    	 * @param {HTMLElement|jQuery|String} content - The new content.
    	 */
    	Owl.prototype.replace = function(content) {
    		this.$stage.empty();
    		this._items = [];

    		if (content) {
    			content = (content instanceof jQuery) ? content : $(content);
    		}

    		if (this.settings.nestedItemSelector) {
    			content = content.find('.' + this.settings.nestedItemSelector);
    		}

    		content.filter(function() {
    			return this.nodeType === 1;
    		}).each($.proxy(function(index, item) {
    			item = this.prepare(item);
    			this.$stage.append(item);
    			this._items.push(item);
    			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
    		}, this));

    		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

    		this.invalidate('items');
    	};

    	/**
    	 * Adds an item.
    	 * @todo Use `item` instead of `content` for the event arguments.
    	 * @public
    	 * @param {HTMLElement|jQuery|String} content - The item content to add.
    	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
    	 */
    	Owl.prototype.add = function(content, position) {
    		var current = this.relative(this._current);

    		position = position === undefined ? this._items.length : this.normalize(position, true);
    		content = content instanceof jQuery ? content : $(content);

    		this.trigger('add', { content: content, position: position });

    		content = this.prepare(content);

    		if (this._items.length === 0 || position === this._items.length) {
    			this._items.length === 0 && this.$stage.append(content);
    			this._items.length !== 0 && this._items[position - 1].after(content);
    			this._items.push(content);
    			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
    		} else {
    			this._items[position].before(content);
    			this._items.splice(position, 0, content);
    			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
    		}

    		this._items[current] && this.reset(this._items[current].index());

    		this.invalidate('items');

    		this.trigger('added', { content: content, position: position });
    	};

    	/**
    	 * Removes an item by its position.
    	 * @todo Use `item` instead of `content` for the event arguments.
    	 * @public
    	 * @param {Number} position - The relative position of the item to remove.
    	 */
    	Owl.prototype.remove = function(position) {
    		position = this.normalize(position, true);

    		if (position === undefined) {
    			return;
    		}

    		this.trigger('remove', { content: this._items[position], position: position });

    		this._items[position].remove();
    		this._items.splice(position, 1);
    		this._mergers.splice(position, 1);

    		this.invalidate('items');

    		this.trigger('removed', { content: null, position: position });
    	};

    	/**
    	 * Preloads images with auto width.
    	 * @todo Replace by a more generic approach
    	 * @protected
    	 */
    	Owl.prototype.preloadAutoWidthImages = function(images) {
    		images.each($.proxy(function(i, element) {
    			this.enter('pre-loading');
    			element = $(element);
    			$(new Image()).one('load', $.proxy(function(e) {
    				element.attr('src', e.target.src);
    				element.css('opacity', 1);
    				this.leave('pre-loading');
    				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
    			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
    		}, this));
    	};

    	/**
    	 * Destroys the carousel.
    	 * @public
    	 */
    	Owl.prototype.destroy = function() {

    		this.$element.off('.owl.core');
    		this.$stage.off('.owl.core');
    		$(document).off('.owl.core');

    		if (this.settings.responsive !== false) {
    			window.clearTimeout(this.resizeTimer);
    			this.off(window, 'resize', this._handlers.onThrottledResize);
    		}

    		for (var i in this._plugins) {
    			this._plugins[i].destroy();
    		}

    		this.$stage.children('.cloned').remove();

    		this.$stage.unwrap();
    		this.$stage.children().contents().unwrap();
    		this.$stage.children().unwrap();
    		this.$stage.remove();
    		this.$element
    			.removeClass(this.options.refreshClass)
    			.removeClass(this.options.loadingClass)
    			.removeClass(this.options.loadedClass)
    			.removeClass(this.options.rtlClass)
    			.removeClass(this.options.dragClass)
    			.removeClass(this.options.grabClass)
    			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
    			.removeData('owl.carousel');
    	};

    	/**
    	 * Operators to calculate right-to-left and left-to-right.
    	 * @protected
    	 * @param {Number} [a] - The left side operand.
    	 * @param {String} [o] - The operator.
    	 * @param {Number} [b] - The right side operand.
    	 */
    	Owl.prototype.op = function(a, o, b) {
    		var rtl = this.settings.rtl;
    		switch (o) {
    			case '<':
    				return rtl ? a > b : a < b;
    			case '>':
    				return rtl ? a < b : a > b;
    			case '>=':
    				return rtl ? a <= b : a >= b;
    			case '<=':
    				return rtl ? a >= b : a <= b;
    			default:
    				break;
    		}
    	};

    	/**
    	 * Attaches to an internal event.
    	 * @protected
    	 * @param {HTMLElement} element - The event source.
    	 * @param {String} event - The event name.
    	 * @param {Function} listener - The event handler to attach.
    	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
    	 */
    	Owl.prototype.on = function(element, event, listener, capture) {
    		if (element.addEventListener) {
    			element.addEventListener(event, listener, capture);
    		} else if (element.attachEvent) {
    			element.attachEvent('on' + event, listener);
    		}
    	};

    	/**
    	 * Detaches from an internal event.
    	 * @protected
    	 * @param {HTMLElement} element - The event source.
    	 * @param {String} event - The event name.
    	 * @param {Function} listener - The attached event handler to detach.
    	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
    	 */
    	Owl.prototype.off = function(element, event, listener, capture) {
    		if (element.removeEventListener) {
    			element.removeEventListener(event, listener, capture);
    		} else if (element.detachEvent) {
    			element.detachEvent('on' + event, listener);
    		}
    	};

    	/**
    	 * Triggers a public event.
    	 * @todo Remove `status`, `relatedTarget` should be used instead.
    	 * @protected
    	 * @param {String} name - The event name.
    	 * @param {*} [data=null] - The event data.
    	 * @param {String} [namespace=carousel] - The event namespace.
    	 * @param {String} [state] - The state which is associated with the event.
    	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
    	 * @returns {Event} - The event arguments.
    	 */
    	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
    		var status = {
    			item: { count: this._items.length, index: this.current() }
    		}, handler = $.camelCase(
    			$.grep([ 'on', name, namespace ], function(v) { return v })
    				.join('-').toLowerCase()
    		), event = $.Event(
    			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
    			$.extend({ relatedTarget: this }, status, data)
    		);

    		if (!this._supress[name]) {
    			$.each(this._plugins, function(name, plugin) {
    				if (plugin.onTrigger) {
    					plugin.onTrigger(event);
    				}
    			});

    			this.register({ type: Owl.Type.Event, name: name });
    			this.$element.trigger(event);

    			if (this.settings && typeof this.settings[handler] === 'function') {
    				this.settings[handler].call(this, event);
    			}
    		}

    		return event;
    	};

    	/**
    	 * Enters a state.
    	 * @param name - The state name.
    	 */
    	Owl.prototype.enter = function(name) {
    		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
    			if (this._states.current[name] === undefined) {
    				this._states.current[name] = 0;
    			}

    			this._states.current[name]++;
    		}, this));
    	};

    	/**
    	 * Leaves a state.
    	 * @param name - The state name.
    	 */
    	Owl.prototype.leave = function(name) {
    		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
    			this._states.current[name]--;
    		}, this));
    	};

    	/**
    	 * Registers an event or state.
    	 * @public
    	 * @param {Object} object - The event or state to register.
    	 */
    	Owl.prototype.register = function(object) {
    		if (object.type === Owl.Type.Event) {
    			if (!$.event.special[object.name]) {
    				$.event.special[object.name] = {};
    			}

    			if (!$.event.special[object.name].owl) {
    				var _default = $.event.special[object.name]._default;
    				$.event.special[object.name]._default = function(e) {
    					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
    						return _default.apply(this, arguments);
    					}
    					return e.namespace && e.namespace.indexOf('owl') > -1;
    				};
    				$.event.special[object.name].owl = true;
    			}
    		} else if (object.type === Owl.Type.State) {
    			if (!this._states.tags[object.name]) {
    				this._states.tags[object.name] = object.tags;
    			} else {
    				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
    			}

    			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
    				return $.inArray(tag, this._states.tags[object.name]) === i;
    			}, this));
    		}
    	};

    	/**
    	 * Suppresses events.
    	 * @protected
    	 * @param {Array.<String>} events - The events to suppress.
    	 */
    	Owl.prototype.suppress = function(events) {
    		$.each(events, $.proxy(function(index, event) {
    			this._supress[event] = true;
    		}, this));
    	};

    	/**
    	 * Releases suppressed events.
    	 * @protected
    	 * @param {Array.<String>} events - The events to release.
    	 */
    	Owl.prototype.release = function(events) {
    		$.each(events, $.proxy(function(index, event) {
    			delete this._supress[event];
    		}, this));
    	};

    	/**
    	 * Gets unified pointer coordinates from event.
    	 * @todo #261
    	 * @protected
    	 * @param {Event} - The `mousedown` or `touchstart` event.
    	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
    	 */
    	Owl.prototype.pointer = function(event) {
    		var result = { x: null, y: null };

    		event = event.originalEvent || event || window.event;

    		event = event.touches && event.touches.length ?
    			event.touches[0] : event.changedTouches && event.changedTouches.length ?
    				event.changedTouches[0] : event;

    		if (event.pageX) {
    			result.x = event.pageX;
    			result.y = event.pageY;
    		} else {
    			result.x = event.clientX;
    			result.y = event.clientY;
    		}

    		return result;
    	};

    	/**
    	 * Determines if the input is a Number or something that can be coerced to a Number
    	 * @protected
    	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
    	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
    	 */
    	Owl.prototype.isNumeric = function(number) {
    		return !isNaN(parseFloat(number));
    	};

    	/**
    	 * Gets the difference of two vectors.
    	 * @todo #261
    	 * @protected
    	 * @param {Object} - The first vector.
    	 * @param {Object} - The second vector.
    	 * @returns {Object} - The difference.
    	 */
    	Owl.prototype.difference = function(first, second) {
    		return {
    			x: first.x - second.x,
    			y: first.y - second.y
    		};
    	};

    	/**
    	 * The jQuery Plugin for the Owl Carousel
    	 * @todo Navigation plugin `next` and `prev`
    	 * @public
    	 */
    	$.fn.owlCarousel = function(option) {
    		var args = Array.prototype.slice.call(arguments, 1);

    		return this.each(function() {
    			var $this = $(this),
    				data = $this.data('owl.carousel');

    			if (!data) {
    				data = new Owl(this, typeof option == 'object' && option);
    				$this.data('owl.carousel', data);

    				$.each([
    					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
    				], function(i, event) {
    					data.register({ type: Owl.Type.Event, name: event });
    					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
    						if (e.namespace && e.relatedTarget !== this) {
    							this.suppress([ event ]);
    							data[event].apply(this, [].slice.call(arguments, 1));
    							this.release([ event ]);
    						}
    					}, data));
    				});
    			}

    			if (typeof option == 'string' && option.charAt(0) !== '_') {
    				data[option].apply(data, args);
    			}
    		});
    	};

    	/**
    	 * The constructor for the jQuery Plugin
    	 * @public
    	 */
    	$.fn.owlCarousel.Constructor = Owl;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the auto refresh plugin.
    	 * @class The Auto Refresh Plugin
    	 * @param {Owl} carousel - The Owl Carousel
    	 */
    	var AutoRefresh = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * Refresh interval.
    		 * @protected
    		 * @type {number}
    		 */
    		this._interval = null;

    		/**
    		 * Whether the element is currently visible or not.
    		 * @protected
    		 * @type {Boolean}
    		 */
    		this._visible = null;

    		/**
    		 * All event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'initialized.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.autoRefresh) {
    					this.watch();
    				}
    			}, this)
    		};

    		// set default options
    		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

    		// register event handlers
    		this._core.$element.on(this._handlers);
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	AutoRefresh.Defaults = {
    		autoRefresh: true,
    		autoRefreshInterval: 500
    	};

    	/**
    	 * Watches the element.
    	 */
    	AutoRefresh.prototype.watch = function() {
    		if (this._interval) {
    			return;
    		}

    		this._visible = this._core.isVisible();
    		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
    	};

    	/**
    	 * Refreshes the element.
    	 */
    	AutoRefresh.prototype.refresh = function() {
    		if (this._core.isVisible() === this._visible) {
    			return;
    		}

    		this._visible = !this._visible;

    		this._core.$element.toggleClass('owl-hidden', !this._visible);

    		this._visible && (this._core.invalidate('width') && this._core.refresh());
    	};

    	/**
    	 * Destroys the plugin.
    	 */
    	AutoRefresh.prototype.destroy = function() {
    		var handler, property;

    		window.clearInterval(this._interval);

    		for (handler in this._handlers) {
    			this._core.$element.off(handler, this._handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the lazy plugin.
    	 * @class The Lazy Plugin
    	 * @param {Owl} carousel - The Owl Carousel
    	 */
    	var Lazy = function(carousel) {

    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * Already loaded items.
    		 * @protected
    		 * @type {Array.<jQuery>}
    		 */
    		this._loaded = [];

    		/**
    		 * Event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
    				if (!e.namespace) {
    					return;
    				}

    				if (!this._core.settings || !this._core.settings.lazyLoad) {
    					return;
    				}

    				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
    					var settings = this._core.settings,
    						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
    						i = ((settings.center && n * -1) || 0),
    						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
    						clones = this._core.clones().length,
    						load = $.proxy(function(i, v) { this.load(v); }, this);
    					//TODO: Need documentation for this new option
    					if (settings.lazyLoadEager > 0) {
    						n += settings.lazyLoadEager;
    						// If the carousel is looping also preload images that are to the "left"
    						if (settings.loop) {
                  position -= settings.lazyLoadEager;
                  n++;
                }
    					}

    					while (i++ < n) {
    						this.load(clones / 2 + this._core.relative(position));
    						clones && $.each(this._core.clones(this._core.relative(position)), load);
    						position++;
    					}
    				}
    			}, this)
    		};

    		// set the default options
    		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

    		// register event handler
    		this._core.$element.on(this._handlers);
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	Lazy.Defaults = {
    		lazyLoad: false,
    		lazyLoadEager: 0
    	};

    	/**
    	 * Loads all resources of an item at the specified position.
    	 * @param {Number} position - The absolute position of the item.
    	 * @protected
    	 */
    	Lazy.prototype.load = function(position) {
    		var $item = this._core.$stage.children().eq(position),
    			$elements = $item && $item.find('.owl-lazy');

    		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
    			return;
    		}

    		$elements.each($.proxy(function(index, element) {
    			var $element = $(element), image,
                    url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');

    			this._core.trigger('load', { element: $element, url: url }, 'lazy');

    			if ($element.is('img')) {
    				$element.one('load.owl.lazy', $.proxy(function() {
    					$element.css('opacity', 1);
    					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
    				}, this)).attr('src', url);
                } else if ($element.is('source')) {
                    $element.one('load.owl.lazy', $.proxy(function() {
                        this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
                    }, this)).attr('srcset', url);
    			} else {
    				image = new Image();
    				image.onload = $.proxy(function() {
    					$element.css({
    						'background-image': 'url("' + url + '")',
    						'opacity': '1'
    					});
    					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
    				}, this);
    				image.src = url;
    			}
    		}, this));

    		this._loaded.push($item.get(0));
    	};

    	/**
    	 * Destroys the plugin.
    	 * @public
    	 */
    	Lazy.prototype.destroy = function() {
    		var handler, property;

    		for (handler in this.handlers) {
    			this._core.$element.off(handler, this.handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the auto height plugin.
    	 * @class The Auto Height Plugin
    	 * @param {Owl} carousel - The Owl Carousel
    	 */
    	var AutoHeight = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		this._previousHeight = null;

    		/**
    		 * All event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.autoHeight) {
    					this.update();
    				}
    			}, this),
    			'changed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
    					this.update();
    				}
    			}, this),
    			'loaded.owl.lazy': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.autoHeight
    					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
    					this.update();
    				}
    			}, this)
    		};

    		// set default options
    		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

    		// register event handlers
    		this._core.$element.on(this._handlers);
    		this._intervalId = null;
    		var refThis = this;

    		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
    		// and have been made compatible with the latest jQuery version
    		$(window).on('load', function() {
    			if (refThis._core.settings.autoHeight) {
    				refThis.update();
    			}
    		});

    		// Autoresize the height of the carousel when window is resized
    		// When carousel has images, the height is dependent on the width
    		// and should also change on resize
    		$(window).resize(function() {
    			if (refThis._core.settings.autoHeight) {
    				if (refThis._intervalId != null) {
    					clearTimeout(refThis._intervalId);
    				}

    				refThis._intervalId = setTimeout(function() {
    					refThis.update();
    				}, 250);
    			}
    		});

    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	AutoHeight.Defaults = {
    		autoHeight: false,
    		autoHeightClass: 'owl-height'
    	};

    	/**
    	 * Updates the view.
    	 */
    	AutoHeight.prototype.update = function() {
    		var start = this._core._current,
    			end = start + this._core.settings.items,
    			lazyLoadEnabled = this._core.settings.lazyLoad,
    			visible = this._core.$stage.children().toArray().slice(start, end),
    			heights = [],
    			maxheight = 0;

    		$.each(visible, function(index, item) {
    			heights.push($(item).height());
    		});

    		maxheight = Math.max.apply(null, heights);

    		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
    			maxheight = this._previousHeight;
    		}

    		this._previousHeight = maxheight;

    		this._core.$stage.parent()
    			.height(maxheight)
    			.addClass(this._core.settings.autoHeightClass);
    	};

    	AutoHeight.prototype.destroy = function() {
    		var handler, property;

    		for (handler in this._handlers) {
    			this._core.$element.off(handler, this._handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] !== 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the video plugin.
    	 * @class The Video Plugin
    	 * @param {Owl} carousel - The Owl Carousel
    	 */
    	var Video = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * Cache all video URLs.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._videos = {};

    		/**
    		 * Current playing item.
    		 * @protected
    		 * @type {jQuery}
    		 */
    		this._playing = null;

    		/**
    		 * All event handlers.
    		 * @todo The cloned content removale is too late
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'initialized.owl.carousel': $.proxy(function(e) {
    				if (e.namespace) {
    					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
    				}
    			}, this),
    			'resize.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
    					e.preventDefault();
    				}
    			}, this),
    			'refreshed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.is('resizing')) {
    					this._core.$stage.find('.cloned .owl-video-frame').remove();
    				}
    			}, this),
    			'changed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && e.property.name === 'position' && this._playing) {
    					this.stop();
    				}
    			}, this),
    			'prepared.owl.carousel': $.proxy(function(e) {
    				if (!e.namespace) {
    					return;
    				}

    				var $element = $(e.content).find('.owl-video');

    				if ($element.length) {
    					$element.css('display', 'none');
    					this.fetch($element, $(e.content));
    				}
    			}, this)
    		};

    		// set default options
    		this._core.options = $.extend({}, Video.Defaults, this._core.options);

    		// register event handlers
    		this._core.$element.on(this._handlers);

    		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
    			this.play(e);
    		}, this));
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	Video.Defaults = {
    		video: false,
    		videoHeight: false,
    		videoWidth: false
    	};

    	/**
    	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
    	 * @protected
    	 * @param {jQuery} target - The target containing the video data.
    	 * @param {jQuery} item - The item containing the video.
    	 */
    	Video.prototype.fetch = function(target, item) {
    			var type = (function() {
    					if (target.attr('data-vimeo-id')) {
    						return 'vimeo';
    					} else if (target.attr('data-vzaar-id')) {
    						return 'vzaar'
    					} else {
    						return 'youtube';
    					}
    				})(),
    				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
    				width = target.attr('data-width') || this._core.settings.videoWidth,
    				height = target.attr('data-height') || this._core.settings.videoHeight,
    				url = target.attr('href');

    		if (url) {

    			/*
    					Parses the id's out of the following urls (and probably more):
    					https://www.youtube.com/watch?v=:id
    					https://youtu.be/:id
    					https://vimeo.com/:id
    					https://vimeo.com/channels/:channel/:id
    					https://vimeo.com/groups/:group/videos/:id
    					https://app.vzaar.com/videos/:id

    					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
    			*/

    			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    			if (id[3].indexOf('youtu') > -1) {
    				type = 'youtube';
    			} else if (id[3].indexOf('vimeo') > -1) {
    				type = 'vimeo';
    			} else if (id[3].indexOf('vzaar') > -1) {
    				type = 'vzaar';
    			} else {
    				throw new Error('Video URL not supported.');
    			}
    			id = id[6];
    		} else {
    			throw new Error('Missing video URL.');
    		}

    		this._videos[url] = {
    			type: type,
    			id: id,
    			width: width,
    			height: height
    		};

    		item.attr('data-video', url);

    		this.thumbnail(target, this._videos[url]);
    	};

    	/**
    	 * Creates video thumbnail.
    	 * @protected
    	 * @param {jQuery} target - The target containing the video data.
    	 * @param {Object} info - The video info object.
    	 * @see `fetch`
    	 */
    	Video.prototype.thumbnail = function(target, video) {
    		var tnLink,
    			icon,
    			path,
    			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
    			customTn = target.find('img'),
    			srcType = 'src',
    			lazyClass = '',
    			settings = this._core.settings,
    			create = function(path) {
    				icon = '<div class="owl-video-play-icon"></div>';

    				if (settings.lazyLoad) {
    					tnLink = $('<div/>',{
    						"class": 'owl-video-tn ' + lazyClass,
    						"srcType": path
    					});
    				} else {
    					tnLink = $( '<div/>', {
    						"class": "owl-video-tn",
    						"style": 'opacity:1;background-image:url(' + path + ')'
    					});
    				}
    				target.after(tnLink);
    				target.after(icon);
    			};

    		// wrap video content into owl-video-wrapper div
    		target.wrap( $( '<div/>', {
    			"class": "owl-video-wrapper",
    			"style": dimensions
    		}));

    		if (this._core.settings.lazyLoad) {
    			srcType = 'data-src';
    			lazyClass = 'owl-lazy';
    		}

    		// custom thumbnail
    		if (customTn.length) {
    			create(customTn.attr(srcType));
    			customTn.remove();
    			return false;
    		}

    		if (video.type === 'youtube') {
    			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
    			create(path);
    		} else if (video.type === 'vimeo') {
    			$.ajax({
    				type: 'GET',
    				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
    				jsonp: 'callback',
    				dataType: 'jsonp',
    				success: function(data) {
    					path = data[0].thumbnail_large;
    					create(path);
    				}
    			});
    		} else if (video.type === 'vzaar') {
    			$.ajax({
    				type: 'GET',
    				url: '//vzaar.com/api/videos/' + video.id + '.json',
    				jsonp: 'callback',
    				dataType: 'jsonp',
    				success: function(data) {
    					path = data.framegrab_url;
    					create(path);
    				}
    			});
    		}
    	};

    	/**
    	 * Stops the current video.
    	 * @public
    	 */
    	Video.prototype.stop = function() {
    		this._core.trigger('stop', null, 'video');
    		this._playing.find('.owl-video-frame').remove();
    		this._playing.removeClass('owl-video-playing');
    		this._playing = null;
    		this._core.leave('playing');
    		this._core.trigger('stopped', null, 'video');
    	};

    	/**
    	 * Starts the current video.
    	 * @public
    	 * @param {Event} event - The event arguments.
    	 */
    	Video.prototype.play = function(event) {
    		var target = $(event.target),
    			item = target.closest('.' + this._core.settings.itemClass),
    			video = this._videos[item.attr('data-video')],
    			width = video.width || '100%',
    			height = video.height || this._core.$stage.height(),
    			html,
    			iframe;

    		if (this._playing) {
    			return;
    		}

    		this._core.enter('playing');
    		this._core.trigger('play', null, 'video');

    		item = this._core.items(this._core.relative(item.index()));

    		this._core.reset(item.index());

    		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
    		html.attr( 'height', height );
    		html.attr( 'width', width );
    		if (video.type === 'youtube') {
    			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
    		} else if (video.type === 'vimeo') {
    			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
    		} else if (video.type === 'vzaar') {
    			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
    		}

    		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));

    		this._playing = item.addClass('owl-video-playing');
    	};

    	/**
    	 * Checks whether an video is currently in full screen mode or not.
    	 * @todo Bad style because looks like a readonly method but changes members.
    	 * @protected
    	 * @returns {Boolean}
    	 */
    	Video.prototype.isInFullScreen = function() {
    		var element = document.fullscreenElement || document.mozFullScreenElement ||
    				document.webkitFullscreenElement;

    		return element && $(element).parent().hasClass('owl-video-frame');
    	};

    	/**
    	 * Destroys the plugin.
    	 */
    	Video.prototype.destroy = function() {
    		var handler, property;

    		this._core.$element.off('click.owl.video');

    		for (handler in this._handlers) {
    			this._core.$element.off(handler, this._handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the animate plugin.
    	 * @class The Navigation Plugin
    	 * @param {Owl} scope - The Owl Carousel
    	 */
    	var Animate = function(scope) {
    		this.core = scope;
    		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
    		this.swapping = true;
    		this.previous = undefined;
    		this.next = undefined;

    		this.handlers = {
    			'change.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && e.property.name == 'position') {
    					this.previous = this.core.current();
    					this.next = e.property.value;
    				}
    			}, this),
    			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
    				if (e.namespace) {
    					this.swapping = e.type == 'translated';
    				}
    			}, this),
    			'translate.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
    					this.swap();
    				}
    			}, this)
    		};

    		this.core.$element.on(this.handlers);
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	Animate.Defaults = {
    		animateOut: false,
    		animateIn: false
    	};

    	/**
    	 * Toggles the animation classes whenever an translations starts.
    	 * @protected
    	 * @returns {Boolean|undefined}
    	 */
    	Animate.prototype.swap = function() {

    		if (this.core.settings.items !== 1) {
    			return;
    		}

    		if (!$.support.animation || !$.support.transition) {
    			return;
    		}

    		this.core.speed(0);

    		var left,
    			clear = $.proxy(this.clear, this),
    			previous = this.core.$stage.children().eq(this.previous),
    			next = this.core.$stage.children().eq(this.next),
    			incoming = this.core.settings.animateIn,
    			outgoing = this.core.settings.animateOut;

    		if (this.core.current() === this.previous) {
    			return;
    		}

    		if (outgoing) {
    			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
    			previous.one($.support.animation.end, clear)
    				.css( { 'left': left + 'px' } )
    				.addClass('animated owl-animated-out')
    				.addClass(outgoing);
    		}

    		if (incoming) {
    			next.one($.support.animation.end, clear)
    				.addClass('animated owl-animated-in')
    				.addClass(incoming);
    		}
    	};

    	Animate.prototype.clear = function(e) {
    		$(e.target).css( { 'left': '' } )
    			.removeClass('animated owl-animated-out owl-animated-in')
    			.removeClass(this.core.settings.animateIn)
    			.removeClass(this.core.settings.animateOut);
    		this.core.onTransitionEnd();
    	};

    	/**
    	 * Destroys the plugin.
    	 * @public
    	 */
    	Animate.prototype.destroy = function() {
    		var handler, property;

    		for (handler in this.handlers) {
    			this.core.$element.off(handler, this.handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the autoplay plugin.
    	 * @class The Autoplay Plugin
    	 * @param {Owl} scope - The Owl Carousel
    	 */
    	var Autoplay = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * The autoplay timeout id.
    		 * @type {Number}
    		 */
    		this._call = null;

    		/**
    		 * Depending on the state of the plugin, this variable contains either
    		 * the start time of the timer or the current timer value if it's
    		 * paused. Since we start in a paused state we initialize the timer
    		 * value.
    		 * @type {Number}
    		 */
    		this._time = 0;

    		/**
    		 * Stores the timeout currently used.
    		 * @type {Number}
    		 */
    		this._timeout = 0;

    		/**
    		 * Indicates whenever the autoplay is paused.
    		 * @type {Boolean}
    		 */
    		this._paused = true;

    		/**
    		 * All event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'changed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && e.property.name === 'settings') {
    					if (this._core.settings.autoplay) {
    						this.play();
    					} else {
    						this.stop();
    					}
    				} else if (e.namespace && e.property.name === 'position' && this._paused) {
    					// Reset the timer. This code is triggered when the position
    					// of the carousel was changed through user interaction.
    					this._time = 0;
    				}
    			}, this),
    			'initialized.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.autoplay) {
    					this.play();
    				}
    			}, this),
    			'play.owl.autoplay': $.proxy(function(e, t, s) {
    				if (e.namespace) {
    					this.play(t, s);
    				}
    			}, this),
    			'stop.owl.autoplay': $.proxy(function(e) {
    				if (e.namespace) {
    					this.stop();
    				}
    			}, this),
    			'mouseover.owl.autoplay': $.proxy(function() {
    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
    					this.pause();
    				}
    			}, this),
    			'mouseleave.owl.autoplay': $.proxy(function() {
    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
    					this.play();
    				}
    			}, this),
    			'touchstart.owl.core': $.proxy(function() {
    				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
    					this.pause();
    				}
    			}, this),
    			'touchend.owl.core': $.proxy(function() {
    				if (this._core.settings.autoplayHoverPause) {
    					this.play();
    				}
    			}, this)
    		};

    		// register event handlers
    		this._core.$element.on(this._handlers);

    		// set default options
    		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	Autoplay.Defaults = {
    		autoplay: false,
    		autoplayTimeout: 5000,
    		autoplayHoverPause: false,
    		autoplaySpeed: false
    	};

    	/**
    	 * Transition to the next slide and set a timeout for the next transition.
    	 * @private
    	 * @param {Number} [speed] - The animation speed for the animations.
    	 */
    	Autoplay.prototype._next = function(speed) {
    		this._call = window.setTimeout(
    			$.proxy(this._next, this, speed),
    			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
    		);

    		if (this._core.is('interacting') || document.hidden) {
    			return;
    		}
    		this._core.next(speed || this._core.settings.autoplaySpeed);
    	};

    	/**
    	 * Reads the current timer value when the timer is playing.
    	 * @public
    	 */
    	Autoplay.prototype.read = function() {
    		return new Date().getTime() - this._time;
    	};

    	/**
    	 * Starts the autoplay.
    	 * @public
    	 * @param {Number} [timeout] - The interval before the next animation starts.
    	 * @param {Number} [speed] - The animation speed for the animations.
    	 */
    	Autoplay.prototype.play = function(timeout, speed) {
    		var elapsed;

    		if (!this._core.is('rotating')) {
    			this._core.enter('rotating');
    		}

    		timeout = timeout || this._core.settings.autoplayTimeout;

    		// Calculate the elapsed time since the last transition. If the carousel
    		// wasn't playing this calculation will yield zero.
    		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);

    		if (this._paused) {
    			// Start the clock.
    			this._time = this.read();
    			this._paused = false;
    		} else {
    			// Clear the active timeout to allow replacement.
    			window.clearTimeout(this._call);
    		}

    		// Adjust the origin of the timer to match the new timeout value.
    		this._time += this.read() % timeout - elapsed;

    		this._timeout = timeout;
    		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
    	};

    	/**
    	 * Stops the autoplay.
    	 * @public
    	 */
    	Autoplay.prototype.stop = function() {
    		if (this._core.is('rotating')) {
    			// Reset the clock.
    			this._time = 0;
    			this._paused = true;

    			window.clearTimeout(this._call);
    			this._core.leave('rotating');
    		}
    	};

    	/**
    	 * Pauses the autoplay.
    	 * @public
    	 */
    	Autoplay.prototype.pause = function() {
    		if (this._core.is('rotating') && !this._paused) {
    			// Pause the clock.
    			this._time = this.read();
    			this._paused = true;

    			window.clearTimeout(this._call);
    		}
    	};

    	/**
    	 * Destroys the plugin.
    	 */
    	Autoplay.prototype.destroy = function() {
    		var handler, property;

    		this.stop();

    		for (handler in this._handlers) {
    			this._core.$element.off(handler, this._handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the navigation plugin.
    	 * @class The Navigation Plugin
    	 * @param {Owl} carousel - The Owl Carousel.
    	 */
    	var Navigation = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * Indicates whether the plugin is initialized or not.
    		 * @protected
    		 * @type {Boolean}
    		 */
    		this._initialized = false;

    		/**
    		 * The current paging indexes.
    		 * @protected
    		 * @type {Array}
    		 */
    		this._pages = [];

    		/**
    		 * All DOM elements of the user interface.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._controls = {};

    		/**
    		 * Markup for an indicator.
    		 * @protected
    		 * @type {Array.<String>}
    		 */
    		this._templates = [];

    		/**
    		 * The carousel element.
    		 * @type {jQuery}
    		 */
    		this.$element = this._core.$element;

    		/**
    		 * Overridden methods of the carousel.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._overrides = {
    			next: this._core.next,
    			prev: this._core.prev,
    			to: this._core.to
    		};

    		/**
    		 * All event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'prepared.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.dotsData) {
    					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
    						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
    				}
    			}, this),
    			'added.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.dotsData) {
    					this._templates.splice(e.position, 0, this._templates.pop());
    				}
    			}, this),
    			'remove.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.dotsData) {
    					this._templates.splice(e.position, 1);
    				}
    			}, this),
    			'changed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && e.property.name == 'position') {
    					this.draw();
    				}
    			}, this),
    			'initialized.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && !this._initialized) {
    					this._core.trigger('initialize', null, 'navigation');
    					this.initialize();
    					this.update();
    					this.draw();
    					this._initialized = true;
    					this._core.trigger('initialized', null, 'navigation');
    				}
    			}, this),
    			'refreshed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._initialized) {
    					this._core.trigger('refresh', null, 'navigation');
    					this.update();
    					this.draw();
    					this._core.trigger('refreshed', null, 'navigation');
    				}
    			}, this)
    		};

    		// set default options
    		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

    		// register event handlers
    		this.$element.on(this._handlers);
    	};

    	/**
    	 * Default options.
    	 * @public
    	 * @todo Rename `slideBy` to `navBy`
    	 */
    	Navigation.Defaults = {
    		nav: false,
    		navText: [
    			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
    			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
    		],
    		navSpeed: false,
    		navElement: 'button type="button" role="presentation"',
    		navContainer: false,
    		navContainerClass: 'owl-nav',
    		navClass: [
    			'owl-prev',
    			'owl-next'
    		],
    		slideBy: 1,
    		dotClass: 'owl-dot',
    		dotsClass: 'owl-dots',
    		dots: true,
    		dotsEach: false,
    		dotsData: false,
    		dotsSpeed: false,
    		dotsContainer: false
    	};

    	/**
    	 * Initializes the layout of the plugin and extends the carousel.
    	 * @protected
    	 */
    	Navigation.prototype.initialize = function() {
    		var override,
    			settings = this._core.settings;

    		// create DOM structure for relative navigation
    		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
    			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

    		this._controls.$previous = $('<' + settings.navElement + '>')
    			.addClass(settings.navClass[0])
    			.html(settings.navText[0])
    			.prependTo(this._controls.$relative)
    			.on('click', $.proxy(function(e) {
    				this.prev(settings.navSpeed);
    			}, this));
    		this._controls.$next = $('<' + settings.navElement + '>')
    			.addClass(settings.navClass[1])
    			.html(settings.navText[1])
    			.appendTo(this._controls.$relative)
    			.on('click', $.proxy(function(e) {
    				this.next(settings.navSpeed);
    			}, this));

    		// create DOM structure for absolute navigation
    		if (!settings.dotsData) {
    			this._templates = [ $('<button role="button">')
    				.addClass(settings.dotClass)
    				.append($('<span>'))
    				.prop('outerHTML') ];
    		}

    		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
    			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

    		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
    			var index = $(e.target).parent().is(this._controls.$absolute)
    				? $(e.target).index() : $(e.target).parent().index();

    			e.preventDefault();

    			this.to(index, settings.dotsSpeed);
    		}, this));

    		/*$el.on('focusin', function() {
    			$(document).off(".carousel");

    			$(document).on('keydown.carousel', function(e) {
    				if(e.keyCode == 37) {
    					$el.trigger('prev.owl')
    				}
    				if(e.keyCode == 39) {
    					$el.trigger('next.owl')
    				}
    			});
    		});*/

    		// override public methods of the carousel
    		for (override in this._overrides) {
    			this._core[override] = $.proxy(this[override], this);
    		}
    	};

    	/**
    	 * Destroys the plugin.
    	 * @protected
    	 */
    	Navigation.prototype.destroy = function() {
    		var handler, control, property, override, settings;
    		settings = this._core.settings;

    		for (handler in this._handlers) {
    			this.$element.off(handler, this._handlers[handler]);
    		}
    		for (control in this._controls) {
    			if (control === '$relative' && settings.navContainer) {
    				this._controls[control].html('');
    			} else {
    				this._controls[control].remove();
    			}
    		}
    		for (override in this.overides) {
    			this._core[override] = this._overrides[override];
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	/**
    	 * Updates the internal state.
    	 * @protected
    	 */
    	Navigation.prototype.update = function() {
    		var i, j, k,
    			lower = this._core.clones().length / 2,
    			upper = lower + this._core.items().length,
    			maximum = this._core.maximum(true),
    			settings = this._core.settings,
    			size = settings.center || settings.autoWidth || settings.dotsData
    				? 1 : settings.dotsEach || settings.items;

    		if (settings.slideBy !== 'page') {
    			settings.slideBy = Math.min(settings.slideBy, settings.items);
    		}

    		if (settings.dots || settings.slideBy == 'page') {
    			this._pages = [];

    			for (i = lower, j = 0, k = 0; i < upper; i++) {
    				if (j >= size || j === 0) {
    					this._pages.push({
    						start: Math.min(maximum, i - lower),
    						end: i - lower + size - 1
    					});
    					if (Math.min(maximum, i - lower) === maximum) {
    						break;
    					}
    					j = 0, ++k;
    				}
    				j += this._core.mergers(this._core.relative(i));
    			}
    		}
    	};

    	/**
    	 * Draws the user interface.
    	 * @todo The option `dotsData` wont work.
    	 * @protected
    	 */
    	Navigation.prototype.draw = function() {
    		var difference,
    			settings = this._core.settings,
    			disabled = this._core.items().length <= settings.items,
    			index = this._core.relative(this._core.current()),
    			loop = settings.loop || settings.rewind;

    		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

    		if (settings.nav) {
    			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
    			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
    		}

    		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

    		if (settings.dots) {
    			difference = this._pages.length - this._controls.$absolute.children().length;

    			if (settings.dotsData && difference !== 0) {
    				this._controls.$absolute.html(this._templates.join(''));
    			} else if (difference > 0) {
    				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
    			} else if (difference < 0) {
    				this._controls.$absolute.children().slice(difference).remove();
    			}

    			this._controls.$absolute.find('.active').removeClass('active');
    			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
    		}
    	};

    	/**
    	 * Extends event data.
    	 * @protected
    	 * @param {Event} event - The event object which gets thrown.
    	 */
    	Navigation.prototype.onTrigger = function(event) {
    		var settings = this._core.settings;

    		event.page = {
    			index: $.inArray(this.current(), this._pages),
    			count: this._pages.length,
    			size: settings && (settings.center || settings.autoWidth || settings.dotsData
    				? 1 : settings.dotsEach || settings.items)
    		};
    	};

    	/**
    	 * Gets the current page position of the carousel.
    	 * @protected
    	 * @returns {Number}
    	 */
    	Navigation.prototype.current = function() {
    		var current = this._core.relative(this._core.current());
    		return $.grep(this._pages, $.proxy(function(page, index) {
    			return page.start <= current && page.end >= current;
    		}, this)).pop();
    	};

    	/**
    	 * Gets the current succesor/predecessor position.
    	 * @protected
    	 * @returns {Number}
    	 */
    	Navigation.prototype.getPosition = function(successor) {
    		var position, length,
    			settings = this._core.settings;

    		if (settings.slideBy == 'page') {
    			position = $.inArray(this.current(), this._pages);
    			length = this._pages.length;
    			successor ? ++position : --position;
    			position = this._pages[((position % length) + length) % length].start;
    		} else {
    			position = this._core.relative(this._core.current());
    			length = this._core.items().length;
    			successor ? position += settings.slideBy : position -= settings.slideBy;
    		}

    		return position;
    	};

    	/**
    	 * Slides to the next item or page.
    	 * @public
    	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
    	 */
    	Navigation.prototype.next = function(speed) {
    		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
    	};

    	/**
    	 * Slides to the previous item or page.
    	 * @public
    	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
    	 */
    	Navigation.prototype.prev = function(speed) {
    		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
    	};

    	/**
    	 * Slides to the specified item or page.
    	 * @public
    	 * @param {Number} position - The position of the item or page.
    	 * @param {Number} [speed] - The time in milliseconds for the transition.
    	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
    	 */
    	Navigation.prototype.to = function(position, speed, standard) {
    		var length;

    		if (!standard && this._pages.length) {
    			length = this._pages.length;
    			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
    		} else {
    			$.proxy(this._overrides.to, this._core)(position, speed);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	/**
    	 * Creates the hash plugin.
    	 * @class The Hash Plugin
    	 * @param {Owl} carousel - The Owl Carousel
    	 */
    	var Hash = function(carousel) {
    		/**
    		 * Reference to the core.
    		 * @protected
    		 * @type {Owl}
    		 */
    		this._core = carousel;

    		/**
    		 * Hash index for the items.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._hashes = {};

    		/**
    		 * The carousel element.
    		 * @type {jQuery}
    		 */
    		this.$element = this._core.$element;

    		/**
    		 * All event handlers.
    		 * @protected
    		 * @type {Object}
    		 */
    		this._handlers = {
    			'initialized.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
    					$(window).trigger('hashchange.owl.navigation');
    				}
    			}, this),
    			'prepared.owl.carousel': $.proxy(function(e) {
    				if (e.namespace) {
    					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

    					if (!hash) {
    						return;
    					}

    					this._hashes[hash] = e.content;
    				}
    			}, this),
    			'changed.owl.carousel': $.proxy(function(e) {
    				if (e.namespace && e.property.name === 'position') {
    					var current = this._core.items(this._core.relative(this._core.current())),
    						hash = $.map(this._hashes, function(item, hash) {
    							return item === current ? hash : null;
    						}).join();

    					if (!hash || window.location.hash.slice(1) === hash) {
    						return;
    					}

    					window.location.hash = hash;
    				}
    			}, this)
    		};

    		// set default options
    		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

    		// register the event handlers
    		this.$element.on(this._handlers);

    		// register event listener for hash navigation
    		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
    			var hash = window.location.hash.substring(1),
    				items = this._core.$stage.children(),
    				position = this._hashes[hash] && items.index(this._hashes[hash]);

    			if (position === undefined || position === this._core.current()) {
    				return;
    			}

    			this._core.to(this._core.relative(position), false, true);
    		}, this));
    	};

    	/**
    	 * Default options.
    	 * @public
    	 */
    	Hash.Defaults = {
    		URLhashListener: false
    	};

    	/**
    	 * Destroys the plugin.
    	 * @public
    	 */
    	Hash.prototype.destroy = function() {
    		var handler, property;

    		$(window).off('hashchange.owl.navigation');

    		for (handler in this._handlers) {
    			this._core.$element.off(handler, this._handlers[handler]);
    		}
    		for (property in Object.getOwnPropertyNames(this)) {
    			typeof this[property] != 'function' && (this[property] = null);
    		}
    	};

    	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

    })(window.Zepto || window.jQuery, window, document);
    (function($, window, document, undefined) {

    	var style = $('<support>').get(0).style,
    		prefixes = 'Webkit Moz O ms'.split(' '),
    		events = {
    			transition: {
    				end: {
    					WebkitTransition: 'webkitTransitionEnd',
    					MozTransition: 'transitionend',
    					OTransition: 'oTransitionEnd',
    					transition: 'transitionend'
    				}
    			},
    			animation: {
    				end: {
    					WebkitAnimation: 'webkitAnimationEnd',
    					MozAnimation: 'animationend',
    					OAnimation: 'oAnimationEnd',
    					animation: 'animationend'
    				}
    			}
    		},
    		tests = {
    			csstransforms: function() {
    				return !!test('transform');
    			},
    			csstransforms3d: function() {
    				return !!test('perspective');
    			},
    			csstransitions: function() {
    				return !!test('transition');
    			},
    			cssanimations: function() {
    				return !!test('animation');
    			}
    		};

    	function test(property, prefixed) {
    		var result = false,
    			upper = property.charAt(0).toUpperCase() + property.slice(1);

    		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
    			if (style[property] !== undefined) {
    				result = prefixed ? property : true;
    				return false;
    			}
    		});

    		return result;
    	}

    	function prefixed(property) {
    		return test(property, true);
    	}

    	if (tests.csstransitions()) {
    		/* jshint -W053 */
    		$.support.transition = new String(prefixed('transition'));
    		$.support.transition.end = events.transition.end[ $.support.transition ];
    	}

    	if (tests.cssanimations()) {
    		/* jshint -W053 */
    		$.support.animation = new String(prefixed('animation'));
    		$.support.animation.end = events.animation.end[ $.support.animation ];
    	}

    	if (tests.csstransforms()) {
    		/* jshint -W053 */
    		$.support.transform = new String(prefixed('transform'));
    		$.support.transform3d = tests.csstransforms3d();
    	}

    })(window.Zepto || window.jQuery, window, document);

    var $ = window.jQuery;
    var ReactOwlCarousel = /** @class */ (function (_super) {
        __extends(ReactOwlCarousel, _super);
        function ReactOwlCarousel(props) {
            var _this = _super.call(this, props) || this;
            _this.containerRef = function (inst) {
                _this.container = inst;
            };
            var _a = filterOptions(_this.props), options = _a[0], propsWithoutOptions = _a[1];
            _this.options = options;
            _this.propsWithoutOptions = propsWithoutOptions;
            return _this;
        }
        ReactOwlCarousel.prototype.componentDidMount = function () {
            this.$ele = $(this.container);
            this.create();
        };
        ReactOwlCarousel.prototype.componentWillReceiveProps = function () {
            this.destory();
        };
        ReactOwlCarousel.prototype.componentDidUpdate = function () {
            var _a = filterOptions(this.props), options = _a[0], propsWithoutOptions = _a[1];
            this.options = options;
            this.propsWithoutOptions = propsWithoutOptions;
            this.create();
        };
        ReactOwlCarousel.prototype.next = function (speed) {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            if (typeof speed === 'number') {
                this.$ele.trigger('next.owl.carousel', [speed]);
            }
            else {
                this.$ele.trigger('next.owl.carousel', speed);
            }
        };
        ReactOwlCarousel.prototype.prev = function (speed) {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            if (typeof speed === 'number') {
                this.$ele.trigger('prev.owl.carousel', [speed]);
            }
            else {
                this.$ele.trigger('prev.owl.carousel', speed);
            }
        };
        ReactOwlCarousel.prototype.to = function (position, speed) {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            if (typeof position === 'number' && typeof speed === 'number') {
                this.$ele.trigger('to.owl.carousel', [position, speed]);
            }
            else {
                this.$ele.trigger('to.owl.carousel');
            }
        };
        ReactOwlCarousel.prototype.create = function (options) {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            this.$ele.owlCarousel(options || this.options);
        };
        ReactOwlCarousel.prototype.destory = function () {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            this.$ele.trigger('destroy.owl.carousel');
        };
        ReactOwlCarousel.prototype.play = function (timeout, speed) {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            if (typeof timeout === 'number' && typeof speed === 'number') {
                this.$ele.trigger('play.owl.autoplay', [timeout, speed]);
            }
            else {
                this.$ele.trigger('play.owl.autoplay');
            }
        };
        ReactOwlCarousel.prototype.stop = function () {
            if (!this.$ele)
                throw new Error('OwlCarousel is not created');
            this.$ele.trigger('stop.owl.autoplay');
        };
        ReactOwlCarousel.prototype.render = function () {
            var _a = this.propsWithoutOptions, className = _a.className, props = __rest(_a, ["className"]);
            return (React__default.createElement("div", __assign({ className: "owl-carousel " + className, ref: this.containerRef }, props)));
        };
        return ReactOwlCarousel;
    }(React.Component));
    var OPTIONS = new Set([
        'items',
        'margin',
        'loop',
        'center',
        'mouseDrag',
        'touchDrag',
        'pullDrag',
        'freeDrag',
        'stagePadding',
        'merge',
        'mergeFit',
        'autoWidth',
        'startPosition',
        'URLhashListener',
        'nav',
        'rewind',
        'navText',
        'navElement',
        'slideBy',
        'dots',
        'dotsEach',
        'dotData',
        'lazyLoad',
        'lazyContent',
        'autoplay',
        'autoplayTimeout',
        'autoplayHoverPause',
        'smartSpeed',
        'fluidSpeed',
        'autoplaySpeed',
        'navSpeed',
        'dotsSpeed',
        'dragEndSpeed',
        'callbacks',
        'responsive',
        'responsiveRefreshRate',
        'responsiveBaseElement',
        'video',
        'videoHeight',
        'videoWidth',
        'animateOut',
        'animateIn',
        'fallbackEasing',
        'info',
        'nestedItemSelector',
        'itemElement',
        'stageElement',
        'navContainer',
        'dotsContainer',
        // 'CLASSES'
        'refreshClass',
        'loadingClass',
        'loadedClass',
        'rtlClass',
        'dragClass',
        'grabClass',
        'stageClass',
        'stageOuterClass',
        'navContainerClass',
        'navClass',
        'controlsClass',
        'dotClass',
        'dotsClass',
        'autoHeightClass',
        'responsiveClass',
        // 'EVENTS'
        'onInitialize',
        'onInitialized',
        'onResize',
        'onResized',
        'onRefresh',
        'onRefreshed',
        'onDrag',
        'onDragged',
        'onTranslate',
        'onTranslated',
        'onChange',
        'onChanged',
        'onLoadLazy',
        'onLoadedLazy',
        'onStopVideo',
        'onPlayVideo',
    ]);
    function filterOptions(item) {
        var options = {};
        var propsWithoutOptions = {};
        Object.keys(item).forEach(function (key) {
            if (OPTIONS.has(key)) {
                options[key] = item[key];
            }
            else {
                propsWithoutOptions[key] = item[key];
            }
        });
        return [options, propsWithoutOptions];
    }

    return ReactOwlCarousel;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(117);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.arePathsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two path arrays of LatLng objects.
   */

  var arePathsEqual = exports.arePathsEqual = function arePathsEqual(pathA, pathB) {
    if (pathA === pathB) {
      return true;
    }
    if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
      return false;
    }
    if (pathA.length !== pathB.length) {
      return false;
    }
    for (var i = 0; i < pathA.length; ++i) {
      if (pathA[i] === pathB[i]) {
        continue;
      }
      if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) {
        return false;
      }
      if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) {
        return false;
      }
    }
    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var isValidLatLng = function isValidLatLng(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('lat') && elem.hasOwnProperty('lng');
  };
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrentLocation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    map: {
        position: 'absolute',
        width: '100%',
        height: '100%'
    }
};

var CurrentLocation = exports.CurrentLocation = function (_React$Component) {
    _inherits(CurrentLocation, _React$Component);

    function CurrentLocation(props) {
        _classCallCheck(this, CurrentLocation);

        var _this = _possibleConstructorReturn(this, (CurrentLocation.__proto__ || Object.getPrototypeOf(CurrentLocation)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props$initialCe = _this.props.initialCenter,
            lat = _this$props$initialCe.lat,
            lng = _this$props$initialCe.lng;

        _this.state = {
            currentLocation: {
                lat: lat,
                lng: lng
            },
            address: ''
        };
        return _this;
    }

    _createClass(CurrentLocation, [{
        key: 'recenterMap',
        value: function recenterMap() {
            var _this2 = this;

            var map = this.map;
            var current = this.state.currentLocation;

            var requestOption = {
                method: 'GET'
            };

            fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + current.lat + ',' + current.lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
                return res.json();
            }).then(function (response) {
                var address = response.results[0].formatted_address;
                //console.log('Inside Recenter');
                //console.log(address);
                _this2.setState({ address: address });
                _this2.handleGetAddress2();
            }).catch(function (error) {
                console.warn(error);
            });

            var google = this.props.google;
            var maps = google.maps;

            if (map) {
                var center = new maps.LatLng(current.lat, current.lng);
                map.panTo(center);
            }
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            if (this.props && this.props.google) {
                // checks if google is available
                var google = this.props.google;

                var maps = google.maps;

                var mapRef = this.refs.map;

                // reference to the actual DOM element
                var node = _reactDom2.default.findDOMNode(mapRef);

                var zoom = this.props.zoom;
                var _state$currentLocatio = this.state.currentLocation,
                    lat = _state$currentLocatio.lat,
                    lng = _state$currentLocatio.lng;

                var center = new maps.LatLng(lat, lng);
                var mapConfig = Object.assign({}, {
                    center: center,
                    zoom: zoom
                });

                // maps.Map() is constructor that instantiates the map
                this.map = new maps.Map(node, mapConfig);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.google !== this.props.google) {
                //console.log('loadmap');
                this.loadMap();
            }
            if (prevState.currentLocation !== this.state.currentLocation) {
                //console.log('recentermap');
                this.recenterMap();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            //console.log('mounted');
            if (this.props.centerAroundCurrentLocation) {
                if (navigator && navigator.geolocation) {

                    //navigator.geolocation.watchPosition(pos => {
                    navigator.geolocation.getCurrentPosition(function (pos) {
                        var coords = pos.coords;
                        var requestOption = {
                            method: 'GET'
                        };

                        //console.log(coords);

                        var address = '';
                        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + coords.latitude + ',' + coords.longitude + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
                            return res.json();
                        }).then(function (response) {
                            address = response.results[0].formatted_address;
                            _this3.setState({
                                currentLocation: {
                                    lat: coords.latitude,
                                    lng: coords.longitude
                                },
                                address: address
                            });
                        }).catch(function (error) {
                            console.warn(error);
                        });
                    });
                }
            }
            this.loadMap();
            this.handleGetAddress2();
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this4 = this;

            var children = this.props.children;


            if (!children) return;

            //console.log(this.state.currentLocation);

            return _react2.default.Children.map(children, function (c) {
                if (!c) return;
                return _react2.default.cloneElement(c, {
                    map: _this4.map,
                    google: _this4.props.google,
                    mapCenter: _this4.state.currentLocation
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var style = Object.assign({}, mapStyles.map);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { style: { width: '100%', height: '300px', 'overFlow': 'hidden' }, ref: 'map' },
                    ' ',
                    _react2.default.createElement(_Loader2.default, null)
                ),
                this.renderChildren()
            );
        }
    }]);

    return CurrentLocation;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.handleGetAddress2 = function () {
        var _state$currentLocatio2 = _this5.state.currentLocation,
            lat = _state$currentLocatio2.lat,
            lng = _state$currentLocatio2.lng;

        _this5.props.handleGetAddress(_this5.state.address, lat, lng);
    };
};

exports.default = CurrentLocation;


CurrentLocation.defaultProps = {
    zoom: 14,
    initialCenter: {
        lat: 15.470236,
        lng: 73.8254184
    },
    centerAroundCurrentLocation: false,
    visible: true
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calcTimeDelta", function() { return calcTimeDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTimeDelta", function() { return formatTimeDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zeroPad", function() { return zeroPad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function zeroPad(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var strValue = String(value);
  if (length === 0) return strValue;
  var match = strValue.match(/(.*?)([0-9]+)(.*)/);
  var prefix = match ? match[1] : '';
  var suffix = match ? match[3] : '';
  var strNo = match ? match[2] : strValue;
  var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function () {
    return '0';
  }).join('') + strNo).slice(length * -1);
  return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
  daysInHours: false,
  zeroPadTime: 2
};
function calcTimeDelta(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$now = _ref.now,
      now = _ref$now === void 0 ? Date.now : _ref$now,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 0 : _ref$precision,
      _ref$controlled = _ref.controlled,
      controlled = _ref$controlled === void 0 ? false : _ref$controlled,
      _ref$offsetTime = _ref.offsetTime,
      offsetTime = _ref$offsetTime === void 0 ? 0 : _ref$offsetTime;

  var startTimestamp;

  if (typeof date === 'string') {
    startTimestamp = new Date(date).getTime();
  } else if (date instanceof Date) {
    startTimestamp = date.getTime();
  } else {
    startTimestamp = date;
  }

  if (!controlled) {
    startTimestamp += offsetTime;
  }

  var total = Math.round(parseFloat((Math.max(0, controlled ? startTimestamp : startTimestamp - now()) / 1000).toFixed(Math.max(0, Math.min(20, precision)))) * 1000);
  var seconds = total / 1000;
  return {
    total: total,
    days: Math.floor(seconds / (3600 * 24)),
    hours: Math.floor(seconds / 3600 % 24),
    minutes: Math.floor(seconds / 60 % 60),
    seconds: Math.floor(seconds % 60),
    milliseconds: Number((seconds % 1 * 1000).toFixed()),
    completed: total <= 0
  };
}
function formatTimeDelta(delta, options) {
  var days = delta.days,
      hours = delta.hours,
      minutes = delta.minutes,
      seconds = delta.seconds;

  var _Object$assign = Object.assign({}, timeDeltaFormatOptionsDefaults, options),
      daysInHours = _Object$assign.daysInHours,
      zeroPadTime = _Object$assign.zeroPadTime,
      _Object$assign$zeroPa = _Object$assign.zeroPadDays,
      zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;

  var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, Math.min(2, zeroPadTime));
  return {
    days: daysInHours ? '' : zeroPad(days, zeroPadDays),
    hours: formattedHours,
    minutes: zeroPad(minutes, Math.min(2, zeroPadTime)),
    seconds: zeroPad(seconds, Math.min(2, zeroPadTime))
  };
}

var Countdown = function (_React$Component) {
  _inherits(Countdown, _React$Component);

  function Countdown() {
    var _this;

    _classCallCheck(this, Countdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Countdown).apply(this, arguments));
    _this.state = {
      count: _this.props.count || 3
    };

    _this.startCountdown = function () {
      _this.interval = window.setInterval(function () {
        var count = _this.state.count - 1;

        if (count === 0) {
          _this.stopCountdown();

          _this.props.onComplete && _this.props.onComplete();
        } else {
          _this.setState(function (prevState) {
            return {
              count: prevState.count - 1
            };
          });
        }
      }, 1000);
    };

    _this.stopCountdown = function () {
      clearInterval(_this.interval);
    };

    _this.addTime = function (seconds) {
      _this.stopCountdown();

      _this.setState(function (prevState) {
        return {
          count: prevState.count + seconds
        };
      }, _this.startCountdown);
    };

    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, {
        count: this.state.count
      }) : null;
    }
  }]);

  return Countdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Countdown.propTypes = {
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  onComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var Countdown$1 = function (_React$Component) {
  _inherits(Countdown$1, _React$Component);

  function Countdown$1(props) {
    var _this;

    _classCallCheck(this, Countdown$1);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Countdown$1).call(this, props));
    _this.mounted = false;
    _this.legacyMode = false;
    _this.legacyCountdownRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();

    _this.tick = function () {
      var onTick = _this.props.onTick;

      var timeDelta = _this.calcTimeDelta();

      _this.setTimeDeltaState(timeDelta);

      if (onTick && timeDelta.total > 0) {
        onTick(timeDelta);
      }
    };

    _this.start = function () {
      _this.setState(function (_ref) {
        var offsetStart = _ref.offsetStart,
            offsetTime = _ref.offsetTime;
        return {
          offsetStart: 0,
          offsetTime: offsetTime + (offsetStart ? Date.now() - offsetStart : 0)
        };
      }, function () {
        var timeDelta = _this.calcTimeDelta();

        _this.setTimeDeltaState(timeDelta);

        _this.props.onStart && _this.props.onStart(timeDelta);

        if (!_this.props.controlled) {
          _this.clearInterval();

          _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
        }
      });
    };

    _this.pause = function () {
      _this.clearInterval();

      _this.setState({
        offsetStart: _this.calcOffsetStart()
      }, function () {
        var timeDelta = _this.calcTimeDelta();

        _this.setTimeDeltaState(timeDelta);

        _this.props.onPause && _this.props.onPause(timeDelta);
      });
    };

    _this.isPaused = function () {
      return _this.state.offsetStart > 0;
    };

    _this.isCompleted = function () {
      return _this.state.timeDelta.completed;
    };

    if (props.date) {
      _this.state = {
        timeDelta: _this.calcTimeDelta(),
        offsetStart: props.autoStart ? 0 : _this.calcOffsetStart(),
        offsetTime: 0
      };
    } else {
      _this.legacyMode = true;
    }

    return _this;
  }

  _createClass(Countdown$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = true;
      this.props.autoStart && this.start();
      this.props.onMount && this.props.onMount(this.calcTimeDelta());
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.legacyMode) {
        return;
      }

      if (!this.shallowCompareProps(this.props, prevProps)) {
        this.setTimeDeltaState(this.calcTimeDelta());
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.legacyMode) {
        return;
      }

      this.mounted = false;
      this.clearInterval();
    }
  }, {
    key: "calcTimeDelta",
    value: function calcTimeDelta$1() {
      var _this$props = this.props,
          date = _this$props.date,
          now = _this$props.now,
          precision = _this$props.precision,
          controlled = _this$props.controlled;
      return calcTimeDelta(date, {
        now: now,
        precision: precision,
        controlled: controlled,
        offsetTime: this.state ? this.state.offsetTime : 0
      });
    }
  }, {
    key: "calcOffsetStart",
    value: function calcOffsetStart() {
      return Date.now();
    }
  }, {
    key: "addTime",
    value: function addTime(seconds) {
      this.legacyCountdownRef.current.addTime(seconds);
    }
  }, {
    key: "clearInterval",
    value: function clearInterval() {
      window.clearInterval(this.interval);
    }
  }, {
    key: "shallowCompareProps",
    value: function shallowCompareProps(propsA, propsB) {
      var keysA = Object.keys(propsA);
      return keysA.length === Object.keys(propsB).length && !keysA.some(function (keyA) {
        var valueA = propsA[keyA];
        var valueB = propsB[keyA];
        return !propsB.hasOwnProperty(keyA) || !(valueA === valueB || valueA !== valueA && valueB !== valueB);
      });
    }
  }, {
    key: "setTimeDeltaState",
    value: function setTimeDeltaState(timeDelta) {
      var _this2 = this;

      var callback;

      if (!this.state.timeDelta.completed && timeDelta.completed) {
        this.clearInterval();

        callback = function callback() {
          return _this2.props.onComplete && _this2.props.onComplete(timeDelta);
        };
      }

      if (this.mounted) {
        return this.setState({
          timeDelta: timeDelta
        }, callback);
      }
    }
  }, {
    key: "getApi",
    value: function getApi() {
      return this.api = this.api || {
        start: this.start,
        pause: this.pause,
        isPaused: this.isPaused,
        isCompleted: this.isCompleted
      };
    }
  }, {
    key: "getRenderProps",
    value: function getRenderProps() {
      var _this$props2 = this.props,
          daysInHours = _this$props2.daysInHours,
          zeroPadTime = _this$props2.zeroPadTime,
          zeroPadDays = _this$props2.zeroPadDays;
      var timeDelta = this.state.timeDelta;
      return Object.assign({}, timeDelta, {
        api: this.getApi(),
        props: this.props,
        formatted: formatTimeDelta(timeDelta, {
          daysInHours: daysInHours,
          zeroPadTime: zeroPadTime,
          zeroPadDays: zeroPadDays
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.legacyMode) {
        var _this$props3 = this.props,
            count = _this$props3.count,
            _children = _this$props3.children,
            onComplete = _this$props3.onComplete;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Countdown, {
          ref: this.legacyCountdownRef,
          count: count,
          onComplete: onComplete
        }, _children);
      }

      var _this$props4 = this.props,
          children = _this$props4.children,
          renderer = _this$props4.renderer;
      var renderProps = this.getRenderProps();

      if (renderer) {
        return renderer(renderProps);
      }

      if (children && this.state.timeDelta.completed) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
          countdown: renderProps
        });
      }

      var _renderProps$formatte = renderProps.formatted,
          days = _renderProps$formatte.days,
          hours = _renderProps$formatte.hours,
          minutes = _renderProps$formatte.minutes,
          seconds = _renderProps$formatte.seconds;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, days, days ? ':' : '', hours, ":", minutes, ":", seconds);
    }
  }]);

  return Countdown$1;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Countdown$1.defaultProps = Object.assign({}, timeDeltaFormatOptionsDefaults, {
  controlled: false,
  intervalDelay: 1000,
  precision: 0,
  autoStart: true
});
Countdown$1.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  daysInHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  zeroPadTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  zeroPadDays: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  controlled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  intervalDelay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  precision: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  autoStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  renderer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  now: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onTick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["default"] = (Countdown$1);



/***/ }),
/* 79 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(81)('keys');
var uid = __webpack_require__(50);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var global = __webpack_require__(22);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(49) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(285);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(34);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(33);
var dPs = __webpack_require__(292);
var enumBugKeys = __webpack_require__(87);
var IE_PROTO = __webpack_require__(80)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(134)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(295).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(24).f;
var has = __webpack_require__(27);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(49);
var wksExt = __webpack_require__(89);
var defineProperty = __webpack_require__(24).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(44),
    overRest = __webpack_require__(317),
    setToString = __webpack_require__(145);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(94),
    baseLodash = __webpack_require__(96);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(396),
    mapCacheDelete = __webpack_require__(403),
    mapCacheGet = __webpack_require__(405),
    mapCacheHas = __webpack_require__(406),
    mapCacheSet = __webpack_require__(407);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(19),
    isSymbol = __webpack_require__(59);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(104)('createBrowserHistory');
module.exports = __webpack_require__(105).createBrowserHistory;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(191);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(112);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(71);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return __WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */](pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(198)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(48),
    _assign = __webpack_require__(21);

var ReactNoopUpdateQueue = __webpack_require__(116);

var canDefineProperty = __webpack_require__(118);
var emptyObject = __webpack_require__(119);
var invariant = __webpack_require__(38);
var lowPriorityWarning = __webpack_require__(216);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(73);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrentLocation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    map: {
        position: 'absolute',
        width: '100%',
        height: '100%'
    }
};

var CurrentLocation = exports.CurrentLocation = function (_React$Component) {
    _inherits(CurrentLocation, _React$Component);

    function CurrentLocation(props) {
        _classCallCheck(this, CurrentLocation);

        var _this = _possibleConstructorReturn(this, (CurrentLocation.__proto__ || Object.getPrototypeOf(CurrentLocation)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props$initialCe = _this.props.initialCenter,
            lat = _this$props$initialCe.lat,
            lng = _this$props$initialCe.lng;

        _this.state = {
            currentLocation: {
                lat: lat,
                lng: lng
            },
            address: ''
        };
        return _this;
    }

    _createClass(CurrentLocation, [{
        key: 'recenterMap',
        value: function recenterMap() {
            var _this2 = this;

            var map = this.map;
            var current = this.state.currentLocation;

            var requestOption = {
                method: 'GET'
            };

            fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + current.lat + ',' + current.lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
                return res.json();
            }).then(function (response) {
                var address = response.results[0].formatted_address;
                //console.log('Inside Recenter');
                //console.log(address);
                _this2.setState({ address: address });
                _this2.handleGetAddress3();
            }).catch(function (error) {
                console.warn(error);
            });

            var google = this.props.google;
            var maps = google.maps;

            if (map) {
                var center = new maps.LatLng(current.lat, current.lng);
                map.panTo(center);
            }
        }
    }, {
        key: 'loadMap',
        value: function loadMap() {
            if (this.props && this.props.google) {
                // checks if google is available
                var google = this.props.google;

                var maps = google.maps;

                var mapRef = this.refs.map;

                // reference to the actual DOM element
                var node = _reactDom2.default.findDOMNode(mapRef);

                var zoom = this.props.zoom;
                var _state$currentLocatio = this.state.currentLocation,
                    lat = _state$currentLocatio.lat,
                    lng = _state$currentLocatio.lng;

                var center = new maps.LatLng(lat, lng);
                var mapConfig = Object.assign({}, {
                    center: center,
                    zoom: zoom
                });

                // maps.Map() is constructor that instantiates the map
                this.map = new maps.Map(node, mapConfig);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.google !== this.props.google) {
                //console.log('loadmap');
                this.loadMap();
            }
            if (prevState.currentLocation !== this.state.currentLocation) {
                //console.log('recentermap');
                this.recenterMap();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //console.log('mounted');
            this.loadMap();
            this.handleGetAddress3();
        }
    }, {
        key: 'renderChildren',
        value: function renderChildren() {
            var _this3 = this;

            var children = this.props.children;


            if (!children) return;

            //console.log(this.state.currentLocation);

            return _react2.default.Children.map(children, function (c) {
                if (!c) return;
                return _react2.default.cloneElement(c, {
                    map: _this3.map,
                    google: _this3.props.google,
                    mapCenter: _this3.state.currentLocation
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var style = Object.assign({}, mapStyles.map);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { style: { width: '100%', height: '300px', 'overFlow': 'hidden' }, ref: 'map' },
                    ' ',
                    _react2.default.createElement(_Loader2.default, null)
                ),
                this.renderChildren()
            );
        }
    }]);

    return CurrentLocation;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleGetAddress3 = function () {
        var _state$currentLocatio2 = _this4.state.currentLocation,
            lat = _state$currentLocatio2.lat,
            lng = _state$currentLocatio2.lng;

        _this4.props.handleGetAddress2(lat, lng);
    };
};

exports.default = CurrentLocation;


CurrentLocation.defaultProps = {
    zoom: 14,
    initialCenter: {
        lat: 15.470236,
        lng: 73.8254184
    },
    centerAroundCurrentLocation: false,
    visible: true
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _reactOwlCarousel = __webpack_require__(72);

var _reactOwlCarousel2 = _interopRequireDefault(_reactOwlCarousel);

__webpack_require__(74);

__webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeBanner = function HomeBanner(props) {

    var Banner = props.banners.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'item', key: post.ID },
            post.LINK != '' && _react2.default.createElement(
                _reactRouterDom.Link,
                { to: post.LINK },
                _react2.default.createElement('img', { src: post.IMAGE, alt: post.ALT, className: 'imaged square w-100' })
            ),
            post.LINK == '' && _react2.default.createElement('img', { src: post.IMAGE, alt: post.ALT, className: 'imaged square w-100' })
        );
    });

    var options = {
        items: 1,
        nav: false,
        loop: false,
        dots: true
    };

    return _react2.default.createElement(
        'div',
        { className: 'section full' },
        _react2.default.createElement(
            'div',
            { className: 'carousel-full owl-carousel owl-theme' },
            _react2.default.createElement(
                _reactOwlCarousel2.default,
                _extends({ className: 'owl-theme' }, options),
                Banner
            )
        )
    );
};

exports.default = HomeBanner;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeCategory = function HomeCategory(props) {

    var Category = props.categories.map(function (post, i) {

        var OfferType = '';
        var OfferType2 = '';
        if (post.OFFER_TYPE !== '') {
            if (post.OFFER_TYPE == 'PER') OfferType = '%';
            if (post.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
        }

        return _react2.default.createElement(
            'div',
            { className: 'col-6', key: post.ID },
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/category/' + post.ID },
                _react2.default.createElement(
                    'div',
                    { className: 'card mb-2' },
                    post.OFFER != '' && _react2.default.createElement(
                        'div',
                        { className: 'chip off-tags chip-warning' },
                        _react2.default.createElement(
                            'span',
                            { className: 'chip-label' },
                            OfferType2,
                            post.OFFER,
                            OfferType,
                            ' Off'
                        )
                    ),
                    _react2.default.createElement('img', { src: post.IMAGE, className: 'card-img-top', alt: 'image' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'card-body pt-07 pb-07 text-center categoryText' },
                        _react2.default.createElement(
                            'p',
                            { className: 'card-text font-size-13 text-dgrey font-weg-500' },
                            post.NAME
                        )
                    )
                )
            )
        );
    });

    return _react2.default.createElement(
        'div',
        { className: 'section pt-2 pb-2' },
        _react2.default.createElement(
            'div',
            { className: 'section-title font-size-17 mb-05 text-sdgrey' },
            'Categories',
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/categories' },
                _react2.default.createElement(
                    'span',
                    { className: 'badge badge-transparent font-size-10 ht-20 font-weg-500' },
                    'View All'
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'row' },
            Category
        )
    );
};

exports.default = HomeCategory;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _reactOwlCarousel = __webpack_require__(72);

var _reactOwlCarousel2 = _interopRequireDefault(_reactOwlCarousel);

__webpack_require__(74);

__webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = function Content(props) {
    var V = props.values.map(function (post, i) {

        var OfferType = '';
        var OfferType2 = '';
        if (post.OFFER_TYPE !== '') {
            if (post.OFFER_TYPE == 'PER') OfferType = '%';
            if (post.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
        }

        return _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/sections/' + post.REFID2, key: i },
            _react2.default.createElement(
                'div',
                { className: 'item' },
                _react2.default.createElement(
                    'div',
                    { className: 'card mb-0' },
                    post.OFFER != '' && _react2.default.createElement(
                        'div',
                        { className: 'chip off-tags chip-warning' },
                        _react2.default.createElement(
                            'span',
                            { className: 'chip-label' },
                            OfferType2,
                            post.OFFER,
                            OfferType,
                            ' Off'
                        )
                    ),
                    _react2.default.createElement('img', { src: post.IMAGE, className: 'card-img-top imaged w-100', alt: post.NAME }),
                    _react2.default.createElement(
                        'div',
                        { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                        _react2.default.createElement(
                            'p',
                            { className: 'card-text text-dgrey font-size-14 font-weg-500 mb-0' },
                            post.NAME
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'mb-0 text-slgrey' },
                            _react2.default.createElement(
                                'small',
                                null,
                                'Per ',
                                post.UNIT
                            )
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'mb-0 font-weg-600' },
                            post.MRP !== '0.00' && post.MRP !== post.RATE && _react2.default.createElement(
                                'span',
                                { className: 'del-price text-slgrey' },
                                _react2.default.createElement(
                                    'del',
                                    null,
                                    '\u20B9',
                                    post.MRP
                                )
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'final-price text-danger font-size-14' },
                                '\u20B9 ',
                                post.RATE
                            )
                        )
                    )
                )
            )
        );
    });

    var options = {
        items: 2,
        nav: false,
        loop: false,
        dots: false,
        stagePadding: 32
    };

    return _react2.default.createElement(
        'div',
        { className: 'carousel-multiple owl-carousel owl-theme' },
        _react2.default.createElement(
            _reactOwlCarousel2.default,
            _extends({ className: 'owl-theme', margin: 16 }, options),
            V
        )
    );
};

var Content2 = function Content2(props) {
    return props.values.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { key: i },
            post.LINK != '' && _react2.default.createElement(
                _reactRouterDom.Link,
                { to: post.LINK },
                _react2.default.createElement('img', { src: post.IMAGE, alt: post.NAME, className: 'img-fluid' })
            ),
            post.LINK == '' && _react2.default.createElement('img', { src: post.IMAGE, alt: post.NAME, className: 'img-fluid' })
        );
    });
};

var HomeManager = function HomeManager(props) {
    return props.home_manager.map(function (post, i) {
        if (post.COUNT == 'M') {
            return _react2.default.createElement(
                'div',
                { className: 'item-list section full mb-3', key: i },
                _react2.default.createElement(
                    'div',
                    { className: 'section-title font-size-17 mb-05 text-sdgrey' },
                    post.NAME,
                    post.LINK != '' && _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: post.LINK },
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-transparent font-size-10 ht-20 font-weg-500' },
                            'View All'
                        )
                    ),
                    post.LINK == '' && post.TYPE == 'GRP' && _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/sections/' + post.ID },
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-transparent font-size-10 ht-20 font-weg-500' },
                            'View All'
                        )
                    ),
                    post.LINK == '' && post.TYPE == 'ITM' && _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/sections/' + post.ID },
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-transparent font-size-10 ht-20 font-weg-500' },
                            'View All'
                        )
                    )
                ),
                _react2.default.createElement(Content, { values: post.VALUES })
            );
        } else {
            return _react2.default.createElement(
                'div',
                { className: 'section pb-2', key: i },
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-12' },
                        _react2.default.createElement(
                            'div',
                            { className: 'text-center' },
                            _react2.default.createElement(Content2, { values: post.VALUES })
                        )
                    )
                )
            );
        }
    });
};

exports.default = HomeManager;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeStores = function HomeStores(props) {

    var Store = props.stores.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'col-6', key: post.ID },
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/vendor/' + post.ID },
                _react2.default.createElement(
                    'div',
                    { className: 'card mb-2' },
                    _react2.default.createElement(
                        'div',
                        { className: 'storeHeight' },
                        _react2.default.createElement('img', { src: post.IMAGE, className: 'card-img-top', alt: post.NAME })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'card-body pt-07 pb-07 pr-06 pl-06 storeTextHeight' },
                        _react2.default.createElement(
                            'p',
                            { className: 'card-text text-dgrey font-size-12 font-weg-500 mb-0' },
                            post.NAME
                        ),
                        post.ITEMS != '' && _react2.default.createElement(
                            'p',
                            { className: 'mb-0 text-slgrey' },
                            _react2.default.createElement(
                                'small',
                                null,
                                post.ITEMS,
                                ' items'
                            )
                        )
                    )
                )
            )
        );
    });

    return _react2.default.createElement(
        'div',
        { className: 'section pt-0 pb-2' },
        _react2.default.createElement(
            'div',
            { className: 'section-title font-size-17 mb-05 text-sdgrey' },
            'Store in Store'
        ),
        _react2.default.createElement(
            'div',
            { className: 'row' },
            Store
        )
    );
};

exports.default = HomeStores;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Items = function (_React$Component) {
    _inherits(Items, _React$Component);

    function Items(props) {
        _classCallCheck(this, Items);

        var _this = _possibleConstructorReturn(this, (Items.__proto__ || Object.getPrototypeOf(Items)).call(this, props));

        _this.handleClickAddToCart = function (id, unit, vendor_id, vendor_name, vendortype_id) {
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var circleID = localStorage.getItem('delCIRCLE2');
            if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }
                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];
                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }
                return temp;
            };

            var cart = localStorage.getItem('cartData');
            var cartVendorID = localStorage.getItem('cartVendorID');
            var cartVendorName = localStorage.getItem('cartVendorName');
            var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + unit, 1);
                localStorage.setItem('cartData', JSON.stringify(a));
                localStorage.setItem('cartVendorID', vendor_id);
                localStorage.setItem('cartVendorName', vendor_name);
                localStorage.setItem('cartVendorTypeID', vendortype_id);

                var _inCart = 'Y';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, cartCount: _cartCount });
                _this.props.inCartCallBack();
            } else {
                var ALLOW_CART = 'Y';
                if (cartVendorID != vendor_id) {
                    var MSG = '';
                    if (cartVendorTypeID != vendortype_id) {
                        if (cartVendorTypeID == '2') MSG = 'Items from ' + cartVendorName + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;else if (vendortype_id == '2') MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;

                        ALLOW_CART = 'N';
                    } else {
                        if (cartVendorTypeID == '2' && vendortype_id == '2') {
                            MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;
                            ALLOW_CART = 'N';
                        }
                    }

                    if (ALLOW_CART == 'N') {
                        that.setState({ RESTRICTION_NOTE: MSG });
                        $('#ModalCartItemRestriction_' + id).modal('show');
                    }
                }

                if (ALLOW_CART == 'Y') {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');
                        if (cart_id[0] == id) cartTotalCount += cartData[key];

                        if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                    });
                    cartTotalCount += 1;

                    cartData = addToObject(cartData, [id + '~~**~~' + unit], 1);
                    localStorage.setItem('cartData', JSON.stringify(cartData));

                    var _inCart2 = 'Y';
                    var _cartCount2 = 1;
                    that.setState({ inCart: _inCart2, cartCount: cartTotalCount });
                    _this.props.inCartCallBack();
                }
            }
        };

        _this.handleClickIncreement = function (id, unit, cartCount, itemqty_cart) {
            var cartTotalCount = 0;
            if (itemqty_cart !== 0 && cartCount < itemqty_cart) {
                cartCount = cartCount + 1;

                var cart = localStorage.getItem('cartData');
                var that = _this;
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) cartTotalCount += cartData[key];

                    if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
                });
                cartTotalCount += 1;

                localStorage.setItem('cartData', JSON.stringify(cartData));

                var inCart = 'Y';
                cartCount = cartCount;
                that.setState({ inCart: inCart, cartCount: cartTotalCount });
                _this.props.inCartCallBack();
            } else $('#ModalCartItemLimit_' + id).modal('show');
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            cartCount = cartCount;
            that.setState({ inCart: inCart, cartCount: cartCount });
            _this.props.inCartCallBack();
        };

        _this.state = {
            items: props.items,
            RESTRICTION_NOTE: ''
        };
        return _this;
    }

    _createClass(Items, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ items: nextProps.items });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.state.items.map(function (item) {

                var inCart = 'N'; //this.state.inCart;
                var added = ''; //this.state.addButton;
                var cartCount = 0; //this.state.cartCount;

                var currentITEM = item.ID;
                var cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var id = key.split('~~**~~');
                        if (id[0] == currentITEM) {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                var OfferType = '';
                var OfferType2 = '';
                if (item.OFFER_TYPE !== '') {
                    if (item.OFFER_TYPE == 'PER') OfferType = '%';
                    if (item.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: item.ID },
                    _react2.default.createElement(
                        'div',
                        { className: 'card  mb-2' },
                        item.OFFER != '' && _react2.default.createElement(
                            'div',
                            { className: 'chip off-tags chip-warning' },
                            _react2.default.createElement(
                                'span',
                                { className: 'chip-label' },
                                OfferType2,
                                item.OFFER,
                                OfferType,
                                ' Off'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'itemsHeight' },
                            _react2.default.createElement('img', { src: item.PIC, className: 'card-img-top imaged w-100', alt: item.NAME })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                            _react2.default.createElement(
                                'p',
                                { className: 'card-text text-dgrey font-size-14 font-weg-400 mb-0 itemsText' },
                                item.NAME
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 text-slgrey' },
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Per ',
                                    item.UNIT
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 font-weg-600' },
                                item.MRP !== '0.00' && item.MRP !== item.RATE && _react2.default.createElement(
                                    'span',
                                    { className: 'del-price text-slgrey' },
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        '\u20B9',
                                        item.MRP
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'final-price text-danger font-size-14' },
                                    '\u20B9 ',
                                    item.RATE
                                )
                            ),
                            item.AVAILABLE_QTY > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'add-btn ' + added + ' mt-2' },
                                    _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                        }, value: '-', className: 'qtyminus' }),
                                    _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                    inCart == 'Y' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickIncreement(item.ID, item.UNIT, cartCount, item.QTY_PER_CART);
                                        }, value: '+', className: 'qtyplus' }),
                                    inCart == 'N' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickAddToCart(item.ID, item.UNIT, item.VENDOR_ID, item.VENDOR_NAME, item.VENDORTYPE_ID);
                                        }, value: '+', className: 'qtyplus' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemLimit_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                'You have reached the limit for this item'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemRestriction_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                _this2.state.RESTRICTION_NOTE
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            item.AVAILABLE_QTY == 0 && _react2.default.createElement(
                                'div',
                                { className: 'add-btn add-btn-incr mt-2 font-size-12' },
                                'Out Of Stock'
                            )
                        )
                    )
                );
            });
        }
    }]);

    return Items;
}(_react2.default.Component);

exports.default = Items;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(props) {
    return props.post.map(function (post2) {
        return _react2.default.createElement(
            'option',
            { key: post2.id, value: post2.id },
            post2.name
        );
    });
};

exports.default = Option;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartToast = function CartToast(props) {

    var cartItemCount = 0;
    var cartItemTotal = 0;
    var cart = localStorage.getItem('cartData');
    var cartData = JSON.parse(cart);
    //console.log(cart);
    //console.log(cartData);
    if (cart !== null && cart !== '{}') {
        Object.keys(cartData).forEach(function (key) {
            var Rate = 0;
            var itemTOTAL = 0;

            var cart_id = key.split('~~**~~');
            var itemID = cart_id[0];
            var itemCOUNT = cartData[key];
            var itemCUSTOM = cart_id[1];

            props.items.map(function (item) {
                if (item.ITEMID == itemID) {
                    Rate = item.RATE;
                }
            });

            if (itemCUSTOM != 'N') {
                var custom = itemCUSTOM.split('|');
                //console.log(custom);
                if (custom != '') {
                    custom.forEach(function (val) {
                        var val2 = val.split('~');
                        Rate = parseFloat(Rate) + parseFloat(val2[3]);
                        //console.log(Rate);
                    });
                }
            }

            itemTOTAL = itemCOUNT * Rate;

            cartItemCount = cartItemCount + itemCOUNT;
            cartItemTotal = cartItemTotal + itemTOTAL;
        });
    }

    var ToastCSS = cartItemCount != 0 ? ' show' : '';

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'div',
            { id: 'toast-5', className: 'toast-box toast-bottom bottom-toast' + ToastCSS },
            _react2.default.createElement(
                'div',
                { className: 'in' },
                _react2.default.createElement(
                    'div',
                    { className: 'text' },
                    _react2.default.createElement(
                        'div',
                        { className: 'text-items' },
                        cartItemCount != 0 && cartItemCount,
                        ' Dish',
                        cartItemCount != 1 ? 'es' : ''
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'dish-price' },
                        '\u20B9 ',
                        cartItemTotal
                    )
                )
            ),
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/cart', className: 'btn btn-sm btn-text-primary' },
                ' CONFIRM'
            )
        )
    );
};

exports.default = CartToast;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__(280);

var _reactGoogleAutocomplete = __webpack_require__(480);

var _reactGoogleAutocomplete2 = _interopRequireDefault(_reactGoogleAutocomplete);

var _reactGeocode = __webpack_require__(482);

var _reactGeocode2 = _interopRequireDefault(_reactGeocode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_reactGeocode2.default.setApiKey("AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U");
_reactGeocode2.default.enableDebug();

var Map = function (_React$Component) {
  _inherits(Map, _React$Component);

  function Map(props) {
    _classCallCheck(this, Map);

    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

    _this.getCity = function (addressArray) {
      var city = '';
      for (var i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
          city = addressArray[i].long_name;
          return city;
        }
      }
    };

    _this.getArea = function (addressArray) {
      var area = '';
      for (var i = 0; i < addressArray.length; i++) {
        if (addressArray[i].types[0]) {
          for (var j = 0; j < addressArray[i].types.length; j++) {
            if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
              area = addressArray[i].long_name;
              return area;
            }
          }
        }
      }
    };

    _this.getState = function (addressArray) {
      var state = '';
      for (var i = 0; i < addressArray.length; i++) {
        for (var _i = 0; _i < addressArray.length; _i++) {
          if (addressArray[_i].types[0] && 'administrative_area_level_1' === addressArray[_i].types[0]) {
            state = addressArray[_i].long_name;
            return state;
          }
        }
      }
    };

    _this.onChange = function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.onInfoWindowClose = function (event) {};

    _this.onPlaceSelected = function (place) {
      var address = place.formatted_address,
          addressArray = place.address_components,
          city = _this.getCity(addressArray),
          area = _this.getArea(addressArray),
          state = _this.getState(addressArray),
          latValue = place.geometry.location.lat(),
          lngValue = place.geometry.location.lng(); // Set these values in the state.
      _this.setState({
        address: address ? address : '',
        area: area ? area : '',
        city: city ? city : '',
        state: state ? state : '',
        markerPosition: {
          lat: latValue,
          lng: lngValue
        },
        mapPosition: {
          lat: latValue,
          lng: lngValue
        }
      });
    };

    _this.onMarkerDragEnd = function (event) {
      console.log('event', event);
      var newLat = event.latLng.lat(),
          newLng = event.latLng.lng(),
          addressArray = [];_reactGeocode2.default.fromLatLng(newLat, newLng).then(function (response) {
        var address = response.results[0].formatted_address,
            addressArray = response.results[0].address_components,
            city = _this.getCity(addressArray),
            area = _this.getArea(addressArray),
            state = _this.getState(addressArray);_this.setState({
          address: address ? address : '',
          area: area ? area : '',
          city: city ? city : '',
          state: state ? state : ''
        });
      }, function (error) {
        console.error(error);
      });
    };

    _this.state = {
      address: '',
      city: '',
      area: '',
      state: '',
      mapPosition: {
        lat: _this.props.center.lat,
        lng: _this.props.center.lng
      },
      markerPosition: {
        lat: _this.props.center.lat,
        lng: _this.props.center.lng }
    };
    return _this;
  }

  /**
   * Get the current address from the default map position and set those values in the state
   */

  _createClass(Map, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _reactGeocode2.default.fromLatLng(this.state.mapPosition.lat, this.state.mapPosition.lng).then(function (response) {
        var address = response.results[0].formatted_address,
            addressArray = response.results[0].address_components,
            city = _this2.getCity(addressArray),
            area = _this2.getArea(addressArray),
            state = _this2.getState(addressArray);

        console.log('city', city, area, state);

        _this2.setState({
          address: address ? address : '',
          area: area ? area : '',
          city: city ? city : '',
          state: state ? state : ''
        });
      }, function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'shouldComponentUpdate',

    /**
     * Component should only update ( meaning re-render ), when the user selects the address, or drags the pin
     *
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.markerPosition.lat !== this.props.center.lat || this.state.address !== nextState.address || this.state.city !== nextState.city || this.state.area !== nextState.area || this.state.state !== nextState.state) {
        return true;
      } else if (this.props.center.lat === nextProps.center.lat) {
        return false;
      }
    } /**
      * Get the city and set the city input value to the one selected
      *
      * @param addressArray
      * @return {string}
      */
    /**
    * Get the area and set the area input value to the one selected
    *
    * @param addressArray
    * @return {string}
    */


    /**
     * Get the address and set the address input value to the one selected
     *
     *@param addressArray
     *@return {string}
    */

    /**
    * And function for city,state and address input
    * @param event
    */
    /**
    * This Event triggers when the marker window is closed
    *
    * @param event
    */
    /**
    * When the user types an address in the search box
    * @param place
    */
    /**
    * When the marker is dragged you get the lat and long using the functions available from event object.
    * Use geocode to get the address, city, area and state from the lat and lng positions.
    * And then set those values in the state.
    *
    * @param event
    */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var AsyncMap = (0, _reactGoogleMaps.withScriptjs)((0, _reactGoogleMaps.withGoogleMap)(function (props) {
        return _react2.default.createElement(
          _reactGoogleMaps.GoogleMap,
          { google: _this3.props.google,
            defaultZoom: _this3.props.zoom,
            defaultCenter: { lat: _this3.state.mapPosition.lat, lng: _this3.state.mapPosition.lng }
          },
          _react2.default.createElement(_reactGoogleAutocomplete2.default, {
            style: {
              width: '100%',
              height: '40px',
              paddingLeft: '16px',
              marginTop: '2px',
              marginBottom: '100px'
            },
            onPlaceSelected: _this3.onPlaceSelected,
            types: ['(regions)']
          }),
          _react2.default.createElement(_reactGoogleMaps.Marker, { google: _this3.props.google,
            name: 'Dolores park',
            draggable: true,
            onDragEnd: _this3.onMarkerDragEnd,
            position: { lat: _this3.state.markerPosition.lat, lng: _this3.state.markerPosition.lng }
          }),
          _react2.default.createElement(_reactGoogleMaps.Marker, null),
          _react2.default.createElement(
            _reactGoogleMaps.InfoWindow,
            {
              onClose: _this3.onInfoWindowClose,
              position: { lat: _this3.state.markerPosition.lat + 0.0018, lng: _this3.state.markerPosition.lng }
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { style: { padding: 0, margin: 0 } },
                _this3.state.address
              )
            )
          )
        );
      }));var map = void 0;
      if (this.props.center.lat !== undefined) {
        map = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: '' },
                'City'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'city', className: 'form-control', onChange: this.onChange, readOnly: 'readOnly', value: this.state.city })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: '' },
                'Area'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'area', className: 'form-control', onChange: this.onChange, readOnly: 'readOnly', value: this.state.area })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: '' },
                'State'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'state', className: 'form-control', onChange: this.onChange, readOnly: 'readOnly', value: this.state.state })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group' },
              _react2.default.createElement(
                'label',
                { htmlFor: '' },
                'Address'
              ),
              _react2.default.createElement('input', { type: 'text', name: 'address', className: 'form-control', onChange: this.onChange, readOnly: 'readOnly', value: this.state.address })
            )
          ),
          _react2.default.createElement(AsyncMap, {
            googleMapURL: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U&libraries=places',
            loadingElement: _react2.default.createElement('div', { style: { height: '100%' } }),
            containerElement: _react2.default.createElement('div', { style: { height: this.props.height } }),
            mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
          })
        );
      } else {
        map = _react2.default.createElement('div', { style: { height: this.props.height } });
      }
      return map;
    }
  }]);

  return Map;
}(_react2.default.Component);

exports.default = Map;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(27);
var toObject = __webpack_require__(41);
var IE_PROTO = __webpack_require__(80)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(25) && !__webpack_require__(35)(function () {
  return Object.defineProperty(__webpack_require__(134)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
var document = __webpack_require__(22).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(286), __esModule: true };

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(288);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(300);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(290)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(138)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(49);
var $export = __webpack_require__(23);
var redefine = __webpack_require__(139);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(43);
var $iterCreate = __webpack_require__(291);
var setToStringTag = __webpack_require__(88);
var getPrototypeOf = __webpack_require__(132);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(32);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(27);
var toIObject = __webpack_require__(36);
var arrayIndexOf = __webpack_require__(293)(false);
var IE_PROTO = __webpack_require__(80)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(86);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(84);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(140);
var hiddenKeys = __webpack_require__(87).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(52);
var createDesc = __webpack_require__(42);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(83);
var has = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(133);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(318),
    shortOut = __webpack_require__(149);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 148 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(44),
    metaMap = __webpack_require__(151);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(152);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(154),
    composeArgsRight = __webpack_require__(155),
    countHolders = __webpack_require__(329),
    createCtor = __webpack_require__(56),
    createRecurry = __webpack_require__(156),
    getHolder = __webpack_require__(97),
    reorder = __webpack_require__(344),
    replaceHolders = __webpack_require__(58),
    root = __webpack_require__(17);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(330),
    setData = __webpack_require__(160),
    setWrapToString = __webpack_require__(161);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(151),
    noop = __webpack_require__(331);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(94),
    baseLodash = __webpack_require__(96);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(150),
    shortOut = __webpack_require__(149);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(336),
    insertWrapDetails = __webpack_require__(337),
    setToString = __webpack_require__(145),
    updateWrapDetails = __webpack_require__(338);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29),
    isSymbol = __webpack_require__(59);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(351);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default.a(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = __WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"](), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = __WEBPACK_IMPORTED_MODULE_0_react__["createFactory"](BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = __WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"]();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(369),
    createBaseEach = __webpack_require__(382);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(374),
    isObjectLike = __webpack_require__(37);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(17),
    stubFalse = __webpack_require__(375);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module)))

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(376),
    baseUnary = __webpack_require__(377),
    nodeUtil = __webpack_require__(378);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(62),
    stackClear = __webpack_require__(391),
    stackDelete = __webpack_require__(392),
    stackGet = __webpack_require__(393),
    stackHas = __webpack_require__(394),
    stackSet = __webpack_require__(395);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(408),
    isObjectLike = __webpack_require__(37);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(409),
    arraySome = __webpack_require__(412),
    cacheHas = __webpack_require__(413);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(29);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(178),
    toKey = __webpack_require__(67);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(19),
    isKey = __webpack_require__(101),
    stringToPath = __webpack_require__(432),
    toString = __webpack_require__(179);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(435);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(178),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(19),
    isIndex = __webpack_require__(57),
    isLength = __webpack_require__(98),
    toKey = __webpack_require__(67);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(183),
    eq = __webpack_require__(64);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(146);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.history = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _createBrowserHistory = __webpack_require__(103);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _reactFontawesome = __webpack_require__(211);

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Intro = __webpack_require__(213);

var _Intro2 = _interopRequireDefault(_Intro);

var _PlotMap = __webpack_require__(233);

var _PlotMap2 = _interopRequireDefault(_PlotMap);

var _PlotMap3 = __webpack_require__(249);

var _PlotMap4 = _interopRequireDefault(_PlotMap3);

var _Home = __webpack_require__(250);

var _Home2 = _interopRequireDefault(_Home);

var _Categories = __webpack_require__(252);

var _Categories2 = _interopRequireDefault(_Categories);

var _Category = __webpack_require__(253);

var _Category2 = _interopRequireDefault(_Category);

var _Sections = __webpack_require__(254);

var _Sections2 = _interopRequireDefault(_Sections);

var _Vendors = __webpack_require__(256);

var _Vendors2 = _interopRequireDefault(_Vendors);

var _Locate = __webpack_require__(258);

var _Locate2 = _interopRequireDefault(_Locate);

var _SpecialDish = __webpack_require__(259);

var _SpecialDish2 = _interopRequireDefault(_SpecialDish);

var _Listing = __webpack_require__(263);

var _Listing2 = _interopRequireDefault(_Listing);

var _Cart = __webpack_require__(266);

var _Cart2 = _interopRequireDefault(_Cart);

var _Checkout = __webpack_require__(270);

var _Checkout2 = _interopRequireDefault(_Checkout);

var _ChangeAddress = __webpack_require__(271);

var _ChangeAddress2 = _interopRequireDefault(_ChangeAddress);

var _AddAddress = __webpack_require__(272);

var _AddAddress2 = _interopRequireDefault(_AddAddress);

var _AddAddress3 = __webpack_require__(273);

var _AddAddress4 = _interopRequireDefault(_AddAddress3);

var _Login = __webpack_require__(274);

var _Login2 = _interopRequireDefault(_Login);

var _ForgotPassword = __webpack_require__(275);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _SmsVerification = __webpack_require__(276);

var _SmsVerification2 = _interopRequireDefault(_SmsVerification);

var _Register = __webpack_require__(277);

var _Register2 = _interopRequireDefault(_Register);

var _SmsVerification3 = __webpack_require__(278);

var _SmsVerification4 = _interopRequireDefault(_SmsVerification3);

var _LocateInMap = __webpack_require__(279);

var _LocateInMap2 = _interopRequireDefault(_LocateInMap);

var _Profile = __webpack_require__(484);

var _Profile2 = _interopRequireDefault(_Profile);

var _AccountSettings = __webpack_require__(485);

var _AccountSettings2 = _interopRequireDefault(_AccountSettings);

var _ChangePassword = __webpack_require__(486);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _CustomerAddresses = __webpack_require__(487);

var _CustomerAddresses2 = _interopRequireDefault(_CustomerAddresses);

var _CustomerAddressDetails = __webpack_require__(488);

var _CustomerAddressDetails2 = _interopRequireDefault(_CustomerAddressDetails);

var _CustomerOrders = __webpack_require__(489);

var _CustomerOrders2 = _interopRequireDefault(_CustomerOrders);

var _CustomerOrdersDetails = __webpack_require__(490);

var _CustomerOrdersDetails2 = _interopRequireDefault(_CustomerOrdersDetails);

var _SubmitOrder = __webpack_require__(491);

var _SubmitOrder2 = _interopRequireDefault(_SubmitOrder);

var _CustomerOrderTrack = __webpack_require__(492);

var _CustomerOrderTrack2 = _interopRequireDefault(_CustomerOrderTrack);

var _OnlinePay = __webpack_require__(493);

var _OnlinePay2 = _interopRequireDefault(_OnlinePay);

var _Failure = __webpack_require__(495);

var _Failure2 = _interopRequireDefault(_Failure);

var _Map = __webpack_require__(130);

var _Map2 = _interopRequireDefault(_Map);

var _SearchLocation = __webpack_require__(496);

var _SearchLocation2 = _interopRequireDefault(_SearchLocation);

var _AboutUs = __webpack_require__(497);

var _AboutUs2 = _interopRequireDefault(_AboutUs);

var _CancellationRefunds = __webpack_require__(498);

var _CancellationRefunds2 = _interopRequireDefault(_CancellationRefunds);

var _Disclaimer = __webpack_require__(499);

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

var _PrivacyPolicy = __webpack_require__(500);

var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);

var _TermsConditions = __webpack_require__(501);

var _TermsConditions2 = _interopRequireDefault(_TermsConditions);

var _VerifyMobile = __webpack_require__(502);

var _VerifyMobile2 = _interopRequireDefault(_VerifyMobile);

var _SmsVerification5 = __webpack_require__(503);

var _SmsVerification6 = _interopRequireDefault(_SmsVerification5);

var _SpecialOffers = __webpack_require__(504);

var _SpecialOffers2 = _interopRequireDefault(_SpecialOffers);

var _Reorder = __webpack_require__(505);

var _Reorder2 = _interopRequireDefault(_Reorder);

var _ReOrder = __webpack_require__(507);

var _ReOrder2 = _interopRequireDefault(_ReOrder);

var _SearchItems = __webpack_require__(508);

var _SearchItems2 = _interopRequireDefault(_SearchItems);

__webpack_require__(510);

__webpack_require__(511);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import AppRouter from './routers/AppRouter';
var history = exports.history = (0, _createBrowserHistory2.default)();

var NotFoundPage = function NotFoundPage() {
    return _react2.default.createElement(
        'div',
        { className: 'news-content', id: 'adver-page' },
        _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
                'div',
                { className: 'ad-box not-found' },
                _react2.default.createElement(
                    'h1',
                    null,
                    '404 Page Not Found'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Sorry, the page you are looking for could not be found'
                )
            )
        )
    );
};

var WebContent = _react2.default.createElement(
    _reactRouterDom.Router,
    { history: history },
    _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: _Intro2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/map', component: _PlotMap2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/map2/:id', component: _PlotMap4.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/search', component: _SearchLocation2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/home', component: _Home2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/categories', component: _Categories2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/category/:id', component: _Category2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/sections/:id', component: _Sections2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/vendor/:id', component: _Vendors2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/cart', component: _Cart2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/login', component: _Login2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/forgot-password', component: _ForgotPassword2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/sms_verification2', component: _SmsVerification2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/change_password', component: _ChangePassword2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/register', component: _Register2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/sms_verification', component: _SmsVerification4.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/checkout', component: _Checkout2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/profile', component: _Profile2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/orders', component: _CustomerOrders2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/ordertrack/:id/:showModal', component: _CustomerOrderTrack2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/ordertrack/:id', component: _CustomerOrderTrack2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/orderdetails/:id', component: _CustomerOrdersDetails2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/addresses', component: _CustomerAddresses2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/addressdetails/:id', component: _CustomerAddressDetails2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/addaddress2', component: _AddAddress4.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/account_settings', component: _AccountSettings2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/changeaddress', component: _ChangeAddress2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/addaddress', component: _AddAddress2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/submit_order', component: _SubmitOrder2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/pay/:id', component: _OnlinePay2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/failure', component: _Failure2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/verifyMobile', component: _VerifyMobile2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/smsverifyMobile', component: _SmsVerification6.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/reorder', component: _Reorder2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/reorder/:id', component: _ReOrder2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/search/:search_text', component: _SearchItems2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/about-us', component: _AboutUs2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/cancellation-and-refunds', component: _CancellationRefunds2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/disclaimer', component: _Disclaimer2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/privacy-policy', component: _PrivacyPolicy2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/terms-and-conditions', component: _TermsConditions2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/special-offers', component: _SpecialOffers2.default, exact: true }),
            _react2.default.createElement(_reactRouterDom.Route, { component: NotFoundPage })
        )
    )
);

//export default App;
_reactDom2.default.render(WebContent, document.getElementById('app'));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(21),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(21),r=__webpack_require__(187);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(188);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(68);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default.a(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(102);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(n){return n&&"object"==typeof n&&"default"in n?n.default:n}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(106)),valueEqual=_interopDefault(__webpack_require__(107));__webpack_require__(108);var invariant=_interopDefault(__webpack_require__(109));function _extends(){return(_extends=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a])}return n}).apply(this,arguments)}function addLeadingSlash(n){return"/"===n.charAt(0)?n:"/"+n}function stripLeadingSlash(n){return"/"===n.charAt(0)?n.substr(1):n}function hasBasename(n,t){return new RegExp("^"+t+"(\\/|\\?|#|$)","i").test(n)}function stripBasename(n,t){return hasBasename(n,t)?n.substr(t.length):n}function stripTrailingSlash(n){return"/"===n.charAt(n.length-1)?n.slice(0,-1):n}function parsePath(n){var t=n||"/",e="",a="",o=t.indexOf("#");-1!==o&&(a=t.substr(o),t=t.substr(0,o));var r=t.indexOf("?");return-1!==r&&(e=t.substr(r),t=t.substr(0,r)),{pathname:t,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(n){var t=n.pathname,e=n.search,a=n.hash,o=t||"/";return e&&"?"!==e&&(o+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(o+="#"===a.charAt(0)?a:"#"+a),o}function createLocation(n,t,e,a){var o;"string"==typeof n?(o=parsePath(n)).state=t:(void 0===(o=_extends({},n)).pathname&&(o.pathname=""),o.search?"?"!==o.search.charAt(0)&&(o.search="?"+o.search):o.search="",o.hash?"#"!==o.hash.charAt(0)&&(o.hash="#"+o.hash):o.hash="",void 0!==t&&void 0===o.state&&(o.state=t));try{o.pathname=decodeURI(o.pathname)}catch(n){throw n instanceof URIError?new URIError('Pathname "'+o.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):n}return e&&(o.key=e),a?o.pathname?"/"!==o.pathname.charAt(0)&&(o.pathname=resolvePathname(o.pathname,a.pathname)):o.pathname=a.pathname:o.pathname||(o.pathname="/"),o}function locationsAreEqual(n,t){return n.pathname===t.pathname&&n.search===t.search&&n.hash===t.hash&&n.key===t.key&&valueEqual(n.state,t.state)}function createTransitionManager(){var r=null;var a=[];return{setPrompt:function(n){return r=n,function(){r===n&&(r=null)}},confirmTransitionTo:function(n,t,e,a){if(null!=r){var o="function"==typeof r?r(n,t):r;"string"==typeof o?"function"==typeof e?e(o,a):a(!0):a(!1!==o)}else a(!0)},appendListener:function(n){var t=!0;function e(){t&&n.apply(void 0,arguments)}return a.push(e),function(){t=!1,a=a.filter(function(n){return n!==e})}},notifyListeners:function(){for(var n=arguments.length,t=new Array(n),e=0;e<n;e++)t[e]=arguments[e];a.forEach(function(n){return n.apply(void 0,t)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(n,t){t(window.confirm(n))}function supportsHistory(){var n=window.navigator.userAgent;return(-1===n.indexOf("Android 2.")&&-1===n.indexOf("Android 4.0")||-1===n.indexOf("Mobile Safari")||-1!==n.indexOf("Chrome")||-1!==n.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(n){void 0===n.state&&navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(n){return{}}}function createBrowserHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var c=window.history,s=supportsHistory(),t=!supportsPopStateOnHashChange(),e=n,a=e.forceRefresh,h=void 0!==a&&a,o=e.getUserConfirmation,u=void 0===o?getConfirmation:o,r=e.keyLength,i=void 0===r?6:r,f=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"";function l(n){var t=n||{},e=t.key,a=t.state,o=window.location,r=o.pathname+o.search+o.hash;return f&&(r=stripBasename(r,f)),createLocation(r,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(n){_extends(T,n),T.length=c.length,v.notifyListeners(T.location,T.action)}function g(n){isExtraneousPopstateEvent(n)||w(l(n.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(t){if(m)m=!1,p();else{v.confirmTransitionTo(t,"POP",u,function(n){n?p({action:"POP",location:t}):function(n){var t=T.location,e=H.indexOf(t.key);-1===e&&(e=0);var a=H.indexOf(n.key);-1===a&&(a=0);var o=e-a;o&&(m=!0,L(o))}(t)})}}var y=l(getHistoryState()),H=[y.key];function x(n){return f+createPath(n)}function L(n){c.go(n)}var O=0;function E(n){1===(O+=n)&&1===n?(window.addEventListener(PopStateEvent,g),t&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),t&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:c.length,action:"POP",location:y,createHref:x,push:function(n,t){var i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.pushState({key:e,state:a},null,t),h)window.location.href=t;else{var o=H.indexOf(T.location.key),r=H.slice(0,-1===o?0:o+1);r.push(i.key),H=r,p({action:"PUSH",location:i})}else window.location.href=t}})},replace:function(n,t){var r="REPLACE",i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,r,u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.replaceState({key:e,state:a},null,t),h)window.location.replace(t);else{var o=H.indexOf(T.location.key);-1!==o&&(H[o]=i.key),p({action:r,location:i})}else window.location.replace(t)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(n){void 0===n&&(n=!1);var t=v.setPrompt(n);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),t()}},listen:function(n){var t=v.appendListener(n);return E(1),function(){E(-1),t()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(n){return"!"===n.charAt(0)?n:"!/"+stripLeadingSlash(n)},decodePath:function(n){return"!"===n.charAt(0)?n.substr(1):n}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function getHashPath(){var n=window.location.href,t=n.indexOf("#");return-1===t?"":n.substring(t+1)}function pushHashPath(n){window.location.hash=n}function replaceHashPath(n){var t=window.location.href.indexOf("#");window.location.replace(window.location.href.slice(0,0<=t?t:0)+"#"+n)}function createHashHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var t=window.history,e=(supportsGoWithoutReloadUsingHash(),n),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,o=e.hashType,r=void 0===o?"slash":o,c=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"",s=HashPathCoders[r],h=s.encodePath,u=s.decodePath;function f(){var n=u(getHashPath());return c&&(n=stripBasename(n,c)),createLocation(n)}var l=createTransitionManager();function d(n){_extends(E,n),E.length=t.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var n=getHashPath(),t=h(n);if(n!==t)replaceHashPath(t);else{var e=f(),a=E.location;if(!v&&locationsAreEqual(a,e))return;if(p===createPath(e))return;p=null,function(t){if(v)v=!1,d();else{l.confirmTransitionTo(t,"POP",i,function(n){n?d({action:"POP",location:t}):function(n){var t=E.location,e=y.lastIndexOf(createPath(t));-1===e&&(e=0);var a=y.lastIndexOf(createPath(n));-1===a&&(a=0);var o=e-a;o&&(v=!0,H(o))}(t)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(n){t.go(n)}var x=0;function L(n){1===(x+=n)&&1===n?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:t.length,action:"POP",location:w,createHref:function(n){return"#"+h(c+createPath(n))},push:function(n,t){var r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,"PUSH",i,function(n){if(n){var t=createPath(r),e=h(c+t);if(getHashPath()!==e){p=t,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),o=y.slice(0,-1===a?0:a+1);o.push(t),y=o,d({action:"PUSH",location:r})}else d()}})},replace:function(n,t){var o="REPLACE",r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,o,i,function(n){if(n){var t=createPath(r),e=h(c+t);getHashPath()!==e&&(p=t,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=t),d({action:o,location:r})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(n){void 0===n&&(n=!1);var t=l.setPrompt(n);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),t()}},listen:function(n){var t=l.appendListener(n);return L(1),function(){L(-1),t()}}};return E}function clamp(n,t,e){return Math.min(Math.max(n,t),e)}function createMemoryHistory(n){void 0===n&&(n={});var t=n,o=t.getUserConfirmation,e=t.initialEntries,a=void 0===e?["/"]:e,r=t.initialIndex,i=void 0===r?0:r,c=t.keyLength,s=void 0===c?6:c,h=createTransitionManager();function u(n){_extends(g,n),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,s)}var l=clamp(i,0,a.length-1),d=a.map(function(n){return createLocation(n,void 0,"string"==typeof n?f():n.key||f())}),v=createPath;function p(n){var t=clamp(g.index+n,0,g.entries.length-1),e=g.entries[t];h.confirmTransitionTo(e,"POP",o,function(n){n?u({action:"POP",location:e,index:t}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(n,t){var a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,"PUSH",o,function(n){if(n){var t=g.index+1,e=g.entries.slice(0);e.length>t?e.splice(t,e.length-t,a):e.push(a),u({action:"PUSH",location:a,index:t,entries:e})}})},replace:function(n,t){var e="REPLACE",a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,e,o,function(n){n&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(n){var t=g.index+n;return 0<=t&&t<g.entries.length},block:function(n){return void 0===n&&(n=!1),h.setPrompt(n)},listen:function(n){return h.appendListener(n)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(68);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default.a(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(104)('createHashHistory');
module.exports = __webpack_require__(105).createHashHistory;


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(195);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(69);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["b" /* createMemoryHistory */](_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(200);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default.a(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(202);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(203);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = __WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */](prevProps.to);
    var nextTo = __WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */](this.props.to);

    if (__WEBPACK_IMPORTED_MODULE_4_history__["d" /* locationsAreEqual */](prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default.a(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return __WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */](to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: __WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */](to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(205);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : __WEBPACK_IMPORTED_MODULE_4_history__["c" /* createPath */](location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, __WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */](location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, __WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */](location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default.a(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, __WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */](location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(207);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(71);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default.a(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default.a(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default.a(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = __WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */](location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(71);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(210);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(112);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default.a(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _screenReaderStyles = __webpack_require__(212);

var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
module.exports = exports['default'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _reactOwlCarousel = __webpack_require__(72);

var _reactOwlCarousel2 = _interopRequireDefault(_reactOwlCarousel);

__webpack_require__(74);

__webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Intro = function (_React$Component) {
    _inherits(Intro, _React$Component);

    function Intro(props) {
        _classCallCheck(this, Intro);

        var _this = _possibleConstructorReturn(this, (Intro.__proto__ || Object.getPrototypeOf(Intro)).call(this, props));

        _this.state = {
            LOADING: 'Y'
        };
        return _this;
    }

    _createClass(Intro, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            /*setTimeout(() => {
                this.setState({ LOADING:'N' });
            }, 3000)*/
            this.setState({ LOADING: 'N' });
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.LOADING == 'N') {
                if (localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE') != null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            var options = {
                items: 1,
                nav: false,
                loop: false,
                dots: true
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING == 'Y' && _react2.default.createElement(_Loader2.default, null),
                this.state.LOADING == 'N' && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { id: 'appCapsule' },
                        _react2.default.createElement(
                            'div',
                            { className: 'carousel-slider owl-carousel owl-theme' },
                            _react2.default.createElement(
                                _reactOwlCarousel2.default,
                                _extends({ className: 'owl-theme' }, options),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'item p-3' },
                                    _react2.default.createElement(
                                        'h2',
                                        { className: 'pb-4' },
                                        '10,000 plus Items onboard'
                                    ),
                                    _react2.default.createElement('img', { src: '/assets/img/products.png', alt: 'alt', className: 'imaged w-100 square mb-4' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'item p-3' },
                                    _react2.default.createElement(
                                        'h2',
                                        null,
                                        'More then 50 delivery locations across Goa'
                                    ),
                                    _react2.default.createElement('img', { src: '/assets/img/locations.png', alt: 'alt', className: 'imaged w-100 square mb-4' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'item p-3' },
                                    _react2.default.createElement(
                                        'h2',
                                        null,
                                        'Largest collection of brands'
                                    ),
                                    _react2.default.createElement('img', { src: '/assets/img/brands.png', alt: 'alt', className: 'imaged w-100 square mb-4' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'carousel-button-footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12 pl-4 pr-4' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/map', className: 'text-upper btn btn-danger square btn-md lt-space1 btn-block skip' },
                                        'Skip'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Intro;
}(_react2.default.Component);

exports.default = Intro;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(215);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

var ReactBaseClasses = __webpack_require__(115);
var ReactChildren = __webpack_require__(217);
var ReactDOMFactories = __webpack_require__(222);
var ReactElement = __webpack_require__(31);
var ReactPropTypes = __webpack_require__(223);
var ReactVersion = __webpack_require__(229);

var createReactClass = __webpack_require__(230);
var onlyChild = __webpack_require__(232);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(218);
var ReactElement = __webpack_require__(31);

var emptyFunction = __webpack_require__(117);
var traverseAllChildren = __webpack_require__(219);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(48);

var invariant = __webpack_require__(38);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(48);

var ReactCurrentOwner = __webpack_require__(120);
var REACT_ELEMENT_TYPE = __webpack_require__(121);

var getIteratorFn = __webpack_require__(220);
var invariant = __webpack_require__(38);
var KeyEscapeUtils = __webpack_require__(221);
var warning = __webpack_require__(73);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(31);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(31),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(224);

module.exports = factory(isValidElement);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(225);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(226);
var assign = __webpack_require__(21);

var ReactPropTypesSecret = __webpack_require__(102);
var checkPropTypes = __webpack_require__(228);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(227);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(115),
    Component = _require.Component;

var _require2 = __webpack_require__(31),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(116);
var factory = __webpack_require__(231);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(21);

var emptyObject = __webpack_require__(119);
var _invariant = __webpack_require__(38);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(48);

var ReactElement = __webpack_require__(31);

var invariant = __webpack_require__(38);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PlotMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(2);

var _googleMapsReact = __webpack_require__(39);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(40);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Map = __webpack_require__(77);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    width: '90%',
    height: '300px'
};

var PlotMap = exports.PlotMap = function (_Component) {
    _inherits(PlotMap, _Component);

    function PlotMap() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PlotMap);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PlotMap.__proto__ || Object.getPrototypeOf(PlotMap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showingInfoWindow: false, //Hides or the shows the infoWindow
            activeMarker: {}, //Shows the active marker upon click
            selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: '',
            CIRCLE: '',
            CIRCLEID: '',
            LOADING: true,
            Notifications: false,
            delSET: false,
            areas: [],
            selectedAREA: ''
        }, _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmPlotMap')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmPlotMap')[0].classList.add('was-validated');

            if (err == 0) {
                $('#submitLoading').css('display', 'block');
                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/locate_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    //alert(result);
                    var del = false;
                    var notify = '';
                    var areas = [];
                    if (result.err != '' && result.err != undefined && result.err != 'undefined') {
                        if (result.err == '1') notify = 'ERR';else if (result.err == '2') notify = 'ERR';else if (result.err == '3') notify = 'ERR';else if (result.err == '4') notify = 'Invalid Access Detected';

                        areas = result.areas;
                    }

                    var circle = result.circle;
                    if (circle != '' && circle != undefined) {
                        var allowAddressChange = 'Y';
                        var cartCIRCLE = localStorage.getItem('cartCIRCLE');
                        var CIRCLEID = result.circleID;
                        if (cartCIRCLE !== null && cartCIRCLE !== '{}') {
                            if (CIRCLEID != cartCIRCLE) allowAddressChange = 'N';
                        }

                        if (allowAddressChange == 'N') {
                            var search_address = result.search_address;
                            if (search_address != '' && search_address != undefined) {
                                localStorage.setItem('searchedADDRESS', search_address);
                            }

                            that.setState({ CIRCLE: circle, CIRCLEID: result.circleID, areas: areas });
                            $('#ModalOtherCircleData').modal('show');
                        } else {
                            localStorage.removeItem('addressID');
                            localStorage.setItem('delCIRCLE', circle);
                            localStorage.setItem('delCIRCLE2', result.circleID);
                            localStorage.setItem('GPS', 'Y');
                            del = true;

                            var _search_address = result.search_address;
                            if (_search_address != '' && _search_address != undefined) {
                                localStorage.setItem('searchedADDRESS', _search_address);
                            }

                            that.setState({ Notifications: notify, delSET: del, areas: areas });
                        }
                    } else that.setState({ Notifications: notify, delSET: del, areas: areas });

                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        }, _this.handleGetNewAddressCircle2 = function (circle_id, circleID) {

            localStorage.removeItem('cartCIRCLE');
            localStorage.removeItem('cartData');
            localStorage.removeItem('addressID');
            localStorage.removeItem('cartInstructions');
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');

            localStorage.setItem('delCIRCLE', circle_id);
            localStorage.setItem('delCIRCLE2', circleID);
            localStorage.setItem('GPS', 'Y');
            _this.setState({ delSET: true });
        }, _this.onMarkerClick = function (props, marker, e) {
            return _this.setState({
                selectedPlace: props,
                activeMarker: marker,
                showingInfoWindow: true
            });
        }, _this.handleGetAddress = function (address, lat, long) {
            _this.setState({ address: address, lat: lat, long: long });
        }, _this.handlecircleChange = function (e) {
            e.preventDefault();

            var type = 'AREA';
            var id = $('#selectedArea option:selected').val().trim();
            if (id != '' && id != 0) {
                var that = _this;
                that.setState({ selectedAREA: id });

                /*fetch('https://m.donedelivery.in/api/deliveryarea_api.php?type='+type+'&id='+id,{
                    mode: 'cors',
                    credentials: 'same-origin',
                    headers: {
                        'Access-Control-Allow-Origin': '*', 
                        Accept: 'application/json', 
                        'Content-Type': 'application/json',
                    },
                }).then(function (response) {
                    return response.json();
                }).then(function (result) {
                      $('#ModalAlert').modal('hide');
                      let notify = '';
                    let areas = [];
                    if(result.err!='' && result.err!=undefined && result.err!='undefined')
                    {
                        if(result.err=='1') notify = 'ERR';
                        else if(result.err=='2') notify = 'ERR';
                        else if(result.err=='3') notify = 'ERR';
                        else if(result.err=='4') notify = 'Invalid Access Detected';
                          areas = result.areas;
                    }
                      if(result.LAT!='' && result.LAT!=undefined && result.LAT!='undefined' && result.LONG!='' && result.LONG!=undefined && result.LONG!='undefined')
                    {
                        that.setState({ lat: result.LAT, long:result.LONG});
                    }
                    else
                        that.setState({ Notifications: notify, delSET:del, areas:areas });
                      if(notify!='')
                        $('#ModalAlert').modal('show');
                });*/
            } else alert('Please select area');
        }, _this.onMarkerDragEnd = function (coord) {
            var latLng = coord.latLng;

            var lat = latLng.lat();
            var lng = latLng.lng();

            var requestOption = {
                method: 'GET'
            };

            //console.log('DRAG');
            //console.log(lat +','+ lng);
            var address = '';
            fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + lat + ',' + lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
                return res.json();
            }).then(function (response) {
                address = response.results[0].formatted_address;
                _this.setState({ address: address, lat: lat, long: lng });
            }).catch(function (error) {
                console.warn(error);
            });
        }, _this.onClose = function (props) {
            if (_this.state.showingInfoWindow) {
                _this.setState({
                    showingInfoWindow: false,
                    activeMarker: null
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PlotMap, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ LOADING: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.selectedAREA !== '') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map2/' + this.state.selectedAREA });
            }

            if (this.state.delSET == true) {
                if (localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE') != null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            var logged = 'N';
            if (localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE') != null) logged = 'Y';

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = logged == 'Y' ? '/home' : '/';
            var AppHeaderTitle = 'Select Location';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';

            //console.log(this.state);

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'mt-1 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full', style: { height: '300px', width: '100%', marginTop: '57px' } },
                        _react2.default.createElement(
                            'div',
                            { id: 'map' },
                            ' ',
                            _react2.default.createElement(
                                _Map2.default,
                                {
                                    centerAroundCurrentLocation: true,
                                    google: this.props.google,
                                    handleGetAddress: this.handleGetAddress
                                },
                                _react2.default.createElement(_googleMapsReact.Marker, {
                                    draggable: true,
                                    name: this.state.address,
                                    position: { lat: this.state.lat, lng: this.state.long },
                                    onDragend: function onDragend(t, map, coord) {
                                        return _this2.onMarkerDragEnd(coord);
                                    } }),
                                _react2.default.createElement(
                                    _googleMapsReact.InfoWindow,
                                    {
                                        marker: this.state.activeMarker,
                                        visible: this.state.showingInfoWindow,
                                        onClose: this.onClose
                                    },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            null,
                                            this.state.selectedPlace.name
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        { name: 'frmPlotMap', id: 'frmPlotMap', ref: function ref(el) {
                                return _this2.form = el;
                            }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                        _react2.default.createElement('input', { type: 'hidden', value: 'PLOT', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                        _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.lat, className: 'form-control', name: 'lat', id: 'lat', required: true }),
                        _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.long, className: 'form-control', name: 'long', id: 'long', required: true }),
                        _react2.default.createElement(
                            'div',
                            { className: 'section full mb-2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'wide-block wide-block1 pb-1 pt-2 pr-3 pl-3' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtaddress' },
                                            'Your Location'
                                        ),
                                        _react2.default.createElement('textarea', { id: 'txtaddress', name: 'txtaddress', rows: '3', className: 'square-inputbox form-control square', readOnly: true, autoComplete: 'off', value: this.state.address }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'carousel-button-footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12 pl-4 pr-4' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'text-upper btn btn-danger square btn-md lt-space1 btn-block skip' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'NEXT'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-icon text-danger' },
                                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    this.state.Notifications == 'ERR' && 'We dont seem to service your current location yet, Please choose your preferred delivery location',
                                    this.state.Notifications != 'ERR' && this.state.Notifications,
                                    this.state.Notifications == 'ERR' && _react2.default.createElement(
                                        'div',
                                        { className: 'form-group basic more-locations' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'select',
                                                { className: 'form-control text-upper btn btn-dark square custom-select', name: 'selectedArea', id: 'selectedArea', onChange: this.handlecircleChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { value: '0' },
                                                    'View Available Locations'
                                                ),
                                                this.state.areas.length > 0 && this.state.areas.map(function (post, i) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { value: post.ID, key: i },
                                                        post.NAME
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                            'Close'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalOtherCircleData', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        '\xA0'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    ' Your cart contains items from another location. The cart will be deleted, proceed? '
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: function onClick() {
                                                    _this2.handleGetNewAddressCircle2(_this2.state.CIRCLE, _this2.state.CIRCLEID);
                                                } },
                                            'Yes'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                            'No'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PlotMap;
}(_react.Component);

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(PlotMap);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(235), __webpack_require__(237)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-dom'), require('./lib/ScriptCache'), require('./lib/GoogleApi'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactDom, global.ScriptCache, global.GoogleApi);
    global.GoogleApiComponent = mod.exports;
  }
})(this, function (exports, _react, _reactDom, _ScriptCache, _GoogleApi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.wrapper = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _GoogleApi2 = _interopRequireDefault(_GoogleApi);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var defaultMapConfig = {};

  var serialize = function serialize(obj) {
    return JSON.stringify(obj);
  };
  var isSame = function isSame(obj1, obj2) {
    return obj1 === obj2 || serialize(obj1) === serialize(obj2);
  };

  var defaultCreateCache = function defaultCreateCache(options) {
    options = options || {};
    var apiKey = options.apiKey;
    var libraries = options.libraries || ['places'];
    var version = options.version || '3';
    var language = options.language || 'en';
    var url = options.url;
    var client = options.client;
    var region = options.region;

    return (0, _ScriptCache.ScriptCache)({
      google: (0, _GoogleApi2.default)({
        apiKey: apiKey,
        language: language,
        libraries: libraries,
        version: version,
        url: url,
        client: client,
        region: region
      })
    });
  };

  var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  };

  var wrapper = exports.wrapper = function wrapper(input) {
    return function (WrappedComponent) {
      var Wrapper = function (_React$Component) {
        _inherits(Wrapper, _React$Component);

        function Wrapper(props, context) {
          _classCallCheck(this, Wrapper);

          // Build options from input
          var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));

          var options = typeof input === 'function' ? input(props) : input;

          // Initialize required Google scripts and other configured options
          _this.initialize(options);

          _this.state = {
            loaded: false,
            map: null,
            google: null,
            options: options
          };

          _this.mapRef = _react2.default.createRef();
          return _this;
        }

        _createClass(Wrapper, [{
          key: 'UNSAFE_componentWillReceiveProps',
          value: function UNSAFE_componentWillReceiveProps(props) {
            // Do not update input if it's not dynamic
            if (typeof input !== 'function') {
              return;
            }

            // Get options to compare
            var prevOptions = this.state.options;
            var options = typeof input === 'function' ? input(props) : input;

            // Ignore when options are not changed
            if (isSame(options, prevOptions)) {
              return;
            }

            // Initialize with new options
            this.initialize(options);

            // Save new options in component state,
            // and remove information about previous API handlers
            this.setState({
              options: options,
              loaded: false,
              google: null
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
            }
          }
        }, {
          key: 'initialize',
          value: function initialize(options) {
            // Avoid race condition: remove previous 'load' listener
            if (this.unregisterLoadHandler) {
              this.unregisterLoadHandler();
              this.unregisterLoadHandler = null;
            }

            // Load cache factory
            var createCache = options.createCache || defaultCreateCache;

            // Build script
            this.scriptCache = createCache(options);
            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));

            // Store information about loading container
            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
          }
        }, {
          key: 'onLoad',
          value: function onLoad(err, tag) {
            this._gapi = window.google;

            this.setState({ loaded: true, google: this._gapi });
          }
        }, {
          key: 'render',
          value: function render() {
            var LoadingContainer = this.LoadingContainer;

            if (!this.state.loaded) {
              return _react2.default.createElement(LoadingContainer, null);
            }

            var props = Object.assign({}, this.props, {
              loaded: this.state.loaded,
              google: window.google
            });

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(WrappedComponent, props),
              _react2.default.createElement('div', { ref: this.mapRef })
            );
          }
        }]);

        return Wrapper;
      }(_react2.default.Component);

      return Wrapper;
    };
  };

  exports.default = wrapper;
});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(236)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('./windowOrGlobal'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.windowOrGlobal);
        global.ScriptCache = mod.exports;
    }
})(this, function (exports, window) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== 'undefined' && window._scriptMap || new Map();
    var ScriptCache = exports.ScriptCache = function (global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};

            Cache._onLoad = function (key) {
                return function (cb) {
                    var registered = true;

                    function unregister() {
                        registered = false;
                    }

                    var stored = scriptMap.get(key);

                    if (stored) {
                        stored.promise.then(function () {
                            if (registered) {
                                stored.error ? cb(stored.error) : cb(null, stored);
                            }

                            return stored;
                        }).catch(function (error) {
                            return cb(error);
                        });
                    } else {
                        // TODO:
                    }

                    return unregister;
                };
            };

            Cache._scriptTag = function (key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === 'undefined') return null;

                    var tag = document.createElement('script');
                    var promise = new Promise(function (resolve, reject) {
                        var body = document.getElementsByTagName('body')[0];

                        tag.type = 'text/javascript';
                        tag.async = false; // Load in order

                        var cbName = 'loaderCB' + counter++ + Date.now();
                        var cb = void 0;

                        var handleResult = function handleResult(state) {
                            return function (evt) {
                                var stored = scriptMap.get(key);
                                if (state === 'loaded') {
                                    stored.resolved = true;
                                    resolve(src);
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = []
                                } else if (state === 'error') {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;

                                cleanup();
                            };
                        };

                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === 'function') {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };

                        tag.onload = handleResult('loaded');
                        tag.onerror = handleResult('error');
                        tag.onreadystatechange = function () {
                            handleResult(tag.readyState);
                        };

                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, '$1' + cbName);
                            cb = window[cbName] = tag.onload;
                        } else {
                            tag.addEventListener('load', tag.onload);
                        }
                        tag.addEventListener('error', tag.onerror);

                        tag.src = src;
                        body.appendChild(tag);

                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key).tag;
            };

            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});

            Object.keys(scripts).forEach(function (key) {
                var script = scripts[key];

                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);

                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });

            return Cache;
        };
    }(window);

    exports.default = ScriptCache;
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.windowOrGlobal = mod.exports;
  }
})(this, function (module) {
  'use strict';

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  module.exports = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.GoogleApi = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var GoogleApi = exports.GoogleApi = function GoogleApi(opts) {
    opts = opts || {};

    if (!opts.hasOwnProperty('apiKey')) {
      throw new Error('You must pass an apiKey to use GoogleApi');
    }

    var apiKey = opts.apiKey;
    var libraries = opts.libraries || ['places'];
    var client = opts.client;
    var URL = opts.url || 'https://maps.googleapis.com/maps/api/js';

    var googleVersion = opts.version || '3.31';

    var script = null;
    var google = typeof window !== 'undefined' && window.google || null;
    var loading = false;
    var channel = null;
    var language = opts.language;
    var region = opts.region || null;

    var onLoadEvents = [];

    var url = function url() {
      var url = URL;
      var params = {
        key: apiKey,
        callback: 'CALLBACK_NAME',
        libraries: libraries.join(','),
        client: client,
        v: googleVersion,
        channel: channel,
        language: language,
        region: region,
        onerror: 'ERROR_FUNCTION'
      };

      var paramStr = Object.keys(params).filter(function (k) {
        return !!params[k];
      }).map(function (k) {
        return k + '=' + params[k];
      }).join('&');

      return url + '?' + paramStr;
    };

    return url();
  };

  exports.default = GoogleApi;
});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.Marker = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Marker = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Marker = exports.Marker = function (_React$Component) {
    _inherits(Marker, _React$Component);

    function Marker() {
      _classCallCheck(this, Marker);

      return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
    }

    _createClass(Marker, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.markerPromise = wrappedPromise();
        this.renderMarker();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
          if (this.marker) {
            this.marker.setMap(null);
          }
          this.renderMarker();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.marker) {
          this.marker.setMap(null);
        }
      }
    }, {
      key: 'renderMarker',
      value: function renderMarker() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            position = _props.position,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            label = _props.label,
            draggable = _props.draggable,
            title = _props.title,
            props = _objectWithoutProperties(_props, ['map', 'google', 'position', 'mapCenter', 'icon', 'label', 'draggable', 'title']);

        if (!google) {
          return null;
        }

        var pos = position || mapCenter;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = new google.maps.LatLng(pos.lat, pos.lng);
        }

        var pref = _extends({
          map: map,
          position: pos,
          icon: icon,
          label: label,
          title: title,
          draggable: draggable
        }, props);
        this.marker = new google.maps.Marker(pref);

        evtNames.forEach(function (e) {
          _this2.marker.addListener(e, _this2.handleEvent(e));
        });

        this.markerPromise.resolve(this.marker);
      }
    }, {
      key: 'getMarker',
      value: function getMarker() {
        return this.markerPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.marker, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Marker;
  }(_react2.default.Component);

  Marker.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object
  };

  evtNames.forEach(function (e) {
    return Marker.propTypes[e] = _propTypes2.default.func;
  });

  Marker.defaultProps = {
    name: 'Marker'
  };

  exports.default = Marker;
});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(1), __webpack_require__(240)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('react-dom'), require('react-dom/server'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.reactDom, global.server);
    global.InfoWindow = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _reactDom, _server) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.InfoWindow = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _reactDom2 = _interopRequireDefault(_reactDom);

  var _server2 = _interopRequireDefault(_server);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InfoWindow = exports.InfoWindow = function (_React$Component) {
    _inherits(InfoWindow, _React$Component);

    function InfoWindow() {
      _classCallCheck(this, InfoWindow);

      return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
    }

    _createClass(InfoWindow, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.renderInfoWindow();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            google = _props.google,
            map = _props.map;


        if (!google || !map) {
          return;
        }

        if (map !== prevProps.map) {
          this.renderInfoWindow();
        }

        if (this.props.position !== prevProps.position) {
          this.updatePosition();
        }

        if (this.props.children !== prevProps.children) {
          this.updateContent();
        }

        if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) {
          this.props.visible ? this.openWindow() : this.closeWindow();
        }
      }
    }, {
      key: 'renderInfoWindow',
      value: function renderInfoWindow() {
        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            mapCenter = _props2.mapCenter,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'mapCenter']);

        if (!google || !google.maps) {
          return;
        }

        var iw = this.infowindow = new google.maps.InfoWindow(_extends({
          content: ''
        }, props));

        google.maps.event.addListener(iw, 'closeclick', this.onClose.bind(this));
        google.maps.event.addListener(iw, 'domready', this.onOpen.bind(this));
      }
    }, {
      key: 'onOpen',
      value: function onOpen() {
        if (this.props.onOpen) {
          this.props.onOpen();
        }
      }
    }, {
      key: 'onClose',
      value: function onClose() {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    }, {
      key: 'openWindow',
      value: function openWindow() {
        this.infowindow.open(this.props.map, this.props.marker);
      }
    }, {
      key: 'updatePosition',
      value: function updatePosition() {
        var pos = this.props.position;
        if (!(pos instanceof google.maps.LatLng)) {
          pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
        }
        this.infowindow.setPosition(pos);
      }
    }, {
      key: 'updateContent',
      value: function updateContent() {
        var content = this.renderChildren();
        this.infowindow.setContent(content);
      }
    }, {
      key: 'closeWindow',
      value: function closeWindow() {
        this.infowindow.close();
      }
    }, {
      key: 'renderChildren',
      value: function renderChildren() {
        var children = this.props.children;

        return _server2.default.renderToString(children);
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return InfoWindow;
  }(_react2.default.Component);

  InfoWindow.propTypes = {
    children: _propTypes2.default.element.isRequired,
    map: _propTypes2.default.object,
    marker: _propTypes2.default.object,
    position: _propTypes2.default.object,
    visible: _propTypes2.default.bool,

    // callbacks
    onClose: _propTypes2.default.func,
    onOpen: _propTypes2.default.func
  };

  InfoWindow.defaultProps = {
    visible: false
  };

  exports.default = InfoWindow;
});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(241);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var p=__webpack_require__(21),q=__webpack_require__(0);function aa(a,b,d,c,f,e,h,g){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var D=[d,c,f,e,h,g],B=0;a=Error(b.replace(/%s/g,function(){return D[B++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function r(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}
var v="function"===typeof Symbol&&Symbol.for,ba=v?Symbol.for("react.portal"):60106,x=v?Symbol.for("react.fragment"):60107,ca=v?Symbol.for("react.strict_mode"):60108,da=v?Symbol.for("react.profiler"):60114,z=v?Symbol.for("react.provider"):60109,ea=v?Symbol.for("react.context"):60110,fa=v?Symbol.for("react.concurrent_mode"):60111,ha=v?Symbol.for("react.forward_ref"):60112,A=v?Symbol.for("react.suspense"):60113,ia=v?Symbol.for("react.memo"):60115,ja=v?Symbol.for("react.lazy"):60116;
function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fa:return"ConcurrentMode";case x:return"Fragment";case ba:return"Portal";case da:return"Profiler";case ca:return"StrictMode";case A:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ea:return"Context.Consumer";case z:return"Context.Provider";case ha:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case ia:return C(a.type);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var E=q.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;E.hasOwnProperty("ReactCurrentDispatcher")||(E.ReactCurrentDispatcher={current:null});var ka={};function F(a,b){for(var d=a._threadCount|0;d<=b;d++)a[d]=a._currentValue2,a._threadCount=d+1}
function la(a,b,d){var c=a.contextType;if("object"===typeof c&&null!==c)return F(c,d),c[d];if(a=a.contextTypes){d={};for(var f in a)d[f]=b[f];b=d}else b=ka;return b}for(var G=new Uint16Array(16),H=0;15>H;H++)G[H]=H+1;G[15]=0;
var ma=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,na=Object.prototype.hasOwnProperty,oa={},pa={};
function qa(a){if(na.call(pa,a))return!0;if(na.call(oa,a))return!1;if(ma.test(a))return pa[a]=!0;oa[a]=!0;return!1}function ra(a,b,d,c){if(null!==d&&0===d.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(c)return!1;if(null!==d)return!d.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function sa(a,b,d,c){if(null===b||"undefined"===typeof b||ra(a,b,d,c))return!0;if(c)return!1;if(null!==d)switch(d.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,d,c,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=c;this.attributeNamespace=f;this.mustUseProperty=d;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a,null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var K=/[\-:]([a-z])/g;function L(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(K,
L);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(K,L);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){J[a]=new I(a,1,!1,a.toLowerCase(),null)});var ta=/["'&<>]/;
function M(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=ta.exec(a);if(b){var d="",c,f=0;for(c=b.index;c<a.length;c++){switch(a.charCodeAt(c)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==c&&(d+=a.substring(f,c));f=c+1;d+=b}a=f!==c?d+a.substring(f,c):d}return a}var N=null,O=null,P=null,Q=!1,S=!1,T=null,U=0;function V(){null===N?r("321"):void 0;return N}
function ua(){0<U&&r("312");return{memoizedState:null,queue:null,next:null}}function W(){null===P?null===O?(Q=!1,O=P=ua()):(Q=!0,P=O):null===P.next?(Q=!1,P=P.next=ua()):(Q=!0,P=P.next);return P}function va(a,b,d,c){for(;S;)S=!1,U+=1,P=null,d=a(b,c);O=N=null;U=0;P=T=null;return d}function wa(a,b){return"function"===typeof b?b(a):b}
function xa(a,b,d){N=V();P=W();if(Q){var c=P.queue;b=c.dispatch;if(null!==T&&(d=T.get(c),void 0!==d)){T.delete(c);c=P.memoizedState;do c=a(c,d.action),d=d.next;while(null!==d);P.memoizedState=c;return[c,b]}return[P.memoizedState,b]}a=a===wa?"function"===typeof b?b():b:void 0!==d?d(b):b;P.memoizedState=a;a=P.queue={last:null,dispatch:null};a=a.dispatch=ya.bind(null,N,a);return[P.memoizedState,a]}
function ya(a,b,d){25>U?void 0:r("301");if(a===N)if(S=!0,a={action:d,next:null},null===T&&(T=new Map),d=T.get(b),void 0===d)T.set(b,a);else{for(b=d;null!==b.next;)b=b.next;b.next=a}}function za(){}
var X=0,Aa={readContext:function(a){var b=X;F(a,b);return a[b]},useContext:function(a){V();var b=X;F(a,b);return a[b]},useMemo:function(a,b){N=V();P=W();b=void 0===b?null:b;if(null!==P){var d=P.memoizedState;if(null!==d&&null!==b){a:{var c=d[1];if(null===c)c=!1;else{for(var f=0;f<c.length&&f<b.length;f++){var e=b[f],h=c[f];if((e!==h||0===e&&1/e!==1/h)&&(e===e||h===h)){c=!1;break a}}c=!0}}if(c)return d[0]}}a=a();P.memoizedState=[a,b];return a},useReducer:xa,useRef:function(a){N=V();P=W();var b=P.memoizedState;
return null===b?(a={current:a},P.memoizedState=a):b},useState:function(a){return xa(wa,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:za,useEffect:za,useDebugValue:za},Ba={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};function Ca(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Da={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ea=p({menuitem:!0},Da),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Fa=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Fa.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Ga=/([A-Z])/g,Ha=/^ms-/,Z=q.Children.toArray,Ia=E.ReactCurrentDispatcher,Ja={listing:!0,pre:!0,textarea:!0},Ka=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,La={},Ma={};function Na(a){if(void 0===a||null===a)return a;var b="";q.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Oa=Object.prototype.hasOwnProperty,Pa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Qa(a,b){void 0===a&&r("152",C(b)||"Component")}
function Ra(a,b,d){function c(c,f){var e=la(f,b,d),g=[],h=!1,l={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===g)return null},enqueueReplaceState:function(a,b){h=!0;g=[b]},enqueueSetState:function(a,b){if(null===g)return null;g.push(b)}},k=void 0;if(f.prototype&&f.prototype.isReactComponent){if(k=new f(c.props,e,l),"function"===typeof f.getDerivedStateFromProps){var t=f.getDerivedStateFromProps.call(null,c.props,k.state);null!=t&&(k.state=p({},k.state,t))}}else if(N={},k=f(c.props,
e,l),k=va(f,c.props,k,e),null==k||null==k.render){a=k;Qa(a,f);return}k.props=c.props;k.context=e;k.updater=l;l=k.state;void 0===l&&(k.state=l=null);if("function"===typeof k.UNSAFE_componentWillMount||"function"===typeof k.componentWillMount)if("function"===typeof k.componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.componentWillMount(),"function"===typeof k.UNSAFE_componentWillMount&&"function"!==typeof f.getDerivedStateFromProps&&k.UNSAFE_componentWillMount(),g.length){l=g;var m=
h;g=null;h=!1;if(m&&1===l.length)k.state=l[0];else{t=m?l[0]:k.state;var u=!0;for(m=m?1:0;m<l.length;m++){var w=l[m];w="function"===typeof w?w.call(k,t,c.props,e):w;null!=w&&(u?(u=!1,t=p({},t,w)):p(t,w))}k.state=t}}else g=null;a=k.render();Qa(a,f);c=void 0;if("function"===typeof k.getChildContext&&(e=f.childContextTypes,"object"===typeof e)){c=k.getChildContext();for(var R in c)R in e?void 0:r("108",C(f)||"Unknown",R)}c&&(b=p({},b,c))}for(;q.isValidElement(a);){var f=a,e=f.type;if("function"!==typeof e)break;
c(f,e)}return{child:a,context:b}}
var Sa=function(){function a(b,d){if(!(this instanceof a))throw new TypeError("Cannot call a class as a function");q.isValidElement(b)?b.type!==x?b=[b]:(b=b.props.children,b=q.isValidElement(b)?[b]:Z(b)):b=Z(b);b={type:null,domNamespace:Ba.html,children:b,childIndex:0,context:ka,footer:""};var c=G[0];if(0===c){var f=G;c=f.length;var e=2*c;65536>=e?void 0:r("304");var h=new Uint16Array(e);h.set(f);G=h;G[0]=c+1;for(f=c;f<e-1;f++)G[f]=f+1;G[e-1]=0}else G[0]=G[c];this.threadID=c;this.stack=[b];this.exhausted=
!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=d;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}a.prototype.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;G[a]=G[0];G[0]=a}};a.prototype.pushProvider=function(a){var b=++this.contextIndex,c=a.type._context,f=this.threadID;F(c,f);var e=c[f];this.contextStack[b]=c;this.contextValueStack[b]=e;c[f]=a.props.value};a.prototype.popProvider=
function(){var a=this.contextIndex,d=this.contextStack[a],c=this.contextValueStack[a];this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;d[this.threadID]=c};a.prototype.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};a.prototype.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Ia.current;Ia.current=Aa;try{for(var f=[""],e=!1;f[0].length<a;){if(0===this.stack.length){this.exhausted=
!0;var h=this.threadID;G[h]=G[0];G[0]=h;break}var g=this.stack[this.stack.length-1];if(e||g.childIndex>=g.children.length){var D=g.footer;""!==D&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===g.type)this.currentSelectValue=null;else if(null!=g.type&&null!=g.type.type&&g.type.type.$$typeof===z)this.popProvider(g.type);else if(g.type===A){this.suspenseDepth--;var B=f.pop();if(e){e=!1;var n=g.fallbackFrame;n?void 0:r("303");this.stack.push(n);continue}else f[this.suspenseDepth]+=B}f[this.suspenseDepth]+=
D}else{var l=g.children[g.childIndex++],k="";try{k+=this.render(l,g.context,g.domNamespace)}catch(t){throw t;}finally{}f.length<=this.suspenseDepth&&f.push("");f[this.suspenseDepth]+=k}}return f[0]}finally{Ia.current=c,X=b}};a.prototype.render=function(a,d,c){if("string"===typeof a||"number"===typeof a){c=""+a;if(""===c)return"";if(this.makeStaticMarkup)return M(c);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+M(c);this.previousWasTextNode=!0;return M(c)}d=Ra(a,d,this.threadID);a=d.child;d=d.context;
if(null===a||!1===a)return"";if(!q.isValidElement(a)){if(null!=a&&null!=a.$$typeof){var b=a.$$typeof;b===ba?r("257"):void 0;r("258",b.toString())}a=Z(a);this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""});return""}b=a.type;if("string"===typeof b)return this.renderDOM(a,d,c);switch(b){case ca:case fa:case da:case x:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case A:r("294")}if("object"===
typeof b&&null!==b)switch(b.$$typeof){case ha:N={};var e=b.render(a.props,a.ref);e=va(b.render,a.props,e,a.ref);e=Z(e);this.stack.push({type:null,domNamespace:c,children:e,childIndex:0,context:d,footer:""});return"";case ia:return a=[q.createElement(b.type,p({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:c,children:a,childIndex:0,context:d,footer:""}),"";case z:return b=Z(a.props.children),c={type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""},this.pushProvider(a),this.stack.push(c),
"";case ea:b=a.type;e=a.props;var h=this.threadID;F(b,h);b=Z(e.children(b[h]));this.stack.push({type:a,domNamespace:c,children:b,childIndex:0,context:d,footer:""});return"";case ja:r("295")}r("130",null==b?b:typeof b,"")};a.prototype.renderDOM=function(a,d,c){var b=a.type.toLowerCase();c===Ba.html&&Ca(b);La.hasOwnProperty(b)||(Ka.test(b)?void 0:r("65",b),La[b]=!0);var e=a.props;if("input"===b)e=p({type:void 0},e,{defaultChecked:void 0,defaultValue:void 0,value:null!=e.value?e.value:e.defaultValue,
checked:null!=e.checked?e.checked:e.defaultChecked});else if("textarea"===b){var h=e.value;if(null==h){h=e.defaultValue;var g=e.children;null!=g&&(null!=h?r("92"):void 0,Array.isArray(g)&&(1>=g.length?void 0:r("93"),g=g[0]),h=""+g);null==h&&(h="")}e=p({},e,{value:void 0,children:""+h})}else if("select"===b)this.currentSelectValue=null!=e.value?e.value:e.defaultValue,e=p({},e,{value:void 0});else if("option"===b){g=this.currentSelectValue;var D=Na(e.children);if(null!=g){var B=null!=e.value?e.value+
"":D;h=!1;if(Array.isArray(g))for(var n=0;n<g.length;n++){if(""+g[n]===B){h=!0;break}}else h=""+g===B;e=p({selected:void 0,children:void 0},e,{selected:h,children:D})}}if(h=e)Ea[b]&&(null!=h.children||null!=h.dangerouslySetInnerHTML?r("137",b,""):void 0),null!=h.dangerouslySetInnerHTML&&(null!=h.children?r("60"):void 0,"object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML?void 0:r("61")),null!=h.style&&"object"!==typeof h.style?r("62",""):void 0;h=e;g=this.makeStaticMarkup;
D=1===this.stack.length;B="<"+a.type;for(y in h)if(Oa.call(h,y)){var l=h[y];if(null!=l){if("style"===y){n=void 0;var k="",t="";for(n in l)if(l.hasOwnProperty(n)){var m=0===n.indexOf("--"),u=l[n];if(null!=u){var w=n;if(Ma.hasOwnProperty(w))w=Ma[w];else{var R=w.replace(Ga,"-$1").toLowerCase().replace(Ha,"-ms-");w=Ma[w]=R}k+=t+w+":";t=n;m=null==u||"boolean"===typeof u||""===u?"":m||"number"!==typeof u||0===u||Y.hasOwnProperty(t)&&Y[t]?(""+u).trim():u+"px";k+=m;t=";"}}l=k||null}n=null;b:if(m=b,u=h,-1===
m.indexOf("-"))m="string"===typeof u.is;else switch(m){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":m=!1;break b;default:m=!0}if(m)Pa.hasOwnProperty(y)||(n=y,n=qa(n)&&null!=l?n+"="+('"'+M(l)+'"'):"");else{m=y;n=l;l=J.hasOwnProperty(m)?J[m]:null;if(u="style"!==m)u=null!==l?0===l.type:!(2<m.length)||"o"!==m[0]&&"O"!==m[0]||"n"!==m[1]&&"N"!==m[1]?!1:!0;u||sa(m,n,l,!1)?n="":null!==
l?(m=l.attributeName,l=l.type,n=3===l||4===l&&!0===n?m+'=""':m+"="+('"'+M(n)+'"')):n=qa(m)?m+"="+('"'+M(n)+'"'):""}n&&(B+=" "+n)}}g||D&&(B+=' data-reactroot=""');var y=B;h="";Da.hasOwnProperty(b)?y+="/>":(y+=">",h="</"+a.type+">");a:{g=e.dangerouslySetInnerHTML;if(null!=g){if(null!=g.__html){g=g.__html;break a}}else if(g=e.children,"string"===typeof g||"number"===typeof g){g=M(g);break a}g=null}null!=g?(e=[],Ja[b]&&"\n"===g.charAt(0)&&(y+="\n"),y+=g):e=Z(e.children);a=a.type;c=null==c||"http://www.w3.org/1999/xhtml"===
c?Ca(a):"http://www.w3.org/2000/svg"===c&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":c;this.stack.push({domNamespace:c,type:b,children:e,childIndex:0,context:d,footer:h});this.previousWasTextNode=!1;return y};return a}(),Ta={renderToString:function(a){a=new Sa(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Sa(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){r("207")},renderToStaticNodeStream:function(){r("208")},
version:"16.8.6"},Ua={default:Ta},Va=Ua&&Ta||Ua;module.exports=Va.default||Va;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.String);
    global.HeatMap = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HeatMap = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseover', 'recenter'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var HeatMap = exports.HeatMap = function (_React$Component) {
    _inherits(HeatMap, _React$Component);

    function HeatMap() {
      _classCallCheck(this, HeatMap);

      return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
    }

    _createClass(HeatMap, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.heatMapPromise = wrappedPromise();
        this.renderHeatMap();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
          if (this.heatMap) {
            this.heatMap.setMap(null);
            this.renderHeatMap();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.heatMap) {
          this.heatMap.setMap(null);
        }
      }
    }, {
      key: 'renderHeatMap',
      value: function renderHeatMap() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            positions = _props.positions,
            mapCenter = _props.mapCenter,
            icon = _props.icon,
            gradient = _props.gradient,
            _props$radius = _props.radius,
            radius = _props$radius === undefined ? 20 : _props$radius,
            _props$opacity = _props.opacity,
            opacity = _props$opacity === undefined ? 0.2 : _props$opacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'positions', 'mapCenter', 'icon', 'gradient', 'radius', 'opacity']);

        if (!google) {
          return null;
        }

        var data = positions.map(function (pos) {
          return { location: new google.maps.LatLng(pos.lat, pos.lng), weight: pos.weight };
        });

        var pref = _extends({
          map: map,
          gradient: gradient,
          radius: radius,
          opacity: opacity,
          data: data
        }, props);

        this.heatMap = new google.maps.visualization.HeatmapLayer(pref);

        this.heatMap.set('radius', radius === undefined ? 20 : radius);

        this.heatMap.set('opacity', opacity === undefined ? 0.2 : opacity);

        evtNames.forEach(function (e) {
          _this2.heatMap.addListener(e, _this2.handleEvent(e));
        });

        this.heatMapPromise.resolve(this.heatMap);
      }
    }, {
      key: 'getHeatMap',
      value: function getHeatMap() {
        return this.heatMapPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.heatMap, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return HeatMap;
  }(_react2.default.Component);

  HeatMap.propTypes = {
    position: _propTypes2.default.object,
    map: _propTypes2.default.object,
    icon: _propTypes2.default.string
  };

  evtNames.forEach(function (e) {
    return HeatMap.propTypes[e] = _propTypes2.default.func;
  });

  HeatMap.defaultProps = {
    name: 'HeatMap'
  };

  exports.default = HeatMap;
});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(76), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polygon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polygon = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polygon = exports.Polygon = function (_React$Component) {
    _inherits(Polygon, _React$Component);

    function Polygon() {
      _classCallCheck(this, Polygon);

      return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
    }

    _createClass(Polygon, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polygonPromise = wrappedPromise();
        this.renderPolygon();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
          if (this.polygon) {
            this.polygon.setMap(null);
          }
          this.renderPolygon();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polygon) {
          this.polygon.setMap(null);
        }
      }
    }, {
      key: 'renderPolygon',
      value: function renderPolygon() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            paths = _props.paths,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'paths', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          paths: paths,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.polygon = new google.maps.Polygon(params);

        evtNames.forEach(function (e) {
          _this2.polygon.addListener(e, _this2.handleEvent(e));
        });

        this.polygonPromise.resolve(this.polygon);
      }
    }, {
      key: 'getPolygon',
      value: function getPolygon() {
        return this.polygonPromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polygon, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polygon;
  }(_react2.default.Component);

  Polygon.propTypes = {
    paths: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polygon.propTypes[e] = _propTypes2.default.func;
  });

  Polygon.defaultProps = {
    name: 'Polygon'
  };

  exports.default = Polygon;
});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(76), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Polyline = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Polyline = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Polyline = exports.Polyline = function (_React$Component) {
    _inherits(Polyline, _React$Component);

    function Polyline() {
      _classCallCheck(this, Polyline);

      return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
    }

    _createClass(Polyline, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.polylinePromise = wrappedPromise();
        this.renderPolyline();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
          if (this.polyline) {
            this.polyline.setMap(null);
          }
          this.renderPolyline();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.polyline) {
          this.polyline.setMap(null);
        }
      }
    }, {
      key: 'renderPolyline',
      value: function renderPolyline() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            path = _props.path,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            props = _objectWithoutProperties(_props, ['map', 'google', 'path', 'strokeColor', 'strokeOpacity', 'strokeWeight']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          path: path,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight
        }, props);

        this.polyline = new google.maps.Polyline(params);

        evtNames.forEach(function (e) {
          _this2.polyline.addListener(e, _this2.handleEvent(e));
        });

        this.polylinePromise.resolve(this.polyline);
      }
    }, {
      key: 'getPolyline',
      value: function getPolyline() {
        return this.polylinePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.polyline, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Polyline;
  }(_react2.default.Component);

  Polyline.propTypes = {
    path: _propTypes2.default.array,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Polyline.propTypes[e] = _propTypes2.default.func;
  });

  Polyline.defaultProps = {
    name: 'Polyline'
  };

  exports.default = Polyline;
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(76), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/arePathsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.arePathsEqual, global.String);
    global.Circle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _arePathsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Circle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Circle = exports.Circle = function (_React$Component) {
    _inherits(Circle, _React$Component);

    function Circle() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Circle);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Circle.__proto__ || Object.getPrototypeOf(Circle)).call.apply(_ref, [this].concat(args))), _this), _this.centerChanged = function (newCenter) {
        var _this$props$center = _this.props.center,
            lat = _this$props$center.lat,
            lng = _this$props$center.lng;

        return lat !== newCenter.lat || lng !== newCenter.lng;
      }, _this.propsChanged = function (newProps) {
        if (_this.centerChanged(newProps.center)) return true;

        return Object.keys(Circle.propTypes).some(function (key) {
          return _this.props[key] !== newProps[key];
        });
      }, _this.destroyCircle = function () {
        if (_this.circle) {
          _this.circle.setMap(null);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Circle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.circlePromise = wrappedPromise();
        this.renderCircle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            path = _props.path,
            map = _props.map;


        if (this.propsChanged(prevProps) || map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(path, prevProps.path)) {
          this.destroyCircle();
          this.renderCircle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.destroyCircle();
      }
    }, {
      key: 'renderCircle',
      value: function renderCircle() {
        var _this2 = this;

        var _props2 = this.props,
            map = _props2.map,
            google = _props2.google,
            center = _props2.center,
            radius = _props2.radius,
            strokeColor = _props2.strokeColor,
            strokeOpacity = _props2.strokeOpacity,
            strokeWeight = _props2.strokeWeight,
            fillColor = _props2.fillColor,
            fillOpacity = _props2.fillOpacity,
            draggable = _props2.draggable,
            visible = _props2.visible,
            props = _objectWithoutProperties(_props2, ['map', 'google', 'center', 'radius', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity', 'draggable', 'visible']);

        if (!google) {
          return null;
        }

        var params = _extends({}, props, {
          map: map,
          center: center,
          radius: radius,
          draggable: draggable,
          visible: visible,
          options: {
            strokeColor: strokeColor,
            strokeOpacity: strokeOpacity,
            strokeWeight: strokeWeight,
            fillColor: fillColor,
            fillOpacity: fillOpacity
          }
        });

        this.circle = new google.maps.Circle(params);

        evtNames.forEach(function (e) {
          _this2.circle.addListener(e, _this2.handleEvent(e));
        });

        this.circlePromise.resolve(this.circle);
      }
    }, {
      key: 'getCircle',
      value: function getCircle() {
        return this.circlePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.circle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return null;
      }
    }]);

    return Circle;
  }(_react2.default.Component);

  Circle.propTypes = {
    center: _propTypes2.default.object,
    radius: _propTypes2.default.number,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number,
    draggable: _propTypes2.default.bool,
    visible: _propTypes2.default.bool
  };

  evtNames.forEach(function (e) {
    return Circle.propTypes[e] = _propTypes2.default.func;
  });

  Circle.defaultProps = {
    name: 'Circle'
  };

  exports.default = Circle;
});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(247), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../lib/areBoundsEqual'), require('../lib/String'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.areBoundsEqual, global.String);
    global.Rectangle = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _areBoundsEqual, _String) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Rectangle = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var evtNames = ['click', 'mouseout', 'mouseover'];

  var wrappedPromise = function wrappedPromise() {
    var wrappedPromise = {},
        promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
    wrappedPromise.then = promise.then.bind(promise);
    wrappedPromise.catch = promise.catch.bind(promise);
    wrappedPromise.promise = promise;

    return wrappedPromise;
  };

  var Rectangle = exports.Rectangle = function (_React$Component) {
    _inherits(Rectangle, _React$Component);

    function Rectangle() {
      _classCallCheck(this, Rectangle);

      return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
    }

    _createClass(Rectangle, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.rectanglePromise = wrappedPromise();
        this.renderRectangle();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.map !== prevProps.map || !(0, _areBoundsEqual.areBoundsEqual)(this.props.bounds, prevProps.bounds)) {
          if (this.rectangle) {
            this.rectangle.setMap(null);
          }
          this.renderRectangle();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.rectangle) {
          this.rectangle.setMap(null);
        }
      }
    }, {
      key: 'renderRectangle',
      value: function renderRectangle() {
        var _this2 = this;

        var _props = this.props,
            map = _props.map,
            google = _props.google,
            bounds = _props.bounds,
            strokeColor = _props.strokeColor,
            strokeOpacity = _props.strokeOpacity,
            strokeWeight = _props.strokeWeight,
            fillColor = _props.fillColor,
            fillOpacity = _props.fillOpacity,
            props = _objectWithoutProperties(_props, ['map', 'google', 'bounds', 'strokeColor', 'strokeOpacity', 'strokeWeight', 'fillColor', 'fillOpacity']);

        if (!google) {
          return null;
        }

        var params = _extends({
          map: map,
          bounds: bounds,
          strokeColor: strokeColor,
          strokeOpacity: strokeOpacity,
          strokeWeight: strokeWeight,
          fillColor: fillColor,
          fillOpacity: fillOpacity
        }, props);

        this.rectangle = new google.maps.Rectangle(params);

        evtNames.forEach(function (e) {
          _this2.rectangle.addListener(e, _this2.handleEvent(e));
        });

        this.rectanglePromise.resolve(this.rectangle);
      }
    }, {
      key: 'getRectangle',
      value: function getRectangle() {
        return this.rectanglePromise;
      }
    }, {
      key: 'handleEvent',
      value: function handleEvent(evt) {
        var _this3 = this;

        return function (e) {
          var evtName = 'on' + (0, _String.camelize)(evt);
          if (_this3.props[evtName]) {
            _this3.props[evtName](_this3.props, _this3.rectangle, e);
          }
        };
      }
    }, {
      key: 'render',
      value: function render() {
        console.log('hii, ', this.props.bounds);
        return null;
      }
    }]);

    return Rectangle;
  }(_react2.default.Component);

  Rectangle.propTypes = {
    bounds: _propTypes2.default.object,
    strokeColor: _propTypes2.default.string,
    strokeOpacity: _propTypes2.default.number,
    strokeWeight: _propTypes2.default.number,
    fillColor: _propTypes2.default.string,
    fillOpacity: _propTypes2.default.number
  };

  evtNames.forEach(function (e) {
    return Rectangle.propTypes[e] = _propTypes2.default.func;
  });

  Rectangle.defaultProps = {
    name: 'Rectangle'
  };

  exports.default = Rectangle;
});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.areBoundsEqual = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  /**
   * Compares two bound objects.
   */

  var areBoundsEqual = exports.areBoundsEqual = function areBoundsEqual(boundA, boundB) {
    if (boundA === boundB) {
      return true;
    }
    if (!(boundA instanceof Object) || !(boundB instanceof Object)) {
      return false;
    }
    if (Object.keys(boundA).length !== Object.keys(boundB).length) {
      return false;
    }
    if (!areValidBounds(boundA) || !areValidBounds(boundB)) {
      return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(boundA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (boundA[key] !== boundB[key]) {
          return false;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  };

  /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */
  var areValidBounds = function areValidBounds(elem) {
    return elem !== null && (typeof elem === 'undefined' ? 'undefined' : _typeof(elem)) === 'object' && elem.hasOwnProperty('north') && elem.hasOwnProperty('south') && elem.hasOwnProperty('east') && elem.hasOwnProperty('west');
  };
});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.cancelablePromise = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html

  var makeCancelable = exports.makeCancelable = function makeCancelable(promise) {
    var hasCanceled_ = false;

    var wrappedPromise = new Promise(function (resolve, reject) {
      promise.then(function (val) {
        return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
      });
      promise.catch(function (error) {
        return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
      });
    });

    return {
      promise: wrappedPromise,
      cancel: function cancel() {
        hasCanceled_ = true;
      }
    };
  };
});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _googleMapsReact = __webpack_require__(39);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _UpdateMap = __webpack_require__(122);

var _UpdateMap2 = _interopRequireDefault(_UpdateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    width: '90%',
    height: '300px'
};

var PlotMap2 = function (_React$Component) {
    _inherits(PlotMap2, _React$Component);

    function PlotMap2(props) {
        var _this$state;

        _classCallCheck(this, PlotMap2);

        var _this = _possibleConstructorReturn(this, (PlotMap2.__proto__ || Object.getPrototypeOf(PlotMap2)).call(this, props));
        //console.log(props);


        _initialiseProps.call(_this);

        _this.state = (_this$state = {
            LOADING: true,
            id: props.match.params.id,
            showingInfoWindow: false, //Hides or the shows the infoWindow
            activeMarker: {}, //Shows the active marker upon click
            selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: '',
            CIRCLE: '',
            CIRCLEID: ''
        }, _defineProperty(_this$state, 'LOADING', true), _defineProperty(_this$state, 'Notifications', false), _defineProperty(_this$state, 'delSET', false), _defineProperty(_this$state, 'areas', []), _defineProperty(_this$state, 'selectedAREA', ''), _this$state);
        return _this;
    }

    _createClass(PlotMap2, [{
        key: 'fetchDeliveryAreaCoordiates',
        value: function fetchDeliveryAreaCoordiates(mode, id) {
            var that = this;
            fetch('https://m.donedelivery.in/api/deliveryarea_api.php?mode=' + mode + '&id=' + id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                var notify = '';
                var areas = [];
                if (result.err != '' && result.err != undefined && result.err != 'undefined') {
                    if (result.err == '1') notify = 'ERR';else if (result.err == '2') notify = 'ERR';else if (result.err == '3') notify = 'ERR';else if (result.err == '4') notify = 'Invalid Access Detected';

                    areas = result.areas;
                }

                if (result.LAT != '' && result.LAT != undefined && result.LAT != 'undefined' && result.LONG != '' && result.LONG != undefined && result.LONG != 'undefined') {
                    var address = result.address;
                    that.setState({ LOADING: false, address: address, lat: result.LAT, long: result.LONG });
                } else that.setState({ LOADING: false, Notifications: notify, delSET: del, areas: areas });

                if (notify != '') $('#ModalAlert').modal('show');
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchDeliveryAreaCoordiates('AREA', this.state.id);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
            //this.setState({ LOADING:true });
            //this.fetchCategoryPage('CATEGORY',nextProps.match.params.id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.selectedAREA !== '') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map2/' + this.state.selectedAREA });
            }

            if (this.state.delSET == true) {
                if (localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE') != null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            /*if(this.state.addressUpdated)
            {
                return (<Redirect to={'/addresses'}/>)
            }*/

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/addresses';
            var AppHeaderTitle = 'Update Address';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'mt-1 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full', style: { height: '300px', width: '100%', marginTop: '57px' } },
                        _react2.default.createElement(
                            'div',
                            { id: 'map' },
                            ' ',
                            this.state.lat != '' && this.state.long != '' && _react2.default.createElement(
                                _UpdateMap2.default,
                                {
                                    centerAroundCurrentLocation: true,
                                    google: this.props.google,
                                    handleGetAddress2: this.handleGetAddress2,
                                    initialCenter: { lat: this.state.lat, lng: this.state.long }
                                },
                                _react2.default.createElement(_googleMapsReact.Marker, {
                                    draggable: true,
                                    name: this.state.address,
                                    onDragend: function onDragend(t, map, coord) {
                                        return _this2.onMarkerDragEnd(coord);
                                    } }),
                                _react2.default.createElement(
                                    _googleMapsReact.InfoWindow,
                                    {
                                        marker: this.state.activeMarker,
                                        visible: this.state.showingInfoWindow,
                                        onClose: this.onClose
                                    },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            null,
                                            this.state.selectedPlace.name
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'form',
                        { name: 'frmPlotMap', id: 'frmPlotMap', ref: function ref(el) {
                                return _this2.form = el;
                            }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                        _react2.default.createElement('input', { type: 'hidden', value: 'PLOT', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                        _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.lat, className: 'form-control', name: 'lat', id: 'lat', required: true }),
                        _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.long, className: 'form-control', name: 'long', id: 'long', required: true }),
                        _react2.default.createElement(
                            'div',
                            { className: 'section full mb-2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'wide-block wide-block1 pb-1 pt-2 pr-3 pl-3' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtaddress' },
                                            'Delivery Location'
                                        ),
                                        _react2.default.createElement('textarea', { id: 'txtaddress', name: 'txtaddress', rows: '3', className: 'square-inputbox form-control square', readOnly: true, autoComplete: 'off', value: this.state.address }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'carousel-button-footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12 pl-4 pr-4' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'text-upper btn btn-danger square btn-md lt-space1 btn-block skip' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'NEXT'
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-icon text-danger' },
                                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    this.state.Notifications == 'ERR' && 'We dont seem to service your current location yet, Please choose your preferred delivery location',
                                    this.state.Notifications != 'ERR' && this.state.Notifications,
                                    this.state.Notifications == 'ERR' && _react2.default.createElement(
                                        'div',
                                        { className: 'form-group basic more-locations' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'select',
                                                { className: 'form-control text-upper btn btn-dark square custom-select', name: 'selectedArea', id: 'selectedArea', onChange: this.handlecircleChange },
                                                _react2.default.createElement(
                                                    'option',
                                                    { value: '0' },
                                                    'View Available Locations'
                                                ),
                                                this.state.areas.length > 0 && this.state.areas.map(function (post, i) {
                                                    return _react2.default.createElement(
                                                        'option',
                                                        { value: post.ID, key: i },
                                                        post.NAME
                                                    );
                                                })
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                            'Close'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalOtherCircleData', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        '\xA0'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    ' Your cart contains items from another location. The cart will be deleted, proceed? '
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: function onClick() {
                                                    _this2.handleGetNewAddressCircle2(_this2.state.CIRCLE, _this2.state.CIRCLEID);
                                                } },
                                            'Yes'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                            'No'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return PlotMap2;
}(_react2.default.Component);

//export default AddAddress2;


var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleSubmit = function (e) {
        e.preventDefault();

        var err = 0;
        if ($('#frmPlotMap')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmPlotMap')[0].classList.add('was-validated');

        if (err == 0) {
            $('#submitLoading').css('display', 'block');
            var method = "POST";
            var body = new FormData(_this3.form);
            //console.log(body);
            var that = _this3;
            fetch("https://m.donedelivery.in/api/locate_api.php", { method: method, body: body }).then(function (response) {
                //console.log(response);
                return response.json();
            }).then(function (result) {

                //console.log(result);
                //alert(result);
                var del = false;
                var notify = '';
                var areas = [];
                if (result.err != '' && result.err != undefined && result.err != 'undefined') {
                    if (result.err == '1') notify = 'ERR';else if (result.err == '2') notify = 'ERR';else if (result.err == '3') notify = 'ERR';else if (result.err == '4') notify = 'Invalid Access Detected';

                    areas = result.areas;
                }

                var circle = result.circle;
                if (circle != '' && circle != undefined) {
                    var allowAddressChange = 'Y';
                    var cartCIRCLE = localStorage.getItem('cartCIRCLE');
                    var CIRCLEID = result.circleID;
                    if (cartCIRCLE !== null && cartCIRCLE !== '{}') {
                        if (CIRCLEID != cartCIRCLE) allowAddressChange = 'N';
                    }

                    if (allowAddressChange == 'N') {
                        var search_address = result.search_address;
                        if (search_address != '' && search_address != undefined) {
                            localStorage.setItem('searchedADDRESS', search_address);
                        }

                        that.setState({ CIRCLE: circle, CIRCLEID: result.circleID, areas: areas });
                        $('#ModalOtherCircleData').modal('show');
                    } else {
                        localStorage.removeItem('addressID');
                        localStorage.setItem('delCIRCLE', circle);
                        localStorage.setItem('delCIRCLE2', result.circleID);
                        localStorage.setItem('GPS', 'Y');
                        del = true;

                        var _search_address = result.search_address;
                        if (_search_address != '' && _search_address != undefined) {
                            localStorage.setItem('searchedADDRESS', _search_address);
                        }

                        that.setState({ Notifications: notify, delSET: del, areas: areas });
                    }
                } else that.setState({ Notifications: notify, delSET: del, areas: areas });

                $('#submitLoading').css('display', 'none');
                if (notify != '') $('#ModalAlert').modal('show');
            });
        }
    };

    this.handlecircleChange = function (e) {
        e.preventDefault();

        var id = $('#selectedArea option:selected').val().trim();
        if (id != '' && id != 0) {
            window.location.href = "https://m.donedelivery.in/map2/" + id;
            //window.location.href = "http://localhost:3000/map2/"+id;
            //var that = this;
            //that.setState({ selectedAREA:id});
        } else alert('Please select area');
    };

    this.handleGetNewAddressCircle2 = function (circle_id, circleID) {

        localStorage.removeItem('cartCIRCLE');
        localStorage.removeItem('cartData');
        localStorage.removeItem('addressID');
        localStorage.removeItem('cartInstructions');
        localStorage.removeItem('cartVendorID');
        localStorage.removeItem('cartVendorName');
        localStorage.removeItem('cartVendorTypeID');

        localStorage.setItem('delCIRCLE', circle_id);
        localStorage.setItem('delCIRCLE2', circleID);
        localStorage.setItem('GPS', 'Y');
        _this3.setState({ delSET: true });
    };

    this.onMarkerClick = function (props, marker, e) {
        return _this3.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    this.handleGetAddress = function (address, lat, long) {
        _this3.setState({ address: address, lat: lat, long: long });
    };

    this.handleGetAddress2 = function (lat, long) {
        _this3.setState({ lat: lat, long: long });
    };

    this.onMarkerDragEnd = function (coord) {
        var latLng = coord.latLng;

        var lat = latLng.lat();
        var lng = latLng.lng();

        var requestOption = {
            method: 'GET'
        };

        //console.log(lat +','+ lng);
        var address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + lat + ',' + lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
            return res.json();
        }).then(function (response) {

            address = response.results[0].formatted_address;
            _this3.setState({ address: address, lat: lat, long: lng });
        }).catch(function (error) {
            console.warn(error);
        });
    };

    this.onClose = function (props) {
        if (_this3.state.showingInfoWindow) {
            _this3.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
};

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(PlotMap2);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _HomeBanner = __webpack_require__(123);

var _HomeBanner2 = _interopRequireDefault(_HomeBanner);

var _HomeCategory = __webpack_require__(124);

var _HomeCategory2 = _interopRequireDefault(_HomeCategory);

var _HomeManager = __webpack_require__(125);

var _HomeManager2 = _interopRequireDefault(_HomeManager);

var _HomeStores = __webpack_require__(126);

var _HomeStores2 = _interopRequireDefault(_HomeStores);

var _HomeStores3 = __webpack_require__(251);

var _HomeStores4 = _interopRequireDefault(_HomeStores3);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_React$Component) {
    _inherits(Home, _React$Component);

    function Home(props) {
        _classCallCheck(this, Home);

        var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

        _this.handleSearchClick = function () {
            var a = $("#search").hasClass("show");
            if (a) {
                $("#search").removeClass("show");
            } else {
                $("#search").addClass("show");
                $("#search .form-control").focus();
            }
        };

        _this.onKeyDown = function (event) {
            //console.log(event.key);
            var that = _this;
            if (event.key === 'Enter') {
                event.preventDefault();
                event.stopPropagation();
                event.preventDefault();

                var search_value = $('#search_text').val();
                that.setState({ redirect: true, search_text: search_value });
            }
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            BANNER: [],
            CATEGORY: [],
            HOME_MANAGER: [],
            STORE: [],
            STORE2: [],
            ADDRESS: '',
            cusADDRESS: '',
            CUSTOMER_DET: '',
            LASTORDER: '',
            POPUP: 'N',
            POPUPTITLE: '',
            POPUPIMAGE: '',
            POPUPFREQUENCY: ''
        };
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }

    _createClass(Home, [{
        key: 'fetchHomePage',
        value: function fetchHomePage(mode) {

            var id = localStorage.getItem('delCIRCLE');

            var address_id = '';
            if (localStorage.getItem('addressID')) address_id = localStorage.getItem('addressID');

            if (address_id == undefined || address_id == 'undefined') address_id = '';

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            if (customer == undefined || customer == 'undefined') customer = '';

            var that = this;
            fetch('https://m.donedelivery.in/api/home_api.php?mode=' + mode + '&id=' + id + '&address_id=' + address_id + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var BANNER = result.BANNER;
                var CATEGORY = result.CATEGORY;
                var HOME_MANAGER = result.HOME_MANAGER;
                var STORE = result.STORE;
                var STORE2 = result.STORE2;
                var ADDRESS = result.ADDRESS;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;
                var LASTORDER_COUNT = result.LASTORDER;

                var POPUP = result.POPUP;
                var POPUPTITLE = result.POPUP_TITLE;
                var POPUPIMAGE = result.POPUP_IMAGE;
                var POPUPFREQUENCY = result.POPUP_FREQUENCY;

                that.setState({ LOADING: false, BANNER: BANNER, CATEGORY: CATEGORY, HOME_MANAGER: HOME_MANAGER, STORE: STORE, STORE2: STORE2, cusADDRESS: ADDRESS, CUSTOMER_DET: CUSTOMER_DET, LASTORDER: LASTORDER_COUNT, POPUP: POPUP, POPUPTITLE: POPUPTITLE, POPUPIMAGE: POPUPIMAGE, POPUPFREQUENCY: POPUPFREQUENCY });

                if (POPUP === 'Y') {
                    if (POPUPFREQUENCY === 'X') $('#popupContent').modal('show');else {
                        var popFREQ = POPUPFREQUENCY.split('~');
                        var f = popFREQ[0];
                        var t = popFREQ[1];

                        var popupDISPLAYED = '';
                        //localStorage.setItem('popData', '');
                        if (localStorage.getItem('popData')) popupDISPLAYED = localStorage.getItem('popData');
                        if (popupDISPLAYED === '' || popupDISPLAYED === undefined || popupDISPLAYED === 'undefined') {
                            $('#popupContent').modal('show');
                            var date = new Date();
                            localStorage.setItem('popData', date);
                        } else {
                            var _date = new Date();
                            var add_minutes = function add_minutes(dt, minutes) {
                                return new Date(dt.getTime() + minutes * 60000);
                            };

                            var add_hours = function add_hours(dt, hours) {
                                return new Date(dt.getTime() + hours * 60 * 60000);
                            };

                            var newDATE = '';
                            if (t === 'M') newDATE = add_minutes(new Date(popupDISPLAYED), f).toString();else if (t === 'H') newDATE = add_hours(new Date(popupDISPLAYED), f).toString();

                            /*console.log('Current Time');
                            console.log(date);
                            console.log('Next Popup Time');
                            console.log(newDATE);*/

                            var compare_dates = function compare_dates(date1, date2) {
                                if (date1 > date2) return 'N';else if (date1 < date2) return 'Y';else return 'N';
                            };

                            var displayPOPUP = compare_dates(new Date(newDATE), new Date(_date));
                            //console.log(displayPOPUP);
                            if (displayPOPUP == 'Y') {
                                $('#popupContent').modal('show');
                                localStorage.setItem('popData', newDATE);
                            }
                        }
                    }
                }
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchHomePage('HOME');
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
            this.setState({ redirect: true });
            this.setState({ search_text: event.target.elements.search.value });

            event.target.elements.search.value = '';
        }
    }, {
        key: 'render',
        value: function render() {

            if (this.state.redirect) {
                this.setState({ redirect: false });
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/search/' + this.state.search_text });
            }

            if (localStorage.getItem('delCIRCLE') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/search' });
            }

            var props = {
                offers: this.state.OFFERS,
                items: this.state.MENU,
                sections: this.state.SECTION,
                page: 'HOME'
            };

            var GPS = 'N';
            if (localStorage.getItem('GPS') !== null) GPS = localStorage.getItem('GPS');

            var LABEL = '';
            var ADD = '';

            if (this.state.cusADDRESS != '' && GPS == 'N') {
                var _cusADDRESS = this.state.cusADDRESS.split('~~**~~');
                LABEL = _cusADDRESS[0];
                ADD = _cusADDRESS[1];
                if (_cusADDRESS[2] != '') ADD += ', ' + _cusADDRESS[2];
            } else {
                var _cusADDRESS2 = '';
                if (localStorage.getItem('searchedADDRESS')) _cusADDRESS2 = localStorage.getItem('searchedADDRESS');

                if (_cusADDRESS2 != '' && _cusADDRESS2 != undefined && _cusADDRESS2 != 'undefined') {
                    var _cusADDRESS2 = _cusADDRESS2.split(",");
                    LABEL = _cusADDRESS2.splice(0, 1).join("");
                    ADD = _cusADDRESS2.join(",");
                }
            }

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            var url = logged == 'Y' ? '/search' : '/map';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                this.state.POPUP === 'Y' && this.state.POPUPIMAGE !== '' && _react2.default.createElement(
                    'div',
                    { className: 'modal fade dialogbox', id: 'popupContent', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-dialog', role: 'document' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body' },
                                _react2.default.createElement('img', { src: this.state.POPUPIMAGE, alt: this.state.POPUPTITLE, className: 'imaged popup-image' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-footer' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'btn-inline' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                        'Close'
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'search', className: 'appHeader' },
                    _react2.default.createElement(
                        'form',
                        { className: 'search-form', onSubmit: this.handleSubmit },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group searchbox' },
                            _react2.default.createElement('input', { type: 'search', className: 'form-control', id: 'search_text', name: 'search', placeholder: 'Search...', onKeyDown: this.onKeyDown, minLength: '3' }),
                            _react2.default.createElement(
                                'i',
                                { className: 'input-icon' },
                                _react2.default.createElement('ion-icon', { name: 'search-outline' })
                            ),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                { to: '#', className: 'ml-1 close toggle-searchbox', onClick: this.handleSearchClick },
                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'appHeader bg-dark text-light' },
                    _react2.default.createElement(
                        'div',
                        { className: 'left' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: url, className: 'headerButton pl-0' },
                            _react2.default.createElement('ion-icon', { name: 'location-outline' })
                        ),
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '/home', className: 'headerButton p-0' },
                            _react2.default.createElement('img', { src: '/assets/img/done-logo.png', alt: 'image', className: 'form-image' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'pageTitle title-cut' },
                        _react2.default.createElement(
                            'div',
                            { className: 'title-cut-sub' },
                            LABEL,
                            '\xA0',
                            ADD
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'right' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '#', onClick: this.handleSearchClick, className: 'headerButton imaged w40 toggle-searchbox' },
                            _react2.default.createElement('ion-icon', { name: 'search-outline' })
                        ),
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            { to: '#', className: 'headerButton text-light', 'data-toggle': 'modal', 'data-target': '#sidebarPanel' },
                            _react2.default.createElement('ion-icon', { name: 'menu-outline' })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'mt-1 p-0' },
                    this.state.BANNER.length > 0 && _react2.default.createElement(_HomeBanner2.default, { banners: this.state.BANNER }),
                    this.state.LASTORDER > 0 && _react2.default.createElement(
                        'div',
                        { className: 'section inset pt-3 pb-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-6' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card pt-1 pb-1 text-center' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/reorder', className: 'text-upper mb-05 font-size-12 text-danger font-weg-600' },
                                        'Re Order'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'content-header text-mgrey font-size-12' },
                                        'Choose from ',
                                        this.state.LASTORDER,
                                        ' item',
                                        this.state.LASTORDER > 1 ? 's' : ''
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-6' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card pt-1 pb-1 text-center' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/special-offers', className: 'text-upper mb-05 font-size-12 text-danger font-weg-600' },
                                        'OFFERS'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'content-header text-mgrey font-size-12' },
                                        'Get Best Deals'
                                    )
                                )
                            )
                        )
                    ),
                    this.state.CATEGORY.length > 0 && _react2.default.createElement(_HomeCategory2.default, { categories: this.state.CATEGORY }),
                    this.state.HOME_MANAGER.length > 0 && _react2.default.createElement(_HomeManager2.default, { home_manager: this.state.HOME_MANAGER }),
                    this.state.STORE.length > 0 && _react2.default.createElement(_HomeStores2.default, { stores: this.state.STORE }),
                    console.log(this.state.STORE2),
                    this.state.STORE2.length > 0 && _react2.default.createElement(_HomeStores4.default, { stores: this.state.STORE2 }),
                    _react2.default.createElement(
                        'div',
                        { className: 'section inset pt-0 pb-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card p-2' },
                                    _react2.default.createElement(
                                        'h3',
                                        null,
                                        'Any service / delivery complaints?'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-mgrey font-size-14' },
                                        'Our Customer Care Executive will try to resolve all possible issues you faced'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'pt-2' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: logged == 'Y' ? '/orders' : '/login', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                            'Click here to start'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section inset pt-0 pb-3 mb-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'card p-2' },
                                    _react2.default.createElement(
                                        'h3',
                                        null,
                                        'Need Assistance?'
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-mgrey font-size-14' },
                                        'You can get in touch with us from 9am to 9pm'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'pt-2' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: 'tel:+917447436811', target: '_blank', className: 'lt-space1 text-upper btn btn-outline-danger font-weg-500 font-size-17 btn-block square btn-md' },
                                            _react2.default.createElement('ion-icon', { className: 'mt-0', name: 'call' }),
                                            '7447436811'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Home;
}(_react2.default.Component);

exports.default = Home;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeStores = function HomeStores(props) {

    var Store = props.stores.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'col-6', key: post.ID },
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/vendor/' + post.ID },
                _react2.default.createElement(
                    'div',
                    { className: 'card mb-2' },
                    _react2.default.createElement(
                        'div',
                        { className: 'storeHeight' },
                        _react2.default.createElement('img', { src: post.IMAGE, className: 'card-img-top', alt: post.NAME })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'card-body pt-07 pb-07 pr-06 pl-06 storeTextHeight' },
                        _react2.default.createElement(
                            'p',
                            { className: 'card-text text-dgrey font-size-12 font-weg-500 mb-0' },
                            post.NAME
                        ),
                        post.ITEMS != '' && _react2.default.createElement(
                            'p',
                            { className: 'mb-0 text-slgrey' },
                            _react2.default.createElement(
                                'small',
                                null,
                                post.ITEMS,
                                ' items'
                            )
                        )
                    )
                )
            )
        );
    });

    return _react2.default.createElement(
        'div',
        { className: 'section pt-0 pb-2' },
        _react2.default.createElement(
            'div',
            { className: 'section-title font-size-17 mb-05 text-sdgrey' },
            'Speciality Store'
        ),
        _react2.default.createElement(
            'div',
            { className: 'row' },
            Store
        )
    );
};

exports.default = HomeStores;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _HomeBanner = __webpack_require__(123);

var _HomeBanner2 = _interopRequireDefault(_HomeBanner);

var _HomeCategory = __webpack_require__(124);

var _HomeCategory2 = _interopRequireDefault(_HomeCategory);

var _HomeManager = __webpack_require__(125);

var _HomeManager2 = _interopRequireDefault(_HomeManager);

var _HomeStores = __webpack_require__(126);

var _HomeStores2 = _interopRequireDefault(_HomeStores);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Categories = function (_React$Component) {
    _inherits(Categories, _React$Component);

    function Categories(props) {
        _classCallCheck(this, Categories);

        var _this = _possibleConstructorReturn(this, (Categories.__proto__ || Object.getPrototypeOf(Categories)).call(this, props));

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            categories: [],
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(Categories, [{
        key: 'fetchCategoryPage',
        value: function fetchCategoryPage(mode) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/categories_api.php?mode=' + mode + '&id=' + id + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var CATEGORIES = result.CATEGORIES;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, categories: CATEGORIES, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchCategoryPage('CATEGORY');
        }
    }, {
        key: 'render',
        value: function render() {
            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Categories';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            var categories = this.state.categories.map(function (post, i) {

                var OfferType = '';
                var OfferType2 = '';
                if (post.OFFER_TYPE !== '') {
                    if (post.OFFER_TYPE == 'PER') OfferType = '%';
                    if (post.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: post.ID },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/category/' + post.ID },
                        _react2.default.createElement(
                            'div',
                            { className: 'card mb-2' },
                            post.OFFER != '' && _react2.default.createElement(
                                'div',
                                { className: 'chip off-tags chip-warning' },
                                _react2.default.createElement(
                                    'span',
                                    { className: 'chip-label' },
                                    OfferType2,
                                    post.OFFER,
                                    OfferType,
                                    ' Off'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'categoriesHeight' },
                                _react2.default.createElement('img', { src: post.IMAGE, className: 'card-img-top', alt: post.NAME })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'card-body pt-07 pb-07 text-center categoriesText' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'card-text font-size-13 text-dgrey font-weg-500' },
                                    post.NAME
                                )
                            )
                        )
                    )
                );
            });

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section pt-2 pb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            categories
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Categories;
}(_react2.default.Component);

exports.default = Categories;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Items = __webpack_require__(127);

var _Items2 = _interopRequireDefault(_Items);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Category = function (_React$Component) {
    _inherits(Category, _React$Component);

    function Category(props) {
        _classCallCheck(this, Category);

        var _this = _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).call(this, props));

        _this.inCartCallBack = function () {

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') cartEMPTY = 'N';

            var that = _this;
            that.setState({ cartEMPTY: cartEMPTY });
        };

        _this.loadMore = function () {
            //this.state.loading = true;
            _this.fetchSecond('CATEGORY', _this.state.category, _this.state.page);
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            categories: [],
            items: [],
            cartEMPTY: 'Y',
            category: props.match.params.id,
            CATEGORYNAME: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
        return _this;
    }

    _createClass(Category, [{
        key: 'fetchCategoryPage',
        value: function fetchCategoryPage(mode, category, page) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/categories_api.php?mode=' + mode + '&id=' + id + '&category=' + category + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var CATEGORIES = result.CATEGORIES;
                var ITEMS = result.ITEMS;
                var CATEGORYNAME = result.CATEGORYNAME;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, categories: CATEGORIES, items: ITEMS, CATEGORYNAME: CATEGORYNAME, CUSTOMER_DET: CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'fetchSecond',
        value: function fetchSecond(mode, category, page) {
            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/categories_api.php?mode=' + mode + '&id=' + id + '&category=' + category + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CATEGORIES = result.CATEGORIES;
                var CATEGORYNAME = result.CATEGORYNAME;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
            //this.setState({ LOADING:true });
            //this.fetchCategoryPage('CATEGORY',nextProps.match.params.id);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchCategoryPage('CATEGORY', this.state.category, this.state.page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/categories';
            var AppHeaderTitle = 'Categories';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            var props = {
                items: this.state.items,
                inCartCallBack: this.inCartCallBack
            };

            var categories = this.state.categories.map(function (post, i) {

                var css = 'btn-outline-mix';
                if (_this2.state.category == post.ID) css = 'tab-active btn-outline-primary';

                return _react2.default.createElement(
                    _reactRouterDom.Link,
                    { key: post.ID, className: 'btn ' + css + ' rounded newshadowed btn-lsm mr-1', to: '/category/' + post.ID },
                    post.NAME
                );
            });

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    this.state.categories.length > 0 && _react2.default.createElement(
                        'div',
                        { className: 'section  pt-3 pb-0 pr-0 pl-0 item-tab' },
                        _react2.default.createElement(
                            'div',
                            { className: 'wide-block wide-block2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper pb-1', style: { 'display': 'flex' } },
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { className: 'btn btn-outline-mix rounded btn-lsm mr-1 newshadowed', to: '/categories' },
                                    'All'
                                ),
                                categories
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section pt-0 pb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            this.state.items.length > 0 && _react2.default.createElement(_Items2.default, props)
                        ),
                        this.state.displayLoadMore == 'Y' && _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'button',
                                { type: 'button', style: { 'height': '31px' }, onClick: function onClick() {
                                        return _this2.loadMore();
                                    }, className: 'btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack' },
                                'Load More'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Category;
}(_react2.default.Component);

exports.default = Category;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SectionItems = __webpack_require__(255);

var _SectionItems2 = _interopRequireDefault(_SectionItems);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sections = function (_React$Component) {
    _inherits(Sections, _React$Component);

    function Sections(props) {
        _classCallCheck(this, Sections);

        var _this = _possibleConstructorReturn(this, (Sections.__proto__ || Object.getPrototypeOf(Sections)).call(this, props));

        _this.inCartCallBack = function () {

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') cartEMPTY = 'N';

            var that = _this;
            that.setState({ cartEMPTY: cartEMPTY });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            items: [],
            cartEMPTY: 'Y',
            section: props.match.params.id,
            SECTIONNAME: '',
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(Sections, [{
        key: 'fetchSectionPage',
        value: function fetchSectionPage(mode, section) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/sections_api.php?mode=' + mode + '&id=' + id + '&section=' + section + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var ITEMS = result.ITEMS;
                var SECTIONNAME = result.SECTIONNAME;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, items: ITEMS, SECTIONNAME: SECTIONNAME, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
            //this.setState({ LOADING:true });
            //this.fetchSectionPage('SECTION',nextProps.match.params.id);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchSectionPage('SECTION', this.state.section);
        }
    }, {
        key: 'render',
        value: function render() {
            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = this.state.SECTIONNAME;
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = ''; //this.state.SECTIONNAME;

            var props = {
                items: this.state.items,
                inCartCallBack: this.inCartCallBack
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                this.state.SECTIONNAME != '' && _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section pt-0 pb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            this.state.items.length > 0 && _react2.default.createElement(_SectionItems2.default, props)
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Sections;
}(_react2.default.Component);

exports.default = Sections;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionItems = function (_React$Component) {
    _inherits(SectionItems, _React$Component);

    function SectionItems(props) {
        _classCallCheck(this, SectionItems);

        var _this = _possibleConstructorReturn(this, (SectionItems.__proto__ || Object.getPrototypeOf(SectionItems)).call(this, props));

        _this.handleClickAddToCart = function (id, unit, vendor_id, vendor_name, vendortype_id) {
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var circleID = localStorage.getItem('delCIRCLE2');
            if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }
                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];
                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }
                return temp;
            };

            var cart = localStorage.getItem('cartData');
            var cartVendorID = localStorage.getItem('cartVendorID');
            var cartVendorName = localStorage.getItem('cartVendorName');
            var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + unit, 1);
                localStorage.setItem('cartData', JSON.stringify(a));
                localStorage.setItem('cartVendorID', vendor_id);
                localStorage.setItem('cartVendorName', vendor_name);
                localStorage.setItem('cartVendorTypeID', vendortype_id);

                var _inCart = 'Y';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, cartCount: _cartCount });
                _this.props.inCartCallBack();
            } else {
                var ALLOW_CART = 'Y';
                if (cartVendorID != vendor_id) {
                    var MSG = '';
                    if (cartVendorTypeID != vendortype_id) {
                        if (cartVendorTypeID == '2') MSG = 'Items from ' + cartVendorName + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;else if (vendortype_id == '2') MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;

                        ALLOW_CART = 'N';
                    } else {
                        if (cartVendorTypeID == '2' && vendortype_id == '2') {
                            MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;
                            ALLOW_CART = 'N';
                        }
                    }

                    if (ALLOW_CART == 'N') {
                        that.setState({ RESTRICTION_NOTE: MSG });
                        $('#ModalCartItemRestriction_' + id).modal('show');
                    }
                }

                if (ALLOW_CART == 'Y') {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');
                        if (cart_id[0] == id) cartTotalCount += cartData[key];

                        if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                    });
                    cartTotalCount += 1;

                    cartData = addToObject(cartData, [id + '~~**~~' + unit], 1);
                    localStorage.setItem('cartData', JSON.stringify(cartData));

                    var _inCart2 = 'Y';
                    var _cartCount2 = 1;
                    that.setState({ inCart: _inCart2, cartCount: cartTotalCount });
                    _this.props.inCartCallBack();
                }
            }
        };

        _this.handleClickIncreement = function (id, unit, cartCount, itemqty_cart) {
            var cartTotalCount = 0;
            if (itemqty_cart !== 0 && cartCount < itemqty_cart) {
                cartCount = cartCount + 1;

                var cart = localStorage.getItem('cartData');
                var that = _this;
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) cartTotalCount += cartData[key];

                    if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
                });
                cartTotalCount += 1;

                localStorage.setItem('cartData', JSON.stringify(cartData));

                var inCart = 'Y';
                cartCount = cartCount;
                that.setState({ inCart: inCart, cartCount: cartTotalCount });
                _this.props.inCartCallBack();
            } else $('#ModalCartItemLimit_' + id).modal('show');
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            cartCount = cartCount;
            that.setState({ inCart: inCart, cartCount: cartCount });
            _this.props.inCartCallBack();
        };

        _this.state = {
            items: props.items,
            RESTRICTION_NOTE: ''
        };
        return _this;
    }

    _createClass(SectionItems, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.state.items.map(function (item) {

                var inCart = 'N'; //this.state.inCart;
                var added = ''; //this.state.addButton;
                var cartCount = 0; //this.state.cartCount;

                var currentITEM = item.ID;
                var cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var id = key.split('~~**~~');
                        if (id[0] == currentITEM) {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                var OfferType = '';
                var OfferType2 = '';
                if (item.OFFER_TYPE !== '') {
                    if (item.OFFER_TYPE == 'PER') OfferType = '%';
                    if (item.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: item.ID },
                    _react2.default.createElement(
                        'div',
                        { className: 'card  mb-2' },
                        item.OFFER != '' && _react2.default.createElement(
                            'div',
                            { className: 'chip off-tags chip-warning' },
                            _react2.default.createElement(
                                'span',
                                { className: 'chip-label' },
                                OfferType2,
                                item.OFFER,
                                OfferType,
                                ' Off'
                            )
                        ),
                        _react2.default.createElement('img', { src: item.PIC, className: 'card-img-top imaged w-100', alt: 'image' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                            _react2.default.createElement(
                                'p',
                                { className: 'card-text text-dgrey font-size-14 font-weg-400 mb-0' },
                                item.NAME
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 text-slgrey' },
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Per ',
                                    item.UNIT
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 font-weg-600' },
                                item.MRP !== '0.00' && item.MRP !== item.RATE && _react2.default.createElement(
                                    'span',
                                    { className: 'del-price text-slgrey' },
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        '\u20B9',
                                        item.MRP
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'final-price text-danger font-size-14' },
                                    '\u20B9 ',
                                    item.RATE
                                )
                            ),
                            item.AVAILABLE_QTY > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'add-btn ' + added + ' mt-2' },
                                    _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                        }, value: '-', className: 'qtyminus' }),
                                    _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                    inCart == 'Y' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickIncreement(item.ID, item.UNIT, cartCount, item.QTY_PER_CART);
                                        }, value: '+', className: 'qtyplus' }),
                                    inCart == 'N' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickAddToCart(item.ID, item.UNIT, item.VENDOR_ID, item.VENDOR_NAME, item.VENDORTYPE_ID);
                                        }, value: '+', className: 'qtyplus' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemLimit_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                'You have reached the limit for this item'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemRestriction_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                _this2.state.RESTRICTION_NOTE
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            item.AVAILABLE_QTY == 0 && _react2.default.createElement(
                                'div',
                                { className: 'add-btn add-btn-incr mt-2 font-size-12' },
                                'Out Of Stock'
                            )
                        )
                    )
                );
            });
        }
    }]);

    return SectionItems;
}(_react2.default.Component);

exports.default = SectionItems;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _VendorItems = __webpack_require__(257);

var _VendorItems2 = _interopRequireDefault(_VendorItems);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Vendors = function (_React$Component) {
    _inherits(Vendors, _React$Component);

    function Vendors(props) {
        _classCallCheck(this, Vendors);

        var _this = _possibleConstructorReturn(this, (Vendors.__proto__ || Object.getPrototypeOf(Vendors)).call(this, props));

        _this.inCartCallBack = function () {

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') cartEMPTY = 'N';

            var that = _this;
            that.setState({ cartEMPTY: cartEMPTY });
        };

        _this.loadMore = function () {
            //this.state.loading = true;
            _this.fetchSecond('VENDOR', _this.state.vendor, _this.state.page);
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            items: [],
            cartEMPTY: 'Y',
            vendor: props.match.params.id,
            VENDORNAME: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
        return _this;
    }

    _createClass(Vendors, [{
        key: 'fetchVendorPage',
        value: function fetchVendorPage(mode, vendor, page) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/vendors_api.php?mode=' + mode + '&id=' + id + '&vendor=' + vendor + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var ITEMS = result.ITEMS;
                var VENDORNAME = result.VENDORNAME;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, items: ITEMS, VENDORNAME: VENDORNAME, CUSTOMER_DET: CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'fetchSecond',
        value: function fetchSecond(mode, vendor, page) {
            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/vendors_api.php?mode=' + mode + '&id=' + id + '&vendor=' + vendor + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var VENDORNAME = result.VENDORNAME;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchVendorPage('VENDOR', this.state.vendor, this.state.page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = this.state.VENDORNAME;
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = ''; //this.state.VENDORNAME;

            var props = {
                items: this.state.items,
                inCartCallBack: this.inCartCallBack
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                this.state.VENDORNAME != '' && _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section mt-2 pt-0 pb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            this.state.items.length > 0 && _react2.default.createElement(_VendorItems2.default, props)
                        ),
                        this.state.displayLoadMore == 'Y' && _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'button',
                                { type: 'button', style: { 'height': '31px' }, onClick: function onClick() {
                                        return _this2.loadMore();
                                    }, className: 'btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack' },
                                'Load More'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Vendors;
}(_react2.default.Component);

exports.default = Vendors;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VendorItems = function (_React$Component) {
    _inherits(VendorItems, _React$Component);

    function VendorItems(props) {
        _classCallCheck(this, VendorItems);

        var _this = _possibleConstructorReturn(this, (VendorItems.__proto__ || Object.getPrototypeOf(VendorItems)).call(this, props));

        _this.handleClickAddToCart = function (id, unit, vendor_id, vendor_name, vendortype_id) {
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var circleID = localStorage.getItem('delCIRCLE2');
            if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }
                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];
                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }
                return temp;
            };

            var cart = localStorage.getItem('cartData');
            var cartVendorID = localStorage.getItem('cartVendorID');
            var cartVendorName = localStorage.getItem('cartVendorName');
            var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + unit, 1);
                localStorage.setItem('cartData', JSON.stringify(a));
                localStorage.setItem('cartVendorID', vendor_id);
                localStorage.setItem('cartVendorName', vendor_name);
                localStorage.setItem('cartVendorTypeID', vendortype_id);

                var _inCart = 'Y';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, cartCount: _cartCount });
                _this.props.inCartCallBack();
            } else {
                var ALLOW_CART = 'Y';
                if (cartVendorID != vendor_id) {
                    var MSG = '';
                    if (cartVendorTypeID != vendortype_id) {
                        if (cartVendorTypeID == '2') MSG = 'Items from ' + cartVendorName + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;else if (vendortype_id == '2') MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;

                        ALLOW_CART = 'N';
                    } else {
                        if (cartVendorTypeID == '2' && vendortype_id == '2') {
                            MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;
                            ALLOW_CART = 'N';
                        }
                    }

                    if (ALLOW_CART == 'N') {
                        that.setState({ RESTRICTION_NOTE: MSG });
                        $('#ModalCartItemRestriction_' + id).modal('show');
                    }
                }

                if (ALLOW_CART == 'Y') {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');
                        if (cart_id[0] == id) cartTotalCount += cartData[key];

                        if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                    });
                    cartTotalCount += 1;

                    cartData = addToObject(cartData, [id + '~~**~~' + unit], 1);
                    localStorage.setItem('cartData', JSON.stringify(cartData));

                    var _inCart2 = 'Y';
                    var _cartCount2 = 1;
                    that.setState({ inCart: _inCart2, cartCount: cartTotalCount });
                    _this.props.inCartCallBack();
                }
            }
        };

        _this.handleClickIncreement = function (id, unit, cartCount, itemqty_cart) {
            var cartTotalCount = 0;
            if (itemqty_cart !== 0 && cartCount < itemqty_cart) {
                cartCount = cartCount + 1;

                var cart = localStorage.getItem('cartData');
                var that = _this;
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) cartTotalCount += cartData[key];

                    if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
                });
                cartTotalCount += 1;

                localStorage.setItem('cartData', JSON.stringify(cartData));

                var inCart = 'Y';
                cartCount = cartCount;
                that.setState({ inCart: inCart, cartCount: cartTotalCount });
                _this.props.inCartCallBack();
            } else $('#ModalCartItemLimit_' + id).modal('show');
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            cartCount = cartCount;
            that.setState({ inCart: inCart, cartCount: cartCount });
            _this.props.inCartCallBack();
        };

        _this.state = {
            items: props.items,
            RESTRICTION_NOTE: ''
        };
        return _this;
    }

    _createClass(VendorItems, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ items: nextProps.items });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.state.items.map(function (item) {

                var inCart = 'N'; //this.state.inCart;
                var added = ''; //this.state.addButton;
                var cartCount = 0; //this.state.cartCount;

                var currentITEM = item.ID;
                var cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var id = key.split('~~**~~');
                        if (id[0] == currentITEM) {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                var OfferType = '';
                var OfferType2 = '';
                if (item.OFFER_TYPE !== '') {
                    if (item.OFFER_TYPE == 'PER') OfferType = '%';
                    if (item.OFFER_TYPE == 'DIS') OfferType = '&#8377;';
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: item.ID },
                    _react2.default.createElement(
                        'div',
                        { className: 'card  mb-2' },
                        item.OFFER != '' && _react2.default.createElement(
                            'div',
                            { className: 'chip off-tags chip-warning' },
                            _react2.default.createElement(
                                'span',
                                { className: 'chip-label' },
                                OfferType2,
                                item.OFFER,
                                OfferType,
                                ' Off'
                            )
                        ),
                        _react2.default.createElement('img', { src: item.PIC, className: 'card-img-top imaged w-100', alt: 'image' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                            _react2.default.createElement(
                                'p',
                                { className: 'card-text text-dgrey font-size-14 font-weg-400 mb-0' },
                                item.NAME
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 text-slgrey' },
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Per ',
                                    item.UNIT
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 font-weg-600' },
                                item.MRP !== '0.00' && item.MRP !== item.RATE && _react2.default.createElement(
                                    'span',
                                    { className: 'del-price text-slgrey' },
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        '\u20B9',
                                        item.MRP
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'final-price text-danger font-size-14' },
                                    '\u20B9 ',
                                    item.RATE
                                )
                            ),
                            item.AVAILABLE_QTY > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'add-btn ' + added + ' mt-2' },
                                    _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                        }, value: '-', className: 'qtyminus' }),
                                    _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                    inCart == 'Y' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickIncreement(item.ID, item.UNIT, cartCount, item.QTY_PER_CART);
                                        }, value: '+', className: 'qtyplus' }),
                                    inCart == 'N' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickAddToCart(item.ID, item.UNIT, item.VENDOR_ID, item.VENDOR_NAME, item.VENDORTYPE_ID);
                                        }, value: '+', className: 'qtyplus' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemLimit_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                'You have reached the limit for this item'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemRestriction_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                _this2.state.RESTRICTION_NOTE
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            item.AVAILABLE_QTY == 0 && _react2.default.createElement(
                                'div',
                                { className: 'add-btn add-btn-incr mt-2 font-size-12' },
                                'Out Of Stock'
                            )
                        )
                    )
                );
            });
        }
    }]);

    return VendorItems;
}(_react2.default.Component);

exports.default = VendorItems;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(40);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Option = __webpack_require__(128);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Register = function (_React$Component) {
    _inherits(Register, _React$Component);

    function Register(props) {
        _classCallCheck(this, Register);

        var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmLocate')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmLocate')[0].classList.add('was-validated');

            if (err == 0) {
                //$('#ModalLoadingAlert').modal('show');
                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://www.peepkitchen.in/peep/pwa/api/locate_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {
                    //console.log(result);
                    //alert(result);
                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Delivery Circle Field is Empty';else if (result.err == '2') notify = 'Area/Near by Locality Field is Empty';else if (result.err == '3') notify = 'No Restaurant Found For The Chosen Area';else if (result.err == '4') notify = 'Invalid Access Detected';
                    }

                    var delcity = false;
                    var delarea = false;

                    var restaurant = result.restaurant;
                    if (restaurant != '' && restaurant != undefined) {
                        localStorage.setItem('REST', restaurant);

                        delcity = result.del_city;
                        delarea = result.del_area;
                        localStorage.setItem('delCity', delcity);
                        localStorage.setItem('delArea', delarea);
                    }

                    that.setState({ Notifications: notify, Del_City: delcity, Del_Area: delarea, delSET: true });
                    ///$('#ModalLoadingAlert').modal('hide');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.handlecircleChange = function (e) {
            //$('#ModalLoadingAlert').modal('show');
            e.preventDefault();

            var type = 'AREA';
            var id = event.target.value;
            var that = _this;
            fetch('https://www.peepkitchen.in/peep/pwa/api/deliveryarea_api.php?type=' + type + '&id=' + id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                that.setState({ DelArea: result.del_area });
                //$('#ModalLoadingAlert').modal('hide');
            });
        };

        _this.state = {
            LOADING: true,
            Notifications: false,
            Del_City: false,
            Del_Area: false,
            DelCity: [],
            DelArea: [],
            delSET: false
        };
        return _this;
    }

    _createClass(Register, [{
        key: 'fetchCircle',
        value: function fetchCircle(type, id) {
            var that = this;
            fetch('https://www.peepkitchen.in/peep/pwa/api/deliveryarea_api.php?type=' + type + '&id=' + id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                that.setState({ DelCity: result.del_circle, LOADING: false });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.fetchCircle('CITY', '0');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem('REST');
            //localStorage.removeItem('delCity');
            //localStorage.removeItem('delArea');

            if (this.state.delSET == true) {
                if (localStorage.getItem('REST') && localStorage.getItem('REST') != null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            /*if(localStorage.getItem('REST') && localStorage.getItem('REST')!=null)
            {
             return (<Redirect to={'/home'}/>)
            }*/

            var AppHeaderClass = 'appHeader bg-primary text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/';
            var AppHeaderTitle = 'Delivery Circle';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';

            var city = this.state.DelCity;
            var arr = [];
            Object.keys(city).forEach(function (key) {
                arr.push(city[key]);
            });

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement('div', { className: 'col-2' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-8 align-content-center' },
                            _react2.default.createElement('img', { src: '/assets/img/location.png', alt: 'location', className: 'center-image' })
                        ),
                        _react2.default.createElement('div', { className: 'col-2' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-2 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmLocate', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'LOCATE', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control custom-select', id: 'cmbdelcity', name: 'cmbdelcity', required: true, onChange: this.handlecircleChange },
                                            _react2.default.createElement(
                                                'option',
                                                { value: '' },
                                                'Delivery Circle'
                                            ),
                                            arr.map(function (post) {
                                                return _react2.default.createElement(
                                                    'optgroup',
                                                    { key: post.name, label: post.name },
                                                    _react2.default.createElement(_Option2.default, { post: post.child })
                                                );
                                            })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please choose the delivery circle.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'select',
                                            { className: 'form-control custom-select', id: 'cmbdelarea', name: 'cmbdelarea', required: true },
                                            _react2.default.createElement(
                                                'option',
                                                { value: '' },
                                                'Area / Near by Locality'
                                            ),
                                            _react2.default.createElement(_Option2.default, { post: this.state.DelArea })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please choose the area/near by locality.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                                        'SUBMIT'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-dialog', role: 'document' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-content' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-icon text-danger' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-body' },
                                            this.state.Notifications
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-footer' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'btn-inline' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                    'Ok'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Register;
}(_react2.default.Component);

exports.default = Register;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(40);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _CuisineSections = __webpack_require__(260);

var _CuisineSections2 = _interopRequireDefault(_CuisineSections);

var _SpecialDishItems = __webpack_require__(261);

var _SpecialDishItems2 = _interopRequireDefault(_SpecialDishItems);

var _CartToast = __webpack_require__(129);

var _CartToast2 = _interopRequireDefault(_CartToast);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuSection = function MenuSection(props) {
    return props.section.map(function (post) {
        return _react2.default.createElement(
            'div',
            { className: 'item dish', key: post.id },
            _react2.default.createElement(
                'p',
                { className: 'ds' },
                post.name
            )
        );
    });
};

var SpecialDish = function (_React$Component) {
    _inherits(SpecialDish, _React$Component);

    function SpecialDish(props) {
        _classCallCheck(this, SpecialDish);

        var _this = _possibleConstructorReturn(this, (SpecialDish.__proto__ || Object.getPrototypeOf(SpecialDish)).call(this, props));

        _this.inCartCallBack = function () {

            var displayCartToast = 'N';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') displayCartToast = 'Y';
            //console.log(cart);
            //console.log(displayCartToast);
            var that = _this;
            that.setState({ displayCartToast: displayCartToast });
        };

        _this.state = {
            LOADING: true,
            LOCATION: _this.props.location.pathname,
            item_id: props.match.params.id,
            SECTION: [],
            itemIMAGE: '',
            ITEMS: [],
            ITEMS2: [],
            CLOSED: '',
            OPENS: '',
            ENDS: '',
            displayCartToast: 'N'
        };
        return _this;
    }

    _createClass(SpecialDish, [{
        key: 'fetchRestaurantMenu',
        value: function fetchRestaurantMenu(mode, id, items) {
            var that = this;
            fetch('https://www.peepkitchen.in/peep/pwa/api/restaurantmenu_api3.php?mode=' + mode + '&id=' + id + '&items=' + items, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                /*//Clearing the cart if restaurant is closed
                if(result.closed=='Y')
                {
                    localStorage.removeItem('cartRES');
                    localStorage.removeItem('cartInstructions');
                    localStorage.removeItem("cartData");
                }*/

                var sections = result.section;
                var displayCartToast = 'N';
                var cart = localStorage.getItem('cartData');
                if (cart !== null && cart !== '{}') displayCartToast = 'Y';

                that.setState({ LOADING: false, SECTION: sections, itemIMAGE: result.item_pic, ITEMS: result.menu, ITEMS2: result.menu2, CLOSED: result.closed, OPENS: result.opens, ENDS: result.ends, displayCartToast: displayCartToast });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }

            var restaurant_id = localStorage.getItem('REST');
            var item_id = this.state.item_id;
            this.fetchRestaurantMenu('MENU', restaurant_id, item_id);
        }
    }, {
        key: 'render',
        value: function render() {

            if (localStorage.getItem('REST') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map2' });
            }

            //localStorage.removeItem("userData");
            //console.log(localStorage.getItem('userData'));

            var AppHeaderClass = 'appHeader bg-primary text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Special Dish';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';

            var props = {
                items: this.state.ITEMS,
                sections: this.state.SECTION,
                inCartCallBack: this.inCartCallBack,
                CLOSED: this.state.CLOSED,
                OPENS: this.state.OPENS
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    this.state.itemIMAGE != '' && _react2.default.createElement(
                        'div',
                        { className: 'section full' },
                        _react2.default.createElement('img', { src: this.state.itemIMAGE, alt: 'image', className: 'imaged square w-100' })
                    ),
                    this.state.CLOSED != 'Y' && this.state.ENDS == '' && _react2.default.createElement(
                        'p',
                        { className: 'timings' },
                        this.state.OPENS
                    ),
                    this.state.CLOSED != 'Y' && this.state.ENDS != '' && _react2.default.createElement(
                        'p',
                        { className: 'timings2' },
                        this.state.ENDS
                    ),
                    this.state.SECTION.length > 0 && _react2.default.createElement(_CuisineSections2.default, props),
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2 mb-2' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'listview image-listview media' },
                            _react2.default.createElement(_SpecialDishItems2.default, props)
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'conditions' },
                        '*Actual dish may differ from the images displayed'
                    ),
                    _react2.default.createElement('br', null)
                ),
                this.state.CLOSED == 'Y' && _react2.default.createElement(
                    'div',
                    { id: 'toast-1', 'class': 'toast-box toast-top bg-warning show', style: { 'padding': '6px', 'minHeight': '22px !important' } },
                    _react2.default.createElement(
                        'div',
                        { 'class': 'in' },
                        _react2.default.createElement(
                            'div',
                            { 'class': 'text' },
                            this.state.OPENS
                        )
                    )
                ),
                this.state.displayCartToast == 'Y' && _react2.default.createElement(_CartToast2.default, { items: this.state.ITEMS2 }),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION })
            );
        }
    }]);

    return SpecialDish;
}(_react2.default.Component);

exports.default = SpecialDish;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CuisineSections2 = function CuisineSections2(props) {
    var Sections = props.sections.map(function (post, i) {
        return _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/listing/s/' + post.id, key: post.id, className: 'btn btn-outline-primary shadowed btn-sm mr-1' },
            post.name
        );
    });

    return _react2.default.createElement(
        'div',
        { className: 'section full mb-3' },
        _react2.default.createElement(
            'div',
            { className: 'section-title' },
            _react2.default.createElement('br', null),
            'Cuisines'
        ),
        _react2.default.createElement(
            'div',
            { className: 'wide-block', style: { 'overflowY': 'scroll', 'borderBottom': '0 none' } },
            _react2.default.createElement(
                'div',
                { style: { 'display': 'flex' } },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/listing', className: 'btn btn-outline-primary shadowed btn-sm mr-1' },
                    'All'
                ),
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/specialdish', className: 'btn btn-primary shadowed btn-sm mr-1' },
                    'Speciality Dish'
                ),
                Sections
            )
        )
    );
};

exports.default = CuisineSections2;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SpecialDishItem = __webpack_require__(262);

var _SpecialDishItem2 = _interopRequireDefault(_SpecialDishItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpecialDishItems = function SpecialDishItems(props) {
    return props.items.map(function (item, i) {
        return _react2.default.createElement(
            'li',
            { key: item.ITEMID },
            _react2.default.createElement(
                'div',
                { className: 'item' },
                _react2.default.createElement(
                    'div',
                    { className: 'veg-non' },
                    _react2.default.createElement('img', { src: '/assets/img/' + item.TYPE + '.svg', alt: item.TYPE })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'imageWrapper' },
                    item.PIC != '' && _react2.default.createElement('img', { src: item.PIC, alt: item.ITEMNAME, className: 'imaged w64' }),
                    item.PIC == '' && _react2.default.createElement('img', { src: '/assets/img/default.gif', alt: item.ITEMNAME, className: 'imaged default' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'in' },
                    _react2.default.createElement(
                        'div',
                        null,
                        ' ',
                        item.ITEMNAME,
                        _react2.default.createElement(
                            'div',
                            { className: 'text-price' },
                            '\u20B9 ',
                            item.RATE
                        )
                    ),
                    props.CLOSED == 'N' && item.NEXTAVAILABLE == '' && _react2.default.createElement(_SpecialDishItem2.default, { id: item.ITEMID, item: item.ITEMNAME, custom: item.CUSTOM_EXIST, customData: item.CUSTOM, inCartCallBack2: props.inCartCallBack }),
                    props.CLOSED == 'N' && item.NEXTAVAILABLE != '' && _react2.default.createElement(
                        'div',
                        { className: 'aditions' },
                        _react2.default.createElement(
                            'div',
                            { className: 'openned' },
                            _react2.default.createElement('p', { 'class': 'available', dangerouslySetInnerHTML: { __html: item.NEXTAVAILABLE } })
                        )
                    )
                )
            )
        );
    });
};

exports.default = SpecialDishItems;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpecialDishItem = function (_React$Component) {
    _inherits(SpecialDishItem, _React$Component);

    function SpecialDishItem(props) {
        _classCallCheck(this, SpecialDishItem);

        var _this = _possibleConstructorReturn(this, (SpecialDishItem.__proto__ || Object.getPrototypeOf(SpecialDishItem)).call(this, props));
        //console.log(props);


        _this.handleClickAddToCart = function (id, custom) {

            var cartRES = localStorage.getItem('cartRES');
            var resID = localStorage.getItem('REST2');
            if (cartRES === null || cartRES === '{}') localStorage.setItem('cartRES', resID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {

                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {

                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }

                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];

                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }

                return temp;
            };

            var cart = localStorage.getItem('cartData');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + custom, 1);
                /*console.log('typeof testObject: ' + typeof a);
                for (var prop in a) {
                    console.log('  ' + prop + ': ' + a[prop]);
                }*/

                localStorage.setItem('cartData', JSON.stringify(a));

                var _inCart = 'Y';
                var _addButton = 'N';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, addButton: _addButton, cartCount: _cartCount });
                _this.props.inCartCallBack2();
                /*var retrievedObject = localStorage.getItem('cartData');
                console.log('typeof retrievedObject: ' + typeof retrievedObject);
                console.log('Value of retrievedObject: ' + JSON.parse(retrievedObject));*/
            } else {
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    //console.log(key);
                    //console.log(cartData[key]);
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) {
                        cartTotalCount += cartData[key];
                    }

                    if (cart_id[0] == id && custom == cart_id[1]) {
                        delete cartData[key];
                    }
                });
                cartTotalCount += 1;

                cartData = addToObject(cartData, [id + '~~**~~' + custom], 1);
                localStorage.setItem('cartData', JSON.stringify(cartData));
                //console.log(localStorage.getItem('cartData'));

                var _inCart2 = 'Y';
                var _addButton2 = 'N';
                var _cartCount2 = 1;
                that.setState({ inCart: _inCart2, addButton: _addButton2, cartCount: cartTotalCount });
                _this.props.inCartCallBack2();
            }
        };

        _this.handleClickIncreement = function (id, custom, cartCount) {

            var cartTotalCount = 0;
            cartCount = cartCount + 1;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id) {
                    cartTotalCount += cartData[key];
                }

                if (cart_id[0] == id && custom == cart_id[1]) {
                    cartData[key] = cartCount;
                }
            });
            cartTotalCount += 1;

            localStorage.setItem('cartData', JSON.stringify(cartData));

            var inCart = 'Y';
            var addButton = 'N';
            cartCount = cartCount;
            that.setState({ inCart: inCart, addButton: addButton, cartCount: cartTotalCount });
            _this.props.inCartCallBack2();
        };

        _this.handleClickDecreement = function (id, custom, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && custom == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartRES');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            var addButton = cartCount == 0 ? 'Y' : 'N';
            cartCount = cartCount;
            that.setState({ inCart: inCart, addButton: addButton, cartCount: cartCount });
            _this.props.inCartCallBack2();
        };

        _this.handleClickGetCustom = function (id) {

            var cartRES = localStorage.getItem('cartRES');
            var resID = localStorage.getItem('REST2');
            if (cartRES === null || cartRES === '{}') localStorage.setItem('cartRES', resID);

            //console.log(id);
            //console.log(custom);
            //console.log(customData);
            $('#ModalCustomData').modal('show');
        };

        _this.handleClickGetItemCustomSelected = function (id, inputTAGS) {
            //console.log(inputTAGS);
            var checkedCustom = '';
            if (inputTAGS != '') {
                var tags2 = inputTAGS.split('|');
                if (tags2 != '') {
                    jQuery.each(tags2, function (i, val) {
                        var val2 = val.split('~');
                        var name2 = 'chkcustomdat_' + val2[1] + '[]';
                        $.each($("input[name='" + name2 + "']:checked"), function () {
                            //checkedCustom.push($(this).val());
                            checkedCustom += $(this).val() + '|';
                        });
                    });
                }
            }
            var custom = checkedCustom != '' ? checkedCustom.substring(0, checkedCustom.length - 1) : '';
            //console.log(custom);
            _this.handleClickAddToCart(id, custom);
        };

        _this.handleClickGetCustomIncreement = function (id, cartCount) {
            $('#ModalCartExist').modal('show');
        };

        _this.handleClickGetCustomChooseNew = function (id) {
            $('#ModalCustomData').modal('show');
        };

        _this.handleClickGetCustomRepeat = function (id, cartCount) {

            var lastItemEntryCount = 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            var lastItemEntry = '';
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id) {
                    lastItemEntry = cart_id[1];
                    lastItemEntryCount = cartData[key];
                }
            });

            var custom = lastItemEntry;
            _this.handleClickIncreement(id, custom, lastItemEntryCount);
        };

        _this.handleClickGetCustomDecreement = function (id, cartCount) {

            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            var ItemEntryCount = 0;
            var lastItemEntryCount = 0;
            var lastItemEntry = '';
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);

                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id) {
                    ItemEntryCount = ItemEntryCount + 1;
                    lastItemEntry = cart_id[1];
                    lastItemEntryCount = cartData[key];
                }
            });

            var custom = lastItemEntry;
            if (ItemEntryCount == '1') _this.handleClickDecreement(id, custom, lastItemEntryCount);else $('#ModalMultiCartExist').modal('show');
        };

        _this.state = {
            id: props.id,
            itemname: props.item,
            custom: props.custom,
            customData: props.customData,
            inCart: 'N',
            addButton: 'Y',
            cartCount: '0',
            ItemAddOn: false
        };
        return _this;
    }

    _createClass(SpecialDishItem, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var inCart = 'N'; //this.state.inCart;
            var addButton = 'Y'; //this.state.addButton;
            var cartCount = 0; //this.state.cartCount;

            var currentITEM = this.state.id;
            //console.log(localStorage.getItem('cartData'));

            var that = this;
            var cart = localStorage.getItem('cartData');
            if (cart !== null) {
                var cartData = JSON.parse(cart);
                //console.log(cartData)

                Object.keys(cartData).forEach(function (key) {
                    //console.log(key);
                    //console.log(cartData[key]);
                    var id = key.split('~~**~~');
                    if (id[0] == currentITEM) {
                        inCart = 'Y';
                        addButton = 'N';
                        cartCount += cartData[key];
                    }

                    that.setState({ inCart: inCart, addButton: addButton, cartCount: cartCount });
                });

                // console.log(Object.keys(cart));
                //console.log(JSON.parse(cart));
                //let inCart = 'Y';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("cartData");
            //console.log(localStorage.getItem("cartData"));
            var inCart = this.state.inCart;
            var addButton = this.state.addButton;
            var cartCount = this.state.cartCount;
            var currentITEM = this.state.id;
            var inputTAGS = ''; //[];

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'aditions' },
                    this.state.custom == 'N' && _react2.default.createElement(
                        'button',
                        { style: { display: addButton == 'N' ? "none" : "block" }, className: 'btn btn-primary add', onClick: function onClick() {
                                _this2.handleClickAddToCart(_this2.state.id, _this2.state.custom);
                            } },
                        'ADD'
                    ),
                    this.state.custom == 'Y' && _react2.default.createElement(
                        'button',
                        { style: { display: addButton == 'N' ? "none" : "block" }, className: 'btn btn-primary add', onClick: function onClick() {
                                _this2.handleClickGetCustom(_this2.state.id);
                            } },
                        'ADD'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'openned', style: { display: addButton == 'N' ? "block" : "none" } },
                        this.state.custom == 'N' && _react2.default.createElement(
                            'button',
                            { onClick: function onClick() {
                                    _this2.handleClickDecreement(_this2.state.id, _this2.state.custom, cartCount);
                                } },
                            ' - '
                        ),
                        this.state.custom == 'Y' && _react2.default.createElement(
                            'button',
                            { onClick: function onClick() {
                                    _this2.handleClickGetCustomDecreement(_this2.state.id);
                                } },
                            ' - '
                        ),
                        _react2.default.createElement('input', { type: 'text', className: 'round-circle', value: cartCount, readOnly: true }),
                        this.state.custom == 'N' && _react2.default.createElement(
                            'button',
                            { onClick: function onClick() {
                                    _this2.handleClickIncreement(_this2.state.id, _this2.state.custom, cartCount);
                                } },
                            ' + '
                        ),
                        this.state.custom == 'Y' && _react2.default.createElement(
                            'button',
                            { onClick: function onClick() {
                                    _this2.handleClickGetCustomIncreement(_this2.state.id);
                                } },
                            ' + '
                        )
                    )
                ),
                this.state.custom == 'Y' && this.state.customData != '' && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade modalbox', id: 'ModalCustomData', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        this.state.itemname
                                    ),
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: 'javascript:;', 'data-dismiss': 'modal' },
                                        'Close'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body p-0' },
                                    this.state.customData.map(function (addon) {
                                        //console.log(addon.CUSTOMID);
                                        //console.log(addon.CUSTOMNAME);
                                        var inputTYPE = addon.TYPE == 'INC' ? 'checkbox' : 'radio';
                                        inputTAGS += inputTYPE + '~' + addon.CUSTOMID + '|';
                                        //inputTAGS.push(inputTYPE+'~'+addon.CUSTOMID);
                                        //console.log(inputTAGS);
                                        return _react2.default.createElement(
                                            'div',
                                            { key: addon.CUSTOMID },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'section full ' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'section-title' },
                                                    addon.CUSTOMNAME
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'input-list' },
                                                addon.DET.map(function (addon2) {
                                                    //console.log(addon2);
                                                    return _react2.default.createElement(
                                                        'div',
                                                        { className: 'custom-control custom-checkbox', key: addon2.CUSTOMDATID },
                                                        _react2.default.createElement('input', { type: addon.TYPE == 'INC' ? 'checkbox' : 'radio', className: 'custom-control-input', value: addon.CUSTOMID + '~' + addon2.CUSTOMDATID + '~' + addon2.DEFAULT + '~' + addon2.RATE + '~' + addon2.TAXID + '~' + addon2.TAXPERCENT + '~' + addon2.CESSPERCENT, name: 'chkcustomdat_' + addon.CUSTOMID + '[]', id: 'chkcustomdat_' + addon.CUSTOMID + '~' + addon2.CUSTOMDATID, defaultChecked: addon2.DEFAULT == 'Y' ? true : false }),
                                                        _react2.default.createElement(
                                                            'label',
                                                            { className: 'custom-control-label', htmlFor: 'chkcustomdat_' + addon.CUSTOMID + '~' + addon2.CUSTOMDATID },
                                                            _react2.default.createElement('img', { src: '/assets/img/' + addon2.TYPE + '.svg', style: { float: "left" } }),
                                                            ' ',
                                                            addon2.CUSTOMDATNAME,
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'text-price' },
                                                                '\u20B9 ',
                                                                addon2.RATE
                                                            )
                                                        )
                                                    );
                                                })
                                            )
                                        );
                                    }),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-button-group' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'row' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-6' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'button', className: 'btn btn-secondary btn-block btn-lg', 'data-dismiss': 'modal' },
                                                    'CLOSE'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-6' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'button', className: 'btn btn-primary btn-block btn-lg', 'data-dismiss': 'modal', onClick: function onClick() {
                                                            _this2.handleClickGetItemCustomSelected(_this2.state.id, inputTAGS);
                                                        } },
                                                    'ADD'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalCartExist', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        '\xA0'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    'Repeat last used customization?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-secondary', 'data-dismiss': 'modal', onClick: function onClick() {
                                                    _this2.handleClickGetCustom(_this2.state.id);
                                                } },
                                            'I\'ll Choose'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-primary', 'data-dismiss': 'modal', onClick: function onClick() {
                                                    _this2.handleClickGetCustomRepeat(_this2.state.id, cartCount);
                                                } },
                                            'Repeat Last'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalMultiCartExist', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        '\xA0'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    'This item has multiple customiszations added. Proceed to cart to remove item?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/cart', className: 'btn btn-text-success', 'data-dismiss': 'modal' },
                                            'Yes'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                            'No'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SpecialDishItem;
}(_react2.default.Component);

exports.default = SpecialDishItem;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(40);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _CuisineSections = __webpack_require__(264);

var _CuisineSections2 = _interopRequireDefault(_CuisineSections);

var _SectionWiseItem = __webpack_require__(265);

var _SectionWiseItem2 = _interopRequireDefault(_SectionWiseItem);

var _CartToast = __webpack_require__(129);

var _CartToast2 = _interopRequireDefault(_CartToast);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuSection = function MenuSection(props) {
    return props.section.map(function (post) {
        return _react2.default.createElement(
            'div',
            { className: 'item dish', key: post.id },
            _react2.default.createElement(
                'p',
                { className: 'ds' },
                post.name
            )
        );
    });
};

var Listing = function (_React$Component) {
    _inherits(Listing, _React$Component);

    function Listing(props) {
        _classCallCheck(this, Listing);

        var _this = _possibleConstructorReturn(this, (Listing.__proto__ || Object.getPrototypeOf(Listing)).call(this, props));

        _this.handleVegOnlyChecked = function (e) {
            //e.preventDefault();
            var restaurant_id = localStorage.getItem('REST');
            var vegONLY = localStorage.getItem('vegONLY') || 'N';
            var vegONLY_new = vegONLY == 'Y' ? 'N' : 'Y';
            localStorage.setItem('vegONLY', vegONLY_new);
            var search_text = _this.state.search_text;
            if (search_text == undefined || search_text == 'undefined') search_text = '';

            _this.fetchRestaurantMenu('MENU', restaurant_id, vegONLY_new, search_text);
        };

        _this.handleCusineClick = function (cuisine_id) {
            var that = _this;
            that.setState({ selectedSECTION: cuisine_id });
        };

        _this.inCartCallBack = function () {

            var displayCartToast = 'N';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') displayCartToast = 'Y';
            //console.log(cart);
            //console.log(displayCartToast);
            var that = _this;
            that.setState({ displayCartToast: displayCartToast });
        };

        _this.state = {
            LOADING: true,
            LOCATION: _this.props.location.pathname,
            id: [],
            SECTION: [],
            MENU: [],
            CLOSED: '',
            OPENS: '',
            ENDS: '',
            displayCartToast: 'N',
            search_text: props.match.params.search_text,
            selectedSECTION: props.match.params.id
        };
        return _this;
    }

    _createClass(Listing, [{
        key: 'fetchRestaurantMenu',
        value: function fetchRestaurantMenu(mode, id, type, search_text, selectedSECTION) {
            var that = this;
            fetch('https://www.peepkitchen.in/peep/pwa/api/restaurantmenu_api.php?mode=' + mode + '&id=' + id + '&type=' + type + '&search_text=' + search_text + '&selectedSECTION=' + selectedSECTION, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var sections = result.section;
                /*Object.keys(sections).forEach(function(key) {
                    //console.log(sections[key].veg);
                    if(type=='Y' && sections[key].veg==0)
                        delete sections[key];
                });*/

                /*//Clearing the cart if restaurant is closed
                if(result.closed=='Y')
                {
                    localStorage.removeItem('cartRES');
                    localStorage.removeItem('cartInstructions');
                    localStorage.removeItem("cartData");
                }*/

                var displayCartToast = 'N';
                var cart = localStorage.getItem('cartData');
                if (cart !== null && cart !== '{}') displayCartToast = 'Y';

                that.setState({ LOADING: false, SECTION: sections, MENU: result.menu, CLOSED: result.closed, OPENS: result.opens, ENDS: result.ends, displayCartToast: displayCartToast });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }

            var restaurant_id = localStorage.getItem('REST');
            var vegONLY = localStorage.getItem('vegONLY') || 'N';
            var search_text = this.state.search_text;
            if (search_text == undefined || search_text == 'undefined') search_text = '';

            this.fetchRestaurantMenu('MENU', restaurant_id, vegONLY, search_text, this.state.selectedSECTION);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();

            //if (nextProps.match.params.search_text !== this.props.match.params.search_text) {
            this.state.loading = true;
            var restaurant_id = localStorage.getItem('REST');
            var vegONLY = localStorage.getItem('vegONLY') || 'N';
            this.state.search_text = nextProps.match.params.search_text;

            this.fetchRestaurantMenu('MENU', restaurant_id, vegONLY, this.state.search_text);
            //}
        }

        /*componentDidUpdate(prevProps, prevState) {
            console.log('1');
            if (prevState.search_text !== this.state.search_text) {
                this.fetchRestaurantMenu('MENU',restaurant_id,vegONLY,search_text);
            }
        }*/

    }, {
        key: 'render',
        value: function render() {

            if (localStorage.getItem('REST') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map2' });
            }

            //localStorage.removeItem("userData");
            //console.log(localStorage.getItem('userData'));

            var AppHeaderClass = 'appHeader bg-primary text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Restaurant';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = this.state.search_text;

            var props = {
                sections: this.state.SECTION,
                items: this.state.MENU,
                selectedSECTION: this.state.selectedSECTION,
                handleVegOnlyChecked: this.handleVegOnlyChecked,
                inCartCallBack: this.inCartCallBack,
                handleCusineClick: this.handleCusineClick,
                CLOSED: this.state.CLOSED,
                OPENS: this.state.OPENS
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full' },
                        _react2.default.createElement('img', { src: '/assets/img/listing-image.jpg', alt: 'image', className: 'imaged square w-100' })
                    ),
                    this.state.CLOSED != 'Y' && this.state.ENDS == '' && _react2.default.createElement(
                        'p',
                        { className: 'timings' },
                        this.state.OPENS
                    ),
                    this.state.CLOSED != 'Y' && this.state.ENDS != '' && _react2.default.createElement(
                        'p',
                        { className: 'timings2' },
                        this.state.ENDS
                    ),
                    this.state.SECTION.length > 0 && _react2.default.createElement(_CuisineSections2.default, props),
                    _react2.default.createElement(_SectionWiseItem2.default, props),
                    _react2.default.createElement(
                        'p',
                        { className: 'conditions' },
                        '*Actual dish may differ from the images displayed'
                    ),
                    _react2.default.createElement('br', null)
                ),
                this.state.CLOSED == 'Y' && _react2.default.createElement(
                    'div',
                    { id: 'toast-1', 'class': 'toast-box toast-top bg-warning show', style: { 'padding': '6px', 'minHeight': '22px !important' } },
                    _react2.default.createElement(
                        'div',
                        { 'class': 'in' },
                        _react2.default.createElement(
                            'div',
                            { 'class': 'text' },
                            this.state.OPENS
                        )
                    )
                ),
                this.state.displayCartToast == 'Y' && _react2.default.createElement(_CartToast2.default, { items: this.state.MENU }),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION })
            );
        }
    }]);

    return Listing;
}(_react2.default.Component);

exports.default = Listing;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CuisineSections = function CuisineSections(props) {

    //console.log(props);

    var allCSS = 'btn-primary';

    var selectedCUISINE = '';
    if (props.selectedSECTION != '' && props.selectedSECTION != 'undefined' && props.selectedSECTION != undefined) {
        selectedCUISINE = props.selectedSECTION;
        allCSS = 'btn-outline-primary';
    }

    var currentPAGE = props.page;
    var Sections = props.sections.map(function (post, i) {
        if (currentPAGE == 'HOME') {
            return _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/listing/s/' + post.id, key: post.id, className: 'btn btn-outline-primary shadowed btn-sm mr-1' },
                post.name
            );
        } else {
            var _React$createElement;

            var cuisineCSS = 'btn-outline-primary';
            if (selectedCUISINE == post.id) cuisineCSS = 'btn-primary';

            return _react2.default.createElement(
                'button',
                (_React$createElement = { onClick: function onClick() {
                        props.handleCusineClick(post.id);
                    }, key: post.id, type: 'button' }, _defineProperty(_React$createElement, 'key', post.id), _defineProperty(_React$createElement, 'className', 'btn ' + cuisineCSS + ' shadowed btn-sm mr-1'), _React$createElement),
                post.name
            );
        }
    });

    return _react2.default.createElement(
        'div',
        { className: 'section full mb-3' },
        _react2.default.createElement(
            'div',
            { className: 'section-title' },
            _react2.default.createElement('br', null),
            'Cuisines'
        ),
        _react2.default.createElement(
            'div',
            { className: 'wide-block', style: { 'overflowY': 'scroll', 'borderBottom': '0 none' } },
            _react2.default.createElement(
                'div',
                { style: { 'display': 'flex' } },
                currentPAGE == 'HOME' && _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/listing', className: 'btn btn-outline-primary btn-sm mr-1 shadowed' },
                    'All'
                ),
                currentPAGE != 'HOME' && _react2.default.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                            props.handleCusineClick(0);
                        }, className: 'btn ' + allCSS + ' shadowed btn-sm mr-1' },
                    'All'
                ),
                currentPAGE != 'HOME' && _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/specialdish', className: 'btn btn-outline-primary btn-sm mr-1 shadowed' },
                    'Speciality Dish'
                ),
                Sections
            )
        )
    );
};

exports.default = CuisineSections;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Items = __webpack_require__(127);

var _Items2 = _interopRequireDefault(_Items);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionWiseItem = function SectionWiseItem(props) {

    var SET = 0;
    var j = 0;
    return props.sections.map(function (post, i) {

        //console.log('=>');
        //console.log(props.selectedSECTION);
        //console.log('<=');
        //console.log(j);
        var vegonly = localStorage.getItem('vegONLY') || 'N';

        var PRINT = 'Y';
        if (vegonly == 'Y' && post.veg == 0) {
            PRINT = 'N';
            if (props.selectedSECTION != '' && props.selectedSECTION != '0' && props.selectedSECTION != 'undefined' && props.selectedSECTION != undefined && props.selectedSECTION == post.id) SET++;
        } else if (vegonly != 'Y' && post.veg == 0 && post.nonveg == 0) {
            PRINT = 'N';
            if (props.selectedSECTION != '' && props.selectedSECTION != '0' && props.selectedSECTION != 'undefined' && props.selectedSECTION != undefined && props.selectedSECTION == post.id) SET++;
        }

        {/*<div className="custom-control custom-checkbox mb-1">
                           <input defaultChecked={vegonly=='Y'?true:false} onChange={props.handleVegOnlyChecked} type="checkbox" className="custom-control-input" id="chkVeg">
                           <label className="custom-control-label" htmlFor="chkVeg">VEG ONLY</label>
                       </div>*/}

        if (props.selectedSECTION != '' && props.selectedSECTION != '0' && props.selectedSECTION != 'undefined' && props.selectedSECTION != undefined && props.selectedSECTION != post.id) PRINT = 'N';

        if (j == 0 && PRINT == 'Y') {
            j++;
            return _react2.default.createElement(
                'div',
                { className: 'section full mt-2 mb-2', key: post.id, id: post.id },
                _react2.default.createElement(
                    'div',
                    { className: 'row', style: { 'width': '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title' },
                            post.name
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-6', style: { 'textAlign': 'right' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'custom-control custom-checkbox mb-1' },
                            _react2.default.createElement('input', { defaultChecked: vegonly == 'Y' ? true : false, onChange: props.handleVegOnlyChecked, type: 'checkbox', className: 'custom-control-input', id: 'chkVeg' }),
                            _react2.default.createElement(
                                'label',
                                { className: 'custom-control-label veg-only-box', htmlFor: 'chkVeg' },
                                'VEG ONLY'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'listview image-listview media' },
                    _react2.default.createElement(_Items2.default, { sec_id: post.id, items: props.items, veg_only: props.vegonly, inCartCallBack: props.inCartCallBack, CLOSED: props.CLOSED, OPENS: props.OPENS })
                )
            );
        } else if (PRINT == 'Y') {
            j++;
            return _react2.default.createElement(
                'div',
                { className: 'section full mt-2 mb-2', key: post.id, id: post.id },
                _react2.default.createElement(
                    'div',
                    { className: 'section-title' },
                    post.name
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'listview image-listview media' },
                    _react2.default.createElement(_Items2.default, { sec_id: post.id, items: props.items, veg_only: props.vegonly, inCartCallBack: props.inCartCallBack, CLOSED: props.CLOSED, OPENS: props.OPENS })
                )
            );
        }

        if (SET == 1 && props.selectedSECTION == post.id) {
            return _react2.default.createElement(
                'div',
                { className: 'section full mt-2 mb-2', key: post.id, id: post.id },
                _react2.default.createElement(
                    'div',
                    { className: 'row', style: { 'width': '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title' },
                            post.name
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-6', style: { 'textAlign': 'right' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'custom-control custom-checkbox mb-1' },
                            _react2.default.createElement('input', { defaultChecked: vegonly == 'Y' ? true : false, onChange: props.handleVegOnlyChecked, type: 'checkbox', className: 'custom-control-input', id: 'chkVeg' }),
                            _react2.default.createElement(
                                'label',
                                { className: 'custom-control-label veg-only-box', htmlFor: 'chkVeg' },
                                'VEG ONLY'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { 'class': 'section-title' },
                    _react2.default.createElement('br', null),
                    'No dish found'
                )
            );
        }
    });
};

exports.default = SectionWiseItem;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _CartItemList = __webpack_require__(267);

var _CartItemList2 = _interopRequireDefault(_CartItemList);

var _CartTotal = __webpack_require__(269);

var _CartTotal2 = _interopRequireDefault(_CartTotal);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OFFER = function OFFER(props) {
    var Offers = props.offers.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'custom-control custom-radio', key: i },
            _react2.default.createElement(
                'div',
                { className: 'custom-control-label', htmlFor: 'customCheck4' },
                _react2.default.createElement(
                    'span',
                    { className: 'coupon-code' },
                    post.CODE
                ),
                _react2.default.createElement(
                    'h5',
                    { className: 'pt-1' },
                    post.NAME
                )
            ),
            _react2.default.createElement(
                'span',
                { className: 'apply-coupon badge badge-light' },
                _react2.default.createElement(
                    'button',
                    { className: 'text-upper font-weg-600', onClick: function onClick() {
                            props.AddCouponToCart(props.cartTOTAL, post.MIN_PURCHASE, post.ID, post.CODE, post.TYPE, post.VALUE, post.TEXT);
                        } },
                    'Apply'
                )
            )
        );
    });

    return _react2.default.createElement(
        'div',
        null,
        Offers
    );
};

var Cart = function (_React$Component) {
    _inherits(Cart, _React$Component);

    function Cart(props) {
        _classCallCheck(this, Cart);

        var _this = _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).call(this, props));
        //console.log(props);


        _this.updateCart = function () {
            console.log('CART UPDATED');
            var that = _this;

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                cartEMPTY = 'N';
            }

            that.setState({ CartCount: 1, cartEMPTY: cartEMPTY });
        };

        _this.AddCouponToCart = function (cartTOTAL, minPURCHASE, offerID, offerCODE, offerTYPE, offerVALUE, offerTEXT) {
            if (parseFloat(cartTOTAL) >= parseFloat(minPURCHASE)) {
                var _OFFER = 0;
                if (offerTYPE == 'PER') _OFFER = parseFloat(cartTOTAL) * parseFloat(offerVALUE) / 100;else if (offerTYPE = 'DIS') _OFFER = offerVALUE;

                var msg = '';
                if (_OFFER != 0 && _OFFER != '0') {
                    msg = '<p className="font-weg-600 font-size-13 text-upper mb-05">\'' + offerCODE + '\'' + ' applied</p> <p className="mb-05 font-size-12 text-danger">&#8377; ' + ('' + _OFFER) + '</p> <p className="font-size-12"> savings with this coupon</p>';
                } else {
                    msg = '<p className="font-weg-600 font-size-13 text-upper mb-05">\'' + offerCODE + '\'' + ' applied</p> <p className="mb-05 font-size-12 text-danger">' + ('' + offerTEXT) + '</p> <p className="font-size-12"> free with this coupon</p>';
                }

                var msg2 = offerCODE;

                localStorage.setItem('OFFER_APPLIED', offerID + '~~**~~' + offerCODE);

                _this.setState({ couponSUCCESS: msg, offerTOTAL: _OFFER, offerAPPLIED: msg2 });
                $('#ModalCouponList').modal('hide');
                $('#couponSuccessModal').modal('show');
            } else {
                localStorage.removeItem('OFFER_APPLIED');
                _this.setState({ couponFAILURE: 'Cart value is not sufficient' });
                $('#ModalCouponList').modal('hide');
                $('#couponFailureModal').modal('show');
            }
        };

        _this.RemoveCouponFromCart = function () {
            localStorage.removeItem('OFFER_APPLIED');
        };

        _this.handleEmptyCart = function () {
            $('#emptyCart').modal('show');
        };

        _this.handleEmptyCartNow = function () {
            localStorage.removeItem('cartCIRCLE');
            localStorage.removeItem('cartData');
            localStorage.removeItem('AnikZai');
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                cartEMPTY = 'N';
            }

            _this.setState({ CartCount: 1, cartEMPTY: cartEMPTY });
        };

        _this.handlePopupClick = function (e) {
            e.preventDefault();
            $('#popupCart').modal('show');
        };

        _this.handleClickSpecialInstructionsClear = function () {
            localStorage.removeItem('AnikZai');
            _this.setState({ AnikZai: '' });
        };

        _this.handleClickAnikZaiInstructionsAdd = function (e) {
            var special_instructions = e.target.value;
            localStorage.setItem('AnikZai', special_instructions);

            //console.log(special_instructions);

            _this.setState({ AnikZai: special_instructions });
        };

        _this.handleClickIncreement = function (id, unit, cartCount) {
            var cartTotalCount = 0;
            cartCount = cartCount + 1;

            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id) cartTotalCount += cartData[key];

                if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
            });
            cartTotalCount += 1;

            localStorage.setItem('cartData', JSON.stringify(cartData));
            _this.setState({ CartCount: 1 });
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('AnikZai');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            _this.CalculateCartOfferExistence();
        };

        _this.CalculateCartOfferExistence = function () {

            var itemLIST = '';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    var itemID = cart_id[0];
                    var itemCOUNT = cartData[key];
                    itemLIST += itemID + '|' + itemCOUNT + ',';
                });
            }

            if (itemLIST != '') {
                itemLIST = itemLIST.substring(0, itemLIST.length - 1);

                var OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
                if (OFFER_APPLIED == null) OFFER_APPLIED = '';

                var offerID = '';
                var offerCODE = '';
                if (OFFER_APPLIED != '') {
                    var OFFER_APPLIED2 = OFFER_APPLIED.split('~~**~~');
                    offerID = OFFER_APPLIED2[0];
                    offerCODE = OFFER_APPLIED2[1];
                }

                _this.fetchCartMenu('ITEMS', itemLIST, offerID, offerCODE);
            } else {
                _this.setState({ CartCount: 1 });
            }
        };

        _this.state = {
            LOADING: true,
            LOCATION: _this.props.location.pathname,
            ITEMS: [],
            OFFERS: [],
            CartCount: 0,
            cartEMPTY: 'Y',
            AnikZai: '',
            couponSUCCESS: '',
            couponFAILURE: '',
            offerTOTAL: 0,
            CUSTOMER_DET: '',
            MIN_ORDER: 0,
            DEL_DATE: '',
            DEL_TIME: ''
        };
        return _this;
    }

    _createClass(Cart, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'fetchCartMenu',
        value: function fetchCartMenu(mode, items, offerID, offerCODE) {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            if (customer == undefined || customer == 'undefined') customer = '';

            var that = this;
            fetch('https://m.donedelivery.in/api/cartitems_api.php?mode=' + mode + '&items=' + items + '&customer=' + customer + '&offer_id=' + offerID + '&offer_code=' + offerCODE, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                if (result.APPLY_OFFER !== '' && result.APPLY_OFFER !== undefined && result.APPLY_OFFER !== 'undefined') {
                    if (result.APPLY_OFFER == 'N') localStorage.removeItem('OFFER_APPLIED');
                }

                that.setState({ LOADING: false, ITEMS: result.ITEMS, OFFERS: result.OFFERS, cartEMPTY: 'N', CUSTOMER_DET: CUSTOMER_DET, MIN_ORDER: result.MIN_ORDER, DEL_DATE: result.DEL_DATE, DEL_TIME: result.DEL_TIME });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var itemLIST = '';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    var itemID = cart_id[0];
                    var itemCOUNT = cartData[key];
                    itemLIST += itemID + '|' + itemCOUNT + ',';
                });
            }

            if (itemLIST != '') {
                itemLIST = itemLIST.substring(0, itemLIST.length - 1);

                var OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
                if (OFFER_APPLIED == null) OFFER_APPLIED = '';

                var offerID = '';
                var offerCODE = '';

                if (OFFER_APPLIED != '') {
                    var OFFER_APPLIED2 = OFFER_APPLIED.split('~~**~~');
                    offerID = OFFER_APPLIED2[0];
                    offerCODE = OFFER_APPLIED2[1];
                }

                this.fetchCartMenu('ITEMS', itemLIST, offerID, offerCODE);
            } else {
                var customer = localStorage.getItem('userData');
                this.fetchCustomerProfile('PROFILE', customer);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //console.log(localStorage.getItem('userData'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'CART';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);

            if (cart !== null && cart !== '{}') {
                var LIST = this.state.ITEMS;
                if (LIST != '') {
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');

                        if (LIST.length > 0) {
                            LIST.map(function (id) {

                                if (cart_id[0] == id.ITEMID) {
                                    //if(id.NEXTAVAILABLE!='')
                                    if (id.AVAILABLE_QTY === '0' || id.AVAILABLE_QTY === 0) {
                                        delete cartData[key];
                                    }
                                }
                            });
                        }
                    });
                }

                localStorage.setItem('cartData', JSON.stringify(cartData));
            }

            cart = localStorage.getItem('cartData');
            cartData = JSON.parse(cart);
            var cartItemCount = 0;
            if (cart !== null && cart !== '{}') {
                Object.keys(cartData).forEach(function (key) {
                    var itemCOUNT = cartData[key];
                    cartItemCount = cartItemCount + itemCOUNT;
                });
            }

            var props = {
                items: this.state.MENU,
                updateCart: this.updateCart
            };

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            var cartTOTAL = 0;

            var anikZaiInstructions = localStorage.getItem('AnikZai');
            if (anikZaiInstructions == null) anikZaiInstructions = '';

            var OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
            if (OFFER_APPLIED == null) OFFER_APPLIED = '';

            var offerID = '';
            var offerAPPLIED = '';
            if (OFFER_APPLIED != '') {
                var OFFER_APPLIED2 = OFFER_APPLIED.split('~~**~~');
                offerID = OFFER_APPLIED2[0];
                offerAPPLIED = OFFER_APPLIED2[1];
            }

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    this.state.cartEMPTY == 'N' && _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title d-flex justify-content-between pb-1 pr-2 pl-2 medium font-weg-400' },
                            ' ',
                            cartItemCount,
                            ' item',
                            cartItemCount > 1 ? 's' : '',
                            _react2.default.createElement(
                                'span',
                                { className: 'badge text-danger font-weg-400', style: { 'cursor': 'pointer' }, onClick: function onClick() {
                                        _this2.handleEmptyCart();
                                    } },
                                'Empty Cart'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-list-items' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'listview image-listview' },
                                this.state.ITEMS.map(function (item) {
                                    var cartCount = 0; //this.state.cartCount;

                                    var currentITEM = item.ID;
                                    var cart = localStorage.getItem('cartData');
                                    if (cart !== null) {
                                        var _cartData = JSON.parse(cart);
                                        Object.keys(_cartData).forEach(function (key) {
                                            var id = key.split('~~**~~');
                                            if (id[0] == currentITEM) cartCount += _cartData[key];
                                        });
                                    }

                                    var itemTOTAL = parseFloat(item.RATE) * parseFloat(cartCount);
                                    cartTOTAL = parseFloat(cartTOTAL) + parseFloat(itemTOTAL);

                                    if (cartCount > 0) {
                                        return _react2.default.createElement(
                                            'li',
                                            { key: item.ID },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item' },
                                                _react2.default.createElement('img', { src: item.PIC, alt: item.NAME, className: 'image' }),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'in' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'item-name font-size-12 font-weg-500 text-dgrey pr-1' },
                                                        item.NAME,
                                                        ' ( per ',
                                                        item.UNIT,
                                                        ')',
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'final-price text-danger font-size-14 font-weg-500' },
                                                            '\u20B9 ',
                                                            item.RATE
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'cart-add-btn add-btn-inc mt-0' },
                                                        _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                                                _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                                            }, value: '-', className: 'qtyminus' }),
                                                        _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                                        _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                                                _this2.handleClickIncreement(item.ID, item.UNIT, cartCount);
                                                            }, value: '+', className: 'qtyplus' })
                                                    ),
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'badge badge-light font-size-14 font-weg-500' },
                                                        '\u20B9 ',
                                                        itemTOTAL
                                                    )
                                                )
                                            )
                                        );
                                    }
                                }),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'section-title w-100  d-flex justify-content-between pt-2 pb-2 pr-2 pl-2 medium' },
                                        ' Total',
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'font-weg-600' },
                                            '\u20B9 ',
                                            cartTOTAL
                                        )
                                    )
                                )
                            )
                        ),
                        logged === 'Y' && this.state.OFFERS.length > 0 && _react2.default.createElement(
                            'div',
                            null,
                            offerAPPLIED != '' && _react2.default.createElement(
                                'div',
                                { className: 'section full mt-2' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'listview image-listview flush transparent mb-1' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'item bg-white' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'in no-flex font-weg-600 font-size-13 text-upper' },
                                                offerAPPLIED,
                                                _react2.default.createElement('br', null),
                                                ' ',
                                                _react2.default.createElement(
                                                    'p',
                                                    { className: 'font-size-10 pb-0 text-lgrey p-0 mb-0 mt-05' },
                                                    'coupon applied for this bill'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '#', onClick: this.RemoveCouponFromCart, className: 'close-button' },
                                                _react2.default.createElement('ion-icon', { name: 'close' })
                                            )
                                        )
                                    )
                                )
                            ),
                            offerAPPLIED === '' && _react2.default.createElement(
                                'div',
                                { className: 'section full mt-2' },
                                _react2.default.createElement(
                                    'ul',
                                    { className: 'listview image-listview flush transparent mb-1' },
                                    _react2.default.createElement(
                                        'li',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '#', className: 'item bg-white', 'data-toggle': 'modal', 'data-target': '#ModalCouponList' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'in font-weg-600 font-size-13 text-upper' },
                                                'Apply Coupon'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal fade modalbox delivery-coupon', id: 'ModalCouponList', tabIndex: '-1', role: 'dialog' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-dialog', role: 'document' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-content' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-header' },
                                            _react2.default.createElement(
                                                'h5',
                                                { className: 'modal-title font-size-10 text-upper' },
                                                'Available coupons'
                                            ),
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '#', 'data-dismiss': 'modal', className: 'font-size-10 text-upper' },
                                                'Close'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-body p-0' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'input-list' },
                                                _react2.default.createElement(OFFER, { offers: this.state.OFFERS, cartTOTAL: cartTOTAL, AddCouponToCart: this.AddCouponToCart })
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal fade dialogbox', id: 'couponSuccessModal', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-dialog', role: 'document' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-content' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-header m-0 p-0' },
                                            _react2.default.createElement(
                                                'h5',
                                                { className: 'modal-title' },
                                                '\xA0'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-body' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-icon text-success mt-0 mb-1' },
                                                _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                                            ),
                                            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.couponSUCCESS } })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-footer' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'btn-inline' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'button', className: 'btn btn-text-success', 'data-dismiss': 'modal' },
                                                    'Ok'
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal fade dialogbox', id: 'couponFailureModal', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-dialog', role: 'document' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-content' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-header m-0 p-0' },
                                            _react2.default.createElement(
                                                'h5',
                                                { className: 'modal-title' },
                                                '\xA0'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-body' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-icon text-danger mt-0 mb-1' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            this.state.couponFAILURE
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-footer' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'btn-inline' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                                    'Ok'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'delivery-date date-slot' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2' },
                                    'Delivery Date'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group basic more-locations pt-05' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'form-control text-upper btn  bg-white square custom-select', id: 'city4' },
                                            this.state.DEL_DATE
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'delivery-date time-slot' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2' },
                                    'Delivery Time'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group basic more-locations pt-05' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'form-control text-upper btn  bg-white square custom-select', id: 'city4' },
                                            this.state.DEL_TIME
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clear' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'pt-0 pr-2 pl-2 pb-4' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-12 p-0' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'anik-jai accordion', id: 'accordionExample1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'accordion-header' },
                                            _react2.default.createElement(
                                                'button',
                                                { className: 'btn text-danger collapsed mb-0', type: 'button', 'data-toggle': 'collapse', 'data-target': '#accordion1', 'aria-expanded': 'false' },
                                                ' ANY SPECIAL INSTRUCTIONS? '
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'mb-1 pb-05 font-size-11' },
                                                '(Leave with Security, Call before delivery)'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { id: 'accordion1', className: 'accordion-body collapse', 'data-parent': '#accordionExample1' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'accordion-content' },
                                                _react2.default.createElement('textarea', { rows: '3', className: 'square-inputbox form-control square', name: 'AnikZaiInstructions', id: 'AnikZaiInstructions', defaultValue: anikZaiInstructions, onChange: function onChange(event) {
                                                        return _this2.handleClickAnikZaiInstructionsAdd(event);
                                                    } })
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'text-upper' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-6' },
                                            ' ',
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '/categories', className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-llg btn-block goBack' },
                                                'Add more items'
                                            ),
                                            ' '
                                        ),
                                        this.state.MIN_ORDER <= cartTOTAL && _react2.default.createElement(
                                            'div',
                                            { className: 'col-6' },
                                            ' ',
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: logged == 'Y' ? '/checkout' : '/login', className: 'btn newshadowed font-size-14 square btn-danger btn-llg btn-block' },
                                                'Checkout'
                                            ),
                                            ' '
                                        ),
                                        this.state.MIN_ORDER > cartTOTAL && _react2.default.createElement(
                                            'div',
                                            { className: 'col-6' },
                                            ' ',
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '#', className: 'btn newshadowed font-size-14 square btn-danger btn-llg btn-block', 'data-toggle': 'modal', 'data-target': '#MinOrderRequired' },
                                                'Checkout'
                                            ),
                                            ' '
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'MinOrderRequired', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'if-no-add' },
                                            'The VENDOR has a minimum order value of ',
                                            this.state.MIN_ORDER
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'emptyCart', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-header' },
                                        _react2.default.createElement(
                                            'h5',
                                            { className: 'modal-title' },
                                            '\xA0'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        'You are about to empty the cart. Continue?'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: this.handleEmptyCartNow },
                                                'Yes'
                                            ),
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                                'No'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    this.state.cartEMPTY == 'Y' && _react2.default.createElement(
                        'div',
                        { className: 'section pt-6', style: { textAlign: 'center' } },
                        _react2.default.createElement('img', { src: '/assets/img/cart-empty.png', alt: 'empty-cart', className: 'form-image imaged w200' }),
                        _react2.default.createElement(
                            'h4',
                            { className: 'size-19' },
                            'Empty Cart'
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Cart;
}(_react2.default.Component);

exports.default = Cart;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CartItem = __webpack_require__(268);

var _CartItem2 = _interopRequireDefault(_CartItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartItemList = function CartItemList(props) {

    var cart = localStorage.getItem('cartData');
    var cartData = JSON.parse(cart);
    var cartItems = Object.keys(cartData).map(function (key) {
        return [key, cartData[key]];
    });

    return cartItems.map(function (post2) {
        var cartITEM = post2[0].split('~~**~~');
        var itemCOUNT = post2[1];

        var itemID = cartITEM[0];
        var itemCUSTOM = cartITEM[1];
        //console.log(post2);
        return _react2.default.createElement(_CartItem2.default, { key: post2, item: props.items, itemID: itemID, itemCUSTOM: itemCUSTOM, itemCOUNT: itemCOUNT, updateCart2: props.updateCart });
    });
};

exports.default = CartItemList;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CartItem = function (_React$Component) {
    _inherits(CartItem, _React$Component);

    function CartItem() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CartItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CartItem.__proto__ || Object.getPrototypeOf(CartItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleCartClickIncreement = function (id, custom, cartCount) {

            var cartTotalCount = 0;
            cartCount = cartCount + 1;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id) {
                    cartTotalCount += cartData[key];
                }

                if (cart_id[0] == id && custom == cart_id[1]) {
                    cartData[key] = cartCount;
                }
            });
            cartTotalCount += 1;

            localStorage.setItem('cartData', JSON.stringify(cartData));
            _this.props.updateCart2();
        }, _this.handleCartClickDecreement = function (id, custom, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                //console.log(key);
                //console.log(cartData[key]);
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && custom == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartRES');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            /*if(cart === null || cart ==='{}')
            {
                localStorage.removeItem('cartRES');
                localStorage.removeItem('cartData');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
            }
            else
                localStorage.setItem('cartData', JSON.stringify(cartData));*/

            _this.props.updateCart2();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CartItem, [{
        key: 'render',


        //const CartItem = (props) => {
        value: function render() {
            var _this2 = this;

            //console.log(this.props);
            return this.props.item.map(function (item, i) {
                if (_this2.props.itemID == item.ITEMID) {
                    var itemTOTAL = 0;
                    var itemRATE = item.RATE;
                    var itemCOUNT = _this2.props.itemCOUNT;
                    var itemCUSTOM = _this2.props.itemCUSTOM;
                    var customLIST = '';

                    if (itemCUSTOM != 'N' && itemCUSTOM != '') {
                        var custom = itemCUSTOM.split('|');
                        //console.log(custom);
                        if (custom != '') {
                            custom.forEach(function (val) {
                                var val2 = val.split('~');
                                itemRATE = parseFloat(itemRATE) + parseFloat(val2[3]);

                                item.CUSTOM.map(function (addon) {

                                    if (addon.CUSTOMID == val2[0]) {
                                        addon.DET.map(function (addon2) {
                                            if (addon2.CUSTOMDATID == val2[1]) customLIST += addon2.CUSTOMDATNAME + ', ';
                                        });
                                    }
                                });
                            });
                        }
                    }

                    if (customLIST != '') customLIST = customLIST.substring(0, customLIST.length - 2);

                    itemTOTAL = itemCOUNT * itemRATE;

                    return (
                        //console.log(item.ITEMID+' == '+itemID);
                        _react2.default.createElement(
                            'li',
                            { key: item.ITEMID },
                            _react2.default.createElement(
                                'div',
                                { className: 'row full', style: { width: '100%' } },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'veggann' },
                                    _react2.default.createElement('img', { src: 'assets/img/' + item.TYPE + '.svg', alt: item.TYPE })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-6' },
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        item.ITEMNAME
                                    ),
                                    customLIST && _react2.default.createElement(
                                        'p',
                                        { className: 'addi' },
                                        'Added: ',
                                        customLIST
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'actual-prize' },
                                        '\u20B9 ',
                                        itemRATE
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-3' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'aditions' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'openned' },
                                            _react2.default.createElement(
                                                'button',
                                                { onClick: function onClick() {
                                                        _this2.handleCartClickDecreement(item.ITEMID, itemCUSTOM, itemCOUNT);
                                                    } },
                                                ' - '
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'round-circle', value: itemCOUNT, readOnly: true }),
                                            _react2.default.createElement(
                                                'button',
                                                { onClick: function onClick() {
                                                        _this2.handleCartClickIncreement(item.ITEMID, itemCUSTOM, itemCOUNT);
                                                    } },
                                                ' + '
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-3 prize' },
                                    '\u20B9 ',
                                    itemTOTAL
                                )
                            )
                        )
                    );
                }
            });
        }
    }]);

    return CartItem;
}(_react2.default.Component);

exports.default = CartItem;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartTotal = function CartTotal(props) {

    var cartItemCount = 0;
    var cartItemTotal = 0;
    var cart = localStorage.getItem('cartData');
    var cartData = JSON.parse(cart);
    //console.log(cart);
    //console.log(cartData);
    if (cart !== null && cart !== '{}') {
        Object.keys(cartData).forEach(function (key) {
            var Rate = 0;
            var itemTOTAL = 0;

            var cart_id = key.split('~~**~~');
            var itemID = cart_id[0];
            var itemCOUNT = cartData[key];
            var itemCUSTOM = cart_id[1];

            props.items.map(function (item) {
                if (item.ITEMID == itemID) {
                    Rate = item.RATE;
                }
            });

            if (itemCUSTOM != 'N') {
                var custom = itemCUSTOM.split('|');
                //console.log(custom);
                if (custom != '') {
                    custom.forEach(function (val) {
                        var val2 = val.split('~');
                        Rate = parseFloat(Rate) + parseFloat(val2[3]);
                        //console.log(Rate);
                    });
                }
            }

            itemTOTAL = itemCOUNT * Rate;

            cartItemCount = cartItemCount + itemCOUNT;
            cartItemTotal = cartItemTotal + itemTOTAL;
        });
    }

    return _react2.default.createElement(
        'div',
        { className: 'row', style: { width: '100%' } },
        _react2.default.createElement(
            'div',
            { className: 'col-6' },
            _react2.default.createElement(
                'div',
                { className: 'section-title' },
                'TOTAL'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'col-6' },
            _react2.default.createElement(
                'div',
                { className: 'red', style: { textAlign: 'right' } },
                '\u20B9 ',
                cartItemTotal
            )
        )
    );
};

exports.default = CartTotal;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cess = function Cess(props) {
    var cess = props.cess;
    return _react2.default.createElement(
        'ul',
        { className: 'item-total listview image-listview' },
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'div',
                { className: 'item font-size-13 font-weg-300' },
                _react2.default.createElement(
                    'div',
                    { className: 'in' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-name font-weg-400' },
                        ' CESS '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-qty' },
                        ' ',
                        parseFloat(cess.PERC),
                        '% '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'badge badge-light font-size-13 font-weg-400' },
                        '\u20B9 ',
                        cess.VALUE
                    )
                )
            )
        )
    );
};

var CessCharges = function CessCharges(props) {
    return props.cessItems.map(function (post2) {
        var cess2 = post2[1];
        return _react2.default.createElement(Cess, { key: post2, cess: cess2 });
    });
};

var Tax = function Tax(props) {
    var tax = props.tax;
    return _react2.default.createElement(
        'ul',
        { className: 'item-total listview image-listview' },
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'div',
                { className: 'item font-size-13 font-weg-300' },
                _react2.default.createElement(
                    'div',
                    { className: 'in' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-name font-weg-400' },
                        ' SGST '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-qty' },
                        ' ',
                        parseFloat(tax.PERC) / 2,
                        '% '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'badge badge-light font-size-13 font-weg-400' },
                        '\u20B9 ',
                        tax.SGST
                    )
                )
            )
        ),
        _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
                'div',
                { className: 'item font-size-13 font-weg-300' },
                _react2.default.createElement(
                    'div',
                    { className: 'in' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-name font-weg-400' },
                        ' CGST '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-qty' },
                        ' ',
                        parseFloat(tax.PERC) / 2,
                        '% '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'badge badge-light font-size-13 font-weg-400' },
                        '\u20B9 ',
                        tax.CGST
                    )
                )
            )
        )
    );
};

var TaxCharges = function TaxCharges(props) {
    return props.taxItems.map(function (post2) {
        var tax2 = post2[1];
        return _react2.default.createElement(Tax, { key: post2, tax: tax2 });
    });
};

var Checkout = function (_React$Component) {
    _inherits(Checkout, _React$Component);

    function Checkout(props) {
        _classCallCheck(this, Checkout);

        var _this = _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call(this, props));
        //console.log(props);


        _this.handleClickAddressMissing = function () {
            $('#ModalAddressMissing').modal('show');
        };

        _this.handlePayModeChecked = function (e, payMode) {
            e.preventDefault();
            localStorage.setItem('payMode', payMode);
            _this.setState({ payMODE: payMode });
        };

        _this.state = {
            LOADING: true,
            LOCATION: _this.props.location.pathname,
            instructions: localStorage.getItem('vegONLY') || '',
            ITEMS: [],
            CartCount: 0,
            CustomerAddress: '',
            r_minthreshold: 0,
            overRIDE: '',
            restaurant_allowed: '',
            delApplicable: '',
            itemtax_charges: [],
            itemcess_charges: [],
            delivery_charges: [],
            conveyance_charges: [],
            coupon_discount: 0,
            coupon_discountTEXT: '',
            payMODE: '',
            CUSTOMER_DET: '',
            DEL_DATE: '',
            DEL_TIME: '',
            ADDITIONAL_DISCOUNT: '',
            ADDITIONAL_DISCOUNT2: 0,
            ADDITIONAL_TEXT: ''
        };
        return _this;
    }

    _createClass(Checkout, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'fetchCheckoutItems',
        value: function fetchCheckoutItems(mode, items, customer, address_id, offer_id, offer_code) {
            var id = localStorage.getItem('delCIRCLE');

            var that = this;
            fetch('https://m.donedelivery.in/api/checkoutitems_api.php?mode=' + mode + '&id=' + id + '&items=' + items + '&customer=' + customer + '&address_id=' + address_id + '&offer_id=' + offer_id + '&offer_code=' + offer_code, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_address = result.address;
                if (customer_address == '' || customer_address == undefined) customer_address = '';

                var address_id = result.address_id;
                if (address_id == '' || address_id == undefined) address_id = '';

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                if (customer_address != '' && address_id != '') localStorage.setItem('addressID', address_id);
                that.setState({ LOADING: false, ITEMS: result.ITEMS, CustomerAddress: customer_address, r_minthreshold: result.r_minthreshold, overRIDE: result.overRIDE, restaurant_allowed: result.restaurant_allowed, delApplicable: result.delApplicable, itemtax_charges: result.tax, itemcess_charges: result.cess, delivery_charges: result.delivery_charges, conveyance_charges: result.conveyance_charges, coupon_discount: result.discount, coupon_discountTEXT: result.discount2, CUSTOMER_DET: CUSTOMER_DET, DEL_DATE: result.DEL_DATE, DEL_TIME: result.DEL_TIME, ADDITIONAL_DISCOUNT: result.ADDITIONAL_DISCOUNT, ADDITIONAL_DISCOUNT2: result.ADDITIONAL_DISCOUNT2, ADDITIONAL_TEXT: result.ADDITIONAL_TEXT });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var address_id = '';
            if (localStorage.getItem('addressID')) address_id = localStorage.getItem('addressID');

            var itemLIST = '';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    var itemID = cart_id[0];
                    var itemCOUNT = cartData[key];
                    itemLIST += itemID + '|' + itemCOUNT + ',';
                });
            }

            if (itemLIST != '') itemLIST = itemLIST.substring(0, itemLIST.length - 1);

            var OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
            if (OFFER_APPLIED == null) OFFER_APPLIED = '';

            var offerID = '';
            var offerAPPLIED = '';
            if (OFFER_APPLIED != '') {
                var OFFER_APPLIED2 = OFFER_APPLIED.split('~~**~~');
                offerID = OFFER_APPLIED2[0];
                offerAPPLIED = OFFER_APPLIED2[1];
            }

            this.fetchCheckoutItems('ITEMS', itemLIST, customer, address_id, offerID, offerAPPLIED);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/cart';
            var AppHeaderTitle = 'Order Review';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);

            if (cart !== null && cart !== '{}') {
                var LIST = this.state.ITEMS;
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');

                    if (LIST.length > 0) {
                        LIST.map(function (id) {

                            if (cart_id[0] == id.ITEMID) {
                                //if(id.NEXTAVAILABLE!='')
                                if (id.AVAILABLE_QTY === '0' || id.AVAILABLE_QTY === 0) {
                                    delete cartData[key];
                                }
                            }
                        });
                    }
                });

                localStorage.setItem('cartData', JSON.stringify(cartData));
            }

            cart = localStorage.getItem('cartData');
            cartData = JSON.parse(cart);
            var cartItemCount = 0;
            var cartEMPTY = 'Y';

            if (cart !== null && cart !== '{}') {
                cartEMPTY = 'N';
                Object.keys(cartData).forEach(function (key) {

                    var itemCOUNT = cartData[key];
                    cartItemCount = cartItemCount + itemCOUNT;
                });
            }

            if (cartEMPTY == 'Y') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var props = {
                items: this.state.ITEMS,
                updateCart: this.updateCart
            };

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');else Verified = 'N';
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.payMODE != '') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/submit_order' });
            }

            var address_id = '';
            if (localStorage.getItem('addressID')) address_id = localStorage.getItem('addressID');

            var cartTOTAL = 0;
            var cartSUBTOTAL = 0;
            var itemtax_charges = this.state.itemtax_charges;
            var itemcess_charges = this.state.itemcess_charges;

            Object.keys(itemtax_charges).forEach(function (key) {
                var tax = itemtax_charges[key];
                cartTOTAL = parseFloat(cartTOTAL) + parseFloat(tax.VALUE);
            });

            Object.keys(itemcess_charges).forEach(function (key) {
                var cess = itemcess_charges[key];
                cartTOTAL = parseFloat(cartTOTAL) + parseFloat(cess.VALUE);
            });

            if (this.state.delApplicable == 'D') {
                cartTOTAL = parseFloat(cartTOTAL) + parseFloat(this.state.delivery_charges.CHARGES) + parseFloat(this.state.delivery_charges.SGST) + parseFloat(this.state.delivery_charges.CGST) + parseFloat(this.state.delivery_charges.IGST);
            } else if (this.state.delApplicable == 'C') {
                cartTOTAL = parseFloat(cartTOTAL) + parseFloat(this.state.conveyance_charges.CHARGES) + parseFloat(this.state.conveyance_charges.SGST) + parseFloat(this.state.conveyance_charges.CGST) + parseFloat(this.state.conveyance_charges.IGST);
            }

            if (this.state.coupon_discount > 0) cartTOTAL = parseFloat(cartTOTAL) - parseFloat(this.state.coupon_discount);

            if (this.state.ADDITIONAL_DISCOUNT2 != 0 && this.state.ADDITIONAL_DISCOUNT2 != undefined && this.state.ADDITIONAL_DISCOUNT2 > 0) cartTOTAL = parseFloat(cartTOTAL) - parseFloat(this.state.ADDITIONAL_DISCOUNT2);

            var taxItems = Object.keys(itemtax_charges).map(function (key) {
                return [key, itemtax_charges[key]];
            });

            var cessItems = Object.keys(itemcess_charges).map(function (key) {
                return [key, itemcess_charges[key]];
            });

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2 pb-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section inset pt-0 pb-1' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card p-2' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'content-header pb-05 pr-0 pl-0 font-size-13 text-dgrey font-weg-500' },
                                            'Delivery Address:'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'section-title w-100  d-flex justify-content-between pt-0 pb-0 pr-0 pl-0' },
                                            this.state.CustomerAddress != '' && _react2.default.createElement(
                                                'p',
                                                { className: 'mb-0 pt-05 w-70 text-mgrey font-size-11' },
                                                _react2.default.createElement(
                                                    'strong',
                                                    { className: 'font-weg-600 text-black' },
                                                    this.state.CustomerAddress.LABEL
                                                ),
                                                ' ',
                                                this.state.CustomerAddress.ADDRESS,
                                                ' ',
                                                this.state.CustomerAddress.ADDRESS2,
                                                ' ',
                                                this.state.CustomerAddress.ADDRESS3,
                                                ' ',
                                                this.state.CustomerAddress.MOBILE
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                null,
                                                this.state.CustomerAddress != '' && _react2.default.createElement(
                                                    _reactRouterDom.Link,
                                                    { to: '/changeaddress', className: 'btn text-upper newshadowed font-size-12 square btn-danger btn-sm btn-block' },
                                                    'Change'
                                                ),
                                                this.state.CustomerAddress == '' && _react2.default.createElement(
                                                    _reactRouterDom.Link,
                                                    { to: '/addaddress', className: 'btn text-upper newshadowed font-size-12 square btn-danger btn-sm btn-block' },
                                                    'Add'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-list-items pb-5' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'item-title listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name' },
                                                ' Item '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' Qty '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                'Price'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'listview image-listview' },
                                this.state.ITEMS.map(function (item) {
                                    var cartCount = 0; //this.state.cartCount;

                                    var currentITEM = item.ID;
                                    var cart = localStorage.getItem('cartData');
                                    if (cart !== null) {
                                        var _cartData = JSON.parse(cart);
                                        Object.keys(_cartData).forEach(function (key) {
                                            var id = key.split('~~**~~');
                                            if (id[0] == currentITEM) cartCount += _cartData[key];
                                        });
                                    }

                                    var itemTOTAL = parseFloat(item.RATE) * parseFloat(cartCount);
                                    cartSUBTOTAL = parseFloat(cartSUBTOTAL) + parseFloat(itemTOTAL);
                                    cartTOTAL = parseFloat(cartTOTAL) + parseFloat(itemTOTAL);

                                    if (cartCount > 0) {
                                        return _react2.default.createElement(
                                            'li',
                                            { key: item.ID },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'in' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'item-name font-size-12 text-sdgrey font-weg-400' },
                                                        item.NAME,
                                                        ' ( per ',
                                                        item.UNIT,
                                                        ')'
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'font-size-12 font-weg-400' },
                                                        _react2.default.createElement(
                                                            'span',
                                                            { className: 'text-danger' },
                                                            '\u20B9 ',
                                                            item.RATE
                                                        ),
                                                        ' x ',
                                                        cartCount
                                                    ),
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'badge badge-light font-size-14 font-weg-400' },
                                                        '\u20B9 ',
                                                        itemTOTAL.toFixed(2)
                                                    )
                                                )
                                            )
                                        );
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-500' },
                                                ' Subtotal '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                '\u20B9 ',
                                                cartSUBTOTAL.toFixed(2)
                                            )
                                        )
                                    )
                                )
                            ),
                            taxItems != '' && _react2.default.createElement(TaxCharges, { taxItems: taxItems }),
                            cessItems != '' && _react2.default.createElement(CessCharges, { cessItems: cessItems }),
                            this.state.coupon_discount != 0 && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name text-warning' },
                                                ' Coupon Discount '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400 text-warning' },
                                                '-\u20B9 ',
                                                this.state.coupon_discount.toFixed(2)
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.coupon_discountTEXT != 0 && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name text-warning', style: { 'width': '100%' } },
                                                ' Free ',
                                                this.state.coupon_discountTEXT,
                                                ' '
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.ADDITIONAL_DISCOUNT2 != 0 && this.state.ADDITIONAL_DISCOUNT2 != undefined && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name text-warning' },
                                                ' ',
                                                this.state.ADDITIONAL_TEXT,
                                                ' '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400 text-warning' },
                                                '-\u20B9 ',
                                                this.state.ADDITIONAL_DISCOUNT2.toFixed(2)
                                            )
                                        )
                                    )
                                )
                            ),
                            console.log(this.state.ADDITIONAL_DISCOUNT),
                            this.state.ADDITIONAL_DISCOUNT != '' && this.state.ADDITIONAL_DISCOUNT != undefined && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name text-warning', style: { 'width': '100%' } },
                                                ' ',
                                                this.state.ADDITIONAL_TEXT,
                                                ': ',
                                                this.state.ADDITIONAL_DISCOUNT,
                                                ' '
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.delApplicable == 'D' && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-500' },
                                                ' Delivery Charges '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.delivery_charges.CHARGES.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.delivery_charges.SGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' SGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.delivery_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.delivery_charges.SGST.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.delivery_charges.CGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' CGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.delivery_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.delivery_charges.CGST.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.delivery_charges.IGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' IGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.delivery_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.delivery_charges.IGST.toFixed(2)
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.delApplicable == 'C' && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-500' },
                                                ' Delivery Charges '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.conveyance_charges.CHARGES.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.conveyance_charges.SGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' SGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.conveyance_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.conveyance_charges.SGST.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.conveyance_charges.CGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' CGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.conveyance_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.conveyance_charges.CGST.toFixed(2)
                                            )
                                        )
                                    )
                                ),
                                this.state.conveyance_charges.IGST != 0 && _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-13 font-weg-300' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name font-weg-400' },
                                                ' IGST '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' ',
                                                parseFloat(this.state.conveyance_charges.PERC) / 2,
                                                '% '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-13 font-weg-400' },
                                                '\u20B9 ',
                                                this.state.conveyance_charges.IGST.toFixed(2)
                                            )
                                        )
                                    )
                                )
                            ),
                            this.state.delApplicable == '' && _react2.default.createElement(
                                'ul',
                                { className: 'item-total listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name' },
                                                ' Delivery Charges '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                'FREE'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: 'delivery-date date-slot' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2' },
                                    'Delivery Date'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group basic more-locations pt-05' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'form-control text-upper btn  bg-white square custom-select', id: 'city4' },
                                            this.state.DEL_DATE
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'delivery-date time-slot' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2' },
                                    'Delivery Time'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group basic more-locations pt-05' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'form-control text-upper btn  bg-white square custom-select', id: 'city4' },
                                            this.state.DEL_TIME
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement('div', { className: 'clear' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-button-group2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'section-title w-100  d-flex justify-content-between pt-1 pb-1 pr-0 pl-0 medium' },
                                    ' Total',
                                    _react2.default.createElement(
                                        'span',
                                        null,
                                        '\u20B9 ',
                                        cartTOTAL.toFixed(2)
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-button-group1 pr-2 pl-2' },
                            _react2.default.createElement(
                                'div',
                                { className: 'col-12' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'text-upper' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-6' },
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '/categories', className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block goBack' },
                                                'Add more items'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-6' },
                                            address_id == '' && _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '#', 'data-toggle': 'modal', 'data-target': '#ModalAddressMissing', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block', onClick: props.handleClickAddressMissing },
                                                'PAY NOW'
                                            ),
                                            address_id != '' && _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                { to: '#', 'data-toggle': 'modal', 'data-target': '#DialogIconedInfo', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                                'PAY NOW'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'modal pay-modal fade dialogbox', id: 'DialogIconedInfo', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-dialog', role: 'document' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-header' },
                                _react2.default.createElement(
                                    'h5',
                                    { className: 'modal-title font-size-13 font-weg-500' },
                                    'Choose a payment option'
                                ),
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '#', className: 'btn close-btn', 'data-dismiss': 'modal' },
                                    'x'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body mt-3' },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'submit', className: 'mb-2 lt-space1 text-upper btn btn-danger btn-block square' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { className: 'text-upper btn-danger', to: '#', onClick: function onClick(e) {
                                                _this2.handlePayModeChecked(e, 2);
                                            } },
                                        'Online Payment'
                                    )
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'submit', className: 'lt-space1 text-upper btn btn-dark btn-block square' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { className: 'text-upper btn-dark', to: '#', onClick: function onClick(e) {
                                                _this2.handlePayModeChecked(e, 1);
                                            } },
                                        'Cash on Delivery'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'item pt-06 pb-06 font-size-14 font-weg-400 text-center' },
                                            'Delivery Date: ',
                                            this.state.DEL_DATE,
                                            _react2.default.createElement('br', null),
                                            this.state.DEL_TIME
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'item font-size-11 font-weg-400 red' },
                                            'Products are subject to availability due to ongoing restrictions'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'modal fade dialogbox', id: 'ModalAddressMissing', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-dialog', role: 'document' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-icon text-danger' },
                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body' },
                                _react2.default.createElement(
                                    'p',
                                    { className: 'if-no-add' },
                                    'Please add delivery address'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-footer' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'btn-inline' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                        'Ok'
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Checkout;
}(_react2.default.Component);

exports.default = Checkout;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeAddress = function (_React$Component) {
    _inherits(ChangeAddress, _React$Component);

    function ChangeAddress(props) {
        _classCallCheck(this, ChangeAddress);

        var _this = _possibleConstructorReturn(this, (ChangeAddress.__proto__ || Object.getPrototypeOf(ChangeAddress)).call(this, props));
        //console.log(props);


        _this.handleAddressChanged = function () {

            var address_id = '';
            $.each($("input[name='address']:checked"), function () {
                address_id = $(this).val();
            });
            localStorage.setItem('addressID', address_id);

            _this.setState({ addressChanged: true });
        };

        _this.state = {
            LOADING: true,
            addressChanged: false,
            CustomerAddresses: ''
        };
        return _this;
    }

    _createClass(ChangeAddress, [{
        key: 'fetchCustomerAddress',
        value: function fetchCustomerAddress(mode, id, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customeraddress_api.php?mode=' + mode + '&id=' + id + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_addresses = result.addresses;
                if (customer_addresses == '' || customer_addresses == undefined) customer_addresses = '';

                that.setState({ LOADING: false, CustomerAddresses: customer_addresses });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var circle_id = localStorage.getItem('delCIRCLE');
            console.log(circle_id);
            this.fetchCustomerAddress('ADDRESS', circle_id, customer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.addressChanged) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/checkout' });
            }

            var address_id = '';
            if (localStorage.getItem('addressID') != null) address_id = localStorage.getItem('addressID');

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/checkout';
            var AppHeaderTitle = 'Delivery Address';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'delivery-location section full mt-0' },
                        this.state.CustomerAddresses.length > 0 && this.state.CustomerAddresses.map(function (post) {
                            var checked = false;
                            if (address_id != '' && address_id == post.ID) checked = true;else {
                                if (post.DEFAULT == 'Y') checked = true;
                            }

                            return _react2.default.createElement(
                                'div',
                                { className: 'wide-block pt-2 pb-2', key: post.ID },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'sumup' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'custom-control custom-radio' },
                                        _react2.default.createElement('input', { type: 'radio', id: 'address_' + post.ID, name: 'address', value: post.ID, className: 'custom-control-input', defaultChecked: checked }),
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'custom-control-label', htmlFor: 'address_' + post.ID },
                                            _react2.default.createElement(
                                                'h5',
                                                { className: 'font-weg-400 mb-05' },
                                                post.CIRCLE,
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'badge chip-warning chip-outline ht-17 font-size-10  font-weg-500 text-upper ltsp' },
                                                    post.LABEL
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'p',
                                                { className: 'font-size-13l font-weg-300 mb-05' },
                                                post.ADDRESS
                                            ),
                                            post.MOBILE_NO && _react2.default.createElement(
                                                'div',
                                                { className: 'stateline pin' },
                                                _react2.default.createElement(
                                                    'span',
                                                    { className: 'text-lgrey font-size-12 mb-05 mr-1' },
                                                    post.MOBILE_NO
                                                )
                                            )
                                        )
                                    )
                                )
                            );
                        })
                    ),
                    this.state.CustomerAddresses.length == 0 && _react2.default.createElement(
                        'div',
                        { className: 'form-button-group1 pr-2 pl-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/addaddress', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                            'Add New Address'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    this.state.CustomerAddresses.length > 0 && _react2.default.createElement(
                        'div',
                        { className: 'form-button-group1 pr-2 pl-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/addaddress', className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block' },
                                            'Add Address'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-6' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block', onClick: function onClick() {
                                                    _this2.handleAddressChanged();
                                                } },
                                            ' NEXT'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ChangeAddress;
}(_react2.default.Component);

exports.default = ChangeAddress;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _googleMapsReact = __webpack_require__(39);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Map = __webpack_require__(77);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    width: '90%',
    height: '300px'
};

var AddAddress = function (_React$Component) {
    _inherits(AddAddress, _React$Component);

    function AddAddress(props) {
        _classCallCheck(this, AddAddress);

        var _this = _possibleConstructorReturn(this, (AddAddress.__proto__ || Object.getPrototypeOf(AddAddress)).call(this, props));
        //console.log(props);


        _initialiseProps.call(_this);

        _this.state = {
            LOADING: true,
            addressAdded: false,
            CustomerAddresses: '',
            Notifications: false,
            DeliveryCirlce: '',
            DeliveryArea: '',
            showingInfoWindow: false, //Hides or the shows the infoWindow
            activeMarker: {}, //Shows the active marker upon click
            selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: ''
        };
        return _this;
    }

    _createClass(AddAddress, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ LOADING: false });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.addressAdded) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/checkout' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/changeaddress';
            var AppHeaderTitle = 'Add New Address';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'pt-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section p-0', style: { height: '300px', width: '100%', marginTop: '57px' } },
                            _react2.default.createElement(
                                'div',
                                { id: 'map' },
                                ' ',
                                _react2.default.createElement(
                                    _Map2.default,
                                    {
                                        centerAroundCurrentLocation: true,
                                        google: this.props.google,
                                        handleGetAddress: this.handleGetAddress
                                    },
                                    _react2.default.createElement(_googleMapsReact.Marker, {
                                        draggable: true,
                                        name: this.state.address,
                                        position: { lat: this.state.lat, lng: this.state.long },
                                        onDragend: function onDragend(t, map, coord) {
                                            return _this2.onMarkerDragEnd(coord);
                                        } }),
                                    _react2.default.createElement(
                                        _googleMapsReact.InfoWindow,
                                        {
                                            marker: this.state.activeMarker,
                                            visible: this.state.showingInfoWindow,
                                            onClose: this.onClose
                                        },
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                this.state.selectedPlace.name
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-1 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmAddAddress', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'ADD_ADDRESS', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer' }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('delCIRCLE'), className: 'form-control', name: 'id', id: 'id' }),
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.lat, className: 'form-control', name: 'lat', id: 'lat', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.long, className: 'form-control', name: 'long', id: 'long', required: true }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtaddress' },
                                            'Address:'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtaddress', id: 'txtaddress', placeholder: 'Address', required: true, defaultValue: this.state.address, autoComplete: 'off', onBlur: this.updateGoogleMarker }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your address.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtlandmark' },
                                            'Landmark:'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', id: 'txtlandmark', name: 'txtlandmark', placeholder: 'Landmark', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter landmark.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtlabel' },
                                            'Label:'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', id: 'txtlabel', name: 'txtlabel', placeholder: 'Label: Work, Office, Home, Other...', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter label.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-20' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtcode' },
                                                'Code'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtcode', id: 'txtcode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your area code.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-80' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtmobile' },
                                                'Mobile No'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtmobile', id: 'txtmobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your 10 digit mobile no.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('div', { className: 'clear' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'text-upper btn btn-danger square btn-md lt-space1 btn-block skip' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'SAVE'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AddAddress;
}(_react2.default.Component);

//export default AddAddress;

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleSubmit = function (e) {
        e.preventDefault();

        var err = 0;
        if ($('#frmAddAddress')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmAddAddress')[0].classList.add('was-validated');

        if (err == 0) {
            $('#submitLoading').css('display', 'block');

            var method = "POST";
            var body = new FormData(_this3.form);
            //console.log(body);
            var that = _this3;
            fetch("https://m.donedelivery.in/api/customeraddaddress_api.php", { method: method, body: body }).then(function (response) {
                //console.log(response);
                return response.json();
            }).then(function (result) {

                //console.log(result);
                //alert(result);
                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '2') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '3') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '4') notify = 'Unknown Customer';else if (result.err == '5') notify = 'Address Field is Empty';else if (result.err == '6') notify = 'Landmark Field is Empty';else if (result.err == '7') notify = 'Label Field is Empty';else if (result.err == '12') notify = 'Invalid Access Detected';else if (result.err == '8') notify = 'Mobile Area Code Field is Empty';else if (result.err == '9') notify = 'Mobile No Field is Empty';
                }

                var addressAdded = false;
                var address_id = result.address_id;
                if (address_id != '' && address_id != undefined) {
                    localStorage.setItem('addressID', address_id);
                    addressAdded = true;
                }

                that.setState({ Notifications: notify, addressAdded: addressAdded });
                $('#submitLoading').css('display', 'none');
                if (notify != '') $('#ModalAlert').modal('show');
            });
        }
    };

    this.onMarkerClick = function (props, marker, e) {
        return _this3.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    this.handleGetAddress = function (address, lat, long) {
        _this3.setState({ address: address, lat: lat, long: long });
    };

    this.updateGoogleMarker = function (e) {
        var address = e.target.value;
        if (address != '') {
            var that = _this3;
            fetch('https://m.donedelivery.in/api/addresslatlong_api.php?mode=LATLONG&address=' + address, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                if (result.DATA == 'Y') {
                    that.setState({ address: address, lat: result.LAT, long: result.LONG });
                }
            });
        }
    };

    this.onMarkerDragEnd = function (coord) {
        var latLng = coord.latLng;

        var lat = latLng.lat();
        var lng = latLng.lng();

        var requestOption = {
            method: 'GET'
        };

        //console.log(lat +','+ lng);
        var address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + lat + ',' + lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
            return res.json();
        }).then(function (response) {
            address = response.results[0].formatted_address;
            _this3.setState({ address: address, lat: lat, long: lng });
        }).catch(function (error) {
            console.warn(error);
        });
    };

    this.onClose = function (props) {
        if (_this3.state.showingInfoWindow) {
            _this3.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
};

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: 'AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U'
})(AddAddress);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _googleMapsReact = __webpack_require__(39);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Map = __webpack_require__(77);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    width: '90%',
    height: '300px'
};

var AddAddress2 = function (_React$Component) {
    _inherits(AddAddress2, _React$Component);

    function AddAddress2(props) {
        _classCallCheck(this, AddAddress2);

        var _this = _possibleConstructorReturn(this, (AddAddress2.__proto__ || Object.getPrototypeOf(AddAddress2)).call(this, props));
        //console.log(props);


        _initialiseProps.call(_this);

        _this.state = {
            LOADING: true,
            addressAdded: false,
            CustomerAddresses: '',
            Notifications: false,
            DeliveryCirlce: '',
            DeliveryArea: '',
            showingInfoWindow: false, //Hides or the shows the infoWindow
            activeMarker: {}, //Shows the active marker upon click
            selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: ''
        };
        return _this;
    }

    _createClass(AddAddress2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ LOADING: false });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.addressAdded) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/addresses' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/addresses';
            var AppHeaderTitle = 'Add New Address';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'pt-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section p-0', style: { height: '300px', width: '100%', marginTop: '57px' } },
                            _react2.default.createElement(
                                'div',
                                { id: 'map' },
                                ' ',
                                _react2.default.createElement(
                                    _Map2.default,
                                    {
                                        centerAroundCurrentLocation: true,
                                        google: this.props.google,
                                        handleGetAddress: this.handleGetAddress
                                    },
                                    _react2.default.createElement(_googleMapsReact.Marker, {
                                        draggable: true,
                                        name: this.state.address,
                                        position: { lat: this.state.lat, lng: this.state.long },
                                        onDragend: function onDragend(t, map, coord) {
                                            return _this2.onMarkerDragEnd(coord);
                                        } }),
                                    _react2.default.createElement(
                                        _googleMapsReact.InfoWindow,
                                        {
                                            marker: this.state.activeMarker,
                                            visible: this.state.showingInfoWindow,
                                            onClose: this.onClose
                                        },
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(
                                                'h4',
                                                null,
                                                this.state.selectedPlace.name
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-1 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmAddAddress', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'ADD_ADDRESS', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer' }),
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.lat, className: 'form-control', name: 'lat', id: 'lat', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.long, className: 'form-control', name: 'long', id: 'long', required: true }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { 'class': 'label', htmlFor: 'txtaddress' },
                                            'Address:'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtaddress', id: 'txtaddress', required: true, defaultValue: this.state.address, autoComplete: 'off', onBlur: this.updateGoogleMarker }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your address.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { 'class': 'label', htmlFor: 'txtlandmark' },
                                            'Landmark:'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', id: 'txtlandmark', name: 'txtlandmark', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter landmark.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { 'class': 'label', htmlFor: 'txtlabel' },
                                            'Label: Work, Office, Home, Other...'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', id: 'txtlabel', name: 'txtlabel', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter label.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-20' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtcode' },
                                                'Code'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtcode', id: 'txtcode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your area code.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-80' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtmobile' },
                                                'Mobile No'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtmobile', id: 'txtmobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your 10 digit mobile no.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('div', { className: 'clear' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'text-upper btn btn-danger square btn-md lt-space1 btn-block skip' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'SAVE'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AddAddress2;
}(_react2.default.Component);

//export default AddAddress2;


var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleSubmit = function (e) {
        e.preventDefault();

        var err = 0;
        if ($('#frmAddAddress')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmAddAddress')[0].classList.add('was-validated');

        if (err == 0) {
            $('#submitLoading').css('display', 'block');

            var method = "POST";
            var body = new FormData(_this3.form);
            //console.log(body);
            var that = _this3;
            fetch("https://m.donedelivery.in/api/customeraddaddress_api.php", { method: method, body: body }).then(function (response) {
                //console.log(response);
                return response.json();
            }).then(function (result) {

                //console.log(result);
                //alert(result);
                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '2') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '3') notify = 'Done delivery is currently unavailable in your area.';else if (result.err == '4') notify = 'Unknown Customer';else if (result.err == '5') notify = 'Address Field is Empty';else if (result.err == '6') notify = 'Landmark Field is Empty';else if (result.err == '7') notify = 'Label Field is Empty';else if (result.err == '12') notify = 'Invalid Access Detected';else if (result.err == '8') notify = 'Mobile Area Code Field is Empty';else if (result.err == '9') notify = 'Mobile No Field is Empty';
                }

                var addressAdded = false;
                var address_id = result.address_id;
                if (address_id != '' && address_id != undefined) {
                    localStorage.setItem('addressID', address_id);
                    addressAdded = true;
                }

                that.setState({ Notifications: notify, addressAdded: addressAdded });
                $('#submitLoading').css('display', 'none');
                if (notify != '') $('#ModalAlert').modal('show');
            });
        }
    };

    this.onMarkerClick = function (props, marker, e) {
        return _this3.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    this.handleGetAddress = function (address, lat, long) {
        _this3.setState({ address: address, lat: lat, long: long });
    };

    this.updateGoogleMarker = function (e) {
        var address = e.target.value;
        if (address != '') {
            var that = _this3;
            fetch('https://m.donedelivery.in/api/addresslatlong_api.php?mode=LATLONG&address=' + address, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                if (result.DATA == 'Y') {
                    that.setState({ address: address, lat: result.LAT, long: result.LONG });
                }
            });
        }
    };

    this.onMarkerDragEnd = function (coord) {
        var latLng = coord.latLng;

        var lat = latLng.lat();
        var lng = latLng.lng();

        var requestOption = {
            method: 'GET'
        };

        //console.log(lat +','+ lng);
        var address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + lat + ',' + lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
            return res.json();
        }).then(function (response) {
            address = response.results[0].formatted_address;
            _this3.setState({ address: address, lat: lat, long: lng });
        }).catch(function (error) {
            console.warn(error);
        });
    };

    this.onClose = function (props) {
        if (_this3.state.showingInfoWindow) {
            _this3.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
};

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(AddAddress2);

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Login = function (_React$Component) {
    _inherits(Login, _React$Component);

    function Login(props) {
        _classCallCheck(this, Login);

        var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmLogin')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmLogin')[0].classList.add('was-validated');

            if (err == 0) {
                var pass = $('#txtpassword').val();
                $('#txtpassword').val(window.b64_md5(pass));

                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/customer_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Mobile No Field is Empty';else if (result.err == '2') notify = 'Password Field is Empty';else if (result.err == '3') notify = 'Mobile No Not Found';else if (result.err == '4') notify = 'Invalid Access Detected';else if (result.err == '5') notify = 'No Such User Exist';else if (result.err == '6') notify = 'Invalid Password Entered';else if (result.err == '7') notify = 'Mobile Area Code Field is Empty';
                    }

                    var logged = false;

                    var customer = result.customer;
                    if (customer != '' && customer != undefined) {
                        localStorage.setItem('userData', customer);
                        localStorage.setItem('Verified', result.verified);
                        logged = true;
                    }

                    that.setState({ Notifications: notify, Logged: logged });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.state = {
            LOADING: true,
            Notifications: false,
            Logged: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(Login, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
            //this.setState({ LOADING:false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (localStorage.getItem('userData')) {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            if (this.state.Logged) {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                cartEMPTY = 'N';
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = cartEMPTY == 'N' ? '/cart' : '/home';
            var AppHeaderTitle = 'Sign in';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section pt-6' },
                            _react2.default.createElement('img', { src: '/assets/img/done-image.png', alt: 'image', className: 'form-image imaged w140' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-5 mb-5 pr-3 pl-3' },
                            _react2.default.createElement(
                                'form',
                                { name: 'frmLogin', id: 'frmLogin', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: 'SIGNIN', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', className: 'form-control', defaultValue: localStorage.getItem('SUBSCRIBER_ID'), name: 'webpushr_id', id: 'webpushr_id' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-20' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusercode' },
                                                'Code'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusercode', id: 'txtusercode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your area code.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-80' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusermobile' },
                                                'Mobile No'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusermobile', id: 'txtusermobile', required: true, minLength: '10', maxLength: '10', pattern: '[0-9]{10}', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your 10 digit mobile no.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('div', { className: 'clear' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtpassword' },
                                            'Password'
                                        ),
                                        _react2.default.createElement('input', { type: 'password', className: 'square-inputbox form-control', name: 'txtpassword', id: 'txtpassword', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your password.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-links' },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/register', className: 'font-weg-400 text-danger' },
                                            'Register'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/forgot-password', className: 'text-lgrey font-weg-400' },
                                            'Forgot Password?'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Sign in'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Login;
}(_react2.default.Component);

exports.default = Login;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ForgotPassword = function (_React$Component) {
  _inherits(ForgotPassword, _React$Component);

  function ForgotPassword(props) {
    _classCallCheck(this, ForgotPassword);

    var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));

    _this.handleSubmit = function (e) {
      e.preventDefault();

      var err = 0;
      if ($('#frmForgotPassword')[0].checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        err++;
      }
      $('#frmForgotPassword')[0].classList.add('was-validated');

      if (err == 0) {
        $('#submitLoading').css('display', 'block');

        var method = "POST";
        var body = new FormData(_this.form);
        //console.log(body);
        var that = _this;
        fetch("https://m.donedelivery.in/api/customerforgotpassword_api.php", { method: method, body: body }).then(function (response) {
          //console.log(response);
          return response.json();
        }).then(function (result) {
          //console.log(result);
          var notify = '';
          if (result.err != '') {
            if (result.err == '1') notify = 'Mobile Field is Empty';else if (result.err == '2') notify = 'No Such User Exist';else if (result.err == '3') notify = 'Invalid Access Detected';else if (result.err == '4') notify = 'Mobile Area Code Field is Empty';
          }

          var otp_sent = false;
          if (result.otp_sent == 'Y') {
            otp_sent = true;
            var mobileno = result.mobileno;
            var customer = result.customer;
            var emailid = result.emailid;

            if (customer != '' && customer != undefined) {
              localStorage.setItem('tempData', customer);
              if (mobileno != '') localStorage.setItem('tempREG', mobileno);
              if (emailid != '') localStorage.setItem('tempEMAIL', emailid);
            }
          }

          //console.log(otp_sent);
          that.setState({ Notifications: notify, OTP: otp_sent });
          $('#submitLoading').css('display', 'none');
          if (notify != '') $('#ModalAlert').modal('show');
        });
      }
    };

    _this.state = {
      LOADING: true,
      OTP: false,
      CUSTOMER_DET: ''
    };
    return _this;
  }

  _createClass(ForgotPassword, [{
    key: 'fetchCustomerProfile',
    value: function fetchCustomerProfile(mode, customer) {
      var that = this;
      fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (result) {

        var CUSTOMER_DET = 'Hi User';
        if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

        that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var mount = $("div").hasClass("modal-backdrop");
      if (mount == true) {
        $('body').removeClass('modal-open');
        $(".modal-backdrop").remove();
        //window.location.reload(true);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var customer = localStorage.getItem('userData');
      this.fetchCustomerProfile('PROFILE', customer);
      //this.setState({ LOADING:false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.OTP) {
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/sms_verification2' });
      }

      var AppHeaderClass = 'appHeader bg-dark text-light';
      var AppHeaderLeft = 'showLINK';
      var AppHeaderLeftLink = '/login';
      var AppHeaderTitle = 'Reset Password';
      var AppHeaderRight = '';
      var AppHeaderRightLink = '';
      var AppHeaderSearch = '';

      return _react2.default.createElement(
        'div',
        null,
        this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
        _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
        _react2.default.createElement(
          'div',
          { id: 'appCapsule' },
          _react2.default.createElement(
            'div',
            { className: 'login-form mt-1' },
            _react2.default.createElement(
              'div',
              { className: 'section pt-6' },
              _react2.default.createElement('img', { src: '/assets/img/done-image.png', alt: 'image', className: 'form-image imaged w140' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'section mt-5 mb-5 pr-3 pl-3' },
              _react2.default.createElement(
                'form',
                { name: 'frmForgotPassword', id: 'frmForgotPassword', ref: function ref(el) {
                    return _this2.form = el;
                  }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                _react2.default.createElement('input', { type: 'hidden', value: 'FORGOT_PASSWORD', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'form-group boxed mb-1' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wid-20' },
                    _react2.default.createElement(
                      'div',
                      { className: 'input-wrapper' },
                      _react2.default.createElement(
                        'label',
                        { className: 'label', htmlFor: 'txtusercode' },
                        'Code'
                      ),
                      _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusercode', id: 'txtusercode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                      _react2.default.createElement(
                        'i',
                        { className: 'clear-input' },
                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'valid-feedback' },
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'invalid-feedback' },
                        'Please enter your area code.'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wid-80' },
                    _react2.default.createElement(
                      'div',
                      { className: 'input-wrapper' },
                      _react2.default.createElement(
                        'label',
                        { className: 'label', htmlFor: 'txtusermobile' },
                        'Mobile'
                      ),
                      _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusermobile', id: 'txtusermobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off' }),
                      _react2.default.createElement(
                        'i',
                        { className: 'clear-input' },
                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'valid-feedback' },
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'invalid-feedback' },
                        'Please enter your 10 digit mobile no.'
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'clear' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-button-group pl-4 pr-4 bg-common' },
                  _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                    _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                    'Verify'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
              _react2.default.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                _react2.default.createElement(
                  'div',
                  { className: 'modal-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-icon text-danger' },
                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-body' },
                    this.state.Notifications
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-footer' },
                    _react2.default.createElement(
                      'div',
                      { className: 'btn-inline' },
                      _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                        'Ok'
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
      );
    }
  }]);

  return ForgotPassword;
}(_react2.default.Component);

exports.default = ForgotPassword;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _reactCountdown = __webpack_require__(78);

var _reactCountdown2 = _interopRequireDefault(_reactCountdown);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Completionist = function Completionist() {
    return _react2.default.createElement(
        'div',
        { className: 'mt-5' },
        _react2.default.createElement(
            'div',
            { id: 'RESEND_OTP', style: { display: 'block' } },
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '#', className: 'font-weg-400 text-danger', onClick: function onClick(e) {
                        undefined.handleResendOTP(e);
                    } },
                'Resend OTP'
            )
        )
    );
};

// Renderer callback with condition
var renderer = function renderer(_ref) {
    var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds,
        completed = _ref.completed;

    if (completed) {
        // Render a complete state
        return _react2.default.createElement(Completionist, null);
    } else {
        // Render a countdown
        return _react2.default.createElement(
            'p',
            null,
            minutes,
            ':',
            seconds
        );
    }
};

var SmsVerification = function (_React$Component) {
    _inherits(SmsVerification, _React$Component);

    function SmsVerification(props) {
        _classCallCheck(this, SmsVerification);

        var _this = _possibleConstructorReturn(this, (SmsVerification.__proto__ || Object.getPrototypeOf(SmsVerification)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmSmsVerify')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmSmsVerify')[0].classList.add('was-validated');

            if (err == 0) {
                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/smsverify_api2.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'OTP Field is Empty';else if (result.err == '3') notify = 'OTP Expired, Please regenrate again';else if (result.err == '4') notify = 'Invalid Access Detected';else if (result.err == '5') notify = 'Invalid Access Detected';
                    }

                    var sms_verified = 'N';
                    var customer = result.customer;
                    if (customer != '' && customer != undefined) {
                        localStorage.setItem('userData', customer);
                        localStorage.setItem('Verified', result.verified);
                        localStorage.removeItem('tempData');
                        localStorage.removeItem('tempREG');
                        localStorage.removeItem('tempEMAIL');

                        sms_verified = 'Y';
                    }

                    that.setState({ Notifications: notify, SMS_VERIFIED: sms_verified });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.handleResendOTP = function (e) {
            e.preventDefault();
            $('#RESEND_OTP').css('display', 'none');

            var customer = localStorage.getItem('tempData');

            var that = _this;
            fetch('https://m.donedelivery.in/api/resendotp_api.php?mode=FP&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'Invalid Access Detected';
                }

                var otp_resent = result.otp_resent;
                if (otp_resent == '' || otp_resent == undefined) otp_resent = '';

                if (otp_resent == 'Y') {
                    notify = 'New OTP has been sent to your mobile no';
                }

                that.setState({ Notifications: notify });
                if (notify != '') $('#ModalAlert').modal('show');
            });
        };

        _this.state = {
            Notifications: false,
            Customer: localStorage.getItem('tempData'),
            SMS_VERIFIED: 'N'
        };

        return _this;
    }

    _createClass(SmsVerification, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.SMS_VERIFIED == 'Y') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/change_password' });
            }

            if (localStorage.getItem('userData')) {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/login';
            var AppHeaderTitle = 'Verification';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            var tempREG = '';
            var tempEMAIL = '';
            if (localStorage.getItem('tempREG') && localStorage.getItem('tempREG') !== 'null' && localStorage.getItem('tempREG') !== null) tempREG = localStorage.getItem('tempREG');

            if (localStorage.getItem('tempEMAIL') && localStorage.getItem('tempEMAIL') !== 'null' && localStorage.getItem('tempEMAIL') !== null) tempEMAIL = localStorage.getItem('tempEMAIL');

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-5 pt-3 pr-3 pl-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section' },
                            tempREG !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Mobile No:  ',
                                localStorage.getItem('tempREG')
                            ),
                            tempEMAIL !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Email Id:  ',
                                localStorage.getItem('tempEMAIL')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-2 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmSmsVerify', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'SMS_VERIFY', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('tempData'), className: 'form-control', name: 'customer', id: 'customer', required: true }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement('input', { type: 'text', className: 'placeholder-size square-inputbox form-control verify-input verify-input-1', name: 'txtotp', id: 'txtotp', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022', maxLength: '6', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter otp.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(_reactCountdown2.default, { date: Date.now() + 59000, renderer: renderer }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Verify'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SmsVerification;
}(_react2.default.Component);

exports.default = SmsVerification;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Option = __webpack_require__(128);

var _Option2 = _interopRequireDefault(_Option);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Register = function (_React$Component) {
    _inherits(Register, _React$Component);

    function Register(props) {
        _classCallCheck(this, Register);

        var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmRegister')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmRegister')[0].classList.add('was-validated');

            var password = $('#txtpassword').val().trim();
            var password2 = $('#txtpassword2').val().trim();

            if (password != password2) {
                err++;
                $('#txtpassword2').val('');
            }

            if (err == 0) {
                var pass = $('#txtpassword').val();
                $('#txtpassword').val(window.b64_md5(pass));

                var pass2 = $('#txtpassword2').val();
                $('#txtpassword2').val(window.b64_md5(pass2));

                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/register_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    //alert(result);
                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Name Field is Empty';else if (result.err == '2') notify = 'Mobile No Field is Empty';else if (result.err == '3') notify = 'Email Id Field is Empty';else if (result.err == '4') notify = 'Password Field is Empty';else if (result.err == '5') notify = 'Password Field is Empty';else if (result.err == '6') notify = 'Please Check The Terms &amp; Condtions';else if (result.err == '7') notify = 'Mobile No Already Exists';else if (result.err == '8') notify = 'Invalid Access Detected';else if (result.err == '9') notify = 'Mobile Area Code Field is Empty';
                    }

                    var registered = false;
                    var customer = result.customer;
                    var mobileno = result.mobileno;
                    var emailid = result.emailid;
                    if (customer != '' && customer != undefined) {
                        localStorage.setItem('tempData', customer);
                        if (mobileno != '') localStorage.setItem('tempREG', mobileno);
                        if (emailid != '') localStorage.setItem('tempEMAIL', emailid);
                        localStorage.setItem('Verified', 'N');
                        registered = true;
                    }

                    that.setState({ Notifications: notify, Registered: registered });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.handleClickGetTerms = function () {
            $('#ModalTerms').modal('show');
        };

        _this.state = {
            LOADING: true,
            Notifications: false,
            Registered: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(Register, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
            //this.setState({ LOADING:false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //console.log(localStorage.getItem('userData'));
            if (this.state.Registered) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/sms_verification' });
            }

            if (localStorage.getItem('userData')) {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/login';
            var AppHeaderTitle = 'Register';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-0' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-0 mb-5 pr-3 pl-3' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmRegister', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'REGISTER', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement('input', { type: 'hidden', defaultValue: localStorage.getItem('SUBSCRIBER_ID'), className: 'form-control', name: 'webpushr_id', id: 'webpushr_id' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtusername' },
                                            'Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusername', id: 'txtusername', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your name.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtuseremail' },
                                            'Email Id'
                                        ),
                                        _react2.default.createElement('input', { type: 'email', className: 'square-inputbox form-control', name: 'txtuseremail', id: 'txtuseremail', required: true, pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$', autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your email id.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-20' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusercode' },
                                                'Code'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusercode', id: 'txtusercode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your area code.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-80' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusermobile' },
                                                'Mobile No'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusermobile', id: 'txtusermobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off' }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your 10 digit mobile no.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('div', { className: 'clear' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtpassword' },
                                            'Password'
                                        ),
                                        _react2.default.createElement('input', { type: 'password', className: 'square-inputbox form-control', name: 'txtpassword', id: 'txtpassword', minLength: '8', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Must contain at least 8 or more characters.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtpassword2' },
                                            'Re-enter Password'
                                        ),
                                        _react2.default.createElement('input', { type: 'password', className: 'square-inputbox form-control', name: 'txtpassword2', id: 'txtpassword2', minLength: '8', required: true, autoComplete: 'off' }),
                                        ' ',
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Must contain at least 8 or more characters.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1 terms-check' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper custom-control custom-checkbox mb-1' },
                                        _react2.default.createElement('input', { type: 'checkbox', className: 'custom-control-input', value: 'Y', id: 'chkterms', name: 'chkterms', required: true }),
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'custom-control-label', htmlFor: 'chkterms' },
                                            'I Agree to ',
                                            _react2.default.createElement(
                                                _reactRouterDom.Link,
                                                {
                                                    to: '#', onClick: function onClick() {
                                                        _this2.handleClickGetTerms();
                                                    } },
                                                'Terms & Conditions'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'valid-feedback' },
                                        '\xA0'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'invalid-feedback' },
                                        'Please select the checkbox.'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Get otp'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade modalbox', id: 'ModalTerms', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-header' },
                                        _react2.default.createElement(
                                            'h5',
                                            { className: 'modal-title' },
                                            'Terms & Conditions'
                                        ),
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: 'javascript:;', 'data-dismiss': 'modal' },
                                            'Close'
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body p-0' },
                                        _react2.default.createElement(
                                            'ol',
                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                'These terms of use (the "Terms of Use") govern your use of our website ',
                                                _react2.default.createElement(
                                                    _reactRouterDom.Link,
                                                    { to: 'https://www.donedelivery.in', target: '_blank' },
                                                    'www.donedelivery.in'
                                                ),
                                                ' (the "Website") and our "Done Delivery" application for mobile and handheld devices (the "App"). The Website and the App are jointly referred to as the "Platform". Please read these "Terms of Use" carefully before you use the services. If you do not agree to these Terms of Use, you may not use the services on the Platform, and we request you to uninstall the App. By installing, downloading or even merely using the Platform, you shall be contracting with Done Delivery / Palasha Enterprises and you signify your acceptance to these Terms of Use and other policies (including but not limited to the Cancellation & Refund Policy, Privacy Policy and Take Down Policy) as posted on the Platform from time to time, which takes effect on the date on which you download, install or use the Services, and create a legally binding arrangement to abide by the same.'
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                'The Platform is operated and owned by Done Delivery and its Holding Company Palasha Enterprises , and having its registered office at A/4, Ganesh Prasad, Altinho, Panjim, Goa, 403001. For the purpose of these Terms of Use, wherever the context so requires, "you" shall mean any natural or legal person who has agreed to become a buyer or customer on the Platform by providing Registration Data while registering on the Platform as a registered user using any computer systems. The terms Done Delivery / Palasha Enterprises, "we", "us" or "our" shall mean Done Delivery/ Palasha Enterprises.'
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                'Done Delivery/ Palasha Enterprises enables transactions between partner shops and buyers, dealing in prepared food and beverages ("Platform Services"). The buyers ("Buyer/s") can choose and place orders ("Orders") from variety of products listed and offered for sale by various neighbourhood partner shops including but not limited to the shops and eateries ("Partner shop/s"), on the Platform and Done Delivery/ Palasha Enterprises enables delivery of such orders at select localities of serviceable cities across Goa, India ("Delivery Services"). The Platform Services and Delivery Services are collectively referred to as "Services".'
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'AMENDMENTS'
                                                ),
                                                'These Terms of Use are subject to modifications at any time. We reserve the right to modify or change these Terms of Use and other policies at any time by posting changes on the Platform, and you shall be liable to update yourself of such changes, if any, by accessing the changes on the Platform. You shall, at all times, be responsible for regularly reviewing the Terms of Use and the other policies and note the changes made on the Platform. Your continued usage of the services after any change is posted constitutes your acceptance of the amended Terms of Use and other policies. As long as you comply with these Terms of Use, Done Delivery/ Palasha Enterprises grants you a personal, non-exclusive, non-transferable, limited privilege to access, enter, and use the Platform. By accepting these Terms of Use, you also accept and agree to be bound by the other terms and conditions and policies (including but not limited to Cancellation & Refund Policy, Privacy Policy and Notice and Take Down Policy) as may be posted on the Platform from time to time.'
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Use of Platform and Services'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'All commercial/contractual terms are offered by and agreed to between the Buyers and Partner shops alone. The commercial/contractual terms include without limitation, price, taxes, shipping costs, payment methods, payment terms, date, period and mode of delivery, warranties related to products and services and after sales services related to products and services. Done Delivery/ Palasha Enterprises does not have any control or does not determine or advise or in any way involve itself in the offering or acceptance of such commercial/contractual terms between the Buyers and Partner shops. Done Delivery/ Palasha Enterprises may, however, offer support services to Partner shops in respect to order fulfilment, payment collection, call centre, and other services, pursuant to independent contracts executed by it with the Partner shops.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises does not make any representation or warranty as to the item-specifics (such as legal title, creditworthiness, identity, etc.) of any of thePartner shops. You are advised to independently verify the bona fides of any particular Partner shop that you choose to deal with on the Platform and use your best judgment in that behalf. All Partner shop offers and third party offers are subject to respective party terms and conditions. Done Delivery/ Palasha Enterprises takes no responsibility for such offers."'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises neither make any representation or warranty as to specifics (such as quality, value, salability, etc.) of the products or services proposed to be sold or offered to be sold or purchased on the Platform nor does implicitly or explicitly support or endorse the sale or purchase of any products or services on the Platform. Done Delivery/ Palasha Enterprises accepts no liability for any errors or omissions, whether on behalf of itself or third parties.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises is not responsible for any non-performance or breach of any contract entered into between Buyers and Partner shops on the Platform. Done Delivery/ Palasha Enterprises cannot and does not guarantee that the concerned Buyers and/or Partner shops will perform any transaction concluded on the Platform. Done Delivery/ Palasha Enterprises is not responsible for unsatisfactory or non- performance of services or damages or delays as a result of products which are out of stock, unavailable or back ordered.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises is operating an online marketplace and assumes the role of facilitator, and does not at any point of time during any transaction between Buyer and Partner shop on the Platform come into or take possession of any of the products or services offered by Partner shop. At no time shall Done Delivery/ Palasha Enterprises hold any right, title or interest over the products nor shall Done Delivery/ Palasha Enterprises have any obligations or liabilities in respect of such contract entered into between Buyer and Partner shop."'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises is only providing a platform for communication and it is agreed that the contract for sale of any of the products or services shall be a strictly bipartite contract between the Partner shop and the Buyer. In case of complaints from the Buyer pertaining to food efficacy, quality, or any other such issues, Done Delivery/ Palasha Enterprises shall notify the same to Partner shop and shall also redirect the Buyer to the consumer call center of the Partner shop. The Partner shop shall be liable for redressing Buyer complaints. In the event you raise any complaint on any Partner shop accessed using our Platform, we shall assist you to the best of our abilities by providing relevant information to you,such as details of the Partner shop and the specific Order to which the complaint relates, to enable satisfactory resolution of the complaint.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Please note that there could be risks in dealing with underage persons or people acting under false pretence.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                'Use of the Website and Apps (Android and iOS)',
                                                _react2.default.createElement('br', null),
                                                'You agree, undertake and confirm that your use of Platform shall be strictly governed by the following binding principles:',
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not host, display, upload, download, modify, publish, transmit, update or share any information which:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'belongs to another person and which you do not have any right to;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'is grossly harmful, harassing, blasphemous, defamatory, obscene, pornographic, paedophilic, libellous, slanderous, criminally inciting or invasive of another\'s privacy, hateful, or racially, ethnically objectionable, disparaging, relating or encouraging money laundering or gambling, or otherwise unlawful in any manner whatsoever; or unlawfully threatening or unlawfully harassing including but not limited to ?indecent representation of women? within the meaning of the Indecent Representation of Women (Prohibition) Act, 1986;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'is misleading or misrepresentative in any way;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'is patently offensive to the online community, such as sexually explicit content, or content that promotes obscenity, paedophilia, racism, bigotry, hatred or physical harm of any kind against any group or individual;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'harasses or advocates harassment of another person;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'involves the transmission of ?junk mail?, ?chain letters?, or unsolicited mass mailing or ?spamming?;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'promotes illegal activities or conduct that is abusive, threatening, obscene, defamatory or libellous;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'infringes upon or violates any third party\'s rights [including, but not limited to, intellectual property rights, rights of privacy (including without limitation unauthorized disclosure of a person\'s name, email address, physical address or phone number) or rights of publicity];'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'promotes an illegal or unauthorized copy of another person\'s copyrighted work (see ?copyright complaint? below for instructions on how to lodge a complaint about uploaded copyrighted material), such as providing pirated computer programs or links to them, providing information to circumvent manufacture-installed copy-protect devices, or providing pirated music or links to pirated music files;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'contains restricted or password-only access pages, or hidden pages or images (those not linked to or from another accessible page);'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'provides material that exploits people in a sexual, violent or otherwise inappropriate manner or solicits personal information from anyone;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'provides instructional information about illegal activities such as making or buying illegal weapons, violating someone\'s privacy, or providing or creating computer viruses;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'contains video, photographs, or images of another person (with a minor or an adult);'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'tries to gain unauthorized access or exceeds the scope of authorized access to the Platform or to profiles, blogs, communities, account information, bulletins, friend request, or other areas of the Platform or solicits passwords or personal identifying information for commercial or unlawful purposes from other users;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'engages in commercial activities and/or sales without our prior written consent such as contests, sweepstakes, barter, advertising and pyramid schemes, or the buying or selling of products related to the Platform. Throughout these Terms of Use, Done Delivery/ Palasha Enterprises prior written consent means a communication coming from Done Delivery/ Palasha Enterprises\'s Legal Department, specifically in response to your request, and expressly addressing and allowing the activity or conduct for which you seek authorization;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'solicits gambling or engages in any gambling activity which is or could be construed as being illegal;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'interferes with another user\'s use and enjoyment of the Platform or any third party\'s user and enjoyment of similar services;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'refers to any website or URL that, in our sole discretion, contains material that is inappropriate for the Platform or any other website, contains content that would be prohibited or violates the letter or spirit of these Terms of Use;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'harm minors in any way;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'infringes any patent, trademark, copyright or other intellectual property rights or third party\'s trade secrets or rights of publicity or privacy or shall not be fraudulent or involve the sale of counterfeit or stolen products;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'violates any law for the time being in force;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'deceives or misleads the addressee/users about the origin of such messages or communicates any information which is grossly offensive or menacing in nature;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'impersonate another person;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer resource; or contains any trojan horses, worms, time bombs, cancelbots, easter eggs or other computer programming routines that may damage, detrimentally interfere with, diminish value of, surreptitiously intercept or expropriate any system, data or personal information;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign states, or public order or causes incitement to the commission of any criminal offence or prevents investigation of any offence or is insulting any other nation;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'is false, inaccurate or misleading;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'directly or indirectly, offers, attempts to offer, trades or attempts to trade in any item, the dealing of which is prohibited or restricted in any manner under the provisions of any applicable law, rule, regulation or guideline for the time being in force; or'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'creates liability for us or causes us to lose (in whole or in part) the services of our internet service provider or other suppliers.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not use any ?deep-link?, ?page-scrape?, ?robot?, ?spider? or other automatic device, program, algorithm or methodology, or any similar or equivalent manual process, to access, acquire, copy or monitor any portion of the Platform or any Content, or in any way reproduce or circumvent the navigational structure or presentation of the Platform or any Content, to obtain or attempt to obtain any materials, documents or information through any means not purposely made available through the Platform. We reserve our right to prohibit any such activity.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not attempt to gain unauthorized access to any portion or feature of the Platform, or any other systems or networks connected to the Platform or to any server, computer, network, or to any of the services offered on or through the Platform, by hacking, ?password mining? or any other illegitimate means.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not probe, scan or test the vulnerability of the Platform or any network connected to the Platform nor breach the security or authentication measures on the Platform or any network connected to the Platform. You may not reverse look-up, trace or seek to trace any information on any other user of or visitor to Platform, or any other Buyer, including any account on the Platform not owned by you, to its source, or exploit the Platform or any service or information made available or offered by or through the Platform, in any way where the purpose is to reveal any information, including but not limited to personal identification or information, other than your own information, as provided for by the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not make any negative, denigrating or defamatory statement(s) or comment(s) about us or the brand name or domain name used by us including the name Done Delivery/ Palasha Enterprises, or otherwise engage in any conduct or action that might tarnish the image or reputation, of Done Delivery/ Palasha Enterprises or Partner shop on platform or otherwise tarnish or dilute any Done Delivery/ Palasha Enterprises trade or service marks, trade name and/or goodwill associated with such trade or service marks, as may be owned or used by us. You agree that you will not take any action that imposes an unreasonable or disproportionately large load on the infrastructure of the Platform or Done Delivery/ Palasha Enterprises systems or networks, or any systems or networks connected to Done Delivery/ Palasha Enterprises.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree not to use any device, software or routine to interfere or attempt to interfere with the proper working of the Platform or any transaction being conducted on the Platform, or with any other person\'s use of the Platform. vii. You may not forge headers or otherwise manipulate identifiers in order to disguise the origin of any message or transmittal you send to us on or through the Platform or any service offered on or through the Platform. You may not pretend that you are, or that you represent, someone else, or impersonate any other individual or entity.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You may not use the Platform or any content on the Platform for any purpose that is unlawful or prohibited by these Terms of Use, or to solicit the  performance of any illegal activity or other activity that infringes the rights of Done Delivery/ Palasha Enterprises and/or others.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        ' You shall at all times ensure full compliance with the applicable provisions, as amended from time to time, of',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'the Information Technology Act, 2000 and the rules thereunder; '
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'all applicable domestic laws, rules and regulations (including the provisions of any applicable exchange control laws or regulations in force); and'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'international laws, foreign exchange laws, statutes, ordinances and regulations (including, but not limited to sales tax/VAT, income tax, octroi, service tax, central excise, custom duty, local levies) regarding your use of our service and your listing, purchase, solicitation of offers to purchase, and sale of products or services. You shall not engage in any transaction in an item or service, which is prohibited by the provisions of any applicable law including exchange control laws or regulations for the time being in force.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'In order to allow us to use the information supplied by you, without violating your rights or any laws, you agree to grant us a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sub-licensable (through multiple tiers) right to exercise the copyright, publicity, database rights or any other rights you have in your Information, in any media now known or not currently known, with respect to your Information. We will only use your information in accordance with these Terms of Use and Privacy Policy applicable to use of the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'From time to time, you shall be responsible for providing information relating to the products or services proposed to be sold by you. In this connection, you undertake that all such information shall be accurate in all respects. You shall not exaggerate or overemphasize the attributes of such products or services so as to mislead other users in any manner.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall not engage in advertising to, or solicitation of, other users of the Platform to buy or sell any products or services, including, but not limited to, products or services related to that being displayed on the Platform or related to us. You may not transmit any chain letters or unsolicited commercial or junk email to other users via the Platform. It shall be a violation of these Terms of Use to use any information obtained from the Platform in order to harass, abuse, or harm another person, or in order to contact, advertise to, solicit, or sell to another person other than us without our prior explicit consent. In order to protect our users from such advertising or solicitation, we reserve the right to restrict the number of messages or emails which a user may send to other users in any 24-hour period which we  deem appropriate in its sole discretion. You understand that we have the right at all times to disclose any information (including the identity of the persons providing information or materials on the Platform) as necessary to satisfy any law, regulation or valid governmental request. This may include, without limitation, disclosure of the information in connection with investigation of alleged illegal activity or solicitation of illegal activity or in response to a lawful court order or subpoena. In addition, We can (and you hereby expressly authorize us to) disclose any information about you to law enforcement or other government officials, as we, in our sole discretion, believe necessary or appropriate in connection with the investigation and/or resolution of possible crimes, especially those that may involve personal injury.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We reserve the right, but has no obligation, to monitor the materials posted on the Platform. Done Delivery/ Palasha Enterprises shall have the right to remove or edit any content that in its sole discretion violates, or is alleged to violate, any applicable law or either the spirit or letter of these Terms of Use. Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE PLATFORM AND IN YOUR PRIVATE MESSAGES. Please be advised that such Content posted does not necessarily reflect Done Delivery/ Palasha Enterprises\'s views. In no event shall Done Delivery/ Palasha Enterprises assume or have any responsibility or liability for any Content posted or for any claims, damages or losses resulting from use of Content and/or appearance of Content on the Platform. You hereby represent and warrant that you have all necessary rights in and to all Content which you provide and all information it contains and that such Content shall not infringe any proprietary or other rights of third parties or contain any libellous, tortious, or otherwise unlawful information.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Your correspondence or business dealings with, or participation in promotions of, advertisers found on or through the Platform, including payment and delivery of related products or services, and any other terms, conditions, warranties or representations associated with such dealings, are solely between you and such advertiser. We shall not be responsible or liable for any loss or damage of any sort incurred as the result of any such dealings or as the result of the presence of such advertisers on the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'It is possible that other users (including unauthorized users or ?hackers\') may post or transmit offensive or obscene materials on the Platform and that you may be involuntarily exposed to such offensive and obscene materials. It also is possible for others to obtain personal information about you due to your use of the Platform, and that the recipient may use such information to harass or injure you. We do not approve of such unauthorized uses, but by using the Platform You acknowledge and agree that we are not responsible for the use of any personal information that you publicly disclose or share with others on the Platform. Please carefully select the type of information that you publicly disclose or share with others on the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises shall have all the rights to take necessary action and claim damages that may occur due to your involvement/participation in any way on your own or through group/s of people, intentionally or unintentionally in DoS/DDoS (Distributed Denial of Services), hacking, pen testing attempts without our prior consent or a mutual legal agreement.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Account Registration or use of the Platform'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You may access the Platform by registering to create an account (?Done Delivery/ Palasha Enterprises Account?) and become a member (?Membership?); or you can also register to join by logging into your account with certain third party social networking sites (?SNS?) (including, but not limited to, Facebook); each such account, a ?Third Party Account?, via our Platform, as described below. The Membership is limited for the purpose and are subject to the terms, and strictly not transferable. As part of the functionality of the Platform services, you may link your Done Delivery/ Palasha Enterprises Account with Third Party Accounts, by either:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'providing your Third Party Account login information to us through the Platform; or'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'allowing us to access your Third Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third Party Account.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You represent that you are entitled to disclose your Third Party Account login information to us and/or grant us access to your Third Party Account (including, but not limited to, for use for the purposes described herein), without breach by you of any of the terms and conditions that govern your use of the applicable Third Party Account and without obligating us to pay any fees or making us subject to any usage limitations imposed by such third party service providers.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'By granting us access to any Third Party Accounts, you understand that we will access, make available and store (if applicable) any content or information that you have provided to and stored in your Third Party Account (?SNS Content?) so that it is available on and through the Platform via your Done Delivery/ Palasha Enterprises Account.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Unless otherwise specified in these Terms of Use, all SNS Content, if any, will be considered to be your content for all purposes of these Terms of Use.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Depending on the Third Party Accounts, you choose, and subject to the privacy settings that you have set in such Third Party Accounts, personally identifiable information that you post to your Third Party Accounts will be available on and through your Done Delivery/ Palasha Enterprises Account on the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Please note that if a Third Party Account or associated service becomes unavailable or our access to such Third Party Account is terminated by the third party service provider, then SNS Content will no longer be available on and through the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We will create your Done Delivery/ Palasha Enterprises Account for your use of the Platform services based upon the personal information you provide to us or that we obtain via an SNS, as described above. You may only have one Done Delivery/ Palasha Enterprises Account and not permitted to create multiple accounts. If found, you having multiple accounts, Done Delivery/ Palasha Enterprises reserves right to suspend such multiple account without being liable for any compensation.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree to provide accurate, current and complete information during the registration process and to update such information to keep it accurate, current and complete.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We reserve the right to suspend or terminate your Done Delivery/ Palasha Enterprises Account and your access to the Services (i) if any information provided during the registration process or thereafter proves to be inaccurate, not current or incomplete; (ii) if it is believed that your actions may cause legal liability for you, other users or us; and/or (iii) if you are found to be non- compliant with the Terms of Use.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You are responsible for safeguarding your password. You agree that you will not disclose your password to any third party and that you will take sole responsibility for any activities or actions under your Done Delivery Account, whether or not you have authorized such activities or actions. You will immediately notify us of any unauthorized use of your Done Delivery Account.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Goods and services purchased from the Platform are intended for your personal use and you represent that the same are not for resale or you are not acting as an agent for other parties.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Bookings and Financial Terms'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The Platform allows you to place food order bookings and we will, subject to the terms and conditions set out herein, enable delivery of such order to you.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises do not own, sell, resell on its own and/or do not control the Partner shops or the related services provided in connection thereof. You understand that any order that you place shall be subject to the terms and conditions set out in these Terms of Use including, but not limited to, product availability and delivery location serviceability.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'As a general rule, all food orders placed on the Platform are treated as confirmed.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'However, upon your successful completion of booking an order, we may call you on the telephone or mobile number provided to confirm the details of the order, the price to be paid and the estimated delivery time. For this purpose, you will be required to share certain information with us, including but not limited to (i) your first and last name (ii) mobile number; and (iii) email address. It shall be your sole responsibility to bring any incorrect details to our attention.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'In addition to the foregoing, we may also contact you by phone and / or email to inform and confirm any change in the order, due to availability or unavailability or change in price of the order as informed by the Partner shop. Please note change or confirmation of the order shall be treated as final. It is clarified that Done Delivery/ Palasha Enterprises reserves the right to not to process your order in the event you are unavailable on the phone at the time we call you for confirming the order and such event the provisions of the cancellation and refund policy below shall be applicable.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'All payments made against the purchases/services on the Platform by you shall be compulsorily in Indian Rupees acceptable in the Republic of India. The Platform will not facilitate transactions with respect to any other form of currency with respect to the purchases made on Platform. You can pay by',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'credit card or debit card or net banking;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'any other RBI approved payment method at the time of booking an order; or'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'credit or debit card or cash at the time of delivery. You understand, accept and agree that the payment facility provided by Done Delivery/ Palasha Enterprises is neither a banking nor financial service but is merely a facilitator providing an electronic, automated online electronic payment, receiving payment on delivery, collection and remittance facility for the transactions on the Platform using the existing authorized banking infrastructure and credit card payment gateway networks. Further, by providing payment facility, Done Delivery/ Palasha Enterprises is neither acting as trustees nor acting in a fiduciary capacity with respect to the transaction or the transaction price.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You acknowledge and agree that we act as the Partner shop\'s payment agent for the limited purpose of accepting payments from you on behalf of the Partner shop. Upon your payment of amounts to us, which are due to the Partner shop, your payment obligation to the Partner shop for such amounts is completed, and we are responsible for remitting such amounts, to the Partner shop. You shall not, under any circumstances whatsoever, make any payment directly to the Partner shop for Order bookings made using the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree to pay us for the total amount for the order placed by you on the Platform. We will collect the total amount in accordance with the terms and conditions of these Terms of Use and the pricing terms set forth in the applicable menu listing for the particular Partner shop. Please note that we cannot control any amount that may be charged to you by your bank related to our collection of the total amount, and we disclaim all liability in this regard.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'In connection with your order, you will be asked to provide customary billing information such as name, billing address and credit card information either to us or our third party payment processor. You agree to pay us for the order placed by you on the Platform, in accordance with these Terms, using of the methods described under clause VII (6) above. You hereby authorize the collection of such amounts by charging the credit card provided as part of requesting the booking, either directly by us or indirectly, via a third party online payment processor or by one of the payment methods described on the Platform. If you are directed to our third-party payment processor, you may be subject to terms and conditions governing use of that third party\'s service and that third party\'s personal information collection practices. Please review such terms and conditions and privacy policy before using the Platform services. Once your confirmed booking transaction is complete you will receive a confirmation email summarizing your confirmed booking.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The final tax bill will be issued by the Partner shop to the Buyer along with the order and Done Delivery/ Palasha Enterprises is merely collecting the payment on behalf of such Partner shop. All applicable taxes and levies, the rates thereof and the manner of applicability of such taxes on the bill are being charged and determined by the Partner shop. Done Delivery/ Palasha Enterprises holds no responsibility for the legal correctness/validity of the levy of such taxes. The sole responsibility for any legal issue arising on the taxes shall reside with the Partner shop.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The prices reflected on the Platform are determined solely by the Partner shop and are listed based on Partner shop\'s information. Very rarely, prices may change at the time of placing order due to Partner shop changing the menu price without due intimation and such change of price are at the sole discretion of the Partner shop attributing to various factors beyond control.',
                                                        _react2.default.createElement('br', null),
                                                        'Disclaimer: Prices on any product(s) as is reflected on the Platform may due to some technical issue, typographical error or product information supplied by Partner shop be incorrectly reflected and in such an event Partner shop may cancel such your order(s).'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The Partner shop shall be solely responsible for any warrantee/guarantee of the food products sold to the Buyers and in no event shall be the responsibility of Done Delivery/ Palasha Enterprises'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The transaction is bilateral between the Partner shop and Buyer and therefore, Done Delivery/ Palasha Enterprises is not liable to charge or deposit any taxes applicable on such transaction.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Cancellations and Refunds'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        _react2.default.createElement(
                                                            'h6',
                                                            null,
                                                            'Cancellation'
                                                        ),
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'As a general rule you shall not be entitled to cancel your order once you have received confirmation of the same. If you cancel your order after it has been confirmed, Done Delivery/ Palasha Enterprises shall have a right to charge you cancellation fee of a minimum INR 100/- upto the order value, with a right to either not to refund the order value or recover from your subsequent order, the complete/ deficit cancellation fee, as applicable, to compensate our shop and delivery partners. Done Delivery/ Palasha Enterprises shall also have right to charge you cancellation fee for the orders cancelled by Done Delivery/ Palasha Enterprises for the reasons specified under clause 1(iii) of this cancellation and refunds policy. In case of cancellations for the reasons attributable to Done Delivery/ Palasha Enterprises or its shop and delivery partners, Done Delivery/ Palasha Enterprises shall not charge you any cancellation fee.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'However, in the unlikely event of an item on your order being unavailable, we will contact you on the phone number provided to us at the time of placing the order and inform you of such unavailability. In such an event you will be entitled to cancel the entire order and shall be entitled to a refund in accordance with our refund policy.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'We reserve the sole right to cancel your order in the following circumstance:',
                                                                _react2.default.createElement(
                                                                    'ol',
                                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'in the event of the designated address falls outside the delivery zone offered by us;'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'failure to contact you by phone or email at the time of confirming the order booking;'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'failure to deliver your order due to lack of information, direction or authorization from you at the time of delivery; or'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'unavailability of all the items ordered by you at the time of booking the order; or'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'unavailability of all the items ordered by you at the time of booking the order; or'
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        _react2.default.createElement(
                                                            'h6',
                                                            null,
                                                            'Refunds'
                                                        ),
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You shall be entitled to a refund only if you pre-pay for your order at the time of placing your order on the Platform and only in the event of any of the following circumstances:',
                                                                _react2.default.createElement(
                                                                    'ol',
                                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'your order packaging has been tampered or damaged at the time of delivery;'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'us cancelling your order due to',
                                                                        _react2.default.createElement(
                                                                            'ol',
                                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                                            _react2.default.createElement(
                                                                                'li',
                                                                                { className: 'mb-1' },
                                                                                'your delivery location following outside our designated delivery zones;'
                                                                            ),
                                                                            _react2.default.createElement(
                                                                                'li',
                                                                                { className: 'mb-1' },
                                                                                'failure to contact you by phone or email at the time of confirming the order booking; or'
                                                                            ),
                                                                            _react2.default.createElement(
                                                                                'li',
                                                                                { className: 'mb-1' },
                                                                                'failure to contact you by phone or email at the time of confirming the order booking; or'
                                                                            )
                                                                        )
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'you cancelling the order at the time of confirmation due to unavailability of the items you ordered for at the time of booking.'
                                                                    )
                                                                )
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'Our decision on refunds shall be at our sole discretion and shall be final and binding.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'All refund amounts shall be credited to your account within 3-4 business days in accordance with the terms that may be stipulated by the bank which has issued the credit / debit card.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        ' In case of payment at the time of delivery, you will not be required to pay for:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'orders where the packaging has been tampered or damaged by us;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'wrong order being delivered; or'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'items missing from your order at the time of delivery.'
                                                            )
                                                        )
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Terms of service'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree and acknowledge that we shall not be responsible for:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'The services or goods provided by the Partner shop including, but not limited, serving of food orders suiting your requirements and needs;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'The Partner shop\'s services or goods not being up to your expectations or leading to any loss, harm or damage to you;'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'The availability or unavailability of certain items on the menu; or'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'The Partner shop serving the incorrect orders.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The details of the menu and price list available on the Platform are based on the information provided by the Partner shops and we shall not be responsible for any change or cancellation or unavailability.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You may not be able to avail our Services if your delivery location is outside our current scope of Service. We will keep you informed of the same at the time of confirming your order booking.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You understand that delivery periods quoted to you at the time of confirming the order is an approximate estimate and may vary. We will not be responsible for any delay in the delivery of your order.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You order will be only delivered to the address designated by you at the time of placing the order on the Platform. We reserve the right to cancel the order, in our sole discretion, in the event of any change to the place of delivery and you shall not be entitled to any refund for the same. Delivery in the event of change of the delivery location shall be at our sole discretion.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall undertake to provide adequate directions, information and authorisations to accept delivery. In the event of any failure to accept delivery, failure to deliver within the estimated time due to your failure to provide appropriate instructions, or authorizations, then such goods shall be deemed to have been delivered to you and all risk and responsibility in relation to such goods shall pass to you and you shall not be entitled to any refund for the same. Our decision in relation to this shall be final and binding.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You understand that our liability ends once your order has been delivered to you.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        ' Services provided:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You confirm that we shall not be responsible for any deficiency in payment of consideration payable towards the goods purchased from the Services.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'Each purchase on the Service shall contain necessary instructions to redeem the Services. The terms of the Services shall be governed by these Terms of Use and any other terms as set out in such document confirm such sale of Service. You shall not be entitled to receive any credit, refund or cash back for the value of the goods sold if you fail to redeem the goods within the expiry date or in accordance with the terms therein.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You agree and acknowledge that neither us nor the Partner shop shall be liable in the event of you failing to adhere to the Terms of Use.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You might be required to provide your credit or debit card details to the approved payment gateways while making the payment. In this regard, you agree to provide correct and accurate credit/ debit card details to the approved payment gateways for availing the Services. You shall not use the credit/ debit card which is not lawfully owned by you, i.e. in any transaction, you must use your own credit/ debit card. The information provided by you will not be utilized or shared with any third party unless required in relation to fraud verifications or by law, regulation or court order. You will be solely responsible for the security and confidentiality of your credit/ debit card details. We expressly disclaim all liabilities that may arise as a consequence of any unauthorized use of your credit/ debit card.'
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We do not offer any refunds against goods already purchased from the Platform unless an error that is directly attributable to us has occurred during the purchase of such product or services.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We constantly strive to provide you with accurate information on the Platform. However, in the event of an error, we may, in our sole discretion, contact you with further instructions.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'If you use the Platform, you do the same at your own risk.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree that the Services shall be provided by us only during the working hours of the relevant Partner shops.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'No Endorsement'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We do not endorse any Partner shop. In addition, although these Terms of Use require you to provide accurate information, we do not attempt to confirm, and do not  confirm if it is purported identity. We will not be responsible for any damage or harm resulting from your interactions with other Members.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'By using the Services, you agree that any legal remedy or liability that you seek to obtain for actions or omissions of other Members or other third parties will be limited to a claim against the particular Members or other third parties who caused you harm and you agree not to attempt to impose liability on, or seek any legal remedy from us with respect to such actions or omissions.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'General terms of use'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Persons who are ?incompetent to contract? within the meaning of the Indian Contract Act, 1872 including minors, un-discharged insolvents etc. are not eligible to use the Platform. Only individuals who are 18 years of age or older may use the Platform and avail Services. If you are under 18 years of age and you wish to download, install, access or use the Platform, your parents or legal guardian must acknowledge and agree to the Terms of Use and Privacy Policy. Should your parents or legal guardian fail to agree or acknowledge the Terms of Use and other policies, you shall immediately discontinue its use. Done Delivery/ Palasha Enterprises reserves the right to terminate your Membership and / or deny access to the platform if it is brought Done Delivery/ Palasha Enterprises notice that you are under the age of 18 years.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'If you choose to use the Platform, it shall be your responsibility to treat your user identification code, password and any other piece of information that we may provide, as part of our security procedures, as confidential and not disclose the same to any person or entity other than us. We shall at times and at our sole discretion reserve the right to disable any user identification code or password if you have failed to comply with any of the provisions of these Terms of Use.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'As we are providing services in the select cities in Goa, India, we have complied with applicable laws of India in making the Platform and its content available to you. In the event the Platform is accessed from outside India or outside our delivery zones, it shall be entirely at your risk. We make no representation that the Platform and its contents are available or otherwise suitable for use outside select cities. If you choose to access or use the Platform from or in locations outside select cities, you do so on your own and shall be responsible for the consequences and ensuring compliance of applicable laws, regulations, byelaws, licenses, registrations, permits, authorisations, rules and guidelines.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You shall at all times be responsible for the use of the Services through your computer or mobile device and for bringing these Terms of Use and other policies to the attention of all such persons accessing the Platform on your computer or mobile device.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You understand and agree that the use of the Services does not include the provision of a computer or mobile device or other necessary equipment to access it. You also understand and acknowledge that the use of the Platform requires internet connectivity and telecommunication links. You shall bear the costs incurred to access and use the Platform and avail the Services, and we shall not, under any circumstances whatsoever, be responsible or liable for such costs.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You agree and grant permission to Done Delivery/ Palasha Enterprises to receive promotional SMS and e-mails from Done Delivery/ Palasha Enterprises or allied partners. In case you wish to opt out of receiving promotional SMS or email please send a mail to?',
                                                        _react2.default.createElement(
                                                            _reactRouterDom.Link,
                                                            { to: 'mailto:donotdisturb@donedelivery.in', target: '_blank' },
                                                            'donotdisturb@donedelivery.in'
                                                        ),
                                                        '.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'By using the Platform you represent and warrant that:',
                                                        _react2.default.createElement(
                                                            'ol',
                                                            { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'All registration information you submit is truthful, lawful and accurate and that you agree to maintain the accuracy of such information.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'Your use of the Platform shall be solely for your personal use and you shall not authorize others to use your account, including your profile or email address and that you are solely responsible for all content published or displayed through your account, including any email messages, and your interactions with other users and you shall abide by all applicable local, state, national and foreign laws, treaties and regulations, including those related to data privacy, international communications and the transmission of technical or personal data.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not submit, post, upload, distribute, or otherwise make available or transmit any content that: (a) is defamatory, abusive, harassing, insulting, threatening, or that could be deemed to be stalking or constitute an invasion of a right of privacy of another person; (b) is bigoted, hateful, or racially or otherwise offensive; (c) is violent, vulgar, obscene, pornographic or otherwise sexually explicit; (d) is illegal or encourages or advocates illegal activity or the discussion of illegal activities with the intent to commit them.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'All necessary licenses, consents, permissions and rights are owned by you and there is no need for any payment or permission or authorization required from any other party or entity to use, distribute or otherwise exploit in all manners permitted by these Terms of Use and Privacy Policy, all trademarks, copyrights, patents, trade secrets, privacy and publicity rights and / or other proprietary rights contained in any content that you submit, post, upload, distribute or otherwise transmit or make available.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not (a) use any services provided by the Platform for commercial purposes of any kind, or (b) advertise or sell any products, services or otherwise (whether or not for profit), or solicit others (including, without limitation, solicitations for contributions or donations) or use any public forum for commercial purposes of any kind. In the event you want to advertise your product or service contact ',
                                                                _react2.default.createElement(
                                                                    _reactRouterDom.Link,
                                                                    { to: 'mailto:partner@donedelivery.in', target: '_blank' },
                                                                    'partner@donedelivery.in'
                                                                ),
                                                                '.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not use the Platform in any way that is unlawful, or harms us or any other person or entity, as determined in our sole discretion. vii. You will not post, submit, upload, distribute, or otherwise transmit or make available any software or other computer files that contain a virus or other harmful component, or otherwise impair or damage the Platform or any connected network, or otherwise interfere with any person or entity\'s use or enjoyment of the Platform.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not use another person\'s username, password or other account information, or another person\'s name, likeness, voice, image or photograph or impersonate any person or entity or misrepresent your identity or affiliation with any person or entity.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not engage in any form of antisocial, disrupting, or destructive acts, including ?flaming,? ?spamming,? ?flooding,? ?trolling,? and ?griefing? as those terms are commonly understood and used on the Internet.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not delete or modify any content of the Platform, including but not limited to, legal notices, disclaimers or proprietary notices such as copyright or trademark symbols, logos, that you do not own or have express permission to modify.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                'You will not post or contribute any information or data that may be obscene, indecent, pornographic, vulgar, profane, racist, sexist, discriminatory, offensive, derogatory, harmful, harassing, threatening, embarrassing, malicious, abusive, hateful, menacing, defamatory, untrue or political or contrary to our interest.'
                                                            ),
                                                            _react2.default.createElement(
                                                                'li',
                                                                { className: 'mb-1' },
                                                                ' You shall not access the Platform without authority or use the Platform in a manner that damages, interferes or disrupts:',
                                                                _react2.default.createElement(
                                                                    'ol',
                                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'any part of the Platform or the Platform software; or'
                                                                    ),
                                                                    _react2.default.createElement(
                                                                        'li',
                                                                        { className: 'mb-1' },
                                                                        'any equipment or any network on which the Platform is stored or any equipment of any third party'
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You release and fully indemnify Done Delivery/ Palasha Enterprises and/or any of its officers and representatives from any cost, damage, liability or other consequence of any of the actions of the Users of the Platform and specifically waive any claims that you may have in this behalf under any applicable laws of India. Notwithstanding its reasonable efforts in that behalf, Done Delivery/ Palasha Enterprises cannot take responsibility or control the information provided by other Users which is made available on the Platform. You may find other User\'s information to be offensive, harmful, inconsistent, inaccurate, or deceptive. Please use caution and practice safe trading when using the Platform.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Access to the Platform, Accuracy and security'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We endeavour to make the Platform available to during Partner shop working hours. However, we do not represent that access to the Platform will be uninterrupted, timely, error free, free of viruses or other harmful components or that such defects will be corrected.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We do not warrant that the Platform will be compatible with all hardware and software which you may use. We shall not be liable for damage to, or viruses or other code that may affect, any equipment (including but not limited to your mobile device), software, data or other property as a result of your download, installation, access to or use of the Platform or your obtaining any material from, or as a result of using, the Platform. We shall also not be liable for the actions of third parties.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We do not represent or warranty that the information available on the Platform will be correct, accurate or otherwise reliable.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We reserve the right to suspend or withdraw access to the Platform to you personally, or to all users temporarily or permanently at any time without notice. We may any time at our sole discretion reinstate suspended users. A suspended User may not register or attempt to register with us or use the Platform in any manner whatsoever until such time that such user is reinstated by us.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Relationship with operators if the Platform is accessed on mobile devices'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'In the event the Platform is accessed on a mobile device, it is not associated, affiliated, sponsored, endorsed or in any way linked to any platform operator, including, without limitation, Apple, Google, Android or RIM Blackberry (each being an ?Operator?).'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Your download, installation, access to or use of the Platform is also bound by the terms and conditions of the Operator.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You and we acknowledge that these Terms of Use are concluded between you and us only, and not with an Operator, and we, not those Operators, are solely responsible for the Platform and the content thereof to the extent specified in these Terms of Use.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'The license granted to you for the Platform is limited to a non-transferable license to use the Platform on a mobile device that you own or control and as permitted by these Terms of Use.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We are solely responsible for providing any maintenance and support services with respect to the Platform as required under applicable law. You and we acknowledge that an Operator has no obligation whatsoever to furnish any maintenance and support services with respect to the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You and we acknowledge that we, not the relevant Operator, are responsible for addressing any claims of you or any third party relating to the Platform or your possession and/or use of the Platform, including, but not limited to: (i) any claim that the Platform fails to conform to any applicable legal or regulatory requirement; and (ii) claims arising under consumer protection or similar legislation.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You and we acknowledge that, in the event of any third party claim that the Platform or your possession and use of the Platform infringes that third party\'s intellectual property rights, we, not the relevant Operator, will be solely responsible for the investigation, defence, settlement and discharge of any such intellectual property infringement claim.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You must comply with any applicable third party terms of agreement when using the Platform (e.g. you must ensure that your use of the Platform is not in violation of your mobile device agreement or any wireless data service agreement).'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You and we acknowledge and agree that the relevant Operator, and that Operator\'s subsidiaries, are third party beneficiaries of these Terms of Use, and that, upon your acceptance of these Terms of Use, that Operator will have the right (and will be deemed to have accepted the right) to enforce these Terms of Use against you as a third party beneficiary thereof.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Disclaimers'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'THE PLATFORM MAY BE UNDER CONSTANT UPGRADES, AND SOME FUNCTIONS AND FEATURES MAY NOT BE FULLY OPERATIONAL.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'DUE TO THE VAGARIES THAT CAN OCCUR IN THE ELECTRONIC DISTRIBUTION OF INFORMATION AND DUE TO THE LIMITATIONS INHERENT IN PROVIDING INFORMATION OBTAINED FROM MULTIPLE SOURCES, THERE MAY BE DELAYS, OMISSIONS, OR INACCURACIES IN THE CONTENT PROVIDED ON THE PLATFORM OR DELAY OR ERRORS IN FUNCTIONALITY OF THE PLATFORM. AS A RESULT, WE DO NOT REPRESENT THAT THE INFORMATION POSTED IS CORRECT IN EVERY CASE.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'WE EXPRESSLY DISCLAIM ALL LIABILITIES THAT MAY ARISE AS A CONSEQUENCE OF ANY UNAUTHORIZED USE OF CREDIT/ DEBIT CARDS.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'YOU ACKNOWLEDGE THAT THIRD PARTY SERVICES ARE AVAILABLE ON THE PLATFORM. WE MAY HAVE FORMED PARTNERSHIPS OR ALLIANCES WITH SOME OF THESE THIRD PARTIES FROM TIME TO TIME IN ORDER TO FACILITATE THE PROVISION OF CERTAIN SERVICES TO YOU. HOWEVER, YOU ACKNOWLEDGE AND AGREE THAT AT NO TIME ARE WE MAKING ANY REPRESENTATION OR WARRANTY REGARDING ANY THIRD PARTY\'S SERVICES NOR WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY CONSEQUENCES OR CLAIMS ARISING FROM OR IN CONNECTION WITH SUCH THIRD PARTY INCLUDING, AND NOT LIMITED TO, ANY LIABILITY OR RESPONSIBILITY FOR, DEATH, INJURY OR IMPAIRMENT EXPERIENCED BY YOU OR ANY THIRD PARTY. YOU HEREBY DISCLAIM AND WAIVE ANY RIGHTS AND CLAIMS YOU MAY HAVE AGAINST US WITH RESPECT TO THIRD PARTY\'S / PARTNER shopS SERVICES.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'DONE DELIVERY / PALASHA ENTERPRISES DISCLAIMS AND ALL LIABILITY THAT MAY ARISE DUE TO ANY VIOLATION OF THE FOOD SAFETY AND STANDARDS ACT, 2006 AND APPLICABLE RULES AND REGULATIONS MADE THEREUNDER AND SUCH LIABILITY SHALL BE ATTRIBUTABLE TO THE PARTNER shop.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'WHILE THE MATERIALS PROVIDED ON THE PLATFORM WERE PREPARED TO PROVIDE ACCURATE INFORMATION REGARDING THE SUBJECT DISCUSSED, THE INFORMATION CONTAINED IN THESE MATERIALS IS BEING MADE AVAILABLE WITH THE UNDERSTANDING THAT WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES WHATSOEVER, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN. FURTHER, WE DO NOT, IN ANY WAY, ENDORSE ANY SERVICE OFFERED OR DESCRIBED HEREIN. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN IN RELIANCE ON SUCH INFORMATION.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'THE INFORMATION PROVIDED HEREUNDER IS PROVIDED ?AS IS?. WE AND / OR OUR EMPLOYEES MAKE NO WARRANTY OR REPRESENTATION REGARDING THE TIMELINESS, CONTENT, SEQUENCE, ACCURACY, EFFECTIVENESS OR COMPLETENESS OF ANY INFORMATION OR DATA FURNISHED HEREUNDER OR THAT THE INFORMATION OR DATA PROVIDED HEREUNDER MAY BE RELIED UPON. MULTIPLE RESPONSES MAY USUALLY BE MADE AVAILABLE FROM DIFFERENT SOURCES AND IT IS LEFT TO THE JUDGEMENT OF USERS BASED ON THEIR SPECIFIC CIRCUMSTANCES TO USE, ADAPT, MODIFY OR ALTER SUGGESTIONS OR USE THEM IN CONJUNCTION WITH ANY OTHER SOURCES THEY MAY HAVE, THEREBY ABSOLVING US AS WELL AS OUR CONSULTANTS, BUSINESS ASSOCIATES, AFFILIATES, BUSINESS PARTNERS AND EMPLOYEES FROM ANY KIND OF PROFESSIONAL LIABILITY.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'WE SHALL NOT BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSSES OR INJURY ARISING OUT OF OR RELATING TO THE INFORMATION PROVIDED ON THE PLATFORM. IN NO EVENT WILL WE OR OUR EMPLOYEES, AFFILIATES, AUTHORS OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN BY YOUR RELIANCE ON THE CONTENT CONTAINED HEREIN.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'IN NO EVENT WILL WE BE LIABLE FOR ANY DAMAGES (INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, DAMAGES ARISING FROM PERSONAL INJURY/WRONGFUL DEATH, AND DAMAGES RESULTING FROM LOST PROFITS, LOST DATA OR BUSINESS INTERRUPTION), RESULTING FROM ANY SERVICES PROVIDED BY ANY THIRD PARTY OR PARTNER shop ACCESSED THROUGH THE PLATFORM, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY AND WHETHER OR NOT WE ARE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Intellectual property?'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We are either the owner of intellectual property rights or have the non-exclusive, worldwide, perpetual, irrevocable, royalty free, sub-licensable (through multiple tiers) right to exercise the intellectual property, in the Platform, and in the material published on  it.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You may print off one copy, and may download extracts, of any page(s) from the Platform for your personal reference and you may draw the attention of others within your organisation to material available on the Platform.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You must not use any part of the materials on the Platform for commercial purposes without obtaining a licence to do so from us or our licensors.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'If you print off, copy or download any part of the Platform in breach of these Terms of Use, your right to use the Platform will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Treatment of information provided by you'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We process information provided by you to us in accordance with our Privacy Policy.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Third Party Content'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'We cannot and will not assure that other users are or will be complying with the foregoing rules or any other provisions of these Terms of Use, and, as between you and us, you hereby assume all risk of harm or injury resulting from any such lack of compliance.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'You acknowledge that when you access a link that leaves the Platform, the site you will enter into is not controlled by us and different terms of use and privacy policy may apply. By assessing links to other sites, you acknowledge that we are not responsible for those sites. We reserve the right to disable links to and / or from third-party sites to the Platform, although we are under no obligation to do so.'
                                                    )
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Severability'
                                                ),
                                                'If any of these Terms of Use should be determined to be illegal, invalid or otherwise unenforceable by reason of the laws of any state or country in which these Terms of Use are intended to be effective, then to the extent and within the jurisdiction where that term is illegal, invalid or unenforceable, it shall be severed and deleted and the remaining Terms of Use shall survive, remain in full force and effect and continue to be binding and enforceable. '
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Non-assignment'
                                                ),
                                                'You shall not assign or transfer or purport to assign or transfer the contract between you and us to any other person. '
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Force Majeure'
                                                ),
                                                'Done Delivery/ Palasha Enterprises shall not be responsible or liable for any delay or failure to perform its obligations (other than an obligation to make payment) under these terms of use due to unforeseen circumstances or any event which is beyond Done Delivery/ Palasha Enterprises\'s reasonable control and without its fault or negligence, but not limited to, acts of God, war, riots, embargoes, strikes, lockouts, acts of any Government authority, delays in obtaining licenses or rejection of applications under the Statutes, failure of telephone connections or power failure, fire or floods. '
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'Governing law and dispute resolution'
                                                ),
                                                'These Terms of Use are governed by the laws of India. Any action, suit, or other legal proceeding, which is commenced to resolve any matter arising under or relating to this Platform, shall be subject to the jurisdiction of the courts at Goa, India. '
                                            ),
                                            _react2.default.createElement(
                                                'li',
                                                { className: 'mb-1' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    null,
                                                    'IP Notice and Take Down Policy'
                                                ),
                                                _react2.default.createElement(
                                                    'ol',
                                                    { className: 'tnc m-1 pl-2 pr-2 font-size-12', style: { 'textAlign': 'left' } },
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Done Delivery/ Palasha Enterprises has put in place IP Notice and Take Down Policy (?Take Down Policy?) so that intellectual property owners could easily report listings that infringe their right to ensure that infringing products are removed from the site, as they erode Buyer and good Seller trust.'
                                                    ),
                                                    _react2.default.createElement(
                                                        'li',
                                                        { className: 'mb-1' },
                                                        'Only the intellectual property rights owner can report potentially infringing products or listings through Take Down Policy by way of Notice of infringement in the specified format. If you are not the intellectual property rights owner, you can still help by getting in touch with the rights owner and encouraging them to contact us.',
                                                        _react2.default.createElement('br', null),
                                                        '(Note: Done Delivery/ Palasha Enterprises does not and cannot verify that Partner shops have the right or ability to sell or distribute their listed products. However, Done Delivery/ Palasha Enterprises is committed ensure that item listings do not infringe upon intellectual property rights of third parties once an authorized representative of the rights owner properly reports them to Done Delivery/ Palasha Enterprises'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Register;
}(_react2.default.Component);

exports.default = Register;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _reactCountdown = __webpack_require__(78);

var _reactCountdown2 = _interopRequireDefault(_reactCountdown);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Completionist = function Completionist() {
    return _react2.default.createElement(
        'p',
        { id: 'RESEND_OTP', style: { display: 'block' } },
        _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '#', onClick: function onClick(e) {
                    undefined.handleResendOTP(e);
                } },
            'Resend OTP'
        )
    );
};

// Renderer callback with condition
var renderer = function renderer(_ref) {
    var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds,
        completed = _ref.completed;

    if (completed) {
        // Render a complete state
        return _react2.default.createElement(Completionist, null);
    } else {
        // Render a countdown
        return _react2.default.createElement(
            'p',
            null,
            minutes,
            ':',
            seconds
        );
    }
};

var SmsVerification = function (_React$Component) {
    _inherits(SmsVerification, _React$Component);

    function SmsVerification(props) {
        _classCallCheck(this, SmsVerification);

        var _this = _possibleConstructorReturn(this, (SmsVerification.__proto__ || Object.getPrototypeOf(SmsVerification)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmSmsVerify')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmSmsVerify')[0].classList.add('was-validated');

            if (err == 0) {
                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/smsverify_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'OTP Field is Empty';else if (result.err == '3') notify = 'OTP Expired, Please regenrate again';else if (result.err == '4') notify = 'Invalid Access Detected';else if (result.err == '5') notify = 'OTP Expired, Please regenrate again';
                    }

                    //console.log(result);
                    var sms_verified = 'N';
                    var customer = result.customer;
                    if (customer != '' && customer != undefined) {
                        localStorage.setItem('userData', customer);
                        localStorage.setItem('Verified', 'Y');
                        localStorage.removeItem('tempData');
                        localStorage.removeItem('tempREG');
                        localStorage.removeItem('tempEMAIL');

                        sms_verified = 'Y';
                    }

                    that.setState({ Notifications: notify, SMS_VERIFIED: sms_verified });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.handleResendOTP = function (e) {
            e.preventDefault();
            $('#RESEND_OTP').css('display', 'none');

            var customer = localStorage.getItem('userData');
            var that = _this;
            fetch('https://m.donedelivery.in/api/resendotp_api.php?mode=REG&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'Invalid Access Detected';
                }

                var otp_resent = result.otp_resent;
                if (otp_resent == '' || otp_resent == undefined) otp_resent = '';

                if (otp_resent == 'Y') {
                    notify = 'New OTP has been sent to your mobile no';
                }

                that.setState({ Notifications: notify });
                if (notify != '') $('#ModalAlert').modal('show');
            });
        };

        _this.state = {
            Notifications: false,
            Verify: localStorage.getItem('Verified'),
            Customer: localStorage.getItem('userData'),
            SMS_VERIFIED: 'N'
        };

        return _this;
    }

    _createClass(SmsVerification, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.state.Verify == 'Y') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            if (this.state.SMS_VERIFIED == 'Y') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = '';
            var AppHeaderLeftLink = '';
            var AppHeaderTitle = 'Verification';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            var tempREG = '';
            var tempEMAIL = '';
            if (localStorage.getItem('tempREG') && localStorage.getItem('tempREG') !== 'null' && localStorage.getItem('tempREG') !== null) tempREG = localStorage.getItem('tempREG');

            if (localStorage.getItem('tempEMAIL') && localStorage.getItem('tempEMAIL') !== 'null' && localStorage.getItem('tempEMAIL') !== null) tempEMAIL = localStorage.getItem('tempEMAIL');

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-5 pt-3 pr-3 pl-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section' },
                            tempREG !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Mobile No:  ',
                                localStorage.getItem('tempREG')
                            ),
                            tempEMAIL !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Email Id:  ',
                                localStorage.getItem('tempEMAIL')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-2 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmSmsVerify', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'SMS_VERIFY', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('tempData'), className: 'form-control', name: 'customer', id: 'customer', required: true }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement('input', { type: 'text', className: 'placeholder-size square-inputbox form-control verify-input verify-input-1', name: 'txtotp', id: 'txtotp', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022', maxLength: '6', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter otp.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(_reactCountdown2.default, { date: Date.now() + 59000, renderer: renderer }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Verify'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SmsVerification;
}(_react2.default.Component);

exports.default = SmsVerification;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(40);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _Map = __webpack_require__(130);

var _Map2 = _interopRequireDefault(_Map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmsVerification = function (_React$Component) {
    _inherits(SmsVerification, _React$Component);

    function SmsVerification(props) {
        _classCallCheck(this, SmsVerification);

        var _this = _possibleConstructorReturn(this, (SmsVerification.__proto__ || Object.getPrototypeOf(SmsVerification)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmSmsVerify')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmSmsVerify')[0].classList.add('was-validated');

            if (err == 0) {
                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://www.peepkitchen.in/peep/pwa/api/smsverify_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    if (result.customer != '') {
                        customer = result.customer;
                        localStorage.setItem('userData', customer);

                        sms_verified = true;
                    }

                    that.setState({ SMS_VERIFIED: sms_verified });
                });
            }
        };

        _this.state = {
            Notifications: false,
            Del_City: localStorage.getItem('delcity'),
            Del_Area: localStorage.getItem('delarea'),
            Verify: localStorage.getItem('Verify'),
            Customer: localStorage.getItem('userData'),
            SMS_VERIFIED: false
        };

        return _this;
    }

    _createClass(SmsVerification, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AppHeaderClass = 'appHeader bg-primary text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderTitle = 'Select Delivery Location';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'pt-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section', style: { height: '300px' } },
                            _react2.default.createElement(
                                'div',
                                { id: 'map' },
                                _react2.default.createElement(_Map2.default, {
                                    google: this.props.google,
                                    center: { lat: 18.5204, lng: 73.8567 },
                                    height: '300px',
                                    zoom: 15
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-1 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmMap', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'ADD_ADDRESS', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer', required: true }),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    'Please enter your delivery location'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement('input', { type: 'text', className: 'form-control verify-input', name: 'txtotp', id: 'txtotp', placeholder: 'Enter OTP', required: true }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter otp.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                                        'Verify'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SmsVerification;
}(_react2.default.Component);

exports.default = SmsVerification;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _withScriptjs = __webpack_require__(281)

Object.defineProperty(exports, "withScriptjs", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withScriptjs).default
  },
})

var _withGoogleMap = __webpack_require__(355)

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default
  },
})

var _GoogleMap = __webpack_require__(356)

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default
  },
})

var _Circle = __webpack_require__(454)

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default
  },
})

var _Marker = __webpack_require__(455)

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default
  },
})

var _Polyline = __webpack_require__(456)

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default
  },
})

var _Polygon = __webpack_require__(457)

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default
  },
})

var _Rectangle = __webpack_require__(458)

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default
  },
})

var _InfoWindow = __webpack_require__(459)

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default
  },
})

var _OverlayView = __webpack_require__(460)

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default
  },
})

var _GroundOverlay = __webpack_require__(473)

Object.defineProperty(exports, "GroundOverlay", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroundOverlay).default
  },
})

var _DirectionsRenderer = __webpack_require__(474)

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default
  },
})

var _FusionTablesLayer = __webpack_require__(475)

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default
  },
})

var _KmlLayer = __webpack_require__(476)

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default
  },
})

var _TrafficLayer = __webpack_require__(477)

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default
  },
})

var _StreetViewPanorama = __webpack_require__(478)

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default
  },
})

var _BicyclingLayer = __webpack_require__(479)

Object.defineProperty(exports, "BicyclingLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BicyclingLayer).default
  },
})

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(131)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(53)

var _bind3 = _interopRequireDefault(_bind2)

exports.withScriptjs = withScriptjs

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(164)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _recompose = __webpack_require__(165)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var LOADING_STATE_NONE = "NONE"
var LOADING_STATE_BEGIN = "BEGIN"
var LOADING_STATE_LOADED = "LOADED"

function withScriptjs(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          loadingState: LOADING_STATE_NONE,
        }),
        (_this.isUnmounted = false),
        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "handleLoaded",
        value: function handleLoaded() {
          if (this.isUnmounted) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_LOADED,
          })
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            loadingElement = _props.loadingElement,
            googleMapURL = _props.googleMapURL

          ;(0, _invariant2.default)(
            !!loadingElement && !!googleMapURL,
            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
          )
        },
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          var loadingState = this.state.loadingState

          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
            return
          }
          this.setState({
            loadingState: LOADING_STATE_BEGIN,
          })
          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
          // eslint-disable-next-line global-require
          var scriptjs = __webpack_require__(354)
          var googleMapURL = this.props.googleMapURL

          scriptjs(googleMapURL, this.handleLoaded)
        },
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.isUnmounted = true
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            loadingElement = _props2.loadingElement,
            googleMapURL = _props2.googleMapURL,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "loadingElement",
              "googleMapURL",
            ])
          var loadingState = this.state.loadingState

          if (loadingState === LOADING_STATE_LOADED) {
            return factory(restProps)
          } else {
            return loadingElement
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    loadingElement: _propTypes2.default.node.isRequired,
    googleMapURL: _propTypes2.default.string.isRequired,
  }

  return Container
}

exports.default = withScriptjs


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(283);
module.exports = __webpack_require__(18).Object.getPrototypeOf;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(41);
var $getPrototypeOf = __webpack_require__(132);

__webpack_require__(284)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(23);
var core = __webpack_require__(18);
var fails = __webpack_require__(35);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(23);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(25), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(289), __esModule: true };

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(137);
__webpack_require__(296);
module.exports = __webpack_require__(89).f('iterator');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(84);
var defined = __webpack_require__(79);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(85);
var descriptor = __webpack_require__(42);
var setToStringTag = __webpack_require__(88);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(32)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var anObject = __webpack_require__(33);
var getKeys = __webpack_require__(51);

module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(36);
var toLength = __webpack_require__(142);
var toAbsoluteIndex = __webpack_require__(294);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(84);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(22).document;
module.exports = document && document.documentElement;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(297);
var global = __webpack_require__(22);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(43);
var TO_STRING_TAG = __webpack_require__(20)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(298);
var step = __webpack_require__(299);
var Iterators = __webpack_require__(43);
var toIObject = __webpack_require__(36);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(138)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(301), __esModule: true };

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
__webpack_require__(307);
__webpack_require__(308);
__webpack_require__(309);
module.exports = __webpack_require__(18).Symbol;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(22);
var has = __webpack_require__(27);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(23);
var redefine = __webpack_require__(139);
var META = __webpack_require__(303).KEY;
var $fails = __webpack_require__(35);
var shared = __webpack_require__(81);
var setToStringTag = __webpack_require__(88);
var uid = __webpack_require__(50);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(89);
var wksDefine = __webpack_require__(90);
var enumKeys = __webpack_require__(304);
var isArray = __webpack_require__(305);
var anObject = __webpack_require__(33);
var isObject = __webpack_require__(34);
var toObject = __webpack_require__(41);
var toIObject = __webpack_require__(36);
var toPrimitive = __webpack_require__(83);
var createDesc = __webpack_require__(42);
var _create = __webpack_require__(85);
var gOPNExt = __webpack_require__(306);
var $GOPD = __webpack_require__(144);
var $GOPS = __webpack_require__(91);
var $DP = __webpack_require__(24);
var $keys = __webpack_require__(51);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(143).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(52).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(49)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(32)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(50)('meta');
var isObject = __webpack_require__(34);
var has = __webpack_require__(27);
var setDesc = __webpack_require__(24).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(35)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(51);
var gOPS = __webpack_require__(91);
var pIE = __webpack_require__(52);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(86);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(36);
var gOPN = __webpack_require__(143).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 307 */
/***/ (function(module, exports) {



/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('asyncIterator');


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('observable');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(311), __esModule: true };

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
module.exports = __webpack_require__(18).Object.setPrototypeOf;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(23);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(313).set });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(34);
var anObject = __webpack_require__(33);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(82)(Function.call, __webpack_require__(144).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(315), __esModule: true };

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(316);
var $Object = __webpack_require__(18).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(23);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(85) });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(93);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(319),
    defineProperty = __webpack_require__(146),
    identity = __webpack_require__(44);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(54),
    isMasked = __webpack_require__(323),
    isObject = __webpack_require__(29),
    toSource = __webpack_require__(148);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(55);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(324);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(150),
    createBind = __webpack_require__(327),
    createCurry = __webpack_require__(328),
    createHybrid = __webpack_require__(153),
    createPartial = __webpack_require__(345),
    getData = __webpack_require__(157),
    mergeData = __webpack_require__(346),
    setData = __webpack_require__(160),
    setWrapToString = __webpack_require__(161),
    toInteger = __webpack_require__(347);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(56),
    root = __webpack_require__(17);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(93),
    createCtor = __webpack_require__(56),
    createHybrid = __webpack_require__(153),
    createRecurry = __webpack_require__(156),
    getHolder = __webpack_require__(97),
    replaceHolders = __webpack_require__(58),
    root = __webpack_require__(17);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(95),
    getData = __webpack_require__(157),
    getFuncName = __webpack_require__(332),
    lodash = __webpack_require__(334);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(333);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 333 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(95),
    LodashWrapper = __webpack_require__(158),
    baseLodash = __webpack_require__(96),
    isArray = __webpack_require__(19),
    isObjectLike = __webpack_require__(37),
    wrapperClone = __webpack_require__(335);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(95),
    LodashWrapper = __webpack_require__(158),
    copyArray = __webpack_require__(159);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(162),
    arrayIncludes = __webpack_require__(339);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(340);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(341),
    baseIsNaN = __webpack_require__(342),
    strictIndexOf = __webpack_require__(343);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(159),
    isIndex = __webpack_require__(57);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(93),
    createCtor = __webpack_require__(56),
    root = __webpack_require__(17);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(154),
    composeArgsRight = __webpack_require__(155),
    replaceHolders = __webpack_require__(58);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(348);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(163);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(353);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */](root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46), __webpack_require__(352)(module)))

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _objectWithoutProperties2 = __webpack_require__(131)

var _objectWithoutProperties3 = _interopRequireDefault(
  _objectWithoutProperties2
)

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _bind2 = __webpack_require__(53)

var _bind3 = _interopRequireDefault(_bind2)

exports.withGoogleMap = withGoogleMap

var _warning = __webpack_require__(47)

var _warning2 = _interopRequireDefault(_warning)

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _recompose = __webpack_require__(165)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function withGoogleMap(BaseComponent) {
  var factory = _react2.default.createFactory(BaseComponent)

  var Container = (function(_React$PureComponent) {
    ;(0, _inherits3.default)(Container, _React$PureComponent)

    function Container() {
      var _ref

      var _temp, _this, _ret

      ;(0, _classCallCheck3.default)(this, Container)

      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key]
      }

      return (
        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
          this,
          (_ref =
            Container.__proto__ ||
            (0, _getPrototypeOf2.default)(Container)).call.apply(
            _ref,
            [this].concat(args)
          )
        )),
        _this)),
        (_this.state = {
          map: null,
        }),
        (_this.handleComponentMount = (0, _bind3.default)(
          _this.handleComponentMount,
          _this
        )),
        _temp)),
        (0, _possibleConstructorReturn3.default)(_this, _ret)
      )
    }

    ;(0, _createClass3.default)(Container, [
      {
        key: "getChildContext",
        value: function getChildContext() {
          return (0, _defineProperty3.default)(
            {},
            _constants.MAP,
            this.state.map
          )
        },
      },
      {
        key: "componentWillMount",
        value: function componentWillMount() {
          var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement

          ;(0, _invariant2.default)(
            !!containerElement && !!mapElement,
            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
          )
        },
      },
      {
        key: "handleComponentMount",
        value: function handleComponentMount(node) {
          if (this.state.map || node === null) {
            return
          }
          ;(0, _warning2.default)(
            "undefined" !== typeof google,
            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
          )
          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
          var map = new google.maps.Map(node)
          this.setState({ map: map })
        },
      },
      {
        key: "render",
        value: function render() {
          var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, [
              "containerElement",
              "mapElement",
            ])
          var map = this.state.map

          if (map) {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null, factory(restProps))
            )
          } else {
            return _react2.default.cloneElement(
              containerElement,
              {},
              _react2.default.cloneElement(mapElement, {
                ref: this.handleComponentMount,
              }),
              _react2.default.createElement("div", null)
            )
          }
        },
      },
    ])
    return Container
  })(_react2.default.PureComponent)

  Container.displayName =
    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
  Container.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired,
  }
  Container.childContextTypes = (0, _defineProperty3.default)(
    {},
    _constants.MAP,
    _propTypes2.default.object
  )

  return Container
}

exports.default = withGoogleMap


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GoogleMap = exports.Map = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _toConsumableArray2 = __webpack_require__(357)

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Map`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
 */
var Map = (exports.Map = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Map, _React$PureComponent)
  ;(0, _createClass3.default)(Map, [
    {
      key: "fitBounds",

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
      value: function fitBounds() {
        var _context$MAP

        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
          _context$MAP,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panBy",
      value: function panBy() {
        var _context$MAP2

        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
          _context$MAP2,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panTo",
      value: function panTo() {
        var _context$MAP3

        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
          _context$MAP3,
          arguments
        )
      },

      /**
       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
       * @public
       */
    },
    {
      key: "panToBounds",
      value: function panToBounds() {
        var _context$MAP4

        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
          _context$MAP4,
          arguments
        )
      },

      /*
     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
     */
    },
  ])

  function Map(props, context) {
    ;(0, _classCallCheck3.default)(this, Map)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
        this,
        props,
        context
      )
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      GoogleMap.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP]
    )
    return _this
  }

  ;(0, _createClass3.default)(Map, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
       * @type LatLngBoundsnullundefined
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.context[_constants.MAP].getBounds()
      },

      /**
       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
       * @type LatLngLatLngLatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.context[_constants.MAP].getCenter()
      },

      /**
       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickableIcons",
      value: function getClickableIcons() {
        return this.context[_constants.MAP].getClickableIcons()
      },

      /**
       *
       * @type Element
       * @public
       */
    },
    {
      key: "getDiv",
      value: function getDiv() {
        return this.context[_constants.MAP].getDiv()
      },

      /**
       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
       * @type number
       * @public
       */
    },
    {
      key: "getHeading",
      value: function getHeading() {
        return this.context[_constants.MAP].getHeading()
      },

      /**
       *
       * @type MapTypeId|string
       * @public
       */
    },
    {
      key: "getMapTypeId",
      value: function getMapTypeId() {
        return this.context[_constants.MAP].getMapTypeId()
      },

      /**
       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
       * @type ProjectionProjectionprojection_changed
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.context[_constants.MAP].getProjection()
      },

      /**
       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
       * @public
       */
    },
    {
      key: "getStreetView",
      value: function getStreetView() {
        return this.context[_constants.MAP].getStreetView()
      },

      /**
       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
       * @type number045satellitehybridsetTiltsetTilt
       * @public
       */
    },
    {
      key: "getTilt",
      value: function getTilt() {
        return this.context[_constants.MAP].getTilt()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return Map
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

Map.displayName = "GoogleMap"
Map.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
   * @type Array<[id:string, mapType:MapType|*]>
   */
  defaultExtraMapTypes: _propTypes2.default.arrayOf(
    _propTypes2.default.arrayOf(_propTypes2.default.any)
  ),

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultHeading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  defaultMapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  defaultStreetView: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultTilt: _propTypes2.default.number,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickableIcons: _propTypes2.default.bool,

  /**
   * @type number
   */
  heading: _propTypes2.default.number,

  /**
   * @type MapTypeId|string
   */
  mapTypeId: _propTypes2.default.any,

  /**
   * @type MapOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type StreetViewPanorama
   */
  streetView: _propTypes2.default.any,

  /**
   * @type number
   */
  tilt: _propTypes2.default.number,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMapTypeIdChanged: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onTilesLoaded: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onHeadingChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIdle: _propTypes2.default.func,

  /**
   * function
   */
  onProjectionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onTiltChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
Map.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
var GoogleMap = (exports.GoogleMap = Map)

exports.default = Map

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  extraMapTypes: function extraMapTypes(instance, extra) {
    extra.forEach(function(it) {
      var _instance$mapTypes

      return (_instance$mapTypes = instance.mapTypes).set.apply(
        _instance$mapTypes,
        (0, _toConsumableArray3.default)(it)
      )
    })
  },
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  clickableIcons: function clickableIcons(instance, _clickableIcons) {
    instance.setClickableIcons(_clickableIcons)
  },
  heading: function heading(instance, _heading) {
    instance.setHeading(_heading)
  },
  mapTypeId: function mapTypeId(instance, _mapTypeId) {
    instance.setMapTypeId(_mapTypeId)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  streetView: function streetView(instance, _streetView) {
    instance.setStreetView(_streetView)
  },
  tilt: function tilt(instance, _tilt) {
    instance.setTilt(_tilt)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(358);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(359), __esModule: true };

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(137);
__webpack_require__(360);
module.exports = __webpack_require__(18).Array.from;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(82);
var $export = __webpack_require__(23);
var toObject = __webpack_require__(41);
var call = __webpack_require__(361);
var isArrayIter = __webpack_require__(362);
var toLength = __webpack_require__(142);
var createProperty = __webpack_require__(363);
var getIterFn = __webpack_require__(364);

$export($export.S + $export.F * !__webpack_require__(366)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(33);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(43);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(24);
var createDesc = __webpack_require__(42);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(365);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(43);
module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(86);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(368),
    baseEach = __webpack_require__(166),
    baseIteratee = __webpack_require__(383),
    baseReduce = __webpack_require__(442),
    isArray = __webpack_require__(19);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(370),
    keys = __webpack_require__(60);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(371);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(373),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(19),
    isBuffer = __webpack_require__(168),
    isIndex = __webpack_require__(57),
    isTypedArray = __webpack_require__(170);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(45),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 375 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(45),
    isLength = __webpack_require__(98),
    isObjectLike = __webpack_require__(37);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(147);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)(module)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(171),
    nativeKeys = __webpack_require__(380);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(381);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(61);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(384),
    baseMatchesProperty = __webpack_require__(430),
    identity = __webpack_require__(44),
    isArray = __webpack_require__(19),
    property = __webpack_require__(439);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(385),
    getMatchData = __webpack_require__(429),
    matchesStrictComparable = __webpack_require__(176);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    baseIsEqual = __webpack_require__(173);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(63);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(63);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(63);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(63);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(62);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(62),
    Map = __webpack_require__(99),
    MapCache = __webpack_require__(100);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(397),
    ListCache = __webpack_require__(62),
    Map = __webpack_require__(99);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(398),
    hashDelete = __webpack_require__(399),
    hashGet = __webpack_require__(400),
    hashHas = __webpack_require__(401),
    hashSet = __webpack_require__(402);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(65);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(65);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(65);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(65);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 404 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(66);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(172),
    equalArrays = __webpack_require__(174),
    equalByTag = __webpack_require__(414),
    equalObjects = __webpack_require__(418),
    getTag = __webpack_require__(425),
    isArray = __webpack_require__(19),
    isBuffer = __webpack_require__(168),
    isTypedArray = __webpack_require__(170);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(100),
    setCacheAdd = __webpack_require__(410),
    setCacheHas = __webpack_require__(411);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(55),
    Uint8Array = __webpack_require__(415),
    eq = __webpack_require__(64),
    equalArrays = __webpack_require__(174),
    mapToArray = __webpack_require__(416),
    setToArray = __webpack_require__(417);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(17);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(419);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(420),
    getSymbols = __webpack_require__(422),
    keys = __webpack_require__(60);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(421),
    isArray = __webpack_require__(19);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(423),
    stubArray = __webpack_require__(424);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 423 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 424 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(426),
    Map = __webpack_require__(99),
    Promise = __webpack_require__(427),
    Set = __webpack_require__(428),
    WeakMap = __webpack_require__(152),
    baseGetTag = __webpack_require__(45),
    toSource = __webpack_require__(148);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(28),
    root = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(175),
    keys = __webpack_require__(60);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(173),
    get = __webpack_require__(431),
    hasIn = __webpack_require__(437),
    isKey = __webpack_require__(101),
    isStrictComparable = __webpack_require__(175),
    matchesStrictComparable = __webpack_require__(176),
    toKey = __webpack_require__(67);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(177);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(433);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(434);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(55),
    arrayMap = __webpack_require__(436),
    isArray = __webpack_require__(19),
    isSymbol = __webpack_require__(59);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(438),
    hasPath = __webpack_require__(180);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(440),
    basePropertyDeep = __webpack_require__(441),
    isKey = __webpack_require__(101),
    toKey = __webpack_require__(67);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(177);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 442 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(162),
    baseEach = __webpack_require__(166),
    castFunction = __webpack_require__(444),
    isArray = __webpack_require__(19);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(44);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(446);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(447),
    hasUnicode = __webpack_require__(181),
    stringToArray = __webpack_require__(449),
    toString = __webpack_require__(179);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(448);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(450),
    hasUnicode = __webpack_require__(181),
    unicodeToArray = __webpack_require__(451);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 451 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(453),
    hasPath = __webpack_require__(180);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Circle = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Circle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Circle = (exports.Circle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Circle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
   */
  function Circle(props, context) {
    ;(0, _classCallCheck3.default)(this, Circle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
        this,
        props,
        context
      )
    )

    var circle = new google.maps.Circle()
    ;(0, _MapChildHelper.construct)(
      Circle.propTypes,
      updaterMap,
      _this.props,
      circle
    )
    circle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
    return _this
  }

  ;(0, _createClass3.default)(Circle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.CIRCLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.CIRCLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var circle = this.state[_constants.CIRCLE]
        if (circle) {
          circle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this Circle.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.CIRCLE].getBounds()
      },

      /**
       * Returns the center of this circle.
       * @type LatLng
       * @public
       */
    },
    {
      key: "getCenter",
      value: function getCenter() {
        return this.state[_constants.CIRCLE].getCenter()
      },

      /**
       * Returns whether this circle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.CIRCLE].getDraggable()
      },

      /**
       * Returns whether this circle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.CIRCLE].getEditable()
      },

      /**
       * Returns the radius of this circle (in meters).
       * @type number
       * @public
       */
    },
    {
      key: "getRadius",
      value: function getRadius() {
        return this.state[_constants.CIRCLE].getRadius()
      },

      /**
       * Returns whether this circle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.CIRCLE].getVisible()
      },
    },
  ])
  return Circle
})(_react2.default.PureComponent))

Circle.propTypes = {
  /**
   * @type LatLng|LatLngLiteral
   */
  defaultCenter: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRadius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLng|LatLngLiteral
   */
  center: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type CircleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type number
   */
  radius: _propTypes2.default.number,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onCenterChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onRadiusChanged: _propTypes2.default.func,
}
Circle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Circle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onRadiusChanged: "radius_changed",
}

var updaterMap = {
  center: function center(instance, _center) {
    instance.setCenter(_center)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Marker = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _Marker$contextTypes /*
                           * -----------------------------------------------------------------------------
                           * This file is auto-generated from the corresponding file at `src/macros/`.
                           * Please **DO NOT** edit this file directly when creating PRs.
                           * -----------------------------------------------------------------------------
                           */
/* global google */

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Marker`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
 */
var Marker = (exports.Marker = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Marker, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
   */
  function Marker(props, context) {
    ;(0, _classCallCheck3.default)(this, Marker)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
        this,
        props,
        context
      )
    )

    var marker = new google.maps.Marker()
    ;(0, _MapChildHelper.construct)(
      Marker.propTypes,
      updaterMap,
      _this.props,
      marker
    )
    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
    } else {
      marker.setMap(_this.context[_constants.MAP])
    }
    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
    return _this
  }

  ;(0, _createClass3.default)(Marker, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.ANCHOR,
          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.MARKER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.MARKER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var marker = this.state[_constants.MARKER]
        if (marker) {
          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
          if (markerClusterer) {
            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
          }
          marker.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       *
       * @type Animation
       * @public
       */
    },
    {
      key: "getAnimation",
      value: function getAnimation() {
        return this.state[_constants.MARKER].getAnimation()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getClickable",
      value: function getClickable() {
        return this.state[_constants.MARKER].getClickable()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getCursor",
      value: function getCursor() {
        return this.state[_constants.MARKER].getCursor()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.MARKER].getDraggable()
      },

      /**
       *
       * @type string|Icon|Symbol
       * @public
       */
    },
    {
      key: "getIcon",
      value: function getIcon() {
        return this.state[_constants.MARKER].getIcon()
      },

      /**
       *
       * @type MarkerLabel
       * @public
       */
    },
    {
      key: "getLabel",
      value: function getLabel() {
        return this.state[_constants.MARKER].getLabel()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.MARKER].getOpacity()
      },

      /**
       *
       * @type MarkerPlace
       * @public
       */
    },
    {
      key: "getPlace",
      value: function getPlace() {
        return this.state[_constants.MARKER].getPlace()
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.MARKER].getPosition()
      },

      /**
       *
       * @type MarkerShape
       * @public
       */
    },
    {
      key: "getShape",
      value: function getShape() {
        return this.state[_constants.MARKER].getShape()
      },

      /**
       *
       * @type string
       * @public
       */
    },
    {
      key: "getTitle",
      value: function getTitle() {
        return this.state[_constants.MARKER].getTitle()
      },

      /**
       *
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.MARKER].getVisible()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.MARKER].getZIndex()
      },
    },
  ])
  return Marker
})(_react2.default.PureComponent))

Marker.propTypes = {
  /**
   * For the 2nd argument of `MarkerCluster#addMarker`
   * @see https://github.com/mikesaidani/marker-clusterer-plus
   */
  noRedraw: _propTypes2.default.bool,

  /**
   * @type Animation
   */
  defaultAnimation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultClickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  defaultCursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  defaultIcon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  defaultLabel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  defaultPlace: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  defaultShape: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultTitle: _propTypes2.default.string,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type Animation
   */
  animation: _propTypes2.default.any,

  /**
   * @type boolean
   */
  clickable: _propTypes2.default.bool,

  /**
   * @type string
   */
  cursor: _propTypes2.default.string,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type string|Icon|Symbol
   */
  icon: _propTypes2.default.any,

  /**
   * @type string|MarkerLabel
   */
  label: _propTypes2.default.any,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * @type MarkerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MarkerPlace
   */
  place: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type MarkerShape
   */
  shape: _propTypes2.default.any,

  /**
   * @type string
   */
  title: _propTypes2.default.string,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onAnimationChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onClickableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onCursorChanged: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,

  /**
   * function
   */
  onDraggableChanged: _propTypes2.default.func,

  /**
   * function
   */
  onFlatChanged: _propTypes2.default.func,

  /**
   * function
   */
  onIconChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onShapeChanged: _propTypes2.default.func,

  /**
   * function
   */
  onTitleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
Marker.contextTypes = ((_Marker$contextTypes = {}),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _Marker$contextTypes,
  _constants.MARKER_CLUSTERER,
  _propTypes2.default.object
),
_Marker$contextTypes)
Marker.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.ANCHOR,
  _propTypes2.default.object
)
exports.default = Marker

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDrag: "drag",
  onDraggableChanged: "draggable_changed",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onPositionChanged: "position_changed",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation)
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable)
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon)
  },
  label: function label(instance, _label) {
    instance.setLabel(_label)
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  place: function place(instance, _place) {
    instance.setPlace(_place)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape)
  },
  title: function title(instance, _title) {
    instance.setTitle(_title)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polyline = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polyline`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polyline = (exports.Polyline = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polyline, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
   */
  function Polyline(props, context) {
    ;(0, _classCallCheck3.default)(this, Polyline)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
        this,
        props,
        context
      )
    )

    var polyline = new google.maps.Polyline()
    ;(0, _MapChildHelper.construct)(
      Polyline.propTypes,
      updaterMap,
      _this.props,
      polyline
    )
    polyline.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.POLYLINE,
      polyline
    )
    return _this
  }

  ;(0, _createClass3.default)(Polyline, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYLINE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYLINE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polyline = this.state[_constants.POLYLINE]
        if (polyline) {
          polyline.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYLINE].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYLINE].getEditable()
      },

      /**
       * Retrieves the path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYLINE].getPath()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYLINE].getVisible()
      },
    },
  ])
  return Polyline
})(_react2.default.PureComponent))

Polyline.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolylineOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polyline.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polyline

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Polygon = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Polygon`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Polygon = (exports.Polygon = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Polygon, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
   */
  function Polygon(props, context) {
    ;(0, _classCallCheck3.default)(this, Polygon)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
        this,
        props,
        context
      )
    )

    var polygon = new google.maps.Polygon()
    ;(0, _MapChildHelper.construct)(
      Polygon.propTypes,
      updaterMap,
      _this.props,
      polygon
    )
    polygon.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
    return _this
  }

  ;(0, _createClass3.default)(Polygon, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.POLYGON],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.POLYGON],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var polygon = this.state[_constants.POLYGON]
        if (polygon) {
          polygon.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns whether this shape can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.POLYGON].getDraggable()
      },

      /**
       * Returns whether this shape can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.POLYGON].getEditable()
      },

      /**
       * Retrieves the first path.
       * @type MVCArray<LatLng>
       * @public
       */
    },
    {
      key: "getPath",
      value: function getPath() {
        return this.state[_constants.POLYGON].getPath()
      },

      /**
       * Retrieves the paths for this polygon.
       * @type MVCArray<MVCArray<LatLng>>
       * @public
       */
    },
    {
      key: "getPaths",
      value: function getPaths() {
        return this.state[_constants.POLYGON].getPaths()
      },

      /**
       * Returns whether this poly is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.POLYGON].getVisible()
      },
    },
  ])
  return Polygon
})(_react2.default.PureComponent))

Polygon.propTypes = {
  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  defaultPath: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  defaultPaths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type PolygonOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
   */
  path: _propTypes2.default.any,

  /**
   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
   */
  paths: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Polygon.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Polygon

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  path: function path(instance, _path) {
    instance.setPath(_path)
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.Rectangle = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.Rectangle`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
   */
  function Rectangle(props, context) {
    ;(0, _classCallCheck3.default)(this, Rectangle)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
        this,
        props,
        context
      )
    )

    var rectangle = new google.maps.Rectangle()
    ;(0, _MapChildHelper.construct)(
      Rectangle.propTypes,
      updaterMap,
      _this.props,
      rectangle
    )
    rectangle.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.RECTANGLE,
      rectangle
    )
    return _this
  }

  ;(0, _createClass3.default)(Rectangle, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.RECTANGLE],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var rectangle = this.state[_constants.RECTANGLE]
        if (rectangle) {
          rectangle.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the bounds of this rectangle.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.RECTANGLE].getBounds()
      },

      /**
       * Returns whether this rectangle can be dragged by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getDraggable",
      value: function getDraggable() {
        return this.state[_constants.RECTANGLE].getDraggable()
      },

      /**
       * Returns whether this rectangle can be edited by the user.
       * @type boolean
       * @public
       */
    },
    {
      key: "getEditable",
      value: function getEditable() {
        return this.state[_constants.RECTANGLE].getEditable()
      },

      /**
       * Returns whether this rectangle is visible on the map.
       * @type boolean
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.state[_constants.RECTANGLE].getVisible()
      },
    },
  ])
  return Rectangle
})(_react2.default.PureComponent))

Rectangle.propTypes = {
  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  defaultBounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultDraggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  defaultEditable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type LatLngBounds|LatLngBoundsLiteral
   */
  bounds: _propTypes2.default.any,

  /**
   * @type boolean
   */
  draggable: _propTypes2.default.bool,

  /**
   * @type boolean
   */
  editable: _propTypes2.default.bool,

  /**
   * @type RectangleOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onDragEnd: _propTypes2.default.func,

  /**
   * function
   */
  onDragStart: _propTypes2.default.func,

  /**
   * function
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * function
   */
  onMouseMove: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOut: _propTypes2.default.func,

  /**
   * function
   */
  onMouseOver: _propTypes2.default.func,

  /**
   * function
   */
  onMouseUp: _propTypes2.default.func,

  /**
   * function
   */
  onRightClick: _propTypes2.default.func,

  /**
   * function
   */
  onBoundsChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onDrag: _propTypes2.default.func,
}
Rectangle.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = Rectangle

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDrag: "drag",
}

var updaterMap = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds)
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable)
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.InfoWindow = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _InfoWindow$contextTy /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _canUseDom = __webpack_require__(164)

var _canUseDom2 = _interopRequireDefault(_canUseDom)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(1)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.InfoWindow`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
 */
var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
   */
  function InfoWindow(props, context) {
    ;(0, _classCallCheck3.default)(this, InfoWindow)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
        this,
        props,
        context
      )
    )

    var infoWindow = new google.maps.InfoWindow()
    ;(0, _MapChildHelper.construct)(
      InfoWindow.propTypes,
      updaterMap,
      _this.props,
      infoWindow
    )
    infoWindow.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.INFO_WINDOW,
      infoWindow
    )
    return _this
  }

  ;(0, _createClass3.default)(InfoWindow, [
    {
      key: "componentWillMount",
      value: function componentWillMount() {
        if (!_canUseDom2.default || this.containerElement) {
          return
        }
        if (_react2.default.version.match(/^16/)) {
          this.containerElement = document.createElement("div")
        }
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap
        )
        if (_react2.default.version.match(/^16/)) {
          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
          open(
            this.state[_constants.INFO_WINDOW],
            this.context[_constants.ANCHOR]
          )
          return
        }
        var content = document.createElement("div")
        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          content
        )
        this.state[_constants.INFO_WINDOW].setContent(content)
        open(
          this.state[_constants.INFO_WINDOW],
          this.context[_constants.ANCHOR]
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.INFO_WINDOW],
          eventMap,
          updaterMap,
          prevProps
        )
        if (_react2.default.version.match(/^16/)) {
          return
        }
        if (this.props.children !== prevProps.children) {
          _reactDom2.default.unstable_renderSubtreeIntoContainer(
            this,
            _react2.default.Children.only(this.props.children),
            this.state[_constants.INFO_WINDOW].getContent()
          )
        }
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var infoWindow = this.state[_constants.INFO_WINDOW]
        if (infoWindow) {
          if (
            !_react2.default.version.match(/^16/) &&
            infoWindow.getContent()
          ) {
            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
          }
          infoWindow.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        if (_react2.default.version.match(/^16/)) {
          return _reactDom2.default.createPortal(
            _react2.default.Children.only(this.props.children),
            this.containerElement
          )
        }
        return false
      },

      /**
       *
       * @type LatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.state[_constants.INFO_WINDOW].getPosition()
      },

      /**
       *
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.INFO_WINDOW].getZIndex()
      },
    },
  ])
  return InfoWindow
})(_react2.default.PureComponent))

InfoWindow.propTypes = {
  /**
   * @type InfoWindowOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type InfoWindowOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onDomReady: _propTypes2.default.func,

  /**
   * function
   */
  onContentChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZindexChanged: _propTypes2.default.func,
}
InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _InfoWindow$contextTy,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_InfoWindow$contextTy)
exports.default = InfoWindow

var open = function open(infoWindow, anchor) {
  if (anchor) {
    infoWindow.open(infoWindow.getMap(), anchor)
  } else if (infoWindow.getPosition()) {
    infoWindow.open(infoWindow.getMap())
  } else {
    ;(0, _invariant2.default)(
      false,
      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
    )
  }
}

var eventMap = {
  onCloseClick: "closeclick",
  onDomReady: "domready",
  onContentChanged: "content_changed",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.OverlayView = undefined

var _extends2 = __webpack_require__(461)

var _extends3 = _interopRequireDefault(_extends2)

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _delay2 = __webpack_require__(466)

var _delay3 = _interopRequireDefault(_delay2)

var _assign2 = __webpack_require__(468)

var _assign3 = _interopRequireDefault(_assign2)

var _bind2 = __webpack_require__(53)

var _bind3 = _interopRequireDefault(_bind2)

var _OverlayView$contextT /*
                            * -----------------------------------------------------------------------------
                            * This file is auto-generated from the corresponding file at `src/macros/`.
                            * Please **DO NOT** edit this file directly when creating PRs.
                            * -----------------------------------------------------------------------------
                            */
/* global google */

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _reactDom = __webpack_require__(1)

var _reactDom2 = _interopRequireDefault(_reactDom)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _OverlayViewHelper = __webpack_require__(472)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.OverlayView`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
 */
var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  function OverlayView(props, context) {
    ;(0, _classCallCheck3.default)(this, OverlayView)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
      ).call(this, props, context)
    )

    var overlayView = new google.maps.OverlayView()
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
    _this.onPositionElement = (0, _bind3.default)(
      _this.onPositionElement,
      _this
    )
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.OVERLAY_VIEW,
      overlayView
    )
    return _this
  }

  ;(0, _createClass3.default)(OverlayView, [
    {
      key: "onAdd",
      value: function onAdd() {
        this.containerElement = document.createElement("div")
        this.containerElement.style.position = "absolute"
      },
    },
    {
      key: "draw",
      value: function draw() {
        var mapPaneName = this.props.mapPaneName

        ;(0, _invariant2.default)(
          !!mapPaneName,
          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
          mapPaneName
        )
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
        mapPanes[mapPaneName].appendChild(this.containerElement)

        _reactDom2.default.unstable_renderSubtreeIntoContainer(
          this,
          _react2.default.Children.only(this.props.children),
          this.containerElement,
          this.onPositionElement
        )
      },
    },
    {
      key: "onPositionElement",
      value: function onPositionElement() {
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
        var mapCanvasProjection = this.state[
          _constants.OVERLAY_VIEW
        ].getProjection()

        var offset = (0, _extends3.default)(
          {
            x: 0,
            y: 0,
          },
          (0, _OverlayViewHelper.getOffsetOverride)(
            this.containerElement,
            this.props
          )
        )
        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
          mapCanvasProjection,
          offset,
          this.props
        )
        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
      },
    },
    {
      key: "onRemove",
      value: function onRemove() {
        this.containerElement.parentNode.removeChild(this.containerElement)
        _reactDom2.default.unmountComponentAtNode(this.containerElement)
        this.containerElement = null
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.OVERLAY_VIEW],
          eventMap,
          updaterMap,
          prevProps
        )
        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var overlayView = this.state[_constants.OVERLAY_VIEW]
        if (overlayView) {
          overlayView.setMap(null)
          // You must implement three methods: onAdd(), draw(), and onRemove().
          overlayView.onAdd = null
          overlayView.draw = null
          overlayView.onRemove = null
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
       * @type MapPanesonAdd
       * @public
       */
    },
    {
      key: "getPanes",
      value: function getPanes() {
        return this.state[_constants.OVERLAY_VIEW].getPanes()
      },

      /**
       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
       * @public
       */
    },
    {
      key: "getProjection",
      value: function getProjection() {
        return this.state[_constants.OVERLAY_VIEW].getProjection()
      },
    },
  ])
  return OverlayView
})(_react2.default.PureComponent))

OverlayView.FLOAT_PANE = "floatPane"
OverlayView.MAP_PANE = "mapPane"
OverlayView.MARKER_LAYER = "markerLayer"
OverlayView.OVERLAY_LAYER = "overlayLayer"
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
OverlayView.propTypes = {
  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  mapPaneName: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  position: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  bounds: _propTypes2.default.object,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
   */
  getPixelPositionOffset: _propTypes2.default.func,
}
OverlayView.contextTypes = ((_OverlayView$contextT = {}),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.MAP,
  _propTypes2.default.object
),
(0, _defineProperty3.default)(
  _OverlayView$contextT,
  _constants.ANCHOR,
  _propTypes2.default.object
),
_OverlayView$contextT)
exports.default = OverlayView

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(462);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(463), __esModule: true };

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(464);
module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(23);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(465) });


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(25);
var getKeys = __webpack_require__(51);
var gOPS = __webpack_require__(91);
var pIE = __webpack_require__(52);
var toObject = __webpack_require__(41);
var IObject = __webpack_require__(141);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(35)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(467),
    baseRest = __webpack_require__(92),
    toNumber = __webpack_require__(163);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 467 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(182),
    copyObject = __webpack_require__(469),
    createAssigner = __webpack_require__(470),
    isArrayLike = __webpack_require__(61),
    isPrototype = __webpack_require__(171),
    keys = __webpack_require__(60);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(182),
    baseAssignValue = __webpack_require__(183);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(92),
    isIterateeCall = __webpack_require__(471);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(64),
    isArrayLike = __webpack_require__(61),
    isIndex = __webpack_require__(57),
    isObject = __webpack_require__(29);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})

var _isFunction2 = __webpack_require__(54)

var _isFunction3 = _interopRequireDefault(_isFunction2)

exports.getOffsetOverride = getOffsetOverride
exports.getLayoutStyles = getLayoutStyles

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/* global google */
function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(
      containerElement.offsetWidth,
      containerElement.offsetHeight
    )
  } else {
    return {}
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng)
}

function createLatLngBounds(inst, Type) {
  return new Type(
    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
  )
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst
  } else {
    return factory(inst, type)
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
  if (point) {
    var x = point.x,
      y = point.y

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px",
    }
  }
  return {
    left: "-9999px",
    top: "-9999px",
  }
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(
      props.bounds,
      google.maps.LatLngBounds,
      createLatLngBounds
    )
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
  } else {
    var position = ensureOfType(
      props.position,
      google.maps.LatLng,
      createLatLng
    )
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
  }
}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.GroundOverlay = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _warning = __webpack_require__(47)

var _warning2 = _interopRequireDefault(_warning)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.GroundOverlay`
 *
 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
 */
var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
   */
  function GroundOverlay(props, context) {
    ;(0, _classCallCheck3.default)(this, GroundOverlay)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
      ).call(this, props, context)
    )

    ;(0, _warning2.default)(
      !props.url || !props.bounds,
      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
    )
    var groundOverlay = new google.maps.GroundOverlay(
      props.defaultUrl || props.url,
      props.defaultBounds || props.bounds
    )
    ;(0, _MapChildHelper.construct)(
      GroundOverlay.propTypes,
      updaterMap,
      _this.props,
      groundOverlay
    )
    groundOverlay.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.GROUND_LAYER,
      groundOverlay
    )
    return _this
  }

  ;(0, _createClass3.default)(GroundOverlay, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.GROUND_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var GroundOverlay = this.state[_constants.GROUND_LAYER]
        if (GroundOverlay) {
          GroundOverlay.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Gets the `LatLngBounds` of this overlay.
       * @type LatLngBoundsLatLngBounds
       * @public
       */
    },
    {
      key: "getBounds",
      value: function getBounds() {
        return this.state[_constants.GROUND_LAYER].getBounds()
      },

      /**
       * Returns the opacity of this ground overlay.
       * @type number
       * @public
       */
    },
    {
      key: "getOpacity",
      value: function getOpacity() {
        return this.state[_constants.GROUND_LAYER].getOpacity()
      },

      /**
       * Gets the url of the projected image.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.GROUND_LAYER].getUrl()
      },
    },
  ])
  return GroundOverlay
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */
/* global google */

GroundOverlay.propTypes = {
  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   */,

  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
   * @type string
   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
   */,

  url: _propTypes2.default.string,

  /**
   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
   */
  bounds: _propTypes2.default.object,

  /**
   * @type number
   */
  defaultOpacity: _propTypes2.default.number,

  /**
   * @type number
   */
  opacity: _propTypes2.default.number,

  /**
   * function
   */
  onDblClick: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
GroundOverlay.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = GroundOverlay

var eventMap = {
  onDblClick: "dblclick",
  onClick: "click",
}

var updaterMap = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity)
  },
}


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.DirectionsRenderer = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.DirectionsRenderer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var DirectionsRenderer = (exports.DirectionsRenderer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
   */
  function DirectionsRenderer(props, context) {
    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        DirectionsRenderer.__proto__ ||
        (0, _getPrototypeOf2.default)(DirectionsRenderer)
      ).call(this, props, context)
    )

    var directionsRenderer = new google.maps.DirectionsRenderer()
    ;(0, _MapChildHelper.construct)(
      DirectionsRenderer.propTypes,
      updaterMap,
      _this.props,
      directionsRenderer
    )
    directionsRenderer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.DIRECTIONS_RENDERER,
      directionsRenderer
    )
    return _this
  }

  ;(0, _createClass3.default)(DirectionsRenderer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.DIRECTIONS_RENDERER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
        if (directionsRenderer) {
          directionsRenderer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Returns the renderer's current set of directions.
       * @type DirectionsResult
       * @public
       */
    },
    {
      key: "getDirections",
      value: function getDirections() {
        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
      },

      /**
       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
       * @type Node<div>DirectionsResult
       * @public
       */
    },
    {
      key: "getPanel",
      value: function getPanel() {
        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
      },

      /**
       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
       * @type numberDirectionsRenderer
       * @public
       */
    },
    {
      key: "getRouteIndex",
      value: function getRouteIndex() {
        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
      },
    },
  ])
  return DirectionsRenderer
})(_react2.default.PureComponent))

DirectionsRenderer.propTypes = {
  /**
   * @type DirectionsResult
   */
  defaultDirections: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type Node
   */
  defaultPanel: _propTypes2.default.any,

  /**
   * @type number
   */
  defaultRouteIndex: _propTypes2.default.number,

  /**
   * @type DirectionsResult
   */
  directions: _propTypes2.default.any,

  /**
   * @type DirectionsRendererOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type Node
   */
  panel: _propTypes2.default.any,

  /**
   * @type number
   */
  routeIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDirectionsChanged: _propTypes2.default.func,
}
DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = DirectionsRenderer

var eventMap = {
  onDirectionsChanged: "directions_changed",
}

var updaterMap = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel)
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex)
  },
}


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.FusionTablesLayer = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.FusionTablesLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var FusionTablesLayer = (exports.FusionTablesLayer = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
   */
  function FusionTablesLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        FusionTablesLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(FusionTablesLayer)
      ).call(this, props, context)
    )

    var fusionTablesLayer = new google.maps.FusionTablesLayer()
    ;(0, _MapChildHelper.construct)(
      FusionTablesLayer.propTypes,
      updaterMap,
      _this.props,
      fusionTablesLayer
    )
    fusionTablesLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.FUSION_TABLES_LAYER,
      fusionTablesLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(FusionTablesLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.FUSION_TABLES_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
        if (fusionTablesLayer) {
          fusionTablesLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return FusionTablesLayer
})(_react2.default.PureComponent))

FusionTablesLayer.propTypes = {
  /**
   * @type FusionTablesLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type FusionTablesLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * function
   */
  onClick: _propTypes2.default.func,
}
FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = FusionTablesLayer

var eventMap = {
  onClick: "click",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.KmlLayer = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.KmlLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
   */
  function KmlLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, KmlLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
        this,
        props,
        context
      )
    )

    var kmlLayer = new google.maps.KmlLayer()
    ;(0, _MapChildHelper.construct)(
      KmlLayer.propTypes,
      updaterMap,
      _this.props,
      kmlLayer
    )
    kmlLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.KML_LAYER,
      kmlLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(KmlLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.KML_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var kmlLayer = this.state[_constants.KML_LAYER]
        if (kmlLayer) {
          kmlLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },

      /**
       * Get the default viewport for the layer being displayed.
       * @type LatLngBounds
       * @public
       */
    },
    {
      key: "getDefaultViewport",
      value: function getDefaultViewport() {
        return this.state[_constants.KML_LAYER].getDefaultViewport()
      },

      /**
       * Get the metadata associated with this layer, as specified in the layer markup.
       * @type KmlLayerMetadata
       * @public
       */
    },
    {
      key: "getMetadata",
      value: function getMetadata() {
        return this.state[_constants.KML_LAYER].getMetadata()
      },

      /**
       * Get the status of the layer, set once the requested document has loaded.
       * @type KmlLayerStatus
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.state[_constants.KML_LAYER].getStatus()
      },

      /**
       * Gets the URL of the KML file being displayed.
       * @type string
       * @public
       */
    },
    {
      key: "getUrl",
      value: function getUrl() {
        return this.state[_constants.KML_LAYER].getUrl()
      },

      /**
       * Gets the z-index of the KML Layer.
       * @type number
       * @public
       */
    },
    {
      key: "getZIndex",
      value: function getZIndex() {
        return this.state[_constants.KML_LAYER].getZIndex()
      },
    },
  ])
  return KmlLayer
})(_react2.default.PureComponent))

KmlLayer.propTypes = {
  /**
   * @type KmlLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultUrl: _propTypes2.default.string,

  /**
   * @type number
   */
  defaultZIndex: _propTypes2.default.number,

  /**
   * @type KmlLayerOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  url: _propTypes2.default.string,

  /**
   * @type number
   */
  zIndex: _propTypes2.default.number,

  /**
   * function
   */
  onDefaultViewportChanged: _propTypes2.default.func,

  /**
   * function
   */
  onClick: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,
}
KmlLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = KmlLayer

var eventMap = {
  onDefaultViewportChanged: "defaultviewport_changed",
  onClick: "click",
  onStatusChanged: "status_changed",
}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  url: function url(instance, _url) {
    instance.setUrl(_url)
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex)
  },
}


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.TrafficLayer = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.TrafficLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
   */
  function TrafficLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, TrafficLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
      ).call(this, props, context)
    )

    var trafficLayer = new google.maps.TrafficLayer()
    ;(0, _MapChildHelper.construct)(
      TrafficLayer.propTypes,
      updaterMap,
      _this.props,
      trafficLayer
    )
    trafficLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.TRAFFIC_LAYER,
      trafficLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(TrafficLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.TRAFFIC_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
        if (trafficLayer) {
          trafficLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return TrafficLayer
})(_react2.default.PureComponent))

TrafficLayer.propTypes = {
  /**
   * @type TrafficLayerOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type TrafficLayerOptions
   */
  options: _propTypes2.default.any,
}
TrafficLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = TrafficLayer

var eventMap = {}

var updaterMap = {
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
}


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.StreetViewPanorama = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _invariant = __webpack_require__(16)

var _invariant2 = _interopRequireDefault(_invariant)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.StreetViewPanorama`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
 */
var StreetViewPanorama = (exports.StreetViewPanorama = (function(
  _React$PureComponent
) {
  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)

  function StreetViewPanorama(props, context) {
    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        StreetViewPanorama.__proto__ ||
        (0, _getPrototypeOf2.default)(StreetViewPanorama)
      ).call(this, props, context)
    )

    ;(0, _invariant2.default)(
      !!_this.context[_constants.MAP],
      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
    )
    ;(0, _MapChildHelper.construct)(
      StreetViewPanorama.propTypes,
      updaterMap,
      _this.props,
      _this.context[_constants.MAP].getStreetView()
    )
    return _this
  }

  ;(0, _createClass3.default)(StreetViewPanorama, [
    {
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)(
          {},
          _constants.MAP,
          this.context[_constants.MAP].getStreetView()
        )
      },
    },
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.context[_constants.MAP].getStreetView(),
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
        if (streetViewPanorama) {
          streetViewPanorama.setVisible(false)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        var children = this.props.children

        return _react2.default.createElement("div", null, children)
      },

      /**
       * Returns the set of navigation links for the Street View panorama.
       * @type Array<StreetViewLink>
       * @public
       */
    },
    {
      key: "getLinks",
      value: function getLinks() {
        return this.context[_constants.MAP].getLinks()
      },

      /**
       * Returns the StreetViewLocation of the current panorama.
       * @type StreetViewLocation
       * @public
       */
    },
    {
      key: "getLocation",
      value: function getLocation() {
        return this.context[_constants.MAP].getLocation()
      },

      /**
       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
       * @type boolean
       * @public
       */
    },
    {
      key: "getMotionTracking",
      value: function getMotionTracking() {
        return this.context[_constants.MAP].getMotionTracking()
      },

      /**
       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
       * @type string
       * @public
       */
    },
    {
      key: "getPano",
      value: function getPano() {
        return this.context[_constants.MAP].getPano()
      },

      /**
       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
       * @type StreetViewPovpano_changed
       * @public
       */
    },
    {
      key: "getPhotographerPov",
      value: function getPhotographerPov() {
        return this.context[_constants.MAP].getPhotographerPov()
      },

      /**
       * Returns the current `LatLng` position for the Street View panorama.
       * @type LatLngLatLng
       * @public
       */
    },
    {
      key: "getPosition",
      value: function getPosition() {
        return this.context[_constants.MAP].getPosition()
      },

      /**
       * Returns the current point of view for the Street View panorama.
       * @type StreetViewPov
       * @public
       */
    },
    {
      key: "getPov",
      value: function getPov() {
        return this.context[_constants.MAP].getPov()
      },

      /**
       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
       * @type StreetViewStatussetPosition()setPano()
       * @public
       */
    },
    {
      key: "getStatus",
      value: function getStatus() {
        return this.context[_constants.MAP].getStatus()
      },

      /**
       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
       * @type booleantrue
       * @public
       */
    },
    {
      key: "getVisible",
      value: function getVisible() {
        return this.context[_constants.MAP].getVisible()
      },

      /**
       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
       * @type number
       * @public
       */
    },
    {
      key: "getZoom",
      value: function getZoom() {
        return this.context[_constants.MAP].getZoom()
      },
    },
  ])
  return StreetViewPanorama
})(
  _react2.default.PureComponent
)) /*
                                   * -----------------------------------------------------------------------------
                                   * This file is auto-generated from the corresponding file at `src/macros/`.
                                   * Please **DO NOT** edit this file directly when creating PRs.
                                   * -----------------------------------------------------------------------------
                                   */

StreetViewPanorama.propTypes = {
  /**
   * @type Array<StreetViewLink>
   */
  defaultLinks: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultMotionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  defaultOptions: _propTypes2.default.any,

  /**
   * @type string
   */
  defaultPano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  defaultPosition: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  defaultPov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  defaultVisible: _propTypes2.default.bool,

  /**
   * @type number
   */
  defaultZoom: _propTypes2.default.number,

  /**
   * @type Array<StreetViewLink>
   */
  links: _propTypes2.default.any,

  /**
   * @type boolean
   */
  motionTracking: _propTypes2.default.bool,

  /**
   * @type StreetViewPanoramaOptions
   */
  options: _propTypes2.default.any,

  /**
   * @type string
   */
  pano: _propTypes2.default.string,

  /**
   * @type LatLng|LatLngLiteral
   */
  position: _propTypes2.default.any,

  /**
   * @type StreetViewPov
   */
  pov: _propTypes2.default.any,

  /**
   * @type boolean
   */
  visible: _propTypes2.default.bool,

  /**
   * @type number
   */
  zoom: _propTypes2.default.number,

  /**
   * function
   */
  onCloseClick: _propTypes2.default.func,

  /**
   * function
   */
  onPanoChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPositionChanged: _propTypes2.default.func,

  /**
   * function
   */
  onPovChanged: _propTypes2.default.func,

  /**
   * function
   */
  onResize: _propTypes2.default.func,

  /**
   * function
   */
  onStatusChanged: _propTypes2.default.func,

  /**
   * function
   */
  onVisibleChanged: _propTypes2.default.func,

  /**
   * function
   */
  onZoomChanged: _propTypes2.default.func,
}
StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = StreetViewPanorama

var eventMap = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed",
}

var updaterMap = {
  links: function links(instance, _links) {
    instance.setLinks(_links)
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking)
  },
  options: function options(instance, _options) {
    instance.setOptions(_options)
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano)
  },
  position: function position(instance, _position) {
    instance.setPosition(_position)
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov)
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible)
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom)
  },
}


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = __webpack_require__(13)

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = __webpack_require__(8)

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = __webpack_require__(9)

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = __webpack_require__(10)

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = __webpack_require__(11)

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = __webpack_require__(12)

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = __webpack_require__(0)

var _react2 = _interopRequireDefault(_react)

var _propTypes = __webpack_require__(4)

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = __webpack_require__(15)

var _constants = __webpack_require__(14)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(481);


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCustomGoogleAutocomplete = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactGoogleAutocomplete = function (_React$Component) {
  _inherits(ReactGoogleAutocomplete, _React$Component);

  function ReactGoogleAutocomplete(props) {
    _classCallCheck(this, ReactGoogleAutocomplete);

    var _this = _possibleConstructorReturn(this, (ReactGoogleAutocomplete.__proto__ || Object.getPrototypeOf(ReactGoogleAutocomplete)).call(this, props));

    _this.handleLoadScript = function () {
      var googleMapsScriptUrl = 'https://maps.googleapis.com/maps/api/js?key=' + _this.props.apiKey + '&libraries=places';

      // Check if script exists already
      if (document.querySelectorAll('script[src="' + googleMapsScriptUrl + '"]').length > 0) {
        return Promise.resolve();
      }

      _this.googleMapsScript = document.createElement('script');
      _this.googleMapsScript.src = googleMapsScriptUrl;

      document.body.appendChild(_this.googleMapsScript);

      return new Promise(function (resolve) {
        _this.googleMapsScript.addEventListener('load', function () {
          return resolve();
        });
      });
    };

    _this.autocomplete = null;
    _this.event = null;
    return _this;
  }

  _createClass(ReactGoogleAutocomplete, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          _props$types = _props.types,
          types = _props$types === undefined ? ['(cities)'] : _props$types,
          componentRestrictions = _props.componentRestrictions,
          bounds = _props.bounds,
          apiKey = _props.apiKey,
          _props$fields = _props.fields,
          fields = _props$fields === undefined ? ['address_components', 'geometry.location', 'place_id', 'formatted_address'] : _props$fields;

      var config = {
        types: types,
        bounds: bounds,
        fields: fields
      };

      if (componentRestrictions) {
        config.componentRestrictions = componentRestrictions;
      }

      this.disableAutofill();

      var handleAutoComplete = function handleAutoComplete() {
        _this2.autocomplete = new google.maps.places.Autocomplete(_this2.refs.input, config);

        _this2.event = _this2.autocomplete.addListener('place_changed', _this2.onSelected.bind(_this2));
      };

      if (apiKey) {
        this.handleLoadScript().then(function () {
          return handleAutoComplete();
        });
      } else {
        handleAutoComplete();
      }
    }
  }, {
    key: 'disableAutofill',
    value: function disableAutofill() {
      var _this3 = this;

      // Autofill workaround adapted from https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/49161445#49161445
      if (window.MutationObserver) {
        var observerHack = new MutationObserver(function () {
          observerHack.disconnect();
          if (_this3.refs && _this3.refs.input) {
            _this3.refs.input.autocomplete = _this3.props.inputAutocompleteValue || 'new-password';
          }
        });
        observerHack.observe(this.refs.input, {
          attributes: true,
          attributeFilter: ['autocomplete']
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.event) this.event.remove();
    }
  }, {
    key: 'onSelected',
    value: function onSelected() {
      if (this.props.onPlaceSelected && this.autocomplete) {
        this.props.onPlaceSelected(this.autocomplete.getPlace(), this.refs.input);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onPlaceSelected = _props2.onPlaceSelected,
          types = _props2.types,
          componentRestrictions = _props2.componentRestrictions,
          bounds = _props2.bounds,
          apiKey = _props2.apiKey,
          rest = _objectWithoutProperties(_props2, ['onPlaceSelected', 'types', 'componentRestrictions', 'bounds', 'apiKey']);

      return _react2.default.createElement('input', _extends({ ref: 'input' }, rest));
    }
  }]);

  return ReactGoogleAutocomplete;
}(_react2.default.Component);

ReactGoogleAutocomplete.propTypes = {
  onPlaceSelected: _propTypes2.default.func,
  types: _propTypes2.default.array,
  componentRestrictions: _propTypes2.default.object,
  bounds: _propTypes2.default.object,
  fields: _propTypes2.default.array,
  inputAutocompleteValue: _propTypes2.default.string,
  apiKey: _propTypes2.default.string
};
exports.default = ReactGoogleAutocomplete;

var ReactCustomGoogleAutocomplete = exports.ReactCustomGoogleAutocomplete = function (_React$Component2) {
  _inherits(ReactCustomGoogleAutocomplete, _React$Component2);

  function ReactCustomGoogleAutocomplete(props) {
    _classCallCheck(this, ReactCustomGoogleAutocomplete);

    var _this4 = _possibleConstructorReturn(this, (ReactCustomGoogleAutocomplete.__proto__ || Object.getPrototypeOf(ReactCustomGoogleAutocomplete)).call(this, props));

    _this4.service = new google.maps.places.AutocompleteService();
    return _this4;
  }

  _createClass(ReactCustomGoogleAutocomplete, [{
    key: 'onChange',
    value: function onChange(e) {
      var _this5 = this;

      var _props$types2 = this.props.types,
          types = _props$types2 === undefined ? ['(cities)'] : _props$types2;


      if (e.target.value) {
        this.service.getPlacePredictions({ input: e.target.value, types: types }, function (predictions, status) {
          if (status === 'OK' && predictions && predictions.length > 0) {
            _this5.props.onOpen(predictions);
          } else {
            _this5.props.onClose();
          }
        });
      } else {
        this.props.onClose();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this6 = this;

      if (this.props.input.value) {
        this.placeService = new google.maps.places.PlacesService(this.refs.div);
        this.placeService.getDetails({ placeId: this.props.input.value }, function (e, status) {
          if (status === 'OK') {
            _this6.refs.input.value = e.formatted_address;
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.cloneElement(this.props.input, _extends({}, this.props, {
          ref: 'input',
          onChange: function onChange(e) {
            _this7.onChange(e);
          }
        })),
        _react2.default.createElement('div', { ref: 'div' })
      );
    }
  }]);

  return ReactCustomGoogleAutocomplete;
}(_react2.default.Component);

ReactCustomGoogleAutocomplete.propTypes = {
  input: _propTypes2.default.node.isRequired,
  onOpen: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var regeneratorRuntime = __webpack_require__(483);function asyncGeneratorStep(e,r,n,t,o,a,c){try{var s=e[a](c),u=s.value}catch(e){return void n(e)}s.done?r(u):Promise.resolve(u).then(t,o)}function _asyncToGenerator(e){return function(){var r=this,n=arguments;return new Promise(function(t,o){var a=e.apply(r,n);function c(e){asyncGeneratorStep(a,t,o,c,s,"next",e)}function s(e){asyncGeneratorStep(a,t,o,c,s,"throw",e)}c(void 0)})}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var DEBUG=!1,API_KEY=null,LANGUAGE="en",REGION=null,GOOGLE_API="https://maps.google.com/maps/api/geocode/json";function log(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];DEBUG&&(r?console.warn(e):console.log(e))}function handleUrl(e){return _handleUrl.apply(this,arguments)}function _handleUrl(){return(_handleUrl=_asyncToGenerator(regeneratorRuntime.mark(function e(r){var n,t;return regeneratorRuntime.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch(r).catch(function(){return Promise.reject(new Error("Error fetching data"))});case 2:return n=e.sent,e.next=5,n.json().catch(function(){return log("Error parsing server response"),Promise.reject(new Error("Error parsing server response"))});case 5:if("OK"!==(t=e.sent).status){e.next=9;break}return log(t),e.abrupt("return",t);case 9:return log("".concat(t.error_message,".\nServer returned status code ").concat(t.status),!0),e.abrupt("return",Promise.reject(new Error("".concat(t.error_message,".\nServer returned status code ").concat(t.status))));case 11:case"end":return e.stop()}},e)}))).apply(this,arguments)}var _default={setApiKey:function(apiKey){API_KEY=apiKey},setLanguage:function(language){LANGUAGE=language},setRegion:function(region){REGION=region},enableDebug:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];DEBUG=e},fromLatLng:function(lat,lng,apiKey,language,region){return _asyncToGenerator(regeneratorRuntime.mark(function a(){var c,s;return regeneratorRuntime.wrap(function(a){for(;;)switch(a.prev=a.next){case 0:if(lat&&lng){a.next=3;break}return log("Provided coordinates are invalid",!0),a.abrupt("return",Promise.reject(new Error("Provided coordinates are invalid")));case 3:return c="".concat(lat,",").concat(lng),s="".concat(GOOGLE_API,"?latlng=").concat(encodeURIComponent(c)),(apiKey||API_KEY)&&(s+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(s+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,s+="&region=".concat(encodeURIComponent(REGION))),a.abrupt("return",handleUrl(s));case 9:case"end":return a.stop()}},a)}))()},fromAddress:function(address,apiKey,language,region){return _asyncToGenerator(regeneratorRuntime.mark(function o(){var a;return regeneratorRuntime.wrap(function(o){for(;;)switch(o.prev=o.next){case 0:if(address){o.next=3;break}return log("Provided address is invalid",!0),o.abrupt("return",Promise.reject(new Error("Provided address is invalid")));case 3:return a="".concat(GOOGLE_API,"?address=").concat(encodeURIComponent(address)),(apiKey||API_KEY)&&(a+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(a+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,a+="&region=".concat(encodeURIComponent(REGION))),o.abrupt("return",handleUrl(a));case 8:case"end":return o.stop()}},o)}))()}};exports.default=_default;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Profile = function (_React$Component) {
    _inherits(Profile, _React$Component);

    function Profile(props) {
        _classCallCheck(this, Profile);

        var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            localStorage.removeItem('Verified');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: false,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(Profile, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, userNAME: result.user_name, userIMAGE: result.user_image, userMOBILE: result.user_mobile, userVERIFIED: result.user_verified, userEMAIL: result.user_email, activeORDERS: result.active_orders, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            if (localStorage.getItem('userData') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            if (this.state.LoggedOut) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Profile';0;
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section half mt-2 text-center' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title text-center' },
                            this.state.userNAME
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title text-center' },
                            this.state.userEMAIL
                        ),
                        this.state.userMOBILE != '' && _react2.default.createElement(
                            'div',
                            { className: 'section-title text-center' },
                            this.state.userMOBILE
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2 mb-2' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'listview image-listview' },
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/orders', className: 'item' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'icon-box' },
                                        _react2.default.createElement('ion-icon', { name: 'reader-outline' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            'Recent Orders'
                                        ),
                                        this.state.activeORDERS != '' && _react2.default.createElement(
                                            'span',
                                            { className: 'badge badge-primary' },
                                            this.state.activeORDERS
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/addresses', className: 'item' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'icon-box' },
                                        _react2.default.createElement('ion-icon', { name: 'location-outline' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            'Delivery Addresses'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/account_settings', className: 'item' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'icon-box' },
                                        _react2.default.createElement('ion-icon', { name: 'cog-outline' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            'Account Settings'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/change_password', className: 'item' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'icon-box' },
                                        _react2.default.createElement('ion-icon', { name: 'git-compare-outline' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            'Change Password'
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '#', className: 'item', onClick: function onClick() {
                                            _this2.handleClickModalLogOut();
                                        } },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'icon-box' },
                                        _react2.default.createElement('ion-icon', { name: 'log-out-outline' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'div',
                                            null,
                                            'Log Out'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalLogout', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-header' },
                                    _react2.default.createElement(
                                        'h5',
                                        { className: 'modal-title' },
                                        '\xA0'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    'You are about to logout. Continue?'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: this.handleClickLogOut },
                                            'Yes'
                                        ),
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                            'No'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Profile;
}(_react2.default.Component);

exports.default = Profile;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountSettings = function (_React$Component) {
    _inherits(AccountSettings, _React$Component);

    function AccountSettings(props) {
        _classCallCheck(this, AccountSettings);

        var _this = _possibleConstructorReturn(this, (AccountSettings.__proto__ || Object.getPrototypeOf(AccountSettings)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmAccount')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmAccount')[0].classList.add('was-validated');

            if (err == 0) {
                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/accountupdate_api.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    //alert(result);
                    var updated = false;
                    var notify = '';
                    if (result.err != '' && result.err != undefined) {
                        if (result.err == '1') notify = 'Name Field is Empty';else if (result.err == '2') notify = 'Email Id Field is Empty';else if (result.err == '3') notify = 'Mobile Area Code Field is Empty';else if (result.err == '4') notify = 'Mobile No Field is Empty';else if (result.err == '5') notify = 'Invalid Access Detected';else if (result.err == '6') notify = 'A different user exists with the mobile area code and number entered';
                    } else updated = true;

                    var userMOBILECODE = '+91';
                    if (result.user_mobilecode !== '' && result.user_mobilecode !== undefined && result.user_mobilecode !== 'undefined') userMOBILECODE = result.user_mobilecode;

                    that.setState({ Notifications: notify, Updated: updated, userNAME: result.user_name, userIMAGE: result.user_image, userMOBILE: result.user_mobile, userEMAIL: result.user_email, userMOBILECODE: userMOBILECODE, userMOBILENO: result.user_mobileno });
                    $('#submitLoading').css('display', 'none');

                    if (notify != '') $('#ModalAlert').modal('show');
                    if (updated) $('#ModalUpdated').modal('show');
                });
            }
        };

        _this.state = {
            LOADING: true,
            Notifications: false,
            Updated: false,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userEMAIL: '',
            userMOBILECODE: '',
            userMOBILENO: '',
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(AccountSettings, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                var userMOBILECODE = '+91';
                if (result.user_mobilecode !== '' && result.user_mobilecode !== undefined && result.user_mobilecode !== 'undefined') userMOBILECODE = result.user_mobilecode;

                that.setState({ LOADING: false, userNAME: result.user_name, userIMAGE: result.user_image, userMOBILE: result.user_mobile, userEMAIL: result.user_email, CUSTOMER_DET: CUSTOMER_DET, userMOBILECODE: userMOBILECODE, userMOBILENO: result.user_mobileno });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (localStorage.getItem('userData') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/profile';
            var AppHeaderTitle = 'Edit Profile';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section pt-6' },
                            _react2.default.createElement('img', { src: '/assets/img/done-image.png', alt: 'image', className: 'form-image imaged w140' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-5 mb-5 pr-3 pl-3' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmAccount', encType: 'multipart/form-data', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'UPDATE', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtusername' },
                                            'Enter Your Name'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusername', id: 'txtusername', required: true, defaultValue: this.state.userNAME }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your name.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtuseremail' },
                                            'Enter Your Email Address'
                                        ),
                                        _react2.default.createElement('input', { type: 'email', className: 'square-inputbox form-control', name: 'txtuseremail', id: 'txtuseremail', required: true, pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$', defaultValue: this.state.userEMAIL }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your email address.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-20' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusercode' },
                                                'Code'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusercode', id: 'txtusercode', required: true, minLength: '3', maxLength: '6', autoComplete: 'off', defaultValue: this.state.userMOBILECODE }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your area code.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'wid-80' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'input-wrapper' },
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'label', htmlFor: 'txtusermobile' },
                                                'Mobile No'
                                            ),
                                            _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusermobile', id: 'txtusermobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off', defaultValue: this.state.userMOBILENO }),
                                            _react2.default.createElement(
                                                'i',
                                                { className: 'clear-input' },
                                                _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'valid-feedback' },
                                                '\xA0'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'invalid-feedback' },
                                                'Please enter your 10 digit mobile no.'
                                            )
                                        )
                                    ),
                                    _react2.default.createElement('div', { className: 'clear' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group1 pr-2 pl-2' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-6' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-upper' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'col-12' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'submit', className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block' },
                                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                                        'SAVE'
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-6' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-upper' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'col-12' },
                                                    _react2.default.createElement(
                                                        _reactRouterDom.Link,
                                                        { to: '/profile', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                                        'Cancel'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalUpdated', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-success' },
                                        _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        'Account Details Updated Successfully'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return AccountSettings;
}(_react2.default.Component);

exports.default = AccountSettings;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangePassword = function (_React$Component) {
    _inherits(ChangePassword, _React$Component);

    function ChangePassword(props) {
        _classCallCheck(this, ChangePassword);

        var _this = _possibleConstructorReturn(this, (ChangePassword.__proto__ || Object.getPrototypeOf(ChangePassword)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmPassword')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmPassword')[0].classList.add('was-validated');

            var password = $('#txtpassword').val().trim();
            var password2 = $('#txtpassword2').val().trim();

            if (password != password2) {
                err++;
                $('#txtpassword2').val('');
            }

            if (err == 0) {
                var pass = $('#txtpassword').val();
                $('#txtpassword').val(window.b64_md5(pass));

                var pass2 = $('#txtpassword2').val();
                $('#txtpassword2').val(window.b64_md5(pass2));

                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/accountupdate_api2.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    //alert(result);
                    var updated = false;
                    var notify = '';
                    if (result.err != '' && result.err != undefined) {
                        if (result.err == '1') notify = 'Invalid Customer Details';else if (result.err == '2') notify = 'Invalid Access Detected';
                    } else updated = true;

                    that.setState({ Notifications: notify, Updated: updated, Password: '', Password2: '' });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                    if (updated) $('#ModalUpdated').modal('show');
                });
            }
        };

        _this.state = {
            LOADING: true,
            Notifications: false,
            Password: '',
            Password2: '',
            Updated: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(ChangePassword, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (localStorage.getItem('userData') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/profile';
            var AppHeaderTitle = 'Change Password';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-1' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section pt-6' },
                            _react2.default.createElement('img', { src: '/assets/img/done-image.png', alt: 'image', className: 'form-image imaged w140' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-5 mb-5 pr-3 pl-3' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmPassword', encType: 'multipart/form-data', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'UPDATE2', className: 'form-control', name: 'mode', id: 'mode' }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer' }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtpassword' },
                                            'Enter New Password'
                                        ),
                                        _react2.default.createElement('input', { type: 'password', className: 'square-inputbox form-control', name: 'txtpassword', id: 'txtpassword', minLength: '8', required: true, defaultValue: this.state.Password, autoComplete: 'off' }),
                                        ' ',
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Must contain at least 8 or more characters.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed mb-1' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtpassword2' },
                                            'Re-enter New Password'
                                        ),
                                        _react2.default.createElement('input', { type: 'password', className: 'square-inputbox form-control', name: 'txtpassword2', id: 'txtpassword2', minLength: '8', required: true, defaultValue: this.state.Password2, autoComplete: 'off' }),
                                        ' ',
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Must contain at least 8 or more characters.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Save'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalUpdated', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-success' },
                                        _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        'Password Details Updated Successfully'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return ChangePassword;
}(_react2.default.Component);

exports.default = ChangePassword;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerAddressesList = function CustomerAddressesList(props) {
    return props.address.map(function (post) {
        return _react2.default.createElement(
            'div',
            { className: 'wide-block pt-2 pb-2', key: post.ID },
            _react2.default.createElement(
                'div',
                { className: 'sumup pr-1 pl-1' },
                _react2.default.createElement(
                    'h5',
                    { className: 'font-weg-400 mb-05' },
                    post.CIRCLE,
                    _react2.default.createElement(
                        'span',
                        { className: 'badge chip-warning chip-outline ht-17 font-size-10 font-weg-600 text-upper ltsp' },
                        post.LABEL
                    )
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'w-80 font-size-13l font-weg-300 mb-05' },
                    post.ADDRESS
                ),
                post.MOBILE_NO && _react2.default.createElement(
                    'div',
                    { className: 'stateline pin' },
                    _react2.default.createElement(
                        'span',
                        { className: 'text-lgrey font-size-12 mb-05 mr-1' },
                        post.MOBILE_NO
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'stateline pt-1' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/addressdetails/' + post.ID, type: 'button', className: 'btn btn-xsm square btn-outline-danger newshadowed shadowed mr-1 mb-1 text-upper' },
                        'Edit'
                    ),
                    _react2.default.createElement(
                        'button',
                        { onClick: function onClick() {
                                props.handleDeleteClickModal(post.ID);
                            }, type: 'button', className: 'btn btn-xsm square btn-outline-danger newshadowed shadowed mr-1 mb-1 text-upper' },
                        'Delete'
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'modal fade dialogbox', id: 'ModalDeleteAddress_' + post.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-dialog', role: 'document' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-header' },
                            _react2.default.createElement(
                                'h5',
                                { className: 'modal-title' },
                                '\xA0'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-body' },
                            'You are about to delete this address. Continue?'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-footer' },
                            _react2.default.createElement(
                                'div',
                                { className: 'btn-inline' },
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: function onClick() {
                                            props.handleClickDeleteAddress(post.ID);
                                        } },
                                    'Yes'
                                ),
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                    'No'
                                )
                            )
                        )
                    )
                )
            )
        );
    });
};

var CustomerAddresses = function (_React$Component) {
    _inherits(CustomerAddresses, _React$Component);

    function CustomerAddresses(props) {
        _classCallCheck(this, CustomerAddresses);

        var _this = _possibleConstructorReturn(this, (CustomerAddresses.__proto__ || Object.getPrototypeOf(CustomerAddresses)).call(this, props));
        //console.log(props);


        _this.handleDeleteClickModal = function (id) {
            $('#ModalDeleteAddress_' + id).modal('show');
        };

        _this.handleClickDeleteAddress = function (id) {
            $('#submitLoading_' + id).css('display', 'block');

            var customer = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            var mode = 'DELETE_ADDRESS';
            var that = _this;
            fetch('https://m.donedelivery.in/api/customeraddaddress_api.php?mode=' + mode + '&customer=' + customer + '&address_id=' + id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                //console.log(result);
                var deleted = result.deleted;
                if (deleted == '' || deleted == undefined) deleted = '';

                if (deleted == 'Y') {
                    var address_id = localStorage.getItem('addressID');
                    if (address_id == id) {
                        localStorage.removeItem('addressID');
                    }
                }

                that.fetchCustomerAddresses('ADDRESS', customer);
                if (deleted == 'Y') $('#ModalAlert2').modal('show');
            });
        };

        _this.state = {
            LOADING: true,
            LOCATION: _this.props.location.pathname,
            CustomerAddresses: [],
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CustomerAddresses, [{
        key: 'fetchCustomerAddresses',
        value: function fetchCustomerAddresses(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customeralladdress_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_address = result.addresses;
                if (customer_address == '' || customer_address == undefined) customer_address = '';

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CustomerAddresses: customer_address, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            this.fetchCustomerAddresses('ADDRESS', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/profile';
            var AppHeaderTitle = 'Adresses';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            var props = {
                address: this.state.CustomerAddresses,
                handleClickDeleteAddress: this.handleClickDeleteAddress,
                handleDeleteClickModal: this.handleDeleteClickModal
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'delivery-location section full mt-0' },
                        this.state.CustomerAddresses.length != '' && _react2.default.createElement(CustomerAddressesList, props),
                        this.state.CustomerAddresses.length == '' && _react2.default.createElement(
                            'div',
                            { className: 'section pt-6', style: { textAlign: 'center' } },
                            _react2.default.createElement('img', { src: '/assets/img/no-address.png', alt: 'no-address', className: 'form-image imaged w200' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-button-group1 pr-2 pl-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/addaddress2', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                            'Add New Address'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalAlert2', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-icon text-success' },
                                    _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    'Address Details Deleted Successfully'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                            'Ok'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return CustomerAddresses;
}(_react2.default.Component);

exports.default = CustomerAddresses;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _googleMapsReact = __webpack_require__(39);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _UpdateMap = __webpack_require__(122);

var _UpdateMap2 = _interopRequireDefault(_UpdateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStyles = {
    width: '90%',
    height: '300px'
};

var CustomerAddressDetails = function (_React$Component) {
    _inherits(CustomerAddressDetails, _React$Component);

    function CustomerAddressDetails(props) {
        _classCallCheck(this, CustomerAddressDetails);

        var _this = _possibleConstructorReturn(this, (CustomerAddressDetails.__proto__ || Object.getPrototypeOf(CustomerAddressDetails)).call(this, props));
        //console.log(props);


        _initialiseProps.call(_this);

        _this.state = {
            LOADING: true,
            id: props.match.params.id,
            CustomerAddress: [],
            addressUpdated: false,
            Notifications: false,
            DeliveryCirlce: '',
            DeliveryArea: '',
            showingInfoWindow: false, //Hides or the shows the infoWindow
            activeMarker: {}, //Shows the active marker upon click
            selectedPlace: {}, //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: '',
            landmark: '',
            label: ''
        };
        return _this;
    }

    _createClass(CustomerAddressDetails, [{
        key: 'fetchCustomerAddress',
        value: function fetchCustomerAddress(mode, customer, address_id) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customeraddressdetails_api.php?mode=' + mode + '&customer=' + customer + '&id=' + address_id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_address = result.address;
                if (customer_address == '' || customer_address == undefined) customer_address = '';

                var mobileCode = result.mobileCode;
                if (mobileCode == '' || mobileCode == undefined) mobileCode = '+91';

                that.setState({ LOADING: false, CustomerAddress: customer_address, address: customer_address, lat: result.latitude, long: result.longitude, landmark: result.landmark, label: result.label, mobileCode: mobileCode, mobileNo: result.mobileNo });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            this.fetchCustomerAddress('ADDRESS_DETAILS', customer, this.state.id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            /*if(this.state.addressUpdated)
            {
                return (<Redirect to={'/addresses'}/>)
            }*/

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/addresses';
            var AppHeaderTitle = 'Update Address';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule', className: 'mt-1 p-0' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full', style: { height: '300px', width: '100%', marginTop: '57px' } },
                        _react2.default.createElement(
                            'div',
                            { id: 'map' },
                            ' ',
                            this.state.lat != '' && this.state.long != '' && _react2.default.createElement(
                                _UpdateMap2.default,
                                {
                                    centerAroundCurrentLocation: true,
                                    google: this.props.google,
                                    handleGetAddress2: this.handleGetAddress2,
                                    initialCenter: { lat: this.state.lat, lng: this.state.long }
                                },
                                _react2.default.createElement(_googleMapsReact.Marker, {
                                    draggable: true,
                                    name: this.state.address,
                                    onDragend: function onDragend(t, map, coord) {
                                        return _this2.onMarkerDragEnd(coord);
                                    } }),
                                _react2.default.createElement(
                                    _googleMapsReact.InfoWindow,
                                    {
                                        marker: this.state.activeMarker,
                                        visible: this.state.showingInfoWindow,
                                        onClose: this.onClose
                                    },
                                    _react2.default.createElement(
                                        'div',
                                        null,
                                        _react2.default.createElement(
                                            'h4',
                                            null,
                                            this.state.selectedPlace.name
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section pb-5 mt-1 mb-5' },
                        _react2.default.createElement(
                            'form',
                            { id: 'frmUpdateAddress', ref: function ref(el) {
                                    return _this2.form = el;
                                }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                            _react2.default.createElement('input', { type: 'hidden', value: 'UPDATE_ADDRESS', className: 'form-control', name: 'mode', id: 'mode' }),
                            _react2.default.createElement('input', { type: 'hidden', value: this.state.id, className: 'form-control', name: 'address_id', id: 'address_id' }),
                            _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('userData'), className: 'form-control', name: 'customer', id: 'customer' }),
                            _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.lat, className: 'form-control', name: 'lat', id: 'lat', required: true }),
                            _react2.default.createElement('input', { type: 'hidden', defaultValue: this.state.long, className: 'form-control', name: 'long', id: 'long', required: true }),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group boxed' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrapper' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'label', htmlFor: 'txtaddress' },
                                        'Address:'
                                    ),
                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', name: 'txtaddress', id: 'txtaddress', required: true, defaultValue: this.state.address, autoComplete: 'off', onBlur: this.updateGoogleMarker }),
                                    _react2.default.createElement(
                                        'i',
                                        { className: 'clear-input' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'valid-feedback' },
                                        '\xA0'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'invalid-feedback' },
                                        'Please enter your address.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group boxed' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrapper' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'label', htmlFor: 'txtlandmark' },
                                        'Landmark:'
                                    ),
                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'txtlandmark', name: 'txtlandmark', defaultValue: this.state.landmark, required: true, autoComplete: 'off' }),
                                    _react2.default.createElement(
                                        'i',
                                        { className: 'clear-input' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'valid-feedback' },
                                        '\xA0'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'invalid-feedback' },
                                        'Please enter landmark.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group boxed' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'input-wrapper' },
                                    _react2.default.createElement(
                                        'label',
                                        { className: 'label', htmlFor: 'txtlabel' },
                                        'Label: Work, Office, Home, Other...'
                                    ),
                                    _react2.default.createElement('input', { type: 'text', className: 'form-control', id: 'txtlabel', name: 'txtlabel', required: true, autoComplete: 'off', defaultValue: this.state.label }),
                                    _react2.default.createElement(
                                        'i',
                                        { className: 'clear-input' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'valid-feedback' },
                                        '\xA0'
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'invalid-feedback' },
                                        'Please enter label.'
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-group boxed mb-1' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'wid-20' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtcode' },
                                            'Code'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtcode', id: 'txtcode', required: true, minLength: '3', maxLength: '6', autoComplete: 'off', defaultValue: this.state.mobileCode }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your area code.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'wid-80' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement(
                                            'label',
                                            { className: 'label', htmlFor: 'txtmobile' },
                                            'Mobile No'
                                        ),
                                        _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtmobile', id: 'txtmobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off', defaultValue: this.state.mobileNo }),
                                        _react2.default.createElement(
                                            'i',
                                            { className: 'clear-input' },
                                            _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'valid-feedback' },
                                            '\xA0'
                                        ),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter your 10 digit mobile no.'
                                        )
                                    )
                                ),
                                _react2.default.createElement('div', { className: 'clear' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'form-button-group1 pr-2 pl-2' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-6' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-upper' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'row' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-12' },
                                                _react2.default.createElement(
                                                    'button',
                                                    { type: 'submit', className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block' },
                                                    _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                                    'SAVE'
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-6' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'text-upper' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'row' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'col-12' },
                                                _react2.default.createElement(
                                                    _reactRouterDom.Link,
                                                    { to: '/addresses', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                                    'Cancel'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-icon text-danger' },
                                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    this.state.Notifications
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                            'Ok'
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal fade dialogbox', id: 'ModalAlert2', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-dialog', role: 'document' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-content' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-icon text-success' },
                                    _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-body' },
                                    'Address Details Updated Successfully'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-footer' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'btn-inline' },
                                        _react2.default.createElement(
                                            'button',
                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                            'Ok'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CustomerAddressDetails;
}(_react2.default.Component);

//export default AddAddress2;


var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleSubmit = function (e) {
        e.preventDefault();

        var err = 0;
        if ($('#frmUpdateAddress')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmUpdateAddress')[0].classList.add('was-validated');

        if (err == 0) {
            $('#submitLoading').css('display', 'block');

            var method = "POST";
            var body = new FormData(_this3.form);
            //console.log(body);
            var that = _this3;
            fetch("https://m.donedelivery.in/api/customeraddaddress_api.php", { method: method, body: body }).then(function (response) {
                //console.log(response);
                return response.json();
            }).then(function (result) {

                //console.log(result);
                //alert(result);
                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Delivery is currently unavailable in your area.';else if (result.err == '2') notify = 'Delivery is currently unavailable in your area.';else if (result.err == '3') notify = 'Delivery is currently unavailable in your area.';else if (result.err == '4') notify = 'Unknown Customer';else if (result.err == '5') notify = 'Address Field is Empty';else if (result.err == '6') notify = 'Landmark Field is Empty';else if (result.err == '7') notify = 'Label Field is Empty';else if (result.err == '12') notify = 'Invalid Access Detected';else if (result.err == '8') notify = 'Mobile Area Code Field is Empty';else if (result.err == '9') notify = 'Mobile No Field is Empty';
                }

                var addressUpdated = false;
                var address_id = result.address_id;
                if (address_id != '' && address_id != undefined) {
                    addressUpdated = true;
                }

                that.setState({ Notifications: notify, addressUpdated: addressUpdated });
                $('#submitLoading').css('display', 'none');
                if (notify != '') $('#ModalAlert').modal('show');
                if (addressUpdated) $('#ModalAlert2').modal('show');
            });
        }
    };

    this.onMarkerClick = function (props, marker, e) {
        return _this3.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };

    this.handleGetAddress = function (address, lat, long) {
        _this3.setState({ address: address, lat: lat, long: long });
    };

    this.handleGetAddress2 = function (lat, long) {
        _this3.setState({ lat: lat, long: long });
    };

    this.updateGoogleMarker = function (e) {
        var address = e.target.value;
        if (address != '') {
            var that = _this3;
            fetch('https://m.donedelivery.in/api/addresslatlong_api.php?mode=LATLONG&address=' + address, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                if (result.DATA == 'Y') {
                    that.setState({ address: address, lat: result.LAT, long: result.LONG });
                }
            });
        }
    };

    this.onMarkerDragEnd = function (coord) {
        var latLng = coord.latLng;

        var lat = latLng.lat();
        var lng = latLng.lng();

        var requestOption = {
            method: 'GET'
        };

        //console.log(lat +','+ lng);
        var address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + lat + ',' + lng + '&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption).then(function (res) {
            return res.json();
        }).then(function (response) {

            address = response.results[0].formatted_address;
            _this3.setState({ address: address, lat: lat, long: lng });
        }).catch(function (error) {
            console.warn(error);
        });
    };

    this.onClose = function (props) {
        if (_this3.state.showingInfoWindow) {
            _this3.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };
};

exports.default = (0, _googleMapsReact.GoogleApiWrapper)({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(CustomerAddressDetails);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerOrdersList = function CustomerOrdersList(props) {
    return props.orders.map(function (post) {

        var ItemList = '';
        post.ITEMS_DET.map(function (post2) {
            ItemList += post2.QTY + ' ' + post2.PROD + ', ';
        });

        if (ItemList != '') ItemList = ItemList.substring(0, ItemList.length - 2);

        var url = post.STATUS2 == 'D' || post.STATUS2 == 'C' ? 'orderdetails' : 'ordertrack';

        return _react2.default.createElement(
            'li',
            { key: post.ID },
            _react2.default.createElement(
                'span',
                { className: 'for-status' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    { className: 'badge square chip-' + post.STATUS_CSS + '2 ht-16 font-size-9 font-weg-500 text-upper ltsp', to: '/' + url + '/' + post.ID },
                    post.STATUS
                )
            ),
            _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/' + url + '/' + post.ID },
                _react2.default.createElement(
                    'div',
                    { className: 'sumup pt-1 pb-1' },
                    _react2.default.createElement(
                        'h5',
                        { className: 'font-weg-500 mb-0' },
                        post.DATE2,
                        ' | Order ID ',
                        post.ID,
                        ' '
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'text-slgrey font-size-12 mb-05 mr-1' },
                        post.ITEMS_COUNT,
                        ' item',
                        post.ITEMS_COUNT > 1 ? 's' : ''
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'font-size-11 font-weg-400 mt-05 mb-05 new-color', style: { 'height': '28px', 'overflow': 'hidden', 'color': '#727272 !important' } },
                        ItemList
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'stateline' },
                        _react2.default.createElement(
                            'span',
                            { className: 'font-size-14 font-weg-600 mr-1' },
                            '\u20B9 ',
                            post.TOTAL
                        )
                    )
                )
            )
        );
    });
};

var CustomerOrders = function (_React$Component) {
    _inherits(CustomerOrders, _React$Component);

    function CustomerOrders(props) {
        _classCallCheck(this, CustomerOrders);

        var _this = _possibleConstructorReturn(this, (CustomerOrders.__proto__ || Object.getPrototypeOf(CustomerOrders)).call(this, props));
        //console.log(props);


        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            CustomerOrders: [],
            OrdersExist: 'N',
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CustomerOrders, [{
        key: 'fetchCustomerOrders',
        value: function fetchCustomerOrders(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customerorders_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_orders = result.orders;
                if (customer_orders == '' || customer_orders == undefined) customer_orders = '';

                var OrdersExist = 'Y';
                if (customer_orders == '') OrdersExist = 'N';

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CustomerOrders: customer_orders, OrdersExist: OrdersExist, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }

            var customer = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            this.fetchCustomerOrders('ORDERS', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/profile';
            var AppHeaderTitle = 'Orders';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'delivery-location cart-item-review' },
                        this.state.OrdersExist == 'Y' && _react2.default.createElement(
                            'ul',
                            { className: 'listview link-listview bg-white' },
                            this.state.CustomerOrders && _react2.default.createElement(CustomerOrdersList, { orders: this.state.CustomerOrders })
                        ),
                        this.state.OrdersExist == 'N' && _react2.default.createElement(
                            'div',
                            { className: 'section pt-6', style: { textAlign: 'center' } },
                            _react2.default.createElement('img', { src: '/assets/img/no-orders.png', alt: 'no-orders', className: 'form-image imaged w200' })
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return CustomerOrders;
}(_react2.default.Component);

exports.default = CustomerOrders;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrdersItem = function OrdersItem(props) {
    return props.items.map(function (post2) {
        return _react2.default.createElement(
            'li',
            { key: post2.ID },
            _react2.default.createElement(
                'div',
                { className: 'item' },
                _react2.default.createElement(
                    'div',
                    { className: 'in' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-name font-size-12 text-dgrey font-weg-300' },
                        ' ',
                        post2.PROD,
                        ' ( per ',
                        post2.VOLUME,
                        post2.UOM,
                        ') '
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'font-size-12 font-weg-400' },
                        _react2.default.createElement(
                            'span',
                            { className: 'text-danger' },
                            '\u20B9 ',
                            post2.RATE2
                        ),
                        ' x ',
                        post2.QTY
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'badge badge-light font-size-14 font-weg-400' },
                        '\u20B9 ',
                        post2.TOTAL
                    )
                )
            )
        );
    });
};

var OrdersItemList = function OrdersItemList(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(OrdersItem, { key: i, items: post.ITEMS_DET });
    });
};

var Discounts = function Discounts(props) {
    return props.discount.map(function (post2, i) {
        return _react2.default.createElement(
            'ul',
            { className: 'item-total listview image-listview', key: i },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                    _react2.default.createElement(
                        'div',
                        { className: 'in' },
                        _react2.default.createElement(
                            'div',
                            { className: 'item-name text-warning' },
                            post2.NAME
                        ),
                        post2.DISCOUNT == '0' && _react2.default.createElement(
                            'span',
                            { className: 'badge badge-light font-size-14 font-weg-400 text-warning' },
                            post2.TEXT
                        ),
                        post2.DISCOUNT != '0' && _react2.default.createElement(
                            'span',
                            { className: 'badge badge-light font-size-14 font-weg-400 text-warning' },
                            '-\u20B9 ',
                            post2.DISCOUNT
                        )
                    )
                )
            )
        );
    });
};

var CessCharges = function CessCharges(props) {
    return props.cessItems.map(function (post2, i) {
        return _react2.default.createElement(
            'ul',
            { className: 'item-total listview image-listview', key: i },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'item font-size-13 font-weg-300' },
                    _react2.default.createElement(
                        'div',
                        { className: 'in' },
                        _react2.default.createElement(
                            'div',
                            { className: 'item-name' },
                            ' CESS '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-qty' },
                            ' ',
                            post2.PERC,
                            '% '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-light font-size-13 font-weg-300' },
                            '\u20B9 ',
                            post2.VALUE
                        )
                    )
                )
            )
        );
    });
};

var TaxCharges = function TaxCharges(props) {
    return props.taxItems.map(function (post2, i) {
        return _react2.default.createElement(
            'ul',
            { className: 'item-total listview image-listview', key: i },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'item font-size-13 font-weg-300' },
                    _react2.default.createElement(
                        'div',
                        { className: 'in' },
                        _react2.default.createElement(
                            'div',
                            { className: 'item-name' },
                            ' SGST '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-qty' },
                            ' ',
                            post2.PERC,
                            '% '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-light font-size-13 font-weg-300' },
                            '\u20B9 ',
                            post2.SGST
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'item font-size-13 font-weg-300' },
                    _react2.default.createElement(
                        'div',
                        { className: 'in' },
                        _react2.default.createElement(
                            'div',
                            { className: 'item-name' },
                            ' CGST '
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'item-qty' },
                            ' ',
                            post2.PERC,
                            '% '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'badge badge-light font-size-13 font-weg-300' },
                            '\u20B9 ',
                            post2.CGST
                        )
                    )
                )
            )
        );
    });
};

var OrdersTotalBreakUp = function OrdersTotalBreakUp(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { key: i },
            _react2.default.createElement(
                'ul',
                { className: 'item-total listview image-listview' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'item font-size-14 font-weg-400' },
                        _react2.default.createElement(
                            'div',
                            { className: 'in' },
                            _react2.default.createElement(
                                'div',
                                { className: 'item-name' },
                                ' Subtotal '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                '\u20B9 ',
                                post.SUB_TOTAL
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(TaxCharges, { taxItems: props.tax }),
            _react2.default.createElement(CessCharges, { cessItems: props.cess }),
            post.DISCOUNTS_APPLIED.length > 0 && _react2.default.createElement(Discounts, { discount: post.DISCOUNTS_APPLIED }),
            _react2.default.createElement(
                'ul',
                { className: 'item-total listview image-listview' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'item pt-06 pb-06 font-size-14 font-weg-400' },
                        _react2.default.createElement(
                            'div',
                            { className: 'in' },
                            _react2.default.createElement(
                                'div',
                                { className: 'item-name' },
                                ' Delivery Charges '
                            ),
                            post.DELIVERY_CHARGES == '' && _react2.default.createElement(
                                'span',
                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                'Free'
                            ),
                            post.DELIVERY_CHARGES != '' && _react2.default.createElement(
                                'span',
                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                '\u20B9 ',
                                post.DELIVERY_CHARGES
                            )
                        )
                    )
                )
            ),
            post.DELIVERY_GST != '' && _react2.default.createElement(
                'ul',
                { className: 'item-total listview image-listview' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'item font-size-13 font-weg-300' },
                        _react2.default.createElement(
                            'div',
                            { className: 'in' },
                            _react2.default.createElement(
                                'div',
                                { className: 'item-name' },
                                ' SGST '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'item-qty' },
                                ' ',
                                post.DELIVERY_GST,
                                '% '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'badge badge-light font-size-13 font-weg-300' },
                                '\u20B9 ',
                                post.DELIVERY_SGST
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'item font-size-13 font-weg-300' },
                        _react2.default.createElement(
                            'div',
                            { className: 'in' },
                            _react2.default.createElement(
                                'div',
                                { className: 'item-name' },
                                ' CGST '
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'item-qty' },
                                ' ',
                                post.DELIVERY_GST,
                                '% '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'badge badge-light font-size-13 font-weg-300' },
                                '\u20B9 ',
                                post.DELIVERY_CGST
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'ul',
                { className: 'item-total listview image-listview' },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'section-title w-100 font-size-14 d-flex justify-content-between pt-2 pb-2 pr-0 pl-0 medium' },
                        ' Total',
                        _react2.default.createElement(
                            'span',
                            { className: 'font-weg-600' },
                            '\u20B9 ',
                            post.TOTAL
                        )
                    )
                )
            )
        );
    });
};

var OrderAddress = function OrderAddress(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'wide-block loc-details', key: i },
            _react2.default.createElement(
                'p',
                { align: 'left', className: 'labbbel' },
                post.LABEL
            ),
            _react2.default.createElement(
                'p',
                { align: 'left' },
                post.ADDRESS
            ),
            post.ADDRESS2 && _react2.default.createElement(
                'p',
                { align: 'left' },
                post.ADDRESS2
            ),
            post.ADDRESS3 && _react2.default.createElement(
                'p',
                { align: 'left' },
                post.ADDRESS3
            )
        );
    });
};

/*<button key={i} type="button" className={`btn btn-${post.STATUS_CSS} btn-block`}>{post.STATUS}</button>*/

var OrderStatus = function OrderStatus(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(
            'span',
            { key: i, className: 'badge badge-' + post.STATUS_CSS },
            post.STATUS
        );
    });
};

var OrderInstructions = function OrderInstructions(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'row', style: { width: '100%' }, key: i },
            post.INSTRUCTIONS != '' && _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                    'div',
                    { className: 'div-instruction' },
                    _react2.default.createElement('ion-icon', { name: 'chatbox-ellipses-outline' }),
                    '\xA0 Special Instructions: ',
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        { key: i, className: 'p-instruction' },
                        post.INSTRUCTIONS
                    )
                )
            )
        );
    });
};

var OrderCancellationReason = function OrderCancellationReason(props) {
    return props.orders.map(function (post, i) {
        return _react2.default.createElement(
            'div',
            { className: 'row', style: { width: '100%' }, key: i },
            post.CANCELLEDREASON != '' && _react2.default.createElement(
                'div',
                { className: 'col-12' },
                _react2.default.createElement(
                    'div',
                    { className: 'div-instruction' },
                    _react2.default.createElement('ion-icon', { name: 'chatbox-ellipses-outline' }),
                    '\xA0 Reason For Cancellation: ',
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        { key: i, className: 'p-instruction' },
                        post.CANCELLEDREASON
                    )
                )
            )
        );
    });
};

var CustomerOrdersDetails = function (_React$Component) {
    _inherits(CustomerOrdersDetails, _React$Component);

    function CustomerOrdersDetails(props) {
        _classCallCheck(this, CustomerOrdersDetails);

        var _this = _possibleConstructorReturn(this, (CustomerOrdersDetails.__proto__ || Object.getPrototypeOf(CustomerOrdersDetails)).call(this, props));
        //console.log(props);


        _this.handleSubmitComplaint = function (e) {
            e.preventDefault();

            var complaint_text = $('#txtcomplaint').val().trim();
            if (complaint_text !== '') {
                var id = _this.state.id;
                var customer = localStorage.getItem('userData');

                var that = _this;
                fetch('https://m.donedelivery.in/api/customerordercomplaint_api.php?mode=COMPLAINT&id=' + id + '&customer=' + customer + '&txtcomplaint=' + complaint_text, {
                    mode: 'cors',
                    credentials: 'same-origin',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    return response.json();
                }).then(function (result) {

                    $('#DialogIconedInfo').modal('hide');

                    var notify = 'Complaint Registered Successfully';
                    var SUCCESS = 'Y';
                    if (result.err != '' && result.err != undefined && result.err != 'undefined') {
                        if (result.err == '1') notify = 'Invalid Details Detected';else if (result.err == '2') notify = 'ERR';else if (result.err == '3') notify = 'ERR';else if (result.err == '4') notify = 'Invalid Access Detected';

                        SUCCESS = 'N';
                    }

                    that.setState({ Notifications: notify, SUCCESS: SUCCESS });
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            } else alert('The field cannot be empty');
        };

        _this.handleReOrderCart = function () {
            $('#reorderCart').modal('show');
        };

        _this.state = {
            LOADING: true,
            id: props.match.params.id,
            CustomerOrders: [],
            CustomerTax: [],
            CustomerCess: [],
            Notifications: '',
            SUCCESS: ''
        };
        return _this;
    }

    _createClass(CustomerOrdersDetails, [{
        key: 'fetchCustomerOrders',
        value: function fetchCustomerOrders(mode, customer, order_id) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customerordersdet_api.php?mode=' + mode + '&customer=' + customer + '&id=' + order_id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_orders = result.orders;
                if (customer_orders == '' || customer_orders == undefined) customer_orders = '';

                that.setState({ LOADING: false, CustomerOrders: customer_orders, CustomerTax: result.tax, CustomerCess: result.cess });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            this.fetchCustomerOrders('ORDERS', customer, this.state.id);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/orders';
            var AppHeaderTitle = 'Order Details';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2 pb-4' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section inset pt-0 pb-1' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-12' },
                                    this.state.CustomerOrders.length > 0 && this.state.CustomerOrders.map(function (post, i) {
                                        return _react2.default.createElement(
                                            'div',
                                            { className: 'card p-2', key: i },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'content-header p-0 font-size-13 text-dgrey font-weg-500' },
                                                'Delivery Address:'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'section-title w-100  d-flex justify-content-between pt-0 pb-0 pr-0 pl-0' },
                                                _react2.default.createElement(
                                                    'p',
                                                    { className: 'mb-0 pt-05 w-70 text-mgrey font-size-12' },
                                                    post.ADDRESS
                                                ),
                                                _react2.default.createElement(
                                                    'span',
                                                    null,
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'btn text-upper newshadowed font-size-9 square btn-' + post.STATUS_CSS + '2 btn-sm btn-block' },
                                                        post.STATUS
                                                    ),
                                                    _react2.default.createElement(
                                                        'p',
                                                        { className: 'font-size-12 pt-1 text-center' },
                                                        post.DATE2
                                                    )
                                                )
                                            )
                                        );
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-list-items' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'item-title listview image-listview' },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'item font-size-14 font-weg-400' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'in' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-name' },
                                                ' Item '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item-qty' },
                                                ' Qty '
                                            ),
                                            _react2.default.createElement(
                                                'span',
                                                { className: 'badge badge-light font-size-14 font-weg-400' },
                                                'Price'
                                            )
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'listview image-listview' },
                                this.state.CustomerOrders.length > 0 && _react2.default.createElement(OrdersItemList, { orders: this.state.CustomerOrders })
                            ),
                            this.state.CustomerOrders.length > 0 && _react2.default.createElement(OrdersTotalBreakUp, { orders: this.state.CustomerOrders, tax: this.state.CustomerTax, cess: this.state.CustomerCess })
                        ),
                        this.state.CustomerOrders.length > 0 && this.state.CustomerOrders.map(function (post, i) {
                            if (post.STATUS2 === 'D') {
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'pt-0 pr-2 pl-2 pb-4', key: i },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12 p-0' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'anik-jai accordion', id: 'accordionExample1' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'item' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'accordion-header' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { className: 'btn text-danger collapsed mb-05', type: 'button', 'data-toggle': 'collapse', 'data-target': '#accordion1', 'aria-expanded': 'false' },
                                                        ' REGISTER YOUR COMPLAINT? '
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { id: 'accordion1', className: 'accordion-body collapse', 'data-parent': '#accordionExample1' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'accordion-content' },
                                                        _react2.default.createElement('textarea', { rows: '3', className: 'square-inputbox form-control square', name: 'txtcomplaint', id: 'txtcomplaint', placeholder: 'Type Here' })
                                                    ),
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'text-upper' },
                                                        _react2.default.createElement(
                                                            'div',
                                                            { className: 'row' },
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'col-4' },
                                                                ' '
                                                            ),
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'col-4' },
                                                                _react2.default.createElement(
                                                                    'button',
                                                                    { type: 'button', style: { 'height': '31px' }, className: 'btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-llg btn-block goBack', onClick: function onClick(event) {
                                                                            return _this2.handleSubmitComplaint(event);
                                                                        } },
                                                                    'Submit'
                                                                )
                                                            ),
                                                            _react2.default.createElement(
                                                                'div',
                                                                { className: 'col-4' },
                                                                ' '
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-dialog', role: 'document' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-content' },
                                                _this2.state.SUCCESS == 'N' && _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-icon text-danger' },
                                                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                                ),
                                                _this2.state.SUCCESS == 'Y' && _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-icon text-success' },
                                                    _react2.default.createElement('ion-icon', { name: 'checkmark-outline' })
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-body' },
                                                    _this2.state.Notifications
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-footer' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'btn-inline' },
                                                        _react2.default.createElement(
                                                            'button',
                                                            { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                            'Close'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                );
                            }
                        }),
                        this.state.CustomerOrders.length > 0 && this.state.CustomerOrders.map(function (post, i) {
                            if (post.STATUS2 !== 'D') {
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group1 pr-2 pl-2', key: i },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'text-upper' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'row' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'col-12' },
                                                    _react2.default.createElement(
                                                        _reactRouterDom.Link,
                                                        { to: '/ordertrack/' + post.ID, className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                                        'Track Order'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                );
                            }

                            if (post.STATUS2 === 'D') {
                                return _react2.default.createElement(
                                    'div',
                                    { key: i },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form-button-group1 pr-2 pl-2' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-12' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'text-upper' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'row' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'col-12' },
                                                        _react2.default.createElement(
                                                            'button',
                                                            { type: 'button', onClick: function onClick() {
                                                                    _this2.handleReOrderCart();
                                                                }, className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                                            'Re-Order'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal fade dialogbox', id: 'reorderCart', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-dialog', role: 'document' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-content' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-header' },
                                                    _react2.default.createElement(
                                                        'h5',
                                                        { className: 'modal-title' },
                                                        '\xA0'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-body' },
                                                    'Items Out of Stock will not be added to the cart. Continue?'
                                                ),
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'modal-footer' },
                                                    _react2.default.createElement(
                                                        'div',
                                                        { className: 'btn-inline' },
                                                        _react2.default.createElement(
                                                            _reactRouterDom.Link,
                                                            { to: '/reorder/' + post.ID, className: 'btn btn-text-success' },
                                                            'Yes'
                                                        ),
                                                        _react2.default.createElement(
                                                            'button',
                                                            { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                                            'No'
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                );
                            }
                        })
                    )
                )
            );
        }
    }]);

    return CustomerOrdersDetails;
}(_react2.default.Component);

exports.default = CustomerOrdersDetails;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitOrder = function (_React$Component) {
    _inherits(SubmitOrder, _React$Component);

    function SubmitOrder(props) {
        _classCallCheck(this, SubmitOrder);

        var _this = _possibleConstructorReturn(this, (SubmitOrder.__proto__ || Object.getPrototypeOf(SubmitOrder)).call(this, props));

        _this.state = {
            LOADING: true,
            orderSubmitted: 'N',
            orderID: ''
        };
        return _this;
    }

    _createClass(SubmitOrder, [{
        key: 'fetchRestaurantMenu',
        value: function fetchRestaurantMenu(mode, id, items, customer, address_id, anikZai, payMode, offer_id, offer_code) {
            var subsciber_id = localStorage.getItem('SUBSCRIBER_ID');
            var that = this;
            fetch('https://m.donedelivery.in/api/submitorder_api.php?mode=' + mode + '&id=' + id + '&items=' + items + '&customer=' + customer + '&address_id=' + address_id + '&anikZai=' + anikZai + '&rdpaymode=' + payMode + '&subsciber_id=' + subsciber_id + '&offer_id=' + offer_id + '&offer_code=' + offer_code, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var order_submitted = result.order_submitted;
                if (order_submitted == '' || order_submitted == undefined) order_submitted = '';

                if (order_submitted == 'Y') {
                    if (payMode == '1') {
                        localStorage.removeItem('cartCIRCLE');
                        localStorage.removeItem('cartData');
                        localStorage.removeItem('AnikZai');
                        localStorage.removeItem('OFFER_APPLIED');
                        localStorage.removeItem('cartVendorID');
                        localStorage.removeItem('cartVendorName');
                        localStorage.removeItem('cartVendorTypeID');
                    }
                }

                that.setState({ orderSubmitted: order_submitted, orderID: result.order_id });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            var address_id = '';
            var anikZai = '';
            var payMode = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            if (localStorage.getItem('addressID')) address_id = localStorage.getItem('addressID');
            if (localStorage.getItem('AnikZai')) anikZai = localStorage.getItem('AnikZai');

            if (localStorage.getItem('payMode')) payMode = localStorage.getItem('payMode');

            if (anikZai == undefined || anikZai == 'undefined') anikZai = '';

            var circle_id = localStorage.getItem('delCIRCLE');
            var itemLIST = '';
            var cart = localStorage.getItem('cartData');
            var cartData = JSON.parse(cart);
            if (cart !== null && cart !== '{}') {
                Object.keys(cartData).forEach(function (key) {
                    var itemCOUNT = cartData[key];
                    var item = key + '~~**~~' + itemCOUNT;
                    itemLIST += item + ',';
                });
            }

            if (itemLIST != '') {
                itemLIST = itemLIST.substring(0, itemLIST.length - 1);

                var OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
                if (OFFER_APPLIED == null) OFFER_APPLIED = '';

                var offerID = '';
                var offerAPPLIED = '';
                if (OFFER_APPLIED != '') {
                    var OFFER_APPLIED2 = OFFER_APPLIED.split('~~**~~');
                    offerID = OFFER_APPLIED2[0];
                    offerAPPLIED = OFFER_APPLIED2[1];
                }

                this.fetchRestaurantMenu('SUBMIT_ORDER', circle_id, itemLIST, customer, address_id, anikZai, payMode, offerID, offerAPPLIED);
            }
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.orderSubmitted == 'Y') {
                var payMode = localStorage.getItem('payMode');
                if (payMode === null || payMode === '{}') {
                    localStorage.setItem('payMode', '1');
                    var _payMode = localStorage.getItem('payMode');
                }

                if (payMode == '2') {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/pay/' + this.state.orderID });
                } else {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/ordertrack/' + this.state.orderID + '/Y' });
                }
            } else {
                var cartEMPTY = 'Y';
                var cart = localStorage.getItem('cartData');
                var cartData = JSON.parse(cart);
                if (cart !== null && cart !== '{}') {
                    cartEMPTY = 'N';
                }

                if (cartEMPTY == 'Y') {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            if (localStorage.getItem('delCIRCLE') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map' });
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section pt-6', style: { textAlign: 'center' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'spinner-border text-danger', role: 'status' },
                            ' '
                        ),
                        _react2.default.createElement(
                            'h4',
                            { className: 'size-19' },
                            'Please Wait'
                        ),
                        _react2.default.createElement(
                            'h4',
                            { className: 'size-19' },
                            'We are processing your order, do not click back or reload. This process can take sometime'
                        )
                    )
                )
            );
        }
    }]);

    return SubmitOrder;
}(_react2.default.Component);

exports.default = SubmitOrder;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerOrderTrack = function (_React$Component) {
    _inherits(CustomerOrderTrack, _React$Component);

    function CustomerOrderTrack(props) {
        _classCallCheck(this, CustomerOrderTrack);

        var _this = _possibleConstructorReturn(this, (CustomerOrderTrack.__proto__ || Object.getPrototypeOf(CustomerOrderTrack)).call(this, props));
        //console.log(props);


        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            id: props.match.params.id,
            showModal: props.match.params.showModal || 'N',
            orderStatus: '',
            orderTimeline: [],
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CustomerOrderTrack, [{
        key: 'fetchCustomerOrders',
        value: function fetchCustomerOrders(mode, customer, order_id) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customerordertrack_api.php?mode=' + mode + '&customer=' + customer + '&id=' + order_id, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, orderStatus: result.status, orderTimeline: result.timeline, CUSTOMER_DET: CUSTOMER_DET });
                if (that.state.showModal == 'Y') $('#OrderPlacedModal').modal('show');
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }

            var customer = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
            this.fetchCustomerOrders('TRACK_ORDER', customer, this.state.id);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            setTimeout(function () {
                //window.location.href = "/ordertrack/"+this.state.id;
                var customer = '';

                if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
                _this2.fetchCustomerOrders('TRACK_ORDER', customer, _this2.state.id);
            }, 60000);
        }
    }, {
        key: 'render',
        value: function render() {

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/orders';
            var AppHeaderTitle = 'Order Status';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            //console.log(this.props);
            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title' },
                            'Order ID: ',
                            this.state.id
                        ),
                        this.state.orderStatus && _react2.default.createElement(
                            'div',
                            { className: 'content-header mb-05' },
                            'STATUS : ',
                            this.state.orderStatus
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'wide-block' },
                            _react2.default.createElement(
                                'div',
                                { className: 'timeline' },
                                this.state.orderTimeline && this.state.orderTimeline.map(function (post, i) {
                                    return _react2.default.createElement(
                                        'div',
                                        { className: 'item', key: i },
                                        _react2.default.createElement('div', { className: 'dot bg-' + post.css }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'content' },
                                            _react2.default.createElement(
                                                'h4',
                                                { className: 'title' },
                                                post.action
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'text' },
                                                post.date
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'section mt-1 mb-5' },
                        ' ',
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement('div', { className: 'col-2' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-8' },
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/orderdetails/' + this.state.id, className: 'btn square btn-danger btn-block' },
                                    'ORDER SUMMARY'
                                )
                            ),
                            _react2.default.createElement('div', { className: 'col-2' })
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET }),
                this.state.showModal == 'Y' && _react2.default.createElement(
                    'div',
                    { className: 'modal fade dialogbox', id: 'OrderPlacedModal', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-dialog', role: 'document' },
                        _react2.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-icon text-success' },
                                _react2.default.createElement('ion-icon', { name: 'checkmark-circle' })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-header' },
                                _react2.default.createElement(
                                    'h5',
                                    { className: 'modal-title' },
                                    'Thank you for placing an order'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-body' },
                                'Your order ',
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    '#',
                                    this.state.id
                                ),
                                ' will be delivered to you soon'
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-footer' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'btn-inline' },
                                    _react2.default.createElement(
                                        _reactRouterDom.Link,
                                        { to: '/ordertrack/' + this.state.id, className: 'btn', 'data-dismiss': 'modal' },
                                        'Order Status'
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CustomerOrderTrack;
}(_react2.default.Component);

exports.default = CustomerOrderTrack;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlinePay = function (_React$Component) {
  _inherits(OnlinePay, _React$Component);

  function OnlinePay(props) {
    _classCallCheck(this, OnlinePay);

    var _this = _possibleConstructorReturn(this, (OnlinePay.__proto__ || Object.getPrototypeOf(OnlinePay)).call(this, props));

    _this.paymentHandler = function () {
      var payment_amount = _this.state.orderTOTAL;
      var self = _this;
      var options = {
        key: 'rzp_live_8UnEdeyncfgBVF', //'rzp_test_Kd6KJyxOVZnPZu', //process.env.RAZOR_PAY_TEST_KEY,
        receipt: _this.state.id,
        amount: payment_amount * 100,
        name: 'DoneDelivery OrderID: ' + _this.state.id,
        description: 'Order Payment for OrderID: ' + _this.state.id,

        handler: function handler(response) {
          console.log(response);

          var paymentId = response.razorpay_payment_id;
          self.UpdateCustomerOrders2(self.state.id, paymentId, payment_amount);

          var url = 'https://m.donedelivery.in/api/v1/rzp_capture/' + paymentId + '/' + payment_amount;
          //const url = 'http://localhost:3000/api/v1/rzp_capture/'+paymentId+'/'+payment_amount;
          console.log(url);

          // Using my server endpoints to capture the payment
        },


        prefill: {
          name: _this.state.cusNAME,
          email: _this.state.cusEMAIL,
          contact: _this.state.cusPHONE
        },
        notes: {
          address: _this.state.cusADDRESS
        },
        theme: {
          color: '#EC4433'
        }
      };
      var rzp1 = new window.Razorpay(options);

      rzp1.open();
    };

    _this.state = {
      LOADING: true,
      id: props.match.params.id,
      orderTOTAL: 0,
      cusNAME: '',
      cusEMAIL: '',
      cusPHONE: '',
      cusADDRESS: '',
      payment_amount: 0,
      refund_id: 0,
      ORDER_STATUS: ''
    };

    _this.paymentHandler = _this.paymentHandler.bind(_this);
    _this.refundHandler = _this.refundHandler.bind(_this);
    return _this;
  }

  _createClass(OnlinePay, [{
    key: 'fetchCustomerOrders',
    value: function fetchCustomerOrders(mode, customer, order_id) {
      var that = this;
      fetch('https://m.donedelivery.in/api/customerorderdet_api.php?mode=' + mode + '&customer=' + customer + '&id=' + order_id, {
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        //console.log(result);

        that.setState({ orderTOTAL: result.total, cusNAME: result.name, cusEMAIL: result.email, cusPHONE: result.phone, cusADDRESS: result.address });
        if (result.total != 0) that.paymentHandler();
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var customer = '';

      if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');
      this.fetchCustomerOrders('ORDER_DET', customer, this.state.id);
    }
  }, {
    key: 'UpdateCustomerOrders2',
    value: function UpdateCustomerOrders2(order_id, a, b) {
      b = b * 100;
      var mode = 'UPDATE';
      var customer = '';
      if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

      var that = this;
      fetch('https://m.donedelivery.in/api/customerorderupdate_api2.php?mode=' + mode + '&customer=' + customer + '&id=' + order_id + '&a=' + a + '&b=' + b, {
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (result) {
        console.log(result);

        var orderSTATUS = 'FAILURE';
        var ag = result.status;
        if (ag == 'captured') {
          orderSTATUS = 'SUCCESS';
          localStorage.removeItem('cartCIRCLE');
          localStorage.removeItem('cartData');
          localStorage.removeItem('payMode');
          localStorage.removeItem('AnikZai');
          localStorage.removeItem('OFFER_APPLIED');
          localStorage.removeItem('cartVendorID');
          localStorage.removeItem('cartVendorName');
          localStorage.removeItem('cartVendorTypeID');
        } else if (ag == 'authorized') {
          orderSTATUS = 'SUCCESS';
          localStorage.removeItem('cartCIRCLE');
          localStorage.removeItem('cartData');
          localStorage.removeItem('payMode');
          localStorage.removeItem('AnikZai');
          localStorage.removeItem('OFFER_APPLIED');
          localStorage.removeItem('cartVendorID');
          localStorage.removeItem('cartVendorName');
          localStorage.removeItem('cartVendorTypeID');
        }

        that.setState({ LOADING: false, ORDER_STATUS: orderSTATUS });
      });
    }
  }, {
    key: 'refundHandler',
    value: function refundHandler(e) {
      e.preventDefault();
      var refund_id = this.state.refund_id;

      var url = process.env.URL + '/api/v1/rzp_refunds/' + refund_id;

      // Using my server endpoints to initiate the refund
      fetch(url, {
        method: 'get',
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        console.log('Request succeeded with JSON response', data);
        alert("Refund Succeeded");
      }).catch(function (error) {
        console.log('Request failed', error);
      });
    }
  }, {
    key: 'render',
    value: function render() {

      var AppHeaderClass = 'appHeader bg-dark text-light';
      var AppHeaderLeft = '';
      var AppHeaderLeftLink = '';
      var AppHeaderTitle = 'PAYNOW';
      var AppHeaderRight = '';
      var AppHeaderRightLink = '';
      var AppHeaderSearch = '';

      if (this.state.ORDER_STATUS == 'SUCCESS') {
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/ordertrack/' + this.state.id + '/Y' });
      }

      if (this.state.ORDER_STATUS == 'FAILURE') {
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/failure' });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
        _react2.default.createElement(
          'div',
          { id: 'appCapsule' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('div', { className: 'col-2' }),
              _react2.default.createElement(
                'div',
                { className: 'col-8 align-content-center' },
                _react2.default.createElement(
                  'center',
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    'Please do not refresh or click the back button.'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'button',
                    { className: 'btn btn-outline-primary', type: 'button', disabled: '' },
                    _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', role: 'status', 'aria-hidden': 'true' }),
                    'Loading...'
                  )
                )
              ),
              _react2.default.createElement('div', { className: 'col-2' })
            )
          )
        )
      );
    }
  }]);

  return OnlinePay;
}(_react2.default.Component);

exports.default = OnlinePay;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)))

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Failure = function (_React$Component) {
  _inherits(Failure, _React$Component);

  function Failure(props) {
    _classCallCheck(this, Failure);

    var _this = _possibleConstructorReturn(this, (Failure.__proto__ || Object.getPrototypeOf(Failure)).call(this, props));

    _this.state = {
      LOADING: true
    };
    return _this;
  }

  _createClass(Failure, [{
    key: 'render',
    value: function render() {

      var AppHeaderClass = 'appHeader bg-dark text-light';
      var AppHeaderLeft = '';
      var AppHeaderLeftLink = '';
      var AppHeaderTitle = 'Transaction Failed';
      var AppHeaderRight = '';
      var AppHeaderRightLink = '';
      var AppHeaderSearch = '';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
        _react2.default.createElement(
          'div',
          { id: 'appCapsule' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('div', { className: 'col-2' }),
              _react2.default.createElement(
                'div',
                { className: 'col-8 align-content-center' },
                _react2.default.createElement(
                  'center',
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    'Transaction Failed. Please try again'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/cart', 'class': 'btn btn-outline-danger', type: 'button' },
                    'Back'
                  )
                )
              ),
              _react2.default.createElement('div', { className: 'col-2' })
            )
          )
        )
      );
    }
  }]);

  return Failure;
}(_react2.default.Component);

exports.default = Failure;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchLocation = function (_React$Component) {
    _inherits(SearchLocation, _React$Component);

    function SearchLocation(props) {
        _classCallCheck(this, SearchLocation);

        var _this = _possibleConstructorReturn(this, (SearchLocation.__proto__ || Object.getPrototypeOf(SearchLocation)).call(this, props));
        //console.log(props);


        _this.handleGetNewAddressDelCircle = function (address_id, circle_id, circleID2) {
            var allowAddressChange = 'Y';
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var resID = circleID2;
            if (cartCIRCLE !== null && cartCIRCLE !== '{}') {
                if (circle_id != cartCIRCLE) allowAddressChange = 'N';
            }

            //console.log(allowAddressChange);

            //allowAddressChange = 'Y';
            if (allowAddressChange == 'N') $('#ModalOtherDelCircleData_' + address_id).modal('show');else {
                localStorage.setItem('addressID', address_id);
                localStorage.setItem('delCIRCLE', circle_id);
                localStorage.setItem('delCIRCLE2', circleID2);
                localStorage.setItem('GPS', 'N');
                _this.setState({ delCIRCLEUpdated: true });
            }
        };

        _this.handleGetNewAddressDelCircle2 = function (address_id, circle_id, circleID2) {
            localStorage.removeItem('cartCIRCLE');
            localStorage.removeItem('cartData');
            localStorage.removeItem('addressID');
            localStorage.removeItem('AnikZai');
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');

            localStorage.setItem('addressID', address_id);
            localStorage.setItem('delCIRCLE', circle_id);
            localStorage.setItem('delCIRCLE2', circleID2);
            localStorage.setItem('GPS', 'N');
            _this.setState({ delCIRCLEUpdated: true });
        };

        _this.state = {
            LOADING: true,
            addressChanged: false,
            CustomerAddresses: '',
            delCIRCLEUpdated: false
        };
        return _this;
    }

    _createClass(SearchLocation, [{
        key: 'fetchCustomerAddress',
        value: function fetchCustomerAddress(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/customeraddress_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var customer_addresses = result.addresses;
                if (customer_addresses == '' || customer_addresses == undefined) customer_addresses = '';

                that.setState({ LOADING: false, CustomerAddresses: customer_addresses });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            var delcity = '';
            var delarea = '';

            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var circle_id = localStorage.getItem('delCIRCLE');
            this.fetchCustomerAddress('ADDRESS', customer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //localStorage.removeItem("userData");
            //localStorage.removeItem("cartData");
            //localStorage.removeItem("delCity");
            //localStorage.removeItem("delArea");
            //console.log(localStorage.getItem('userData'));

            if (this.state.delCIRCLEUpdated == true) {
                if (localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE') != null) {
                    return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
                }
            }

            var logged = 'N';
            if (localStorage.getItem('userData')) logged = 'Y';

            if (logged == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map' });
            }

            var address_id = '';
            if (localStorage.getItem('addressID') != null) address_id = localStorage.getItem('addressID');

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Search Location';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'delivery-location section full mt-0' },
                        this.state.CustomerAddresses.length > 0 && this.state.CustomerAddresses.map(function (post) {
                            var checked = false;
                            if (address_id != '' && address_id == post.ID) checked = true;else {
                                if (post.DEFAULT == 'Y') checked = true;
                            }

                            return _react2.default.createElement(
                                'div',
                                { key: post.ID },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'wide-block pt-2 pb-2' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'sumup' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'custom-control custom-radio' },
                                            _react2.default.createElement('input', { type: 'radio', id: 'address_' + post.ID, name: 'address', value: post.ID, className: 'custom-control-input', defaultChecked: checked, onClick: function onClick() {
                                                    _this2.handleGetNewAddressDelCircle(post.ID, post.CIRCLE_ID, post.CIRCLE_ID2);
                                                } }),
                                            _react2.default.createElement(
                                                'label',
                                                { className: 'custom-control-label', htmlFor: 'address_' + post.ID },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'font-weg-400 mb-05' },
                                                    post.CIRCLE,
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'badge chip-warning chip-outline ht-17 font-size-10  font-weg-500 text-upper ltsp' },
                                                        post.LABEL
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'p',
                                                    { className: 'font-size-13l font-weg-300 mb-05' },
                                                    post.ADDRESS
                                                ),
                                                post.MOBILE_NO && _react2.default.createElement(
                                                    'div',
                                                    { className: 'stateline pin' },
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'text-lgrey font-size-12 mb-05 mr-1' },
                                                        post.MOBILE_NO
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalOtherDelCircleData_' + post.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                ' Your cart contains dishes from another location. The cart will be deleted, proceed? '
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { className: 'btn btn-text-success', 'data-dismiss': 'modal', onClick: function onClick() {
                                                                _this2.handleGetNewAddressDelCircle2(post.ID, post.CIRCLE_ID, post.CIRCLE_ID2);
                                                            } },
                                                        'Yes'
                                                    ),
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn btn-text-danger', 'data-dismiss': 'modal' },
                                                        'No'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            );
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-button-group1 pr-2 pl-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-12' },
                            _react2.default.createElement(
                                'div',
                                { className: 'text-upper' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-12' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { to: '/map', className: 'btn newshadowed font-size-14 square btn-danger btn-ssm btn-block' },
                                            'USE CURRENT LOCATION'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SearchLocation;
}(_react2.default.Component);

exports.default = SearchLocation;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AboutUs = function (_React$Component) {
    _inherits(AboutUs, _React$Component);

    function AboutUs(props) {
        _classCallCheck(this, AboutUs);

        var _this = _possibleConstructorReturn(this, (AboutUs.__proto__ || Object.getPrototypeOf(AboutUs)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(AboutUs, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'About Us';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pr-2 pl-2 pt-2 pb-1 font-size-14' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'Done Delivery is a Goa-based consumer friendly hyper-local delivery solution provider which delivers your favorite food from your chosen outlet to your doorstep. It is a subsidiary of Palasha Enterprises which is into FMCG distribution business since Aug 2012. Done Delivery\'s core focus is to be a smooth bridge between partnering restaurants and their customers.'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return AboutUs;
}(_react2.default.Component);

exports.default = AboutUs;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancellationRefunds = function (_React$Component) {
    _inherits(CancellationRefunds, _React$Component);

    function CancellationRefunds(props) {
        _classCallCheck(this, CancellationRefunds);

        var _this = _possibleConstructorReturn(this, (CancellationRefunds.__proto__ || Object.getPrototypeOf(CancellationRefunds)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CancellationRefunds, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Cancellation & Refunds';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pr-2 pl-2 pt-2 pb-1 font-size-14' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'set1 p-0', style: { 'listStyle': 'none' } },
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'h5',
                                        null,
                                        'Cancellation'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'set2 pl-2 pb-2' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-1' },
                                            'As a general rule you shall not be entitled to cancel your order once you have received confirmation of the same. If you cancel your order after it has been confirmed, Done Delivery / Palasha Enterprises shall have a right to charge you cancellation fee of a minimum INR 100/- upto the order value, with a right to either not to refund the order value or recover from your subsequent order, the complete/ deficit cancellation fee, as applicable, to compensate our shop and delivery partners. Done Delivery/ Palasha Enterprises shall also have right to charge you cancellation fee for the orders cancelled by Done Delivery/ Palasha Enterprises for the reasons specified under clause 1(iii) of this cancellation and refunds policy. In case of cancellations for the reasons attributable to Done Delivery/ Palasha Enterprises or its shop and delivery partners, Done Delivery/ Palasha Enterprises shall not charge you any cancellation fee.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-1' },
                                            'However, in the unlikely event of an item on your order being unavailable, we will contact you on the phone number provided to us at the time of placing the order and inform you of such unavailability. In such an event you will be entitled to cancel the entire order and shall be entitled to a refund in accordance with our refund policy.'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-1' },
                                            'We reserve the sole right to cancel your order in the following circumstance:',
                                            _react2.default.createElement(
                                                'ul',
                                                { className: 'set3 pt-05' },
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'in the event of the designated address falls outside the delivery zone offered by us;'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'failure to contact you by phone or email at the time of confirming the order booking;'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'failure to deliver your order due to lack of information, direction or authorization from you at the time of delivery; or'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'unavailability of all the items ordered by you at the time of booking the order; or'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'unavailability of all the items ordered by you at the time of booking the order; or'
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'h5',
                                        null,
                                        'Refunds'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'set2 pl-2 pb-2' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-1' },
                                            'You shall be entitled to a refund only if you pre-pay for your order at the time of placing your order on the Platform and only in the event of any of the following circumstances:',
                                            _react2.default.createElement(
                                                'ul',
                                                { className: 'set3 pt-05' },
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'your order packaging has been tampered or damaged at the time of delivery;'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'us cancelling your order due to',
                                                    _react2.default.createElement(
                                                        'ul',
                                                        { className: 'set4 pt-05' },
                                                        _react2.default.createElement(
                                                            'li',
                                                            { className: 'mb-05' },
                                                            'your delivery location following outside our designated delivery zones;'
                                                        ),
                                                        _react2.default.createElement(
                                                            'li',
                                                            { className: 'mb-05' },
                                                            'failure to contact you by phone or email at the time of confirming the order booking; or'
                                                        ),
                                                        _react2.default.createElement(
                                                            'li',
                                                            { className: 'mb-05' },
                                                            'failure to contact you by phone or email at the time of confirming the order booking; or'
                                                        )
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'you cancelling the order at the time of confirmation due to unavailability of the items you ordered for at the time of booking.'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'Our decision on refunds shall be at our sole discretion and shall be final and binding.'
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    { className: 'mb-05' },
                                                    'All refund amounts shall be credited to your account within 3-4 Working Banking days in accordance with the terms that may be stipulated by the bank which has issued the credit / debit card.'
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    ' In case of payment at the time of delivery, you will not be required to pay for:',
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'set2 pt-05' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'orders where the packaging has been tampered or damaged by us;'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'wrong order being delivered; or'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'items missing from your order at the time of delivery.'
                                        )
                                    )
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return CancellationRefunds;
}(_react2.default.Component);

exports.default = CancellationRefunds;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancellationRefunds = function (_React$Component) {
    _inherits(CancellationRefunds, _React$Component);

    function CancellationRefunds(props) {
        _classCallCheck(this, CancellationRefunds);

        var _this = _possibleConstructorReturn(this, (CancellationRefunds.__proto__ || Object.getPrototypeOf(CancellationRefunds)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CancellationRefunds, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Disclaimer';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pr-2 pl-2 pt-2 pb-1 font-size-14' },
                            _react2.default.createElement(
                                'ul',
                                { className: 'set1 pl-2' },
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'THE PLATFORM MAY BE UNDER CONSTANT UPGRADES, AND SOME FUNCTIONS AND FEATURES MAY NOT BE FULLY OPERATIONAL.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'DUE TO THE VAGARIES THAT CAN OCCUR IN THE ELECTRONIC DISTRIBUTION OF INFORMATION AND DUE TO THE LIMITATIONS INHERENT IN PROVIDING INFORMATION OBTAINED FROM MULTIPLE SOURCES, THERE MAY BE DELAYS, OMISSIONS, OR INACCURACIES IN THE CONTENT PROVIDED ON THE PLATFORM OR DELAY OR ERRORS IN FUNCTIONALITY OF THE PLATFORM. AS A RESULT, WE DO NOT REPRESENT THAT THE INFORMATION POSTED IS CORRECT IN EVERY CASE.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'WE EXPRESSLY DISCLAIM ALL LIABILITIES THAT MAY ARISE AS A CONSEQUENCE OF ANY UNAUTHORIZED USE OF CREDIT/ DEBIT CARDS.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'YOU ACKNOWLEDGE THAT THIRD PARTY SERVICES ARE AVAILABLE ON THE PLATFORM. WE MAY HAVE FORMED PARTNERSHIPS OR ALLIANCES WITH SOME OF THESE THIRD PARTIES FROM TIME TO TIME IN ORDER TO FACILITATE THE PROVISION OF CERTAIN SERVICES TO YOU. HOWEVER, YOU ACKNOWLEDGE AND AGREE THAT AT NO TIME ARE WE MAKING ANY REPRESENTATION OR WARRANTY REGARDING ANY THIRD PARTY\'S SERVICES NOR WILL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY CONSEQUENCES OR CLAIMS ARISING FROM OR IN CONNECTION WITH SUCH THIRD PARTY INCLUDING, AND NOT LIMITED TO, ANY LIABILITY OR RESPONSIBILITY FOR, DEATH, INJURY OR IMPAIRMENT EXPERIENCED BY YOU OR ANY THIRD PARTY. YOU HEREBY DISCLAIM AND WAIVE ANY RIGHTS AND CLAIMS YOU MAY HAVE AGAINST US WITH RESPECT TO THIRD PARTY\'S / PARTNER shopS SERVICES.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'DONE DELIVERY / PALASHA ENTERPRISES DISCLAIMS AND ALL LIABILITY THAT MAY ARISE DUE TO ANY VIOLATION OF THE FOOD SAFETY AND STANDARDS ACT, 2006 AND APPLICABLE RULES AND REGULATIONS MADE THEREUNDER AND SUCH LIABILITY SHALL BE ATTRIBUTABLE TO THE PARTNER shop.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'WHILE THE MATERIALS PROVIDED ON THE PLATFORM WERE PREPARED TO PROVIDE ACCURATE INFORMATION REGARDING THE SUBJECT DISCUSSED, THE INFORMATION CONTAINED IN THESE MATERIALS IS BEING MADE AVAILABLE WITH THE UNDERSTANDING THAT WE MAKE NO GUARANTEES, REPRESENTATIONS OR WARRANTIES WHATSOEVER, WHETHER EXPRESSED OR IMPLIED, WITH RESPECT TO PROFESSIONAL QUALIFICATIONS, EXPERTISE, QUALITY OF WORK OR OTHER INFORMATION HEREIN. FURTHER, WE DO NOT, IN ANY WAY, ENDORSE ANY SERVICE OFFERED OR DESCRIBED HEREIN. IN NO EVENT SHALL WE BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN IN RELIANCE ON SUCH INFORMATION.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'THE INFORMATION PROVIDED HEREUNDER IS PROVIDED ?AS IS?. WE AND / OR OUR EMPLOYEES MAKE NO WARRANTY OR REPRESENTATION REGARDING THE TIMELINESS, CONTENT, SEQUENCE, ACCURACY, EFFECTIVENESS OR COMPLETENESS OF ANY INFORMATION OR DATA FURNISHED HEREUNDER OR THAT THE INFORMATION OR DATA PROVIDED HEREUNDER MAY BE RELIED UPON. MULTIPLE RESPONSES MAY USUALLY BE MADE AVAILABLE FROM DIFFERENT SOURCES AND IT IS LEFT TO THE JUDGEMENT OF USERS BASED ON THEIR SPECIFIC CIRCUMSTANCES TO USE, ADAPT, MODIFY OR ALTER SUGGESTIONS OR USE THEM IN CONJUNCTION WITH ANY OTHER SOURCES THEY MAY HAVE, THEREBY ABSOLVING US AS WELL AS OUR CONSULTANTS, BUSINESS ASSOCIATES, AFFILIATES, BUSINESS PARTNERS AND EMPLOYEES FROM ANY KIND OF PROFESSIONAL LIABILITY.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'WE SHALL NOT BE LIABLE TO YOU OR ANYONE ELSE FOR ANY LOSSES OR INJURY ARISING OUT OF OR RELATING TO THE INFORMATION PROVIDED ON THE PLATFORM. IN NO EVENT WILL WE OR OUR EMPLOYEES, AFFILIATES, AUTHORS OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DECISION MADE OR ACTION TAKEN BY YOUR RELIANCE ON THE CONTENT CONTAINED HEREIN.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    'IN NO EVENT WILL WE BE LIABLE FOR ANY DAMAGES (INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, DAMAGES ARISING FROM PERSONAL INJURY/WRONGFUL DEATH, AND DAMAGES RESULTING FROM LOST PROFITS, LOST DATA OR BUSINESS INTERRUPTION), RESULTING FROM ANY SERVICES PROVIDED BY ANY THIRD PARTY OR PARTNER shop ACCESSED THROUGH THE PLATFORM, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER LEGAL THEORY AND WHETHER OR NOT WE ARE ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return CancellationRefunds;
}(_react2.default.Component);

exports.default = CancellationRefunds;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancellationRefunds = function (_React$Component) {
    _inherits(CancellationRefunds, _React$Component);

    function CancellationRefunds(props) {
        _classCallCheck(this, CancellationRefunds);

        var _this = _possibleConstructorReturn(this, (CancellationRefunds.__proto__ || Object.getPrototypeOf(CancellationRefunds)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(CancellationRefunds, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Privacy Policy';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pr-2 pl-2 pt-2 pb-1 font-size-14' },
                            _react2.default.createElement(
                                'p',
                                null,
                                'We Done Delivery/ Palasha Enterprises are fully committed to respecting your privacy and shall ensure that your personal information is safe with us. This privacy policy("Privacy Policy") sets out the information practices, with respect to the use of our website ',
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: '/home' },
                                    'www.donedelivery.in'
                                ),
                                ' ("Website") and our App under the name "Done Delivery" (" Done DeliveryApp"), including the type of information collected, how the information is collected, how the information is used and with whom it is shared. The Website and Done Delivery App are jointly referred to as the "Platform". References to "you" or "your" in this Privacy Policy refer to the users of this Platform whether or not you access the services available on the Platform or consummate a transaction on the Platform. References to "we", "our" or "us" shall mean Done Delivery / Palasha Enterprises.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'By using or accessing this Platform, you agree to the terms and conditions of this Privacy Policy. You also expressly consent to our use and disclosure of your Personal Information (as defined below) in any manner as described in this Privacy Policy and further signify your agreement to this Privacy Policy and the Terms of Use (being incorporated by reference herein). If you do not agree with the terms and conditions of this Privacy Policy, please do not proceed further, use or access this Platform.'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Definitions'
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'set1 pl-3' },
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'App(s)'
                                    ),
                                    '" shall mean applications for mobile and includes Done Delivery App and Done Delivery Partner Apps for Delivery Partner and Merchant Partner and/or other Devices..'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Device(s)'
                                    ),
                                    '" shall mean a desktop computer, laptop computer, tablet, mobile phone, smart watch or such other electronic equipment.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Force Majeure Event'
                                    ),
                                    '" shall mean any event that is beyond our reasonable control and shall include, without limitation, sabotage, fire, flood, explosion, acts of God, civil commotion, strikes or industrial action or any kind, riots, insurrection, war, acts of government, computer hacking, unauthorized access to your mobile or storage device, crashes, breach of security and encryption.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Personal Information'
                                    ),
                                    '" refers to any information that identifies or can be used to identify, contact or locate the person, to whom such information pertains including, but not limited to, name, address, phone number and email address disclosed by you in relation to the services available on the Platform.'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-1' },
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Sensitive personal data or information'
                                    ),
                                    '" consists of information relating to the following:',
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'set2 pl-3' },
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'passwords;"'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'financial information such as bank account or credit card or debit card or other payment instrument details;'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'physical, physiological and mental health condition;'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'sexual orientation;"'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'medical records and history;"'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'Biometric information;"'
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'any detail relating to the above clauses as provided to body corporate for providing service; and '
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            { className: 'mb-05' },
                                            'any of the information received under above clauses by body corporate for processing, stored or processed under lawful contract or otherwise.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    '"',
                                    _react2.default.createElement(
                                        'strong',
                                        null,
                                        'Third Party'
                                    ),
                                    '" refers to any person or entity other than you or us.'
                                )
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Personal Information that may be collected and manner of its use'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Personal Information provided by you in relation to the use of the Platform:'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In order for us to enable successful delivery of your order to you, we collect your Personal Information as may be required for the purposes connected thereto when you place an order on the Platform.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We may be required to disclose such Personal Information to the Third Parties solely in connection with purchase, sale and delivery of your order in accordance with the terms and conditions stipulated by such Third Party.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We use the details provided by you during check out to ensure that orders are successfully delivered on time, and to keep you informed on the status of your order.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Personal Information provided by you in relation to the registration process'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In order to provide you a safe, efficient, smooth and customized experience and in order to take advantage of certain features available on the Platform including, but not limited to, public forums, accessing or uploading reviews or taking part in surveys, you will be asked to complete an online registration form which will provide us with Personal Information. In the event you register with us, you will also be asked to choose a user identity and password in order to identify yourself during future uses of the Platform.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'You can also register on the Platform by logging into online accounts you may have with Third Party social networking sites ("SNS") (e.g. Facebook, Twitter); each such account, a "Third Party Account", via our Platform as described below. As part of the functionality of the Platform, you may link your account with Third Party Accounts, by either: (i) providing your Third Party Account login information to us through the Platform; or (ii) allowing us to access your Third Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third Party Account. You represent that you are entitled to disclose your Third Party Account login information to us and/or grant us access to your Third Party Account (including, but not limited to, for the purposes described herein), without breach by you of any of the terms and conditions that govern your use of the applicable Third Party Account and without obligating us to pay any fees or making us subject to any usage limitations imposed by the applicable SNS. If you decide to register by logging into a Third Party Account via our Platform, we will obtain the Personal Information you have provided to the applicable SNS (such as your "real" name, email address, profile picture, names of SNS friends, names of SNS groups to which you belong, other information you make publicly available via the applicable SNS and/or other information you authorize us to access by authorizing the SNS to provide such information) from your Third Party Accounts and use that information to create your account and profile page and you will become a member. Depending on the Third Party Accounts you choose and subject to the privacy settings that you have set in such Third Party Accounts, you understand that by granting us access to the Third Party Accounts, we will access, make available and store (if applicable and as permitted by the SNS and authorized by you) the information in your Third Party Accounts so that it is available on and through your account on the Platform. If there is information about your "friends" or people with whom you are associated in your Third Party Account, the information we obtain about those "friends" or people with whom you are associated, may also depend on the privacy settings such people have with the applicable SNS.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We also collect certain additional information that is not Personal Information which you provide as part of registration and the administration and personalization of your account profile. When you use our Services, we collect information about you in the following general categories.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'If you permit the App to access the address book on your Device through the permission system used by your Devise platform, we may access and store names, contact and messages information from your address book to facilitate any form of interactions through our Services and for other purposes specified in this Privacy Policy or the Terms of Use.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In connection with facilitating this service, we receive call data, including the date and time of the call or SMS message, the parties" phone numbers, and the content of the SMS message, etc.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In case you permit the App meant for Done Delivery, delivery executives to access the address book on your Device (through the permission system of your Device), we may access and store your contact information from your Device to facilitate any form of interactions for providing our services and/or for other purposes specified in this Privacy Policy.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Cookies'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Cookies are small pieces of information saved by your browser. Cookies are used to record various aspects of your visit and assist us in providing you with uninterrupted service. Cookies may be set in your browser by us when you access the Platform or may be set in when you visit Third Party websites.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'This anonymous information is maintained distinctly and is not linked to the Personal Information that you submit to us. We use cookies collected to:'
                            ),
                            _react2.default.createElement(
                                'ul',
                                { className: 'set1' },
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-05' },
                                    'Authenticate your login information;'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-05' },
                                    'Enable our security features;'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-05' },
                                    'Show you advertising; and'
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'mb-05' },
                                    'Improve and develop the features of the Website.'
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Please feel free to change your browser settings if you do not wish to accept cookies. However, please note that changing your browser setting may affect your experience on the Platform.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Collection of Sensitive personal data or information'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We do not collect, store or process Sensitive personal data or information as part of our services on our Platform.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Others'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In addition to the cookies, we may also collect information to enable us to understand you better so that we can improve (i) your user experience; (ii) to assist our customer service and technical support personnel; and (iii) put processes in place to prevent fraud and unlawful use. In an effort to make the Platform effective and improve the Platform, certain information may be collected each time you access the Platform. Such information may be saved in server logs in an encrypted form which may not identify you personally. Such information or data may include, but shall not be limited to, IP address, your server details, duration of your visit, date, time or purpose of your visit. In addition to cookies we use web beacons, ad tags, pixels to advertise as part of the Platform. The abovementioned data may be used by us and may be shared with our sponsors, investors, advertisers, developers, strategic business partners or other associates to enhance and grow the user experience in relation to the Platform.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Other uses of the information provided'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We make all efforts to ensure that we collect only such Personal Information that we believe to be relevant in order to record, support, facilitate access to the Platform.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Sharing information with Third Party service providers in relation to the Platform'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'To the extent necessary to provide you the services on the Platform, we may provide your Personal Information to Third Party contractors who work on behalf of or with us to provide you with such services, to help us communicate with you or to maintain the Platform.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Communication'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We may offer email, Done Delivery App notifications, SMS, multimedia message service (MMS) or other forms of communication to share information with you about certain promotions or features the Platform may choose to offer or about our affiliates, subsidiaries, business partners, advertisers and sponsors. You may receive such communication when you have registered as a user in order to provide advertisements about goods and services of interest to you.'
                            ),
                            _react2.default.createElement(
                                'h6',
                                null,
                                'Legal proceedings'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'In the event we are required to respond to subpoenas, court orders or other legal process, your Personal Information may be disclosed pursuant to such subpoena, court order or legal process, which may be without notice to you.'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Link to Third Party apps and websites'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'The Platform and any communication sent to you may also contain/display Third Party advertisements and links to other websites or products and services. You agree and acknowledge that these Apps and websites are operated by Third Parties and are not controlled by, or affiliated to, or associated with us unless expressly specified. We are not responsible for any form of transmission, whatsoever, received by you from any such Third Party. Accordingly, we do not make any representations concerning the privacy practices or policies of such Third Parties or terms of use of such websites or Apps, nor do we control or guarantee the accuracy, integrity, or quality of the information, data, text, software, music, sound, photographs, graphics, videos, messages or other materials available on such websites or Apps. The inclusion or exclusion does not imply any endorsement by us of the website, the Third Party, or the information on the website. The information provided by you to such Third Party websites shall be governed in accordance with the privacy policies of such websites and it is recommended that you review the privacy policy on any such websites and Apps prior to using such websites. '
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'These Third Party websites and Apps and advertisers may use technology to send the advertisements directly to your browser. In such cases, the Third Party websites or advertisers automatically receive your IP address. They may also use cookies, JavaScript, web beacons and other technologies to measure the effectiveness of their advertisements and to personalize advertising content. We do not have access to or control over cookies or other features that such Third Party websites and Apps and advertisers may use, and the information practices of these Third Party websites and Apps and advertisers are not covered by this Privacy Policy. Please contact them directly for more information about their privacy practices.'
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Security'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                ' We strive to ensure the security, integrity and privacy of your Personal Information and to protect your Personal Information against unauthorized access or unauthorized alteration, disclosure or destruction. We are not responsible for any breach of security or for any actions of any Third Parties that receive your Personal Information. The Services are also linked to many other sites and we are not/shall be not responsible for their privacy policies or practices as it is beyond our control. '
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Notwithstanding anything contained in this Privacy Policy or elsewhere, we shall not be held responsible for any loss, damage or misuse of your Personal Information, if such loss, damage or misuse is attributable to a Force Majeure Event.'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'Done Delivery/ Palasha Enterprises shall address your discrepancies and grievances with respect to processing of information in a time bound manner. For this purpose, Done Delivery/ Palasha Enterprises has designated Mr. Abhay Mishra as the Grievance Officer, who will redress your grievances expeditiously but in any event within one month from the date of receipt of grievance, and who can be reached by sending a letter marked to the attention of The Grievance Officer to Done Delivery, c/o Palasha Enterprises, A/4, Ganesh Prasad, Altinho, Panjim, Goa, 403001 or sending an email to ',
                                _react2.default.createElement(
                                    _reactRouterDom.Link,
                                    { to: 'mailto:grievance@donedelivery.in', target: '_blank' },
                                    'grievance@donedelivery.in'
                                )
                            ),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'h4',
                                null,
                                'Changes to Privacy Policy'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                'We may change this Privacy Policy from time to time. If we make material changes to this Privacy Policy and in the manner we treat your personal information, we will provide you notice through the Website and/or Done Delivery App. Your continued use of the services after such notice constitutes your consent to the changes. You are encouraged to check this Privacy Policy regularly for the latest updates to our privacy practices.'
                            )
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return CancellationRefunds;
}(_react2.default.Component);

exports.default = CancellationRefunds;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermsConditions = function (_React$Component) {
    _inherits(TermsConditions, _React$Component);

    function TermsConditions(props) {
        _classCallCheck(this, TermsConditions);

        var _this = _possibleConstructorReturn(this, (TermsConditions.__proto__ || Object.getPrototypeOf(TermsConditions)).call(this, props));

        _this.handleClickModalLogOut = function () {
            $('#ModalLogout').modal('show');
        };

        _this.handleClickLogOut = function () {
            localStorage.removeItem('userData');
            _this.setState({ LoggedOut: true });
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userVERIFIED: '',
            userEMAIL: '',
            activeORDERS: '',
            LoggedOut: false,
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(TermsConditions, [{
        key: 'fetchCustomerProfile',
        value: function fetchCustomerProfile(mode, customer) {
            var that = this;
            fetch('https://m.donedelivery.in/api/profile_api2.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE', customer);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Terms & Conditions';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'section full mt-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'pr-2 pl-2 pt-2 pb-1 font-size-14' },
                            _react2.default.createElement('p', null)
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return TermsConditions;
}(_react2.default.Component);

exports.default = TermsConditions;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerifyMobile = function (_React$Component) {
  _inherits(VerifyMobile, _React$Component);

  function VerifyMobile(props) {
    _classCallCheck(this, VerifyMobile);

    var _this = _possibleConstructorReturn(this, (VerifyMobile.__proto__ || Object.getPrototypeOf(VerifyMobile)).call(this, props));

    _this.handleSubmit = function (e) {
      e.preventDefault();

      var err = 0;
      if ($('#frmVerifyMobile')[0].checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        err++;
      }
      $('#frmVerifyMobile')[0].classList.add('was-validated');

      if (err == 0) {
        $('#submitLoading').css('display', 'block');

        var method = "POST";
        var body = new FormData(_this.form);
        //console.log(body);
        var that = _this;
        fetch("https://m.donedelivery.in/api/customerverifymobile_api.php", { method: method, body: body }).then(function (response) {
          //console.log(response);
          return response.json();
        }).then(function (result) {
          //console.log(result);
          var notify = '';
          if (result.err != '') {
            if (result.err == '1') notify = 'Mobile Field is Empty';else if (result.err == '2') notify = 'No Such User Exist';else if (result.err == '3') notify = 'Invalid Access Detected';else if (result.err == '4') notify = 'Mobile Area Code Field is Empty';
          }

          var otp_sent = false;
          if (result.otp_sent == 'Y') {
            otp_sent = true;
            var customer = result.customer;
            var mobileno = result.mobileno;
            var emailid = result.emailid;

            if (customer != '' && customer != undefined) {
              localStorage.setItem('tempData', customer);
              if (mobileno != '') localStorage.setItem('tempREG', mobileno);
              if (emailid != '') localStorage.setItem('tempEMAIL', emailid);
            }
          }

          that.setState({ Notifications: notify, OTP: otp_sent });
          $('#submitLoading').css('display', 'none');
          if (notify != '') $('#ModalAlert').modal('show');
        });
      }
    };

    _this.state = {
      LOADING: true,
      OTP: false
    };
    return _this;
  }

  _createClass(VerifyMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var mount = $("div").hasClass("modal-backdrop");
      if (mount == true) {
        $('body').removeClass('modal-open');
        $(".modal-backdrop").remove();
        //window.location.reload(true);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ LOADING: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state.OTP) {
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/smsverifyMobile' });
      }

      var AppHeaderClass = 'appHeader bg-dark text-light';
      var AppHeaderLeft = 'showLINK';
      var AppHeaderLeftLink = '/cart';
      var AppHeaderTitle = 'Verify Account';
      var AppHeaderRight = '';
      var AppHeaderRightLink = '';
      var AppHeaderSearch = '';

      return _react2.default.createElement(
        'div',
        null,
        this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
        _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
        _react2.default.createElement(
          'div',
          { id: 'appCapsule' },
          _react2.default.createElement(
            'div',
            { className: 'login-form mt-5 pt-3 pr-3 pl-3' },
            _react2.default.createElement(
              'div',
              { className: 'section' },
              _react2.default.createElement(
                'h4',
                { className: 'size-19' },
                'Type your registered mobile no to verify your account'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'section mt-2 mb-5' },
              _react2.default.createElement(
                'form',
                { name: 'frmVerifyMobile', id: 'frmVerifyMobile', ref: function ref(el) {
                    return _this2.form = el;
                  }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                _react2.default.createElement('input', { type: 'hidden', value: 'VERIFY_MOBILE', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                _react2.default.createElement(
                  'div',
                  { className: 'form-group boxed' },
                  _react2.default.createElement(
                    'div',
                    { className: 'wid-20' },
                    _react2.default.createElement(
                      'div',
                      { className: 'input-wrapper' },
                      _react2.default.createElement(
                        'label',
                        { className: 'label', htmlFor: 'txtusercode' },
                        'Code'
                      ),
                      _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusercode', id: 'txtusercode', required: true, minLength: '3', maxLength: '6', defaultValue: '+91', autoComplete: 'off' }),
                      _react2.default.createElement(
                        'i',
                        { className: 'clear-input' },
                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'valid-feedback' },
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'invalid-feedback' },
                        'Please enter your area code.'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'wid-80-VM' },
                    _react2.default.createElement(
                      'div',
                      { className: 'input-wrapper' },
                      _react2.default.createElement(
                        'label',
                        { className: 'label', htmlFor: 'txtusermobile' },
                        'Mobile'
                      ),
                      _react2.default.createElement('input', { type: 'text', className: 'square-inputbox form-control', name: 'txtusermobile', id: 'txtusermobile', required: true, minLength: '10', maxLength: '11', pattern: '[0-9]{10}', autoComplete: 'off' }),
                      _react2.default.createElement(
                        'i',
                        { className: 'clear-input' },
                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'valid-feedback' },
                        '\xA0'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'invalid-feedback' },
                        'Please enter your 10 digit mobile no.'
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'clear' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'form-button-group pl-4 pr-4 bg-common' },
                  _react2.default.createElement(
                    'button',
                    { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                    _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                    'Submit'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
              _react2.default.createElement(
                'div',
                { className: 'modal-dialog', role: 'document' },
                _react2.default.createElement(
                  'div',
                  { className: 'modal-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-icon text-danger' },
                    _react2.default.createElement('ion-icon', { name: 'close-circle' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-body' },
                    this.state.Notifications
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'modal-footer' },
                    _react2.default.createElement(
                      'div',
                      { className: 'btn-inline' },
                      _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                        'Ok'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return VerifyMobile;
}(_react2.default.Component);

exports.default = VerifyMobile;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _reactCountdown = __webpack_require__(78);

var _reactCountdown2 = _interopRequireDefault(_reactCountdown);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Completionist = function Completionist() {
    return _react2.default.createElement(
        'p',
        { id: 'RESEND_OTP', style: { display: 'block' } },
        _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '#', onClick: function onClick(e) {
                    undefined.handleResendOTP(e);
                } },
            'Resend OTP'
        )
    );
};

// Renderer callback with condition
var renderer = function renderer(_ref) {
    var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds,
        completed = _ref.completed;

    if (completed) {
        // Render a complete state
        return _react2.default.createElement(Completionist, null);
    } else {
        // Render a countdown
        return _react2.default.createElement(
            'p',
            null,
            minutes,
            ':',
            seconds
        );
    }
};

var SmsVerification = function (_React$Component) {
    _inherits(SmsVerification, _React$Component);

    function SmsVerification(props) {
        _classCallCheck(this, SmsVerification);

        var _this = _possibleConstructorReturn(this, (SmsVerification.__proto__ || Object.getPrototypeOf(SmsVerification)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            var err = 0;
            if ($('#frmSmsVerify')[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
                err++;
            }
            $('#frmSmsVerify')[0].classList.add('was-validated');

            if (err == 0) {
                $('#submitLoading').css('display', 'block');

                var method = "POST";
                var body = new FormData(_this.form);
                //console.log(body);
                var that = _this;
                fetch("https://m.donedelivery.in/api/smsverify_api3.php", { method: method, body: body }).then(function (response) {
                    //console.log(response);
                    return response.json();
                }).then(function (result) {

                    //console.log(result);
                    var notify = '';
                    if (result.err != '') {
                        if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'OTP Field is Empty';else if (result.err == '3') notify = 'OTP Expired, Please regenrate again';else if (result.err == '4') notify = 'Invalid Access Detected';else if (result.err == '5') notify = 'OTP Expired, Please regenrate again';
                    }

                    var sms_verified = 'N';
                    var customer = result.customer;
                    if (customer != '' && customer != undefined) {
                        localStorage.setItem('userData', customer);
                        localStorage.setItem('Verified', 'Y');
                        localStorage.removeItem('tempData');
                        localStorage.removeItem('tempREG');
                        localStorage.removeItem('tempEMAIL');

                        sms_verified = 'Y';
                    }

                    that.setState({ Notifications: notify, SMS_VERIFIED: sms_verified });
                    $('#submitLoading').css('display', 'none');
                    if (notify != '') $('#ModalAlert').modal('show');
                });
            }
        };

        _this.handleResendOTP = function (e) {
            e.preventDefault();
            $('#RESEND_OTP').css('display', 'none');

            var customer = localStorage.getItem('tempData');

            var that = _this;
            fetch('https://m.donedelivery.in/api/resendotp_api.php?mode=VER&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var notify = '';
                if (result.err != '') {
                    if (result.err == '1') notify = 'Invalid Customer';else if (result.err == '2') notify = 'Invalid Access Detected';
                }

                var otp_resent = result.otp_resent;
                if (otp_resent == '' || otp_resent == undefined) otp_resent = '';

                if (otp_resent == 'Y') {
                    notify = 'New OTP has been sent to your mobile no';
                }

                that.setState({ Notifications: notify });
                if (notify != '') $('#ModalAlert').modal('show');
            });
        };

        _this.state = {
            Notifications: false,
            Customer: localStorage.getItem('tempData'),
            SMS_VERIFIED: 'N'
        };

        return _this;
    }

    _createClass(SmsVerification, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
                //window.location.reload(true);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //console.log(localStorage.getItem('userData'));

            if (this.state.SMS_VERIFIED == 'Y') {
                if (localStorage.getItem('cartData')) return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });else return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');else Verified = 'N';
            } else Verified = 'N';

            if (Verified == 'Y') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/login';
            var AppHeaderTitle = 'Verification';
            var AppHeaderRight = '';
            var AppHeaderRightLink = '';
            var AppHeaderSearch = '';

            var tempREG = '';
            var tempEMAIL = '';
            if (localStorage.getItem('tempREG') && localStorage.getItem('tempREG') !== 'null' && localStorage.getItem('tempREG') !== null) tempREG = localStorage.getItem('tempREG');

            if (localStorage.getItem('tempEMAIL') && localStorage.getItem('tempEMAIL') !== 'null' && localStorage.getItem('tempEMAIL') !== null) tempEMAIL = localStorage.getItem('tempEMAIL');

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'login-form mt-5 pt-3 pr-3 pl-3' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section' },
                            tempREG !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Mobile No:  ',
                                localStorage.getItem('tempREG')
                            ),
                            tempEMAIL !== '' && _react2.default.createElement(
                                'h4',
                                { className: 'size-19' },
                                'Enter The 6 Digit OTP Received on your Registered Email Id:  ',
                                localStorage.getItem('tempEMAIL')
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-2 mb-5' },
                            _react2.default.createElement(
                                'form',
                                { id: 'frmSmsVerify', ref: function ref(el) {
                                        return _this2.form = el;
                                    }, onSubmit: this.handleSubmit, className: 'needs-validation', noValidate: true },
                                _react2.default.createElement('input', { type: 'hidden', value: 'SMS_VERIFY', className: 'form-control', name: 'mode', id: 'mode', required: true }),
                                _react2.default.createElement('input', { type: 'hidden', value: localStorage.getItem('tempData'), className: 'form-control', name: 'customer', id: 'customer', required: true }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-group boxed' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'input-wrapper' },
                                        _react2.default.createElement('input', { type: 'text', className: 'placeholder-size square-inputbox form-control verify-input verify-input-1', name: 'txtotp', id: 'txtotp', placeholder: '\u2022\u2022\u2022\u2022\u2022\u2022', maxLength: '6', required: true, autoComplete: 'off' }),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'invalid-feedback' },
                                            'Please enter otp.'
                                        )
                                    )
                                ),
                                _react2.default.createElement(_reactCountdown2.default, { date: Date.now() + 59000, renderer: renderer }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form-button-group pl-4 pr-4 bg-common' },
                                    _react2.default.createElement(
                                        'button',
                                        { type: 'submit', className: 'lt-space1 text-upper btn btn-danger btn-block square btn-md' },
                                        _react2.default.createElement('span', { className: 'spinner-border spinner-border-sm mr-05', id: 'submitLoading', style: { display: 'none' }, role: 'status', 'aria-hidden': 'true' }),
                                        'Verify'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'modal fade dialogbox', id: 'ModalAlert', 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                            _react2.default.createElement(
                                'div',
                                { className: 'modal-dialog', role: 'document' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal-content' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-icon text-danger' },
                                        _react2.default.createElement('ion-icon', { name: 'close-circle' })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-body' },
                                        this.state.Notifications
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-footer' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'btn-inline' },
                                            _react2.default.createElement(
                                                'button',
                                                { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                'Ok'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SmsVerification;
}(_react2.default.Component);

exports.default = SmsVerification;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpecialOffers = function (_React$Component) {
    _inherits(SpecialOffers, _React$Component);

    function SpecialOffers(props) {
        _classCallCheck(this, SpecialOffers);

        var _this = _possibleConstructorReturn(this, (SpecialOffers.__proto__ || Object.getPrototypeOf(SpecialOffers)).call(this, props));

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            OFFERS: [],
            CUSTOMER_DET: ''
        };
        return _this;
    }

    _createClass(SpecialOffers, [{
        key: 'fetchSpecialOffersPage',
        value: function fetchSpecialOffersPage(mode, vendor, page) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/specialoffers_api.php?mode=' + mode + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var OFFERS = result.OFFERS;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, OFFERS: OFFERS, CUSTOMER_DET: CUSTOMER_DET });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchSpecialOffersPage('OFFERS');
        }
    }, {
        key: 'render',
        value: function render() {

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Special Offers';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    _react2.default.createElement(
                        'div',
                        { className: 'delivery-location cart-item-review' },
                        _react2.default.createElement(
                            'div',
                            { className: 'section mt-2' },
                            this.state.OFFERS.length > 0 && this.state.OFFERS.map(function (offer) {

                                var OFFER = 0;
                                if (offer.VALUE != 0) {
                                    if (offer.TYPE == 'PER') OFFER = offer.VALUE + '% Off';else if (offer.TYPE = 'DIS') OFFER = '&#8377; ' + offer.VALUE + ' Off';
                                } else OFFER = 'Free ' + offer.TEXT;

                                if (OFFER == 0 || OFFER == 'null') OFFER = '';else {
                                    if (offer.CODE != '') OFFER += ' | ';
                                }

                                return _react2.default.createElement(
                                    'div',
                                    { className: 'card mb-2', key: offer.ID },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'card-body pt-2 pb-2' },
                                        _react2.default.createElement(
                                            'h6',
                                            { className: 'font-size-12 font-weg-600 mb-05 text-danger' },
                                            _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: OFFER } }),
                                            offer.CODE
                                        ),
                                        _react2.default.createElement(
                                            'p',
                                            { className: 'font-size-12 font-weg-400 mb-05' },
                                            offer.NAME
                                        ),
                                        offer.AVAILABLE != '' && offer.AVAILABLE > '0' && _react2.default.createElement(
                                            'p',
                                            { className: 'font-size-12 font-weg-400 mb-05' },
                                            'Available: ',
                                            offer.AVAILABLE
                                        )
                                    )
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return SpecialOffers;
}(_react2.default.Component);

exports.default = SpecialOffers;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _ReorderItems = __webpack_require__(506);

var _ReorderItems2 = _interopRequireDefault(_ReorderItems);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reorder = function (_React$Component) {
    _inherits(Reorder, _React$Component);

    function Reorder(props) {
        _classCallCheck(this, Reorder);

        var _this = _possibleConstructorReturn(this, (Reorder.__proto__ || Object.getPrototypeOf(Reorder)).call(this, props));

        _this.inCartCallBack = function () {

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') cartEMPTY = 'N';

            var that = _this;
            that.setState({ cartEMPTY: cartEMPTY });
        };

        _this.loadMore = function () {
            //this.state.loading = true;
            _this.fetchSecond('REORDER', _this.state.page);
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            items: [],
            cartEMPTY: 'Y',
            ITEMCOUNT: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
        return _this;
    }

    _createClass(Reorder, [{
        key: 'fetchReorderPage',
        value: function fetchReorderPage(mode, page) {

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var id = localStorage.getItem('delCIRCLE');
            var that = this;
            fetch('https://m.donedelivery.in/api/reorder_api.php?mode=' + mode + '&id=' + id + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var ITEMS = result.ITEMS;
                var ITEMCOUNT = result.ITEMCOUNT;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, items: ITEMS, ITEMCOUNT: ITEMCOUNT, CUSTOMER_DET: CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'fetchSecond',
        value: function fetchSecond(mode, page) {
            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/reorder_api.php?mode=' + mode + '&id=' + id + '&customer=' + customer + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var ITEMCOUNT = result.ITEMCOUNT;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
            //this.setState({ LOADING:true });
            //this.fetchReorderPage('CATEGORY',nextProps.match.params.id);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchReorderPage('REORDER', this.state.page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Reorder';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = '';

            if (localStorage.getItem('userData') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            var props = {
                items: this.state.items,
                inCartCallBack: this.inCartCallBack
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    this.state.items.length > 0 && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'section-title font-size-17 mb-05 text-sdgrey mr-2 ml-2 mt-1' },
                            ' ',
                            this.state.ITEMCOUNT,
                            ' Item',
                            this.state.ITEMCOUNT > 1 ? 's' : ''
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section pt-0 pb-2 mt-1' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(_ReorderItems2.default, props)
                            ),
                            this.state.displayLoadMore == 'Y' && _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'button',
                                    { type: 'button', style: { 'height': '31px' }, onClick: function onClick() {
                                            return _this2.loadMore();
                                        }, className: 'btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack' },
                                    'Load More'
                                )
                            )
                        )
                    ),
                    this.state.items.length == 0 && _react2.default.createElement(
                        'div',
                        { className: 'section pt-6', style: { textAlign: 'center' } },
                        _react2.default.createElement('img', { src: '/assets/img/no-records.png', alt: 'empty-cart', className: 'form-image imaged w200' })
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return Reorder;
}(_react2.default.Component);

exports.default = Reorder;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FavouriteItems = function (_React$Component) {
    _inherits(FavouriteItems, _React$Component);

    function FavouriteItems(props) {
        _classCallCheck(this, FavouriteItems);

        var _this = _possibleConstructorReturn(this, (FavouriteItems.__proto__ || Object.getPrototypeOf(FavouriteItems)).call(this, props));

        _this.handleClickAddToCart = function (id, unit, vendor_id, vendor_name, vendortype_id) {
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var circleID = localStorage.getItem('delCIRCLE2');
            if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }
                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];
                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }
                return temp;
            };

            var cart = localStorage.getItem('cartData');
            var cartVendorID = localStorage.getItem('cartVendorID');
            var cartVendorName = localStorage.getItem('cartVendorName');
            var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + unit, 1);
                localStorage.setItem('cartData', JSON.stringify(a));
                localStorage.setItem('cartVendorID', vendor_id);
                localStorage.setItem('cartVendorName', vendor_name);
                localStorage.setItem('cartVendorTypeID', vendortype_id);

                var _inCart = 'Y';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, cartCount: _cartCount });
                _this.props.inCartCallBack();
            } else {
                var ALLOW_CART = 'Y';
                if (cartVendorID != vendor_id) {
                    var MSG = '';
                    if (cartVendorTypeID != vendortype_id) {
                        if (cartVendorTypeID == '2') MSG = 'Items from ' + cartVendorName + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;else if (vendortype_id == '2') MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;

                        ALLOW_CART = 'N';
                    } else {
                        if (cartVendorTypeID == '2' && vendortype_id == '2') {
                            MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;
                            ALLOW_CART = 'N';
                        }
                    }

                    if (ALLOW_CART == 'N') {
                        that.setState({ RESTRICTION_NOTE: MSG });
                        $('#ModalCartItemRestriction_' + id).modal('show');
                    }
                }

                if (ALLOW_CART == 'Y') {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');
                        if (cart_id[0] == id) cartTotalCount += cartData[key];

                        if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                    });
                    cartTotalCount += 1;

                    cartData = addToObject(cartData, [id + '~~**~~' + unit], 1);
                    localStorage.setItem('cartData', JSON.stringify(cartData));

                    var _inCart2 = 'Y';
                    var _cartCount2 = 1;
                    that.setState({ inCart: _inCart2, cartCount: cartTotalCount });
                    _this.props.inCartCallBack();
                }
            }
        };

        _this.handleClickIncreement = function (id, unit, cartCount, itemqty_cart) {
            var cartTotalCount = 0;
            if (itemqty_cart !== 0 && cartCount < itemqty_cart) {
                cartCount = cartCount + 1;

                var cart = localStorage.getItem('cartData');
                var that = _this;
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) cartTotalCount += cartData[key];

                    if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
                });
                cartTotalCount += 1;

                localStorage.setItem('cartData', JSON.stringify(cartData));

                var inCart = 'Y';
                cartCount = cartCount;
                that.setState({ inCart: inCart, cartCount: cartTotalCount });
                _this.props.inCartCallBack();
            } else $('#ModalCartItemLimit_' + id).modal('show');
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            cartCount = cartCount;
            that.setState({ inCart: inCart, cartCount: cartCount });
            _this.props.inCartCallBack();
        };

        _this.state = {
            items: props.items,
            RESTRICTION_NOTE: ''
        };
        return _this;
    }

    _createClass(FavouriteItems, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ items: nextProps.items });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.state.items.map(function (item) {

                var inCart = 'N'; //this.state.inCart;
                var added = ''; //this.state.addButton;
                var cartCount = 0; //this.state.cartCount;

                var currentITEM = item.ID;
                var cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var id = key.split('~~**~~');
                        if (id[0] == currentITEM) {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: item.ID },
                    _react2.default.createElement(
                        'div',
                        { className: 'card  mb-2' },
                        _react2.default.createElement('img', { src: item.PIC, className: 'card-img-top imaged w-100', alt: 'image' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                            _react2.default.createElement(
                                'p',
                                { className: 'card-text text-dgrey font-size-14 font-weg-500 mb-0' },
                                item.NAME
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 text-slgrey' },
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Per ',
                                    item.UNIT
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 font-weg-600' },
                                item.MRP !== '0.00' && item.MRP !== item.RATE && _react2.default.createElement(
                                    'span',
                                    { className: 'del-price text-slgrey' },
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        '\u20B9',
                                        item.MRP
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'final-price text-danger font-size-14' },
                                    '\u20B9 ',
                                    item.RATE
                                )
                            ),
                            item.AVAILABLE_QTY > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'add-btn ' + added + ' mt-2' },
                                    _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                        }, value: '-', className: 'qtyminus' }),
                                    _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                    inCart == 'Y' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickIncreement(item.ID, item.UNIT, cartCount, item.QTY_PER_CART);
                                        }, value: '+', className: 'qtyplus' }),
                                    inCart == 'N' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickAddToCart(item.ID, item.UNIT, item.VENDOR_ID, item.VENDOR_NAME, item.VENDORTYPE_ID);
                                        }, value: '+', className: 'qtyplus' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemLimit_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                'You have reached the limit for this item'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemRestriction_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                _this2.state.RESTRICTION_NOTE
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            item.AVAILABLE_QTY == 0 && _react2.default.createElement(
                                'div',
                                { className: 'add-btn add-btn-incr mt-2 font-size-12' },
                                'Out Of Stock'
                            )
                        )
                    )
                );
            });
        }
    }]);

    return FavouriteItems;
}(_react2.default.Component);

exports.default = FavouriteItems;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReOrder2 = function (_React$Component) {
    _inherits(ReOrder2, _React$Component);

    function ReOrder2(props) {
        _classCallCheck(this, ReOrder2);

        var _this = _possibleConstructorReturn(this, (ReOrder2.__proto__ || Object.getPrototypeOf(ReOrder2)).call(this, props));

        _this.state = {
            LOADING: true,
            ORDER_ADDED: '',
            id: props.match.params.id
        };
        return _this;
    }

    _createClass(ReOrder2, [{
        key: 'fetchRestaurantMenu',
        value: function fetchRestaurantMenu(mode, customer, id) {
            var subsciber_id = localStorage.getItem('SUBSCRIBER_ID');
            var that = this;
            fetch('https://m.donedelivery.in/api/reorder_api2.php?mode=' + mode + '&order_id=' + id + '&customer=' + customer, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);

                var ORDER_ADDED = result.ORDER_ADDED;
                if (ORDER_ADDED == '' || ORDER_ADDED == undefined) ORDER_ADDED = '';

                var ITEMS = result.ITEMS;
                if (ITEMS != '' && ITEMS != undefined) {
                    var cartCIRCLE = localStorage.getItem('cartCIRCLE');
                    var circleID = localStorage.getItem('delCIRCLE2');
                    if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

                    var cartTotalCount = 0;
                    var inCart = 'N';
                    var addButton = 'Y';
                    var cartCount = 0;

                    var addToObject = function addToObject(obj, key, value, index) {
                        // Create a temp object and index variable
                        var temp = {};
                        var i = 0;

                        // Loop through the original object
                        for (var prop in obj) {
                            if (obj.hasOwnProperty(prop)) {
                                // If the indexes match, add the new item
                                if (i === index && key && value) {
                                    temp[key] = value;
                                }
                                // Add the current item in the loop to the temp obj
                                temp[prop] = obj[prop];
                                // Increase the count
                                i++;
                            }
                        }

                        // If no index, add to the end
                        if (!index && key && value) {
                            temp[key] = value;
                        }
                        return temp;
                    };

                    ITEMS.map(function (item) {

                        var id = item.ID;
                        var unit = item.UNIT;
                        var qty = parseInt(item.CART_QTY);
                        var vendor_id = item.VENDOR_ID;
                        var vendor_name = item.VENDOR_NAME;
                        var vendortype_id = item.VENDORTYPE_ID;

                        var cart = localStorage.getItem('cartData');
                        var cartVendorID = localStorage.getItem('cartVendorID');
                        var cartVendorName = localStorage.getItem('cartVendorName');
                        var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

                        if (cart === null) {
                            var a = _defineProperty({}, id + '~~**~~' + unit, qty);
                            localStorage.setItem('cartData', JSON.stringify(a));
                            localStorage.setItem('cartVendorID', vendor_id);
                            localStorage.setItem('cartVendorName', vendor_name);
                            localStorage.setItem('cartVendorTypeID', vendortype_id);
                        } else {
                            var ALLOW_CART = 'Y';
                            if (cartVendorID != vendor_id) {
                                if (cartVendorTypeID != vendortype_id) ALLOW_CART = 'N';else {
                                    if (cartVendorTypeID == '2' && vendortype_id == '2') ALLOW_CART = 'N';
                                }
                            }

                            if (ALLOW_CART == 'Y') {
                                var cartData = JSON.parse(cart);
                                Object.keys(cartData).forEach(function (key) {
                                    var cart_id = key.split('~~**~~');
                                    if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                                });

                                cartData = addToObject(cartData, [id + '~~**~~' + unit], qty);
                                localStorage.setItem('cartData', JSON.stringify(cartData));
                            }
                        }
                    });
                    that.setState({ ORDER_ADDED: 'Y' });
                } else that.setState({ ORDER_ADDED: 'N' });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            this.fetchRestaurantMenu('REORDER', customer, this.state.id);
        }
    }, {
        key: 'render',
        value: function render() {

            //console.log(localStorage.getItem('delCity'));
            //console.log(localStorage.getItem('delArea'));

            var Verified = '';
            if (localStorage.getItem('Verified') !== null && localStorage.getItem('Verified') !== '{}') {
                if (localStorage.getItem('userData')) Verified = localStorage.getItem('Verified');
            } else Verified = 'N';

            if (Verified == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/verifyMobile' });
            }

            if (this.state.ORDER_ADDED == 'Y') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/cart' });
            }

            if (this.state.ORDER_ADDED == 'N') {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/home' });
            }

            if (localStorage.getItem('delCIRCLE') == null) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/map' });
            }

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null)
            );
        }
    }]);

    return ReOrder2;
}(_react2.default.Component);

exports.default = ReOrder2;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(2);

var _Loader = __webpack_require__(3);

var _Loader2 = _interopRequireDefault(_Loader);

var _AppHeader = __webpack_require__(5);

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _SearchItems = __webpack_require__(509);

var _SearchItems2 = _interopRequireDefault(_SearchItems);

var _BottomMenu = __webpack_require__(7);

var _BottomMenu2 = _interopRequireDefault(_BottomMenu);

var _SidebarPanel = __webpack_require__(6);

var _SidebarPanel2 = _interopRequireDefault(_SidebarPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchItem = function (_React$Component) {
    _inherits(SearchItem, _React$Component);

    function SearchItem(props) {
        _classCallCheck(this, SearchItem);

        var _this = _possibleConstructorReturn(this, (SearchItem.__proto__ || Object.getPrototypeOf(SearchItem)).call(this, props));

        _this.inCartCallBack = function () {

            var cartEMPTY = 'Y';
            var cart = localStorage.getItem('cartData');
            if (cart !== null && cart !== '{}') cartEMPTY = 'N';

            var that = _this;
            that.setState({ cartEMPTY: cartEMPTY });
        };

        _this.loadMore = function () {
            var search_text = _this.state.search_text;
            if (search_text == undefined || search_text == 'undefined') search_text = '';
            //this.state.loading = true;
            _this.fetchSecond('SEARCH', search_text, _this.state.page);
        };

        _this.state = {
            LOCATION: _this.props.location.pathname,
            LOADING: true,
            items: [],
            cartEMPTY: 'Y',
            search_text: props.match.params.search_text,
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
        return _this;
    }

    _createClass(SearchItem, [{
        key: 'fetchSearchPage',
        value: function fetchSearchPage(mode, search_text, page) {

            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/search_api.php?mode=' + mode + '&id=' + id + '&search_text=' + search_text + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                //console.log(result);
                var ITEMS = result.ITEMS;

                var ITEMCOUNT = result.ITEMCOUNT;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ LOADING: false, items: ITEMS, CUSTOMER_DET: CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'fetchSecond',
        value: function fetchSecond(mode, search_text, page) {
            var id = localStorage.getItem('delCIRCLE');

            var customer = '';
            if (localStorage.getItem('userData')) customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/search_api.php?mode=' + mode + '&id=' + id + '&search_text=' + search_text + '&page=' + page, {
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                var ITEMCOUNT = result.ITEMCOUNT;
                var CUSTOMER_DET = 'Hi User';
                if (result.CUSTOMER !== '' && result.CUSTOMER !== undefined && result.CUSTOMER !== 'undefined') CUSTOMER_DET = result.CUSTOMER;

                that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE });
            });
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mount = $("div").hasClass("modal-backdrop");
            if (mount == true) {
                $('body').removeClass('modal-open');
                $(".modal-backdrop").remove();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            window.location.reload();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var search_text = this.state.search_text;
            if (search_text == undefined || search_text == 'undefined') search_text = '';
            this.fetchSearchPage('SEARCH', search_text, this.state.page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var AppHeaderClass = 'appHeader bg-dark text-light';
            var AppHeaderLeft = 'showLINK';
            var AppHeaderLeftLink = '/home';
            var AppHeaderTitle = 'Search Result';
            var AppHeaderRight = '';
            var AppHeaderRightLink = 'SEARCH';
            var AppHeaderSearch = ''; //this.state.VENDORNAME;

            var props = {
                items: this.state.items,
                inCartCallBack: this.inCartCallBack
            };

            return _react2.default.createElement(
                'div',
                null,
                this.state.LOADING && _react2.default.createElement(_Loader2.default, null),
                this.state.VENDORNAME != '' && _react2.default.createElement(_AppHeader2.default, { AppHeaderClass: AppHeaderClass, AppHeaderLeft: AppHeaderLeft, AppHeaderLeftLink: AppHeaderLeftLink, AppHeaderTitle: AppHeaderTitle, AppHeaderRight: AppHeaderRight, AppHeaderRightLink: AppHeaderRightLink, AppHeaderSearch: AppHeaderSearch }),
                _react2.default.createElement(
                    'div',
                    { id: 'appCapsule' },
                    this.state.items.length > 0 && _react2.default.createElement(
                        'div',
                        { className: 'section pt-0 pb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: 'row' },
                            _react2.default.createElement(_SearchItems2.default, props)
                        ),
                        this.state.displayLoadMore == 'Y' && _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(
                                'button',
                                { type: 'button', style: { 'height': '31px' }, onClick: function onClick() {
                                        return _this2.loadMore();
                                    }, className: 'btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack' },
                                'Load More'
                            )
                        )
                    ),
                    this.state.items.length == 0 && _react2.default.createElement(
                        'div',
                        { className: 'section pt-6', style: { textAlign: 'center' } },
                        _react2.default.createElement('img', { src: '/assets/img/no-records.png', alt: 'empty-cart', className: 'form-image imaged w200' })
                    )
                ),
                _react2.default.createElement(_BottomMenu2.default, { LOCATION: this.state.LOCATION }),
                this.state.CUSTOMER_DET && _react2.default.createElement(_SidebarPanel2.default, { CUSTOMER_DET: this.state.CUSTOMER_DET })
            );
        }
    }]);

    return SearchItem;
}(_react2.default.Component);

exports.default = SearchItem;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(1);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchItems2 = function (_React$Component) {
    _inherits(SearchItems2, _React$Component);

    function SearchItems2(props) {
        _classCallCheck(this, SearchItems2);

        var _this = _possibleConstructorReturn(this, (SearchItems2.__proto__ || Object.getPrototypeOf(SearchItems2)).call(this, props));

        _this.handleClickAddToCart = function (id, unit, vendor_id, vendor_name, vendortype_id) {
            var cartCIRCLE = localStorage.getItem('cartCIRCLE');
            var circleID = localStorage.getItem('delCIRCLE2');
            if (cartCIRCLE === null || cartCIRCLE === '{}') localStorage.setItem('cartCIRCLE', circleID);

            var cartTotalCount = 0;
            var inCart = 'N';
            var addButton = 'Y';
            var cartCount = 0;

            var addToObject = function addToObject(obj, key, value, index) {
                // Create a temp object and index variable
                var temp = {};
                var i = 0;

                // Loop through the original object
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        // If the indexes match, add the new item
                        if (i === index && key && value) {
                            temp[key] = value;
                        }
                        // Add the current item in the loop to the temp obj
                        temp[prop] = obj[prop];
                        // Increase the count
                        i++;
                    }
                }

                // If no index, add to the end
                if (!index && key && value) {
                    temp[key] = value;
                }
                return temp;
            };

            var cart = localStorage.getItem('cartData');
            var cartVendorID = localStorage.getItem('cartVendorID');
            var cartVendorName = localStorage.getItem('cartVendorName');
            var cartVendorTypeID = localStorage.getItem('cartVendorTypeID');

            var that = _this;
            if (cart === null) {
                var a = _defineProperty({}, id + '~~**~~' + unit, 1);
                localStorage.setItem('cartData', JSON.stringify(a));
                localStorage.setItem('cartVendorID', vendor_id);
                localStorage.setItem('cartVendorName', vendor_name);
                localStorage.setItem('cartVendorTypeID', vendortype_id);

                var _inCart = 'Y';
                var _cartCount = 1;

                that.setState({ inCart: _inCart, cartCount: _cartCount });
                _this.props.inCartCallBack();
            } else {
                var ALLOW_CART = 'Y';
                if (cartVendorID != vendor_id) {
                    var MSG = '';
                    if (cartVendorTypeID != vendortype_id) {
                        if (cartVendorTypeID == '2') MSG = 'Items from ' + cartVendorName + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;else if (vendortype_id == '2') MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;

                        ALLOW_CART = 'N';
                    } else {
                        if (cartVendorTypeID == '2' && vendortype_id == '2') {
                            MSG = 'Items from ' + vendor_name + ' needs to be ordered independently. Please clear the cart if you wish to add items from ' + vendor_name;
                            ALLOW_CART = 'N';
                        }
                    }

                    if (ALLOW_CART == 'N') {
                        that.setState({ RESTRICTION_NOTE: MSG });
                        $('#ModalCartItemRestriction_' + id).modal('show');
                    }
                }

                if (ALLOW_CART == 'Y') {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var cart_id = key.split('~~**~~');
                        if (cart_id[0] == id) cartTotalCount += cartData[key];

                        if (cart_id[0] == id && unit == cart_id[1]) delete cartData[key];
                    });
                    cartTotalCount += 1;

                    cartData = addToObject(cartData, [id + '~~**~~' + unit], 1);
                    localStorage.setItem('cartData', JSON.stringify(cartData));

                    var _inCart2 = 'Y';
                    var _cartCount2 = 1;
                    that.setState({ inCart: _inCart2, cartCount: cartTotalCount });
                    _this.props.inCartCallBack();
                }
            }
        };

        _this.handleClickIncreement = function (id, unit, cartCount, itemqty_cart) {
            var cartTotalCount = 0;
            if (itemqty_cart !== 0 && cartCount < itemqty_cart) {
                cartCount = cartCount + 1;

                var cart = localStorage.getItem('cartData');
                var that = _this;
                var cartData = JSON.parse(cart);
                Object.keys(cartData).forEach(function (key) {
                    var cart_id = key.split('~~**~~');
                    if (cart_id[0] == id) cartTotalCount += cartData[key];

                    if (cart_id[0] == id && unit == cart_id[1]) cartData[key] = cartCount;
                });
                cartTotalCount += 1;

                localStorage.setItem('cartData', JSON.stringify(cartData));

                var inCart = 'Y';
                cartCount = cartCount;
                that.setState({ inCart: inCart, cartCount: cartTotalCount });
                _this.props.inCartCallBack();
            } else $('#ModalCartItemLimit_' + id).modal('show');
        };

        _this.handleClickDecreement = function (id, unit, cartCount) {

            cartCount = cartCount != 0 ? cartCount - 1 : 0;
            var cart = localStorage.getItem('cartData');
            var that = _this;
            var cartData = JSON.parse(cart);
            Object.keys(cartData).forEach(function (key) {
                var cart_id = key.split('~~**~~');
                if (cart_id[0] == id && unit == cart_id[1]) {
                    if (cartCount == 0) delete cartData[key];else cartData[key] = cartCount;
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
            cart = localStorage.getItem('cartData');
            if (cart === null || cart === '{}') {
                localStorage.removeItem('cartCIRCLE');
                localStorage.removeItem('cartInstructions');
                localStorage.removeItem("cartData");
                localStorage.removeItem('cartVendorID');
                localStorage.removeItem('cartVendorName');
                localStorage.removeItem('cartVendorTypeID');
            }

            var inCart = cartCount == 0 ? 'N' : 'Y';
            cartCount = cartCount;
            that.setState({ inCart: inCart, cartCount: cartCount });
            _this.props.inCartCallBack();
        };

        _this.state = {
            items: props.items,
            RESTRICTION_NOTE: ''
        };
        return _this;
    }

    _createClass(SearchItems2, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ items: nextProps.items });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.state.items.map(function (item) {

                var inCart = 'N'; //this.state.inCart;
                var added = ''; //this.state.addButton;
                var cartCount = 0; //this.state.cartCount;

                var currentITEM = item.ID;
                var cart = localStorage.getItem('cartData');
                if (cart !== null) {
                    var cartData = JSON.parse(cart);
                    Object.keys(cartData).forEach(function (key) {
                        var id = key.split('~~**~~');
                        if (id[0] == currentITEM) {
                            inCart = 'Y';
                            added = 'add-btn-inc';
                            cartCount += cartData[key];
                        }
                    });
                }

                return _react2.default.createElement(
                    'div',
                    { className: 'col-6', key: item.ID },
                    _react2.default.createElement(
                        'div',
                        { className: 'card  mb-2' },
                        _react2.default.createElement('img', { src: item.PIC, className: 'card-img-top imaged w-100', alt: 'image' }),
                        _react2.default.createElement(
                            'div',
                            { className: 'card-body pt-07 pb-07 pr-06 pl-06' },
                            _react2.default.createElement(
                                'p',
                                { className: 'card-text text-dgrey font-size-14 font-weg-400 mb-0' },
                                item.NAME
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 text-slgrey' },
                                _react2.default.createElement(
                                    'small',
                                    null,
                                    'Per ',
                                    item.UNIT
                                )
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: 'mb-0 font-weg-600' },
                                item.MRP !== '0.00' && item.MRP !== item.RATE && _react2.default.createElement(
                                    'span',
                                    { className: 'del-price text-slgrey' },
                                    _react2.default.createElement(
                                        'del',
                                        null,
                                        '\u20B9',
                                        item.MRP
                                    )
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'final-price text-danger font-size-14' },
                                    '\u20B9 ',
                                    item.RATE
                                )
                            ),
                            item.AVAILABLE_QTY > 0 && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'add-btn ' + added + ' mt-2' },
                                    _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickDecreement(item.ID, item.UNIT, cartCount);
                                        }, value: '-', className: 'qtyminus' }),
                                    _react2.default.createElement('input', { type: 'text', value: cartCount, readOnly: true, className: 'qty' }),
                                    inCart == 'Y' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickIncreement(item.ID, item.UNIT, cartCount, item.QTY_PER_CART);
                                        }, value: '+', className: 'qtyplus' }),
                                    inCart == 'N' && _react2.default.createElement('input', { type: 'button', onClick: function onClick() {
                                            _this2.handleClickAddToCart(item.ID, item.UNIT, item.VENDOR_ID, item.VENDOR_NAME, item.VENDORTYPE_ID);
                                        }, value: '+', className: 'qtyplus' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemLimit_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                'You have reached the limit for this item'
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'modal fade dialogbox', id: 'ModalCartItemRestriction_' + item.ID, 'data-backdrop': 'static', tabIndex: '-1', role: 'dialog' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'modal-dialog', role: 'document' },
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'modal-content' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-header' },
                                                _react2.default.createElement(
                                                    'h5',
                                                    { className: 'modal-title' },
                                                    '\xA0'
                                                )
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-body' },
                                                _this2.state.RESTRICTION_NOTE
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'modal-footer' },
                                                _react2.default.createElement(
                                                    'div',
                                                    { className: 'btn-inline' },
                                                    _react2.default.createElement(
                                                        'button',
                                                        { type: 'button', className: 'btn', 'data-dismiss': 'modal' },
                                                        'Ok'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            item.AVAILABLE_QTY == 0 && _react2.default.createElement(
                                'div',
                                { className: 'add-btn add-btn-incr mt-2 font-size-12' },
                                'Out Of Stock'
                            )
                        )
                    )
                );
            });
        }
    }]);

    return SearchItems2;
}(_react2.default.Component);

exports.default = SearchItems2;

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js